(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9780],{

/***/ 40160:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgArrowLeft(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 11,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M9.313 16l-7.5-7.5 7.5-7.5",
    stroke: "#D4A976",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
/* harmony default export */ __webpack_exports__["Z"] = (SvgArrowLeft);

/***/ }),

/***/ 59994:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgArrowRight(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 11,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M1.688 1l7.5 7.5-7.5 7.5",
    stroke: "#D4A976",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
/* harmony default export */ __webpack_exports__["Z"] = (SvgArrowRight);

/***/ }),

/***/ 60831:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgSmallWhiteLogo(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    id: "small-white-logo_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 112 112"
  }, props), _defs || (_defs = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("defs", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("style", null, ".small-white-logo_svg__cls-1{fill:#fff}"))), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    className: "small-white-logo_svg__cls-1",
    d: "M62.95 16.14c-1.74-3.64-5.45-5.96-9.51-5.96h-.02-6.89L56.04 56l-9.51 45.82H53.44c4.06 0 7.77-2.33 9.51-5.96L84.21 56 62.95 16.14z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    className: "small-white-logo_svg__cls-1",
    d: "M88.95 58.77H31.43a2.77 2.77 0 110-5.54h57.52a2.77 2.77 0 110 5.54z"
  })), _path3 || (_path3 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    className: "small-white-logo_svg__cls-1",
    d: "M56 112C25.12 112 0 86.88 0 56S25.12 0 56 0s56 25.12 56 56-25.12 56-56 56zM56 2.87C26.7 2.87 2.87 26.7 2.87 56S26.71 109.14 56 109.14 109.13 85.3 109.13 56 85.3 2.87 56 2.87z"
  })));
}
/* harmony default export */ __webpack_exports__["Z"] = (SvgSmallWhiteLogo);

/***/ }),

/***/ 8589:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ Header; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(34727);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(67573);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(52875);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(44747);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(72276);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Close.js
var Close = __webpack_require__(50594);
// EXTERNAL MODULE: ./node_modules/@mui/material/Dialog/Dialog.js + 2 modules
var Dialog = __webpack_require__(78262);
// EXTERNAL MODULE: ./node_modules/@react-hook/window-size/dist/module/index.js + 3 modules
var dist_module = __webpack_require__(61715);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/react-intersection-observer.m.js
var react_intersection_observer_m = __webpack_require__(70131);
// EXTERNAL MODULE: ./components/index.js + 25 modules
var components = __webpack_require__(60306);
// EXTERNAL MODULE: ./config/index.js + 2 modules
var config = __webpack_require__(74907);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/MenuRounded.js
var MenuRounded = __webpack_require__(69750);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/PersonOutlineRounded.js
var PersonOutlineRounded = __webpack_require__(78499);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/SearchRounded.js
var SearchRounded = __webpack_require__(3327);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/CloseRounded.js
var CloseRounded = __webpack_require__(36191);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./public/logo.svg
var logo = __webpack_require__(79409);
// EXTERNAL MODULE: ./Layout/MobileHeader/MobileHeader.module.scss
var MobileHeader_module = __webpack_require__(11980);
var MobileHeader_module_default = /*#__PURE__*/__webpack_require__.n(MobileHeader_module);
// EXTERNAL MODULE: ./components/assets/Logo.module.scss
var Logo_module = __webpack_require__(43587);
var Logo_module_default = /*#__PURE__*/__webpack_require__.n(Logo_module);
// EXTERNAL MODULE: ./utils/httpClient.js
var httpClient = __webpack_require__(22550);
;// CONCATENATED MODULE: ./components/utils/changeCurrency.js

function changeCurrency(code, session) {
    (0,httpClient/* httpPut */.e8)("/api/user/currency", {
        currency: code
    }).then(function() {
        session();
    });
}

;// CONCATENATED MODULE: ./config/hasETG.js
var HAS_ETG = {
    AE: {
        hasEtg: true,
        code: "en-usd"
    },
    AR: {
        hasEtg: true,
        code: "la-usd"
    },
    AT: {
        hasEtg: true,
        code: "en-eur"
    },
    AU: {
        hasEtg: true
    },
    BE: {
        hasEtg: true,
        code: "en-eur"
    },
    BO: {
        hasEtg: true,
        code: "la-usd"
    },
    BR: {
        hasEtg: true,
        code: "en-usd"
    },
    CA: {
        hasEtg: true
    },
    CH: {
        hasEtg: true,
        code: "en-eur"
    },
    CL: {
        hasEtg: true,
        code: "la-usd"
    },
    CO: {
        hasEtg: true,
        code: "la-usd"
    },
    CR: {
        hasEtg: true,
        code: "la-usd"
    },
    CZ: {
        hasEtg: true,
        code: "en-eur"
    },
    DE: {
        hasEtg: true,
        code: "en-eur"
    },
    DK: {
        hasEtg: true
    },
    DO: {
        hasEtg: true,
        code: "la-usd"
    },
    EC: {
        hasEtg: true,
        code: "la-usd"
    },
    ES: {
        hasEtg: true,
        code: "la-eur"
    },
    FI: {
        hasEtg: true,
        code: "en-eur"
    },
    FR: {
        hasEtg: true,
        code: "en-eur"
    },
    GB: {
        hasEtg: true
    },
    GR: {
        hasEtg: true,
        code: "en-eur"
    },
    GT: {
        hasEtg: true,
        code: "la-usd"
    },
    HK: {
        hasEtg: true,
        code: "en-usd"
    },
    HN: {
        hasEtg: true,
        code: "la-usd"
    },
    ID: {
        hasEtg: true,
        code: "en-usd"
    },
    IE: {
        hasEtg: true
    },
    IL: {
        hasEtg: true,
        code: "en-usd"
    },
    IN: {
        hasEtg: true
    },
    IT: {
        hasEtg: true,
        code: "en-eur"
    },
    JP: {
        hasEtg: true,
        code: "en-usd"
    },
    KR: {
        hasEtg: true,
        code: "en-usd"
    },
    MX: {
        hasEtg: true,
        code: "la-usd"
    },
    MY: {
        hasEtg: true,
        code: "en-usd"
    },
    NI: {
        hasEtg: true,
        code: "la-usd"
    },
    NL: {
        hasEtg: true,
        code: "en-eur"
    },
    NO: {
        hasEtg: true
    },
    NZ: {
        hasEtg: true,
        code: "en-usd"
    },
    PA: {
        hasEtg: true,
        code: "la-usd"
    },
    PE: {
        hasEtg: true,
        code: "la-usd"
    },
    PH: {
        hasEtg: true,
        code: "en-usd"
    },
    PL: {
        hasEtg: true,
        code: "en-eur"
    },
    PR: {
        hasEtg: true,
        code: "la-usd"
    },
    PT: {
        hasEtg: true,
        code: "en-eur"
    },
    PY: {
        hasEtg: true,
        code: "la-usd"
    },
    QA: {
        hasEtg: true,
        code: "en-usd"
    },
    RO: {
        hasEtg: true,
        code: "en-eur"
    },
    SA: {
        hasEtg: true,
        code: "en-usd"
    },
    SE: {
        hasEtg: true
    },
    SG: {
        hasEtg: true,
        code: "en-usd"
    },
    SV: {
        hasEtg: true,
        code: "la-usd"
    },
    TH: {
        hasEtg: true,
        code: "en-usd"
    },
    TR: {
        hasEtg: true,
        code: "en-eur"
    },
    TW: {
        hasEtg: true,
        code: "en-usd"
    },
    UA: {
        hasEtg: true,
        code: "en-eur"
    },
    US: {
        hasEtg: true
    },
    UY: {
        hasEtg: true,
        code: "la-usd"
    },
    VN: {
        hasEtg: true,
        code: "en-usd"
    },
    ZA: {
        hasEtg: true,
        code: "en-usd"
    }
};

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Person.js
var Person = __webpack_require__(15398);
;// CONCATENATED MODULE: ./Layout/MobileHeader/MobileHeader.jsx





















var MobileHeader = function(_param) {
    var transparentHeader = _param.transparentHeader, menuItems = _param.menuItems, sessionState = _param.sessionState, toggleLoginDialog = _param.toggleLoginDialog, loginDialogState = _param.loginDialogState, session = _param.session, props = (0,_object_without_properties/* default */.Z)(_param, [
        "transparentHeader",
        "menuItems",
        "sessionState",
        "toggleLoginDialog",
        "loginDialogState",
        "session"
    ]);
    var ref;
    var ref1 = (0,react.useState)(false), showForum = ref1[0], setShowForum = ref1[1];
    var ref2 = (0,react.useState)(false), menuState = ref2[0], setMenuState = ref2[1];
    var ref3 = (0,react.useState)(false), searchState = ref3[0], setSearchState = ref3[1];
    var ref4 = (0,react.useState)(false), cookieAccepted = ref4[0], setCookieAccepted = ref4[1];
    var userStore = (0,es/* useSelector */.v9)(function(state) {
        return state.user.value;
    });
    var headerRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if ((userStore === null || userStore === void 0 ? void 0 : userStore.country) === "SE" || (userStore === null || userStore === void 0 ? void 0 : userStore.country) === "DK" || (userStore === null || userStore === void 0 ? void 0 : userStore.country) === "NO") {
            setShowForum(true);
        } else {
            setShowForum(false);
        }
    }, [
        userStore === null || userStore === void 0 ? void 0 : userStore.country
    ]);
    (0,react.useEffect)(function() {
        var cookieState = JSON.parse(localStorage.getItem("bcCookieConsentShowed"));
        if (cookieState) {
            setCookieAccepted(cookieState);
        } else {
            window.addEventListener("storage", function() {
                cookieState = JSON.parse(localStorage.getItem("bcCookieConsentShowed"));
                if (cookieState) {
                    setCookieAccepted(cookieState);
                }
            });
        }
    }, []);
    (0,react.useEffect)(function() {
        var handleClickOutside = function(event) {
            if (headerRef.current && !headerRef.current.contains(event.target)) {
                setMenuState(false);
                setSearchState(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        document.addEventListener("touchstart", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
            document.removeEventListener("touchstart", handleClickOutside);
        };
    }, [
        headerRef
    ]);
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            ref: headerRef,
            className: classnames_default()("w-full px-2")
        }, props), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()("w-full flex justify-between items-center"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                            className: "m-2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: "flex h-full",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: "my-auto",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "/",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(logo/* default */.Z, {
                                            className: classnames_default()((_obj = {}, (0,_define_property/* default */.Z)(_obj, (Logo_module_default()).logoMobileBlack, !transparentHeader), (0,_define_property/* default */.Z)(_obj, (Logo_module_default()).logoMobile, transparentHeader), _obj))
                                        })
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "m-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchRounded/* default */.Z, {
                                    className: "cursor-pointer",
                                    fontSize: "medium",
                                    onClick: function() {
                                        setSearchState(!searchState);
                                    }
                                }),
                                !(sessionState === null || sessionState === void 0 ? void 0 : sessionState.userid) && /*#__PURE__*/ (0,jsx_runtime.jsx)(PersonOutlineRounded/* default */.Z, {
                                    className: "lg:mx-5 sm:ml-6 cursor-pointer",
                                    fontSize: "medium",
                                    sx: {
                                        color: transparentHeader ? "#ffffff" : "#202020",
                                        fontSize: "28px"
                                    },
                                    onClick: function() {
                                        if (sessionState && sessionState.userid) {
                                            document.location = "/profile";
                                            return;
                                        }
                                        toggleLoginDialog(!loginDialogState);
                                    }
                                }),
                                (sessionState === null || sessionState === void 0 ? void 0 : sessionState.userid) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Person/* default */.Z, {
                                    className: "lg:mx-5 sm:ml-6 cursor-pointer",
                                    fontSize: "medium",
                                    sx: {
                                        color: transparentHeader ? "#ffffff" : "#202020",
                                        fontSize: "28px"
                                    },
                                    onClick: function() {
                                        if (sessionState && sessionState.userid) {
                                            document.location = "/profile";
                                            return;
                                        }
                                        toggleLoginDialog(!loginDialogState);
                                    }
                                }),
                                !menuState && /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuRounded/* default */.Z, {
                                    fontSize: "medium",
                                    className: "lg:mx-5 sm:ml-6 cursor-pointer",
                                    onClick: function() {
                                        return setMenuState(true);
                                    }
                                }),
                                menuState && /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseRounded/* default */.Z, {
                                    fontSize: "medium",
                                    className: "lg:mx-5 sm:ml-6 cursor-pointer",
                                    onClick: function() {
                                        return setMenuState(false);
                                    }
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()("flex flex-col px-3 font-libre", (0,_define_property/* default */.Z)({
                        hidden: !searchState,
                        visible: searchState
                    }, (MobileHeader_module_default()).searchContainer, searchState)),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "w-full text-xs",
                            children: "Search on this website"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "gcse-search"
                        })
                    ]
                }),
                menuState && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()("flex flex-col font-libre, bg-white", (MobileHeader_module_default()).menuContainer),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()((MobileHeader_module_default()).accordionTitle, "w-full px-5"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "/club",
                                children: "The Club"
                            })
                        }),
                        sessionState && ((ref = HAS_ETG[sessionState === null || sessionState === void 0 ? void 0 : sessionState.country]) === null || ref === void 0 ? void 0 : ref.hasEtg) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()((MobileHeader_module_default()).accordionTitle, "w-full px-5 py-1"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "/booking-support",
                                children: "My Bookings"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()((MobileHeader_module_default()).accordionTitle, "w-full px-5"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CustomizedAccordion */.A_, {
                                label: "Airlines",
                                items: menuItems.airlines
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()((MobileHeader_module_default()).accordionTitle, "w-full px-5"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CustomizedAccordion */.A_, {
                                label: "Flights",
                                items: menuItems.flights
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()((MobileHeader_module_default()).accordionTitle, "w-full px-5"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CustomizedAccordion */.A_, {
                                label: "Hotels",
                                items: menuItems.hotels
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()((MobileHeader_module_default()).accordionTitle, "w-full px-5"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CustomizedAccordion */.A_, {
                                label: "More",
                                items: menuItems.more
                            })
                        }),
                        showForum && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()((MobileHeader_module_default()).accordionTitle, "w-full px-5"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "/forum",
                                children: "Forum"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()((MobileHeader_module_default()).accordionTitle, "w-full px-5"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CustomizedAccordion */.A_, {
                                items: Object.keys(config/* CURRENCY */.wA).map(function(currency) {
                                    return {
                                        label: currency,
                                        action: function() {
                                            return changeCurrency(currency, session);
                                        }
                                    };
                                }),
                                label: sessionState === null || sessionState === void 0 ? void 0 : sessionState.currency,
                                columnsNumber: 3
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()((MobileHeader_module_default()).accordionTitle, "w-full px-5"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CountryAccordion */.LC, {
                                currentCountry: sessionState === null || sessionState === void 0 ? void 0 : sessionState.country,
                                session: session,
                                columnsNumber: 2
                            })
                        })
                    ]
                })
            ]
        }))
    });
};

// EXTERNAL MODULE: ./Layout/Header/Header.module.scss
var Header_module = __webpack_require__(87753);
var Header_module_default = /*#__PURE__*/__webpack_require__.n(Header_module);
;// CONCATENATED MODULE: ./Layout/Header/navitems/NavigationItems.js
var navigationItems = {
    airlines: [
        {
            label: "Reviews",
            href: "/airlines/reviews"
        },
        {
            label: "Articles",
            href: "/airlines/articles"
        },
        {
            label: "TopLists",
            href: "/airlines/toplists"
        },
        {
            label: "News",
            href: "/airlines/news"
        },
        {
            label: "Offers",
            href: "/offers"
        }, 
    ],
    flights: [
        {
            label: "Business Class",
            href: "/flights/business-class"
        },
        {
            label: "First Class",
            href: "/flights/first-class"
        },
        {
            label: "Premium Economy Class",
            href: "/flights/premium-economy-class"
        },
        {
            label: "Economy Class",
            href: "/flights"
        }, 
    ],
    hotels: [
        {
            label: "Reviews",
            href: "/hotels/reviews"
        },
        {
            label: "Articles",
            href: "/hotels/articles"
        },
        {
            label: "TopLists",
            href: "/hotels/toplists"
        },
        {
            label: "News",
            href: "/hotels/news"
        }, 
    ],
    more: [
        {
            label: "About",
            href: "/about"
        },
        {
            label: "Destinations",
            href: "/destinations",
            children: [
                // {
                //   label: 'Reviews',
                //   href: '/destinations/reviews/',
                // },
                {
                    label: "Articles",
                    href: "/destinations/articles"
                },
                {
                    label: "TopLists",
                    href: "/destinations/toplists"
                },
                {
                    label: "News",
                    href: "/destinations/news"
                }, 
            ]
        },
        {
            label: "Lifestyle",
            href: "/lifestyle",
            children: [
                // {
                //   label: 'Reviews',
                //   href: '/lifestyle/reviews/',
                // },
                {
                    label: "Articles",
                    href: "/lifestyle/articles"
                },
                // {
                //   label: 'TopLists',
                //   href: '/lifestyle/toplists/',
                // },
                {
                    label: "News",
                    href: "/lifestyle/news"
                }, 
            ]
        },
        {
            label: "Guides",
            href: "/guides",
            children: [
                // {
                //   label: 'Reviews',
                //   href: '/guides/reviews',
                // },
                {
                    label: "Articles",
                    href: "/guides/articles"
                }, 
            ]
        },
        {
            label: "Trains",
            href: "/trains",
            children: [
                {
                    label: "Reviews",
                    href: "/trains/reviews"
                },
                // {
                //   label: 'Articles',
                //   href: '/trains/articles',
                // },
                {
                    label: "TopLists",
                    href: "/trains/toplists"
                },
                {
                    label: "News",
                    href: "/trains/news"
                }, 
            ]
        },
        {
            label: "Cruises",
            href: "/cruises",
            children: [
                // {
                //   label: 'Reviews',
                //   href: '/cruises/reviews',
                // },
                {
                    label: "Articles",
                    href: "/cruises/articles"
                }, 
            ]
        },
        {
            label: "Airports",
            href: "/airports",
            children: [
                // {
                //   label: 'Reviews',
                //   href: '/airports/reviews',
                // },
                {
                    label: "Articles",
                    href: "/airports/articles"
                },
                {
                    label: "TopLists",
                    href: "/airports/toplists"
                },
                {
                    label: "News",
                    href: "/airports/news"
                }, 
            ]
        },
        {
            label: "Dining",
            href: "/dining",
            children: [
                {
                    label: "Reviews",
                    href: "/dining/reviews"
                },
                {
                    label: "Articles",
                    href: "/dining/articles"
                },
                {
                    label: "TopLists",
                    href: "/dining/toplists"
                },
                {
                    label: "News",
                    href: "/dining/news"
                }, 
            ]
        }, 
    ]
};

// EXTERNAL MODULE: ./utils/store/features/userSlice.js
var userSlice = __webpack_require__(2363);
// EXTERNAL MODULE: ./components/Authentication/GoogleOneTapAuth/GoogleOneTapAuth.jsx
var GoogleOneTapAuth = __webpack_require__(33770);
// EXTERNAL MODULE: ./node_modules/react-gtm-module/dist/index.js
var dist = __webpack_require__(1785);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@mui/material/Popper/Popper.js + 3 modules
var Popper = __webpack_require__(79350);
// EXTERNAL MODULE: ./node_modules/@mui/material/Paper/Paper.js + 2 modules
var Paper = __webpack_require__(90629);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box = __webpack_require__(5616);
// EXTERNAL MODULE: ./node_modules/@mui/material/CircularProgress/CircularProgress.js + 1 modules
var CircularProgress = __webpack_require__(98456);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 3 modules
var Button = __webpack_require__(69417);
// EXTERNAL MODULE: ./components/FlightSearch/FlightSearchAutocomplete/FlightSearchAutocomplete.jsx
var FlightSearchAutocomplete = __webpack_require__(57907);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/FlightTakeoff.js
var FlightTakeoff = __webpack_require__(92585);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Info.js
var Info = __webpack_require__(74721);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/Tooltip/Tooltip.js + 3 modules
var Tooltip = __webpack_require__(68760);
// EXTERNAL MODULE: ./components/api/flight/autocomplete.js
var autocomplete = __webpack_require__(35381);
;// CONCATENATED MODULE: ./Layout/Header/UserAirportDropdown/UserAirportDropdown.jsx











var UserAirportDropdown = function(param) {
    var anchorEl = param.anchorEl, onClose = param.onClose;
    var userStore = (0,es/* useSelector */.v9)(function(state) {
        return state.user.value;
    });
    //   const userCity = useSelector((state) => state.userStore.city); // Adjust selector based on your store
    var ref = (0,react.useState)(null), nearestAirport = ref[0], setNearestAirport = ref[1];
    var ref1 = (0,react.useState)(null), selectedAirport = ref1[0], setSelectedAirport = ref1[1];
    var ref2 = (0,react.useState)(false), showAutocomplete = ref2[0], setShowAutocomplete = ref2[1];
    var ref3 = (0,react.useState)(false), loading = ref3[0], setLoading = ref3[1];
    var ref4 = (0,react.useState)(false), isShown = ref4[0], setIsShown = ref4[1];
    (0,react.useEffect)(function() {
        if (!(userStore === null || userStore === void 0 ? void 0 : userStore.detectLocation)) return;
        if (localStorage.getItem("BC_preferredAirport") || (userStore === null || userStore === void 0 ? void 0 : userStore.userid)) {
            setIsShown(false);
        } else {
            setIsShown(true);
            setLoading(true);
            (0,autocomplete/* getFlightAirportsAutocomplete */._)(userStore === null || userStore === void 0 ? void 0 : userStore.detectLocation).then(function(airports) {
                if (airports.length > 0) {
                    // Select the first airport as the nearest for simplicity
                    setNearestAirport(airports[0]);
                } else {
                    setShowAutocomplete(true);
                }
                setLoading(false);
            }).catch(function() {
                return setLoading(false);
            });
        }
    }, [
        userStore === null || userStore === void 0 ? void 0 : userStore.detectLocation,
        userStore === null || userStore === void 0 ? void 0 : userStore.userid
    ]);
    var savePreferredAirport = function(airport) {
        document.cookie = "BC_preferredAirport=".concat(JSON.stringify(airport), " max-age=31536000;path=/;domain=.first-class.com");
        localStorage.setItem("BC_preferredAirport", JSON.stringify(airport));
        if (userStore === null || userStore === void 0 ? void 0 : userStore.userid) {
            (0,httpClient/* httpPut */.e8)("/api/user/profile", {
                userAirports: [
                    {
                        code: airport === null || airport === void 0 ? void 0 : airport.Iata,
                        name: airport === null || airport === void 0 ? void 0 : airport.Name,
                        isCity: (airport === null || airport === void 0 ? void 0 : airport.primaryPlaceType) === "country"
                    }, 
                ]
            });
        }
        onClose();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Popper/* default */.Z, {
        open: !!anchorEl && isShown,
        anchorEl: anchorEl,
        placement: "bottom-start",
        style: {
            zIndex: 1300
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paper/* default */.Z, {
            style: {
                padding: "16px",
                paddingTop: "24px",
                minWidth: "300px"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                    color: "inherit",
                    onClick: function() {
                        return onClose(true);
                    },
                    "aria-label": "close",
                    sx: {
                        position: "absolute",
                        right: 0,
                        top: 0
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
                }),
                loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "16px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                        size: 24
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: !showAutocomplete ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                variant: "body1",
                                gutterBottom: true,
                                className: "pr-8",
                                children: [
                                    "Is this your closest preferred airport?",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                        title: "We will use this airport as your origin and try to show you more personalized flight deals",
                                        placement: "right",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Info/* default */.Z, {
                                            sx: {
                                                color: "#00454A",
                                                marginLeft: "5px"
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-lg font-semibold text-gray-600 mb-5 font-libre",
                                children: nearestAirport === null || nearestAirport === void 0 ? void 0 : nearestAirport.fullName
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                variant: "contained",
                                color: "primary",
                                type: "button",
                                fullWidth: true,
                                sx: {
                                    backgroundColor: "#00454A",
                                    "&:hover": {
                                        backgroundColor: "#00454A"
                                    },
                                    textTransform: "none",
                                    color: "white",
                                    marginBottom: "10px"
                                },
                                onClick: function() {
                                    return savePreferredAirport(nearestAirport);
                                },
                                children: "Confirm and Save"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                color: "primary",
                                type: "button",
                                fullWidth: true,
                                onClick: function() {
                                    return setShowAutocomplete(true);
                                },
                                sx: {
                                    textTransform: "none",
                                    color: "#020202",
                                    textDecoration: "underline"
                                },
                                children: "Select another airport"
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                variant: "body1",
                                gutterBottom: true,
                                children: [
                                    "Please select your preferred airport",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                        title: "We will use this airport as your origin and try to show you more personalized flight deals",
                                        placement: "right",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Info/* default */.Z, {
                                            sx: {
                                                color: "#00454A",
                                                marginLeft: "5px"
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FlightSearchAutocomplete/* FlightSearchAutocomplete */.s, {
                                label: "Search and select airport",
                                showLabel: true,
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(FlightTakeoff/* default */.Z, {}),
                                name: "selectedAirport",
                                setFieldValue: function(_, value) {
                                    return setSelectedAirport(value);
                                },
                                patch: {
                                    value: selectedAirport
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                marginTop: 2,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    variant: "contained",
                                    color: "primary",
                                    fullWidth: true,
                                    onClick: function() {
                                        return savePreferredAirport(selectedAirport);
                                    },
                                    disabled: !selectedAirport,
                                    sx: {
                                        backgroundColor: "#00454A",
                                        "&:hover": {
                                            backgroundColor: "#00454A"
                                        },
                                        textTransform: "none",
                                        color: "white"
                                    },
                                    children: "Save"
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var UserAirportDropdown_UserAirportDropdown = (UserAirportDropdown);

// EXTERNAL MODULE: ./node_modules/currency-symbol-map/currency-symbol-map.js
var currency_symbol_map = __webpack_require__(81463);
var currency_symbol_map_default = /*#__PURE__*/__webpack_require__.n(currency_symbol_map);
;// CONCATENATED MODULE: ./Layout/Header/Header.jsx




































var getProfile = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var res, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0,httpClient/* httpGet */.kA)("/api/user/profile")
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        4,
                        res.json()
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
                case 3:
                    e = _state.sent();
                    console.log(e);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2,
                        null
                    ];
            }
        });
    });
    return function getProfile() {
        return _ref.apply(this, arguments);
    };
}();
var Authentication = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4231), __webpack_require__.e(6700), __webpack_require__.e(6420), __webpack_require__.e(8522)]).then(__webpack_require__.bind(__webpack_require__, 59200));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(59200)
            ];
        }
    }
});
var Header = function(_param) {
    var handleSession = _param.handleSession, transparentHeader = _param.transparentHeader, _standalone = _param.standalone, standalone = _standalone === void 0 ? false : _standalone, props = (0,_object_without_properties/* default */.Z)(_param, [
        "handleSession",
        "transparentHeader",
        "standalone"
    ]);
    var ref;
    var ref1 = (0,react.useState)(null), sessionState = ref1[0], setSessionState = ref1[1];
    var ref2 = (0,react.useState)(true), sessionLoading = ref2[0], setSessionLoading = ref2[1];
    // eslint-disable-next-line no-unused-vars
    var ref3 = (0,react.useState)(false), mainPage = ref3[0], setMainPage = ref3[1];
    var ref4 = (0,react.useState)(false), showForum = ref4[0], setShowForum = ref4[1];
    var ref5 = (0,react.useState)(false), searchState = ref5[0], setSearchState = ref5[1];
    var ref6 = (0,react.useState)(false), loginDialogState = ref6[0], setLoginDialogState = ref6[1];
    var userStore = (0,es/* useSelector */.v9)(function(state) {
        return state.user.value;
    });
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref7 = (0,react.useState)(0), windowWidth = ref7[0], setWindowWidth = ref7[1];
    var ref8 = (0,react.useState)(false), hideHeader = ref8[0], setHideHeader = ref8[1];
    var width = (0,dist_module/* useWindowWidth */.Lm)();
    var ref9 = (0,react.useState)(false), cookieAccepted = ref9[0], setCookieAccepted = ref9[1];
    var ref10 = (0,react.useState)(false), googlePromptLoaded = ref10[0], setGooglePromptLoaded = ref10[1];
    var ref11 = (0,react.useState)(null), profileData = ref11[0], setProfileData = ref11[1];
    var ref12 = (0,react.useState)(false), popperOpen = ref12[0], setPopperOpen = ref12[1];
    var router = (0,next_router.useRouter)();
    var logoRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if (!(sessionState === null || sessionState === void 0 ? void 0 : sessionState.userid) && !googlePromptLoaded) {
            setGooglePromptLoaded(true); // Ensure Google One Tap shows only once
        }
    }, [
        sessionState === null || sessionState === void 0 ? void 0 : sessionState.userid,
        googlePromptLoaded
    ]);
    (0,react.useEffect)(function() {
        setWindowWidth(width);
    }, [
        width
    ]);
    (0,react.useEffect)(function() {
        if (document.location.pathname === "/") {
            setMainPage(true);
        }
        var cookieState = JSON.parse(localStorage.getItem("BC-Consent-Cookie"));
        if ((cookieState === null || cookieState === void 0 ? void 0 : cookieState.ad_storage) === "granted") {
            setCookieAccepted(true);
        } else {
            window.addEventListener("storage", function() {
                cookieState = JSON.parse(localStorage.getItem("BC-Consent-Cookie"));
                setCookieAccepted((cookieState === null || cookieState === void 0 ? void 0 : cookieState.ad_storage) === "granted");
            });
        }
        if (standalone) {
            session();
        }
        var lastScrollTop = 0;
        // element should be replaced with the actual target element on which you have applied scroll, use window in case of no target element.
        window.addEventListener("scroll", function() {
            // or window.addEventListener("scroll"....
            var st = window.pageYOffset || document.documentElement.scrollTop;
            if (st > lastScrollTop) {
                setHideHeader(true);
            } else if (st < lastScrollTop) {
                setHideHeader(false);
            } // else was horizontal scroll
            lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
        }, false);
    }, []);
    (0,react.useEffect)(function() {
        if (userStore) {
            setSessionLoading(false);
            if (userStore.userid && !profileData) {
                getProfile().then(function(profile) {
                    var ref;
                    console.log(profile);
                    setProfileData(profile);
                    if ((profile === null || profile === void 0 ? void 0 : (ref = profile.userAirports) === null || ref === void 0 ? void 0 : ref.length) > 0) {
                        setPopperOpen(false);
                    } else {
                        setPopperOpen(true);
                    }
                });
            } else {
                try {
                    var isAirportClosed = JSON.parse(localStorage.getItem("BC_preferredAirportClosed"));
                    var preferredAirport = JSON.parse(localStorage.getItem("BC_preferredAirport"));
                    if (!isAirportClosed && !preferredAirport) {
                        setPopperOpen(true);
                    }
                } catch (error) {
                    console.error("Error accessing localStorage: ", error);
                }
            }
        }
        setSessionState(userStore);
        if ((userStore === null || userStore === void 0 ? void 0 : userStore.country) === "SE" || (userStore === null || userStore === void 0 ? void 0 : userStore.country) === "DK" || (userStore === null || userStore === void 0 ? void 0 : userStore.country) === "NO") {
            setShowForum(true);
        } else {
            setShowForum(false);
        }
    }, [
        userStore,
        profileData
    ]);
    var authCompleted = function() {
        console.log("Auth completed");
        setLoginDialogState(false);
        session();
    };
    var session = function(isSNAuth) {
        handleSession().then(function(userInfo) {
            setSessionLoading(false);
            var user = !(userInfo === null || userInfo === void 0 ? void 0 : userInfo.country) ? {
                userid: null,
                country: "us",
                detectCountry: null,
                detectRegion: null,
                is_admin: null,
                currency: "USD",
                username: null,
                fullname: null,
                membershipNumber: null
            } : userInfo;
            if (user.country === "uk") {
                user.country = "gb";
            }
            if (isSNAuth) {
                user.isSNAuth = true;
                var tagManagerArgs = {
                    dataLayer: {
                        event: "accountCreated",
                        userCountry: user.country.toUpperCase(),
                        pageType: router === null || router === void 0 ? void 0 : router.pathname,
                        source: "google",
                        membershipId: user.membershipNumber,
                        signupSource: "Google One Tap"
                    }
                };
                dist_default().dataLayer(tagManagerArgs);
            }
            dispatch((0,userSlice/* setUser */.av)(user));
            setSessionState(user);
        }).catch(function(err) {
            console.log(err);
            if (sessionState) {
                setSessionLoading(false);
                dispatch((0,userSlice/* setUser */.av)({}));
                setSessionState(null);
            }
        });
    };
    var redirectToProfile = function() {
        if (!router.pathname.includes("flightsearch")) {
            window.location.href = "/profile?accountCreated=true";
        } else {
            window.open("/profile?accountCreated=true", "_blank");
        }
    };
    var handleClose = function() {
        setPopperOpen(false);
        localStorage.setItem("BC_preferredAirportClosed", JSON.stringify(true));
    };
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                className: classnames_default()((_obj = {}, (0,_define_property/* default */.Z)(_obj, (Header_module_default()).hidden, hideHeader), (0,_define_property/* default */.Z)(_obj, (Header_module_default()).transparentHeader, transparentHeader), (0,_define_property/* default */.Z)(_obj, (Header_module_default()).header, !transparentHeader), _obj), "font-libre", "items-center", "top-0", "w-full")
            }, props), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()((Header_module_default()).headerContentContainer, "lg:flex sm:hidden flex-row text-white px-2 lg:px-6 py-2 w-full"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                                ref: logoRef,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: "flex h-full",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "my-auto",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "/",
                                            "aria-label": "Go to main First-Class.com page",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(logo/* default */.Z, {
                                                className: classnames_default()((Logo_module_default()).logo, (0,_define_property/* default */.Z)({}, (Logo_module_default()).logoBlack, !transparentHeader))
                                            })
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                                className: "ml-auto flex flex-row font-sans text-white font-libre p-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    className: "flex menu",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: classnames_default()((Header_module_default()).navItem, "px-3"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "/club",
                                                    className: classnames_default()("hover:no-underline text-bold", (0,_define_property/* default */.Z)({
                                                        "text-black": !transparentHeader,
                                                        "text-white": transparentHeader
                                                    }, (Header_module_default()).darkFont, !transparentHeader)),
                                                    children: "The Club"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: classnames_default()((Header_module_default()).navItem, "px-3"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* DropDown */.vb, {
                                                items: navigationItems.airlines,
                                                transparentHeader: transparentHeader,
                                                label: "Airlines"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: classnames_default()((Header_module_default()).navItem, "px-3"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* DropDown */.vb, {
                                                items: navigationItems.flights,
                                                transparentHeader: transparentHeader,
                                                label: "Flights"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: classnames_default()((Header_module_default()).navItem, "px-3"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* DropDown */.vb, {
                                                items: navigationItems.hotels,
                                                transparentHeader: transparentHeader,
                                                label: "Hotels"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: classnames_default()((Header_module_default()).navItem, "px-3"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* DropDown */.vb, {
                                                items: navigationItems.more,
                                                transparentHeader: transparentHeader,
                                                isForumShown: showForum,
                                                label: "More"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: classnames_default()((Header_module_default()).navItem, "px-3"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* DropDown */.vb, {
                                                items: Object.keys(config/* CURRENCY */.wA).map(function(currency) {
                                                    return {
                                                        label: "".concat(currency, " (").concat(currency_symbol_map_default()(currency), ")"),
                                                        action: function() {
                                                            return changeCurrency(currency, session);
                                                        },
                                                        rel: "nofollow"
                                                    };
                                                }),
                                                transparentHeader: transparentHeader,
                                                label: sessionState === null || sessionState === void 0 ? void 0 : sessionState.currency,
                                                columnsNumber: 3
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: classnames_default()((Header_module_default()).navItem, "px-3"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CountrySelect */.OP, {
                                                className: classnames_default()("flex items-center", {
                                                    "text-black": !transparentHeader,
                                                    "text-white": transparentHeader
                                                }),
                                                selectedCountry: sessionState === null || sessionState === void 0 ? void 0 : sessionState.country,
                                                transparentHeader: transparentHeader,
                                                session: session
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            className: classnames_default()((Header_module_default()).navItem, "flex flex-col items-center"),
                                            children: [
                                                !(sessionState === null || sessionState === void 0 ? void 0 : sessionState.userid) && /*#__PURE__*/ (0,jsx_runtime.jsx)(PersonOutlineRounded/* default */.Z, {
                                                    className: "cursor-pointer",
                                                    fontSize: "medium",
                                                    sx: {
                                                        color: transparentHeader ? "#ffffff" : "#202020"
                                                    },
                                                    onClick: function() {
                                                        setLoginDialogState({
                                                            state: "signUp",
                                                            opened: true,
                                                            sourcePage: "Header link"
                                                        });
                                                    }
                                                }),
                                                (sessionState === null || sessionState === void 0 ? void 0 : sessionState.userid) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Person/* default */.Z, {
                                                    className: "cursor-pointer",
                                                    fontSize: "medium",
                                                    sx: {
                                                        color: transparentHeader ? "#ffffff" : "#202020"
                                                    },
                                                    onClick: function() {
                                                        if (sessionState === null || sessionState === void 0 ? void 0 : sessionState.userid) {
                                                            document.location = "/profile";
                                                            return;
                                                        } else {
                                                            setLoginDialogState({
                                                                state: "signUp",
                                                                opened: true,
                                                                sourcePage: "Header link"
                                                            });
                                                        }
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "text-xs",
                                                    style: {
                                                        color: transparentHeader ? "#ffffff" : "#202020"
                                                    },
                                                    onClick: function() {
                                                        if (sessionState === null || sessionState === void 0 ? void 0 : sessionState.userid) {
                                                            document.location = "/profile";
                                                            return;
                                                        } else {
                                                            setLoginDialogState({
                                                                state: "signUp",
                                                                opened: true,
                                                                sourcePage: "Header link"
                                                            });
                                                            return;
                                                        }
                                                    },
                                                    children: [
                                                        !(sessionState === null || sessionState === void 0 ? void 0 : sessionState.userid) && "Login",
                                                        (sessionState === null || sessionState === void 0 ? void 0 : sessionState.userid) && "Profile"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: classnames_default()((Header_module_default()).navItem, "px-3"),
                                            children: !sessionLoading && ((ref = HAS_ETG[sessionState === null || sessionState === void 0 ? void 0 : sessionState.country]) === null || ref === void 0 ? void 0 : ref.hasEtg) && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "/booking-support",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    className: classnames_default()((Header_module_default()).loginButton, "text-white font-libre"),
                                                    children: "My Bookings"
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "lg:hidden sm:flex",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileHeader, {
                            transparentHeader: transparentHeader,
                            sessionState: sessionState,
                            menuItems: navigationItems,
                            toggleLoginDialog: function(isOpen) {
                                setLoginDialogState({
                                    state: "signUp",
                                    opened: isOpen,
                                    sourcePage: "Header link"
                                });
                            },
                            loginDialogState: loginDialogState,
                            session: session
                        })
                    })
                ]
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
                open: (loginDialogState === null || loginDialogState === void 0 ? void 0 : loginDialogState.opened) || false,
                onBackdropClick: function() {
                    if ((loginDialogState === null || loginDialogState === void 0 ? void 0 : loginDialogState.state) === "setAiport") {
                        redirectToProfile();
                    }
                    setLoginDialogState(false);
                },
                PaperProps: {
                    style: {
                        borderRadius: 0
                    }
                },
                fullScreen: windowWidth <= 1024,
                fullWidth: false,
                maxWidth: "md",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                        color: "inherit",
                        onClick: function() {
                            if ((loginDialogState === null || loginDialogState === void 0 ? void 0 : loginDialogState.state) === "setAiport") {
                                redirectToProfile();
                            }
                            setLoginDialogState(false);
                        },
                        "aria-label": "close",
                        className: (Header_module_default()).closeDialog,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_intersection_observer_m/* InView */.df, {
                        triggerOnce: true,
                        children: function(param) {
                            var inView = param.inView, ref = param.ref;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                ref: ref,
                                children: inView && /*#__PURE__*/ (0,jsx_runtime.jsx)(Authentication, {
                                    authCompleted: authCompleted,
                                    sourcePage: "Header link"
                                })
                            });
                        }
                    })
                ]
            }),
            userStore && !userStore.userid && googlePromptLoaded && /*#__PURE__*/ (0,jsx_runtime.jsx)(GoogleOneTapAuth/* default */.Z, {
                handleCredentialResponse: function(res) {
                    console.log("GoogleOneTapAuth");
                    var login = function(values, provider) {
                        (0,httpClient/* httpPost */.Ko)("/api/login/".concat(provider), values).then(function(response) {
                            if (response.ok) {
                                response.json().then(function(res) {
                                    if (res.isNewUser) {
                                        // dispatch(setUser({...userStore, isSNAuth: true}));
                                        session(true);
                                    } else {
                                        authCompleted();
                                    }
                                });
                                return;
                            }
                        }).catch(function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(function(error) {
                                var ref, _, _tmp;
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            _ = console.log;
                                            return [
                                                4,
                                                error
                                            ];
                                        case 1:
                                            _tmp = _state.sent().msg;
                                            if (_tmp) return [
                                                3,
                                                3
                                            ];
                                            return [
                                                4,
                                                error
                                            ];
                                        case 2:
                                            _tmp = (ref = _state.sent().reason) === null || ref === void 0 ? void 0 : ref[0].msg;
                                            _state.label = 3;
                                        case 3:
                                            _.apply(console, [
                                                _tmp
                                            ]);
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(error) {
                                return _ref.apply(this, arguments);
                            };
                        }());
                    };
                    login({
                        token: res.credential
                    }, "google");
                }
            }),
            popperOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(UserAirportDropdown_UserAirportDropdown, {
                anchorEl: logoRef.current,
                onClose: handleClose
            })
        ]
    });
};


/***/ }),

/***/ 94740:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ AirlineAutocomplete; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(52875);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68239);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43665);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57144);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(90629);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(22430);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(61903);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(98456);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _utils_httpClient__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22550);
/* harmony import */ var _AirlineAutocomplete_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(40889);
/* harmony import */ var _AirlineAutocomplete_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_AirlineAutocomplete_module_scss__WEBPACK_IMPORTED_MODULE_8__);








var AirlineAutocomplete = function(param) {
    var label = param.label, placeholder = param.placeholder, icon = param.icon, name = param.name, setFieldValue = param.setFieldValue, error = param.error, value = param.value, _primaryColor = param.primaryColor, primaryColor = _primaryColor === void 0 ? "#00454A" : _primaryColor;
    var theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        shape: {
            borderRadius: 12
        },
        palette: {
            primary: {
                main: primaryColor
            }
        },
        typography: {
            fontFamily: '"Libre Franklin", sans-serif'
        }
    });
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), options = ref[0], setOptions = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), open = ref1[0], setOpen = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), loading = ref2[0], setLoading = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (value) {
            setOpen(false);
        }
    }, [
        value
    ]);
    var setInputValue = function(value) {
        setLoading(true);
        (0,_utils_httpClient__WEBPACK_IMPORTED_MODULE_4__/* .httpGet */ .kA)("/api/airline?name=".concat(value)).then(function(response) {
            response.json().then(function(result) {
                if (!(result === null || result === void 0 ? void 0 : result.empty)) {
                    setOptions(result.content);
                }
                setLoading(false);
            });
        });
    };
    var setValue = function(newValue) {
        setFieldValue(name, newValue);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        disablePortal: false,
        value: value || "",
        onChange: function(event, newValue) {
            setValue(newValue);
        },
        isOptionEqualToValue: function(evt) {
            return evt.name;
        },
        open: open,
        onClose: function() {
            setOpen(false);
        },
        filterOptions: function(x) {
            return x;
        },
        onInputChange: (0,_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(event, newInputValue, reason) {
            if (newInputValue.length && reason === "input") {
                setOpen(true);
                setInputValue(newInputValue);
            }
        }, 300),
        PaperComponent: function(param) {
            var children = param.children;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_AirlineAutocomplete_module_scss__WEBPACK_IMPORTED_MODULE_8___default().option), "font-libre"),
                children: children
            });
        },
        options: options,
        onBlur: function() {
            return setOptions([]);
        },
        getOptionLabel: function(option) {
            return option ? "".concat(option.name, " (").concat(option.code, ")") : "";
        },
        freeSolo: true,
        fullWidth: true,
        renderInput: function(params) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                theme: theme,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, params), {
                    error: error,
                    placeholder: placeholder,
                    label: label,
                    InputProps: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, params.InputProps), {
                        startAdornment: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: icon
                        }),
                        endAdornment: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                params.InputProps.endAdornment,
                                loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                    color: "inherit",
                                    size: 20
                                }) : null
                            ]
                        })
                    })
                }))
            });
        }
    });
};


/***/ }),

/***/ 33770:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var loadScript = function(src) {
    return new Promise(function(resolve, reject) {
        // Check if the script is already loaded
        if (document.querySelector('script[src="'.concat(src, '"]'))) {
            return resolve();
        }
        var script = document.createElement("script");
        script.src = src;
        script.async = true;
        script.defer = true;
        script.onload = resolve;
        script.onerror = reject;
        document.body.appendChild(script);
    });
};
var GoogleOneTapAuth = function(param) {
    var handleCredentialResponse = param.handleCredentialResponse;
    var promptDisplayed = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    var scriptLoaded = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var src = "https://accounts.google.com/gsi/client";
        var id = "893428684510-svfcd3kpp6g6h6ukm9ienjutc2hh7tjo.apps.googleusercontent.com";
        if (scriptLoaded.current) {
            return;
        }
        scriptLoaded.current = true;
        loadScript(src).then(function() {
            if (!window.google || !google.accounts) return;
            /*global google*/ google.accounts.id.initialize({
                client_id: id,
                callback: handleCredentialResponse,
                // auto_select: true, // Optional: if you want to automatically sign in returning users
                cancel_on_tap_outside: false // Prevent dismissal when clicking outside the prompt
            });
            // Ensure prompt is displayed only once
            if (!promptDisplayed.current) {
                // setTimeout(() => {
                google.accounts.id.prompt(); // Trigger the One Tap UI
                promptDisplayed.current = true; // Prevent multiple prompts
            // }, 2000);
            }
            // Define the rePromptGoogleOneTap function
            GoogleOneTapAuth.rePromptGoogleOneTap = function() {
                google.accounts.id.cancel(); // Cancel any existing prompt
                google.accounts.id.prompt(); // Show the prompt again
            };
        }).catch(console.error);
        return function() {
            // const scriptTag = document.querySelector(`script[src="${src}"]`);
            // if (scriptTag) document.body.removeChild(scriptTag);
            // if (window.google && google.accounts) {
            //   google.accounts.id.cancel(); // Cancel any outstanding credential requests
            // }
            GoogleOneTapAuth.rePromptGoogleOneTap = null;
        };
    }, [
        handleCredentialResponse
    ]);
    return null;
};
/* harmony default export */ __webpack_exports__["Z"] = (GoogleOneTapAuth);


/***/ }),

/***/ 71186:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ BCBreadcrumbs; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(34727);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52875);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(80969);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69779);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_Breadcrumbs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12963);
/* harmony import */ var _mui_material_Link__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(23795);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(15861);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _mui_icons_material_NavigateNext__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(37958);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90948);















// import { BC } from '../../utils/flightUtils';
// eslint-disable-next-line no-unused-vars
var _defaultGetTextGenerator = function(param, query) {
    return null;
};
var _defaultGetDefaultTextGenerator = function(path) {
    return path;
};
// Pulled out the path part breakdown because its
// going to be used by both `asPath` and `pathname`
var generatePathParts = function(pathStr) {
    var pathWithoutQuery = pathStr.split("?")[0];
    return pathWithoutQuery.split("/").filter(function(v) {
        return v.length > 0;
    });
};
var StyledBreadcrumbs = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Breadcrumbs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props), {
        "aria-label": "breadcrumb"
    }));
})({
    "& .MuiBox-root": {},
    "& .MuiBreadcrumbs-ol": {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        listStyle: "none",
        width: "100%",
        marginTop: "1rem",
        color: "inherit",
        padding: "0 1.25rem"
    },
    "& .MuiBreadcrumbs-li": {
        p: {
            margin: 0,
            marginTop: "2px",
            padding: 0,
            width: "100%",
            color: "#9b9b9b"
        },
        svg: {
            fontSize: "1rem"
        }
    }
});
var BCBreadcrumbs = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _getTextGenerator = param.getTextGenerator, getTextGenerator = _getTextGenerator === void 0 ? _defaultGetTextGenerator : _getTextGenerator, _getDefaultTextGenerator = param.getDefaultTextGenerator, getDefaultTextGenerator = _getDefaultTextGenerator === void 0 ? _defaultGetDefaultTextGenerator : _getDefaultTextGenerator, headerText = param.headerText;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var breadcrumbs = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(function generateBreadcrumbs() {
        var asPathNestedRoutes = generatePathParts(router.asPath);
        // const pathnameNestedRoutes = generatePathParts(router.pathname);
        var crumblist = asPathNestedRoutes.map(function(subpath, idx) {
            // Pull out and convert "[post_id]" into "post_id"
            var _$param = asPathNestedRoutes[idx].replace("[", "").replace("]", "").replace("_", " ").replace("-", " ");
            var href = "/" + asPathNestedRoutes.slice(0, idx + 1).join("/");
            return {
                href: href,
                textGenerator: getTextGenerator(_$param, router.query),
                text: getDefaultTextGenerator(subpath, href)
            };
        });
        return [
            {
                href: "/",
                text: "Home"
            }
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(crumblist));
    }, [
        router.asPath,
        router.pathname,
        router.query,
        getTextGenerator,
        getDefaultTextGenerator
    ]);
    var schemaObject = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": breadcrumbs.map(function(crumb, idx) {
            return {
                "@type": "ListItem",
                "position": idx + 1,
                "item": {
                    "@id": "https://www.first-class.com" + crumb.href,
                    "name": crumb.text
                }
            };
        })
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(schemaObject)
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledBreadcrumbs, {
                className: className,
                separator: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_NavigateNext__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    fontSize: "inherit"
                }),
                children: breadcrumbs.map(function(crumb, idx) {
                    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createElement)(Crumb, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, crumb), {
                        key: idx,
                        last: idx === breadcrumbs.length - 1,
                        headerText: headerText
                    }));
                })
            })
        ]
    });
};
function Crumb(param) {
    var defaultText = param.text, textGenerator = param.textGenerator, href = param.href, _last = param.last, last = _last === void 0 ? false : _last, headerText = param.headerText;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(defaultText), 2), text = ref[0], setText = ref[1];
    // useEffect(async () => {
    //   // If `textGenerator` is nonexistent, then don't do anything
    //   // eslint-disable-next-line no-extra-boolean-cast
    //   if (!Boolean(textGenerator)) { return; }
    //   // Run the text generator and set the text again
    //   const finalText = await textGenerator();
    //   setText(finalText);
    // }, [textGenerator]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var isMounted = true; // To prevent state update after unmount
        var generateText = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function() {
                var finalText, error;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!textGenerator) return [
                                2
                            ];
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                textGenerator()
                            ];
                        case 2:
                            finalText = _state.sent();
                            if (isMounted) {
                                setText(finalText); // Only set text if component is still mounted
                            }
                            return [
                                3,
                                4
                            ];
                        case 3:
                            error = _state.sent();
                            console.error("Error generating text:", error);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function generateText() {
                return _ref.apply(this, arguments);
            };
        }();
        generateText();
        return function() {
            isMounted = false; // Cleanup: component unmounted, prevent setting state
        };
    }, [
        textGenerator
    ]);
    if (last) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
            className: "font-libre text-xs normal-case",
            children: headerText || text
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Link__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
        underline: "hover",
        color: "inherit",
        href: href,
        className: "font-libre text-xs underline capitalize",
        children: text
    });
}


/***/ }),

/***/ 30948:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ BCCarousel; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(52875);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_responsive_carousel_lib_styles_carousel_min_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16703);
/* harmony import */ var react_responsive_carousel_lib_styles_carousel_min_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_responsive_carousel_lib_styles_carousel_min_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(32867);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(72276);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(78262);
/* harmony import */ var _react_hook_window_size__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(61715);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_responsive_carousel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10615);
/* harmony import */ var _mui_icons_material_Close__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(50594);
/* harmony import */ var _assets_arrow_right_svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59994);
/* harmony import */ var _assets_arrow_left_svg__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40160);
/* harmony import */ var _Carousel_module_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(88766);
/* harmony import */ var _Carousel_module_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_Carousel_module_scss__WEBPACK_IMPORTED_MODULE_11__);













var Transition = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.forwardRef(function Transition(props, ref) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        direction: "up",
        ref: ref
    }, props));
});
var BCCarousel = function(param) {
    var props = param.props, children = param.children, interval = param.interval, autoPlay = param.autoPlay, onSlideChange = param.onSlideChange, renderThumbs = param.renderThumbs, selectedItem = param.selectedItem, renderIndicator = param.renderIndicator, _fullHD = param.fullHD, fullHD = _fullHD === void 0 ? true : _fullHD, _thumbWidth = param.thumbWidth, thumbWidth = _thumbWidth === void 0 ? 80 : _thumbWidth, _showThumbs = param.showThumbs, showThumbs = _showThumbs === void 0 ? false : _showThumbs, _infiniteLoop = param.infiniteLoop, infiniteLoop = _infiniteLoop === void 0 ? true : _infiniteLoop, _showIndicators = param.showIndicators, showIndicators = _showIndicators === void 0 ? true : _showIndicators, _disableFullscreen = param.disableFullscreen, disableFullscreen = _disableFullscreen === void 0 ? false : _disableFullscreen, _customArrowPos = param.customArrowPos, customArrowPos = _customArrowPos === void 0 ? {} : _customArrowPos, responsive = param.responsive, _alwaysShowPrevious = param.alwaysShowPrevious, alwaysShowPrevious = _alwaysShowPrevious === void 0 ? false : _alwaysShowPrevious;
    var toggleFullScreen = function toggleFullScreen(index) {
        setFullscreenItemIndex(index);
        setFullscreen(!fullscreen);
    };
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), fullscreen = ref[0], setFullscreen = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0), fullscreenItemIndex = ref1[0], setFullscreenItemIndex = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        position: "absolute",
        zIndex: 2,
        buttonOffset: 20,
        borderRadius: "50%",
        textAlign: "center",
        border: "1px solid #D4A976",
        backgroundColor: "#202020",
        top: "calc(50% - 25px)",
        width: "50px",
        height: "50px",
        lineHeight: "50px",
        cursor: "pointer"
    }), buttonStyles = ref2[0], setButtonStyles = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (Object.keys(customArrowPos).length) {
            setButtonStyles((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, customArrowPos), {
                position: "absolute",
                zIndex: 2,
                borderRadius: "50%",
                textAlign: "center",
                border: "1px solid #D4A976",
                backgroundColor: "#202020",
                top: customArrowPos.top ? customArrowPos.top : customArrowPos.width ? "calc(50% - ".concat(customArrowPos.width / 2, "px)") : "calc(50% - 25px)",
                width: customArrowPos.width || "50px",
                height: customArrowPos.height || "50px",
                lineHeight: "50px",
                cursor: "pointer"
            }));
        }
    }, [
        customArrowPos
    ]);
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0), carouselHeight = ref3[0], setCarouselHeight = ref3[1];
    var width = (0,_react_hook_window_size__WEBPACK_IMPORTED_MODULE_9__/* .useWindowWidth */ .Lm)();
    var carousel = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.createRef)();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (fullHD) {
            setCarouselHeight(carousel.current.offsetWidth / 1.78);
        }
    }, [
        width
    ]);
    var childrenWithProps = react__WEBPACK_IMPORTED_MODULE_2__.Children.map(children, function(child) {
        // Checking isValidElement is the safe way and avoids a typescript
        // error too.
        if (/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.isValidElement(child && child.props.children)) {
            return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.cloneElement(child.props.children, {
                priority: "true",
                objectfit: "contain",
                layout: "fill"
            });
        }
        return child;
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                open: fullscreen && !disableFullscreen,
                fullScreen: true,
                onBackdropClick: toggleFullScreen,
                TransitionComponent: Transition,
                PaperProps: {
                    classes: {
                        root: (_Carousel_module_scss__WEBPACK_IMPORTED_MODULE_11___default().dialogPaper)
                    }
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        color: "inherit",
                        onClick: toggleFullScreen,
                        "aria-label": "close",
                        className: (_Carousel_module_scss__WEBPACK_IMPORTED_MODULE_11___default().closeDialog),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Close__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {})
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_responsive_carousel__WEBPACK_IMPORTED_MODULE_3__/* .Carousel */ .lr, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                        selectedItem: fullscreenItemIndex,
                        showThumbs: showThumbs,
                        showStatus: false,
                        showIndicators: children.length === 1 ? false : showIndicators,
                        infiniteLoop: infiniteLoop,
                        onChange: onSlideChange,
                        preventMovementUntilSwipeScrollTolerance: true,
                        swipeScrollTolerance: 100,
                        autoPlay: autoPlay,
                        interval: interval,
                        thumbWidth: thumbWidth,
                        renderThumbs: renderThumbs,
                        renderIndicator: renderIndicator,
                        className: (_Carousel_module_scss__WEBPACK_IMPORTED_MODULE_11___default().fullscreenCarousel),
                        responsive: responsive
                    }, props), {
                        renderArrowPrev: function(onClickHandler, hasPrev, label) {
                            return (alwaysShowPrevious || hasPrev) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                style: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, buttonStyles), {
                                    left: buttonStyles.buttonOffset
                                }),
                                type: "button",
                                onClick: onClickHandler,
                                title: label,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_arrow_left_svg__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    fontSize: "small",
                                    style: {
                                        marginLeft: 17
                                    }
                                })
                            });
                        },
                        renderArrowNext: function(onClickHandler, hasNext, label) {
                            return hasNext && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                type: "button",
                                onClick: onClickHandler,
                                title: label,
                                style: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, buttonStyles), {
                                    right: buttonStyles.buttonOffset
                                }),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_arrow_right_svg__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    fontSize: "small",
                                    style: {
                                        marginLeft: 20
                                    }
                                })
                            });
                        },
                        children: childrenWithProps
                    }))
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_Carousel_module_scss__WEBPACK_IMPORTED_MODULE_11___default().carouselWrapper),
                style: {
                    height: carouselHeight || "100%",
                    maxHeight: "100%"
                },
                ref: carousel,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_responsive_carousel__WEBPACK_IMPORTED_MODULE_3__/* .Carousel */ .lr, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                    selectedItem: selectedItem || null,
                    showThumbs: showThumbs,
                    showStatus: false,
                    infiniteLoop: infiniteLoop,
                    autoPlay: autoPlay,
                    interval: interval,
                    renderIndicator: renderIndicator,
                    showIndicators: children.length === 1 ? false : showIndicators,
                    onChange: onSlideChange,
                    preventMovementUntilSwipeScrollTolerance: true,
                    swipeScrollTolerance: 100,
                    renderThumbs: renderThumbs,
                    thumbWidth: thumbWidth,
                    sx: {
                        overflow: "visible"
                    },
                    onClickItem: function(index) {
                        return toggleFullScreen(index);
                    }
                }, props), {
                    responsive: responsive,
                    renderArrowPrev: function(onClickHandler, hasPrev, label) {
                        return (alwaysShowPrevious || hasPrev) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                            type: "button",
                            onClick: function(evt) {
                                if (alwaysShowPrevious && !hasPrev) {
                                    evt.stopPropagation();
                                    return;
                                } else {
                                    onClickHandler();
                                }
                            },
                            title: label,
                            style: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, buttonStyles), {
                                left: -buttonStyles.buttonOffset,
                                borderColor: alwaysShowPrevious && !hasPrev ? "grey" : "#D4A976"
                            }),
                            sx: {
                                path: {
                                    stroke: alwaysShowPrevious && !hasPrev ? "grey" : "#D4A976"
                                }
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_arrow_left_svg__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {})
                        });
                    },
                    renderArrowNext: function(onClickHandler, hasNext, label) {
                        return hasNext && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                            type: "button",
                            onClick: onClickHandler,
                            title: label,
                            style: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, buttonStyles), {
                                right: -buttonStyles.buttonOffset
                            }),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_arrow_right_svg__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
                        });
                    },
                    children: children
                }))
            })
        ]
    });
};


/***/ }),

/***/ 70231:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BC": function() { return /* binding */ BC; },
/* harmony export */   "BG": function() { return /* binding */ convertDuration; },
/* harmony export */   "CP": function() { return /* binding */ getCabinClass; },
/* harmony export */   "Ck": function() { return /* binding */ flipAlliances; },
/* harmony export */   "Ff": function() { return /* binding */ normalizeAirSearchResults; },
/* harmony export */   "HG": function() { return /* binding */ payoffs; },
/* harmony export */   "IU": function() { return /* binding */ cabinClasses; },
/* harmony export */   "Qr": function() { return /* binding */ isEmptyObject; },
/* harmony export */   "dv": function() { return /* binding */ additionalCabinMapping; },
/* harmony export */   "pQ": function() { return /* binding */ getSegmentWithImages; },
/* harmony export */   "vE": function() { return /* binding */ getSegmentImages; },
/* harmony export */   "wg": function() { return /* binding */ mapQuery; }
/* harmony export */ });
/* unused harmony exports normalizeAmenities, Alliances */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52875);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69779);



function normalizeAmenities(amenities) {
    // Add bc_type for seat
    if (amenities.seat && amenities.seat.type !== "n/a" && amenities.seat.flatness && amenities.seat.flatness !== "n/a") {
        // Concat type and flatness
        amenities.seat.bc_type = amenities.seat.type + "," + amenities.seat.flatness;
    }
    // Add bc_type for aircraft
    if (amenities.aircraft && amenities.aircraft.model !== "n/a" && amenities.aircraft.type !== "n/a") {
        // Concat model and type
        amenities.aircraft.bc_type = amenities.aircraft.model + "," + amenities.aircraft.type;
    }
    // Add bc_type for wifi
    if (amenities.wifi != null) {
        if (amenities.wifi.exists === "no") {
            amenities.wifi.bc_type = "not available";
        } else if (amenities.wifi.cost !== "n/a" && amenities.wifi.performance !== "n/a") {
            // Concat cost and performance
            amenities.wifi.bc_type = amenities.wifi.cost + "," + amenities.wifi.performance;
        }
    }
    // Add bc_type for power
    if (amenities.power != null) {
        if (amenities.power.exists === "no") {
            amenities.power.bc_type = "not available";
        } else if (amenities.power.cost !== "n/a" && amenities.power.usb_port !== "n/a" && amenities.power.power_outlet !== "n/a") {
            // Concat cost, usb and outlet
            amenities.power.bc_type = amenities.power.cost + ",usb_" + amenities.power.usb_port + ",outlet_" + amenities.power.usb_port;
        }
    }
    // Add bc_type for fresh_food
    if (amenities.fresh_food != null) {
        if (amenities.fresh_food.exists === "no") {
            amenities.fresh_food.bc_type = "not available";
        } else if (amenities.fresh_food.cost !== "n/a" && amenities.fresh_food.type !== "n/a") {
            // Concat cost and type
            amenities.fresh_food.bc_type = amenities.fresh_food.cost + "," + amenities.fresh_food.type;
        }
    }
    // Add bc_type for entertainment
    if (amenities.entertainment != null) {
        if (amenities.entertainment.exists === "no") {
            amenities.entertainment.bc_type = "not available";
        } else if (amenities.entertainment.cost !== "n/a" && amenities.entertainment.type !== "n/a") {
            // Concat cost and type
            amenities.entertainment.bc_type = amenities.entertainment.cost + "," + amenities.entertainment.type;
        }
    }
    return amenities;
}
var Alliances = {
    NO_ALLIANCE: {
        id: "No Alliance"
    },
    ALL: {
        id: "All Airlines"
    }
};
var normalizeAirSearchResults = function(classTag, data, alliances) {
    var seatTypes = new Set();
    var seatFlatness = new Set();
    var flightsAlliances = {};
    // let bestPriceFlight = null;
    // let bestDurationFlight = null;
    // let bestScoreFlight = null;
    // let bestValueForMoneyFlight = null;
    var flights = [];
    var airportsList = [];
    var lookedFrom = {};
    var lookedTo = {};
    if (!data.BC_Amenities) data.BC_Amenities = {};
    if (data.airlines) {
        Object.keys(data.airlines).forEach(function(Iata) {
            var ref, ref1, ref2;
            return ((ref = data.BC_Airlines) === null || ref === void 0 ? void 0 : ref[Iata]) ? data.BC_Airlines[Iata] = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, data.BC_Airlines[Iata]), {
                BC_Images: data.BC_Airlines[Iata] ? (ref1 = data.BC_Airlines[Iata]) === null || ref1 === void 0 ? void 0 : ref1.BC_Images : [],
                Iata: Iata,
                Name: data.airlines[Iata],
                Logo: ((ref2 = data.airlineLogos[Iata]) === null || ref2 === void 0 ? void 0 : ref2.startsWith("http")) ? data.airlineLogos[Iata] : "https://kayak.co.uk" + data.airlineLogos[Iata]
            }) : function() {
                console.warn(Iata, "Airline is missing");
            }();
        });
    }
    if (data.tripset && data.tripset.length > 0) {
        data.tripset.forEach(function(flight) {
            if (flight.lowTotal <= 0) return;
            flight.providers = flight.providers.filter(function(p) {
                return p.totalPrice > 0;
            });
            if (flight.providers.length === 0) return;
            flight.providers.forEach(function(p) {
                return p.mixedClass = p.faringInfo && p.faringInfo.legInfo.map(function(param) {
                    var segmentInfo = param.segmentInfo;
                    return segmentInfo.map(function(param) {
                        var cabinClass = param.cabinClass;
                        return cabinClass;
                    });
                }).reduce(function(acc, v) {
                    return acc.concat(v);
                }, []).filter(function(v, i, acc) {
                    return i > 0 && v !== acc[0];
                }).length > 0;
            });
            flight.BC_Flight = {};
            flight.BC_Amenities = [];
            var correct = {
                B: "BIZ",
                E: "ECO",
                F: "FST",
                P: "FLX"
            };
            flight.legs.forEach(function(leg, idx) {
                var codeShares = flight.codeShares[idx];
                leg.segmentsData = leg.segments.map(function(segmentId, segmentIndex) {
                    var segmentData = data.segset[segmentId];
                    data.BC_Amenities[segmentId] = {
                        BIZ: {
                            aircraft: {
                                model: segmentData.equipmentType,
                                type: segmentData.equipmentCategory
                            }
                        },
                        ECO: {
                            aircraft: {
                                model: segmentData.equipmentType,
                                type: segmentData.equipmentCategory
                            }
                        },
                        FLX: {
                            aircraft: {
                                model: segmentData.equipmentType,
                                type: segmentData.equipmentCategory
                            }
                        },
                        FST: {
                            aircraft: {
                                model: segmentData.equipmentType,
                                type: segmentData.equipmentCategory
                            }
                        }
                    };
                    var segmentCodeShares = codeShares.legSegments[segmentIndex];
                    segmentData.isCShare = segmentCodeShares.isCShare || 0;
                    if (segmentData.isCShare) {
                        segmentData.dname = segmentCodeShares.dName || "UNKNOWN OPERATING AIRLINE";
                        segmentData.opCode = segmentCodeShares.opAirCode;
                    }
                    if (!segmentData) {
                        console.log("WARNING, no segment data for", flight, segmentId);
                        return;
                    } else {
                    // console.log('Segment data exists', segment);
                    }
                    segmentData.segmentId = segmentId;
                    if (segmentData.quicketData) segmentData.quicketData.plane = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, segmentData.quicketData.plane), {
                        kayakModel: segmentData.equipmentType,
                        kayakCategory: [
                            segmentData.equipmentCategory.split("_").join(" "), 
                        ].map(function(s) {
                            return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
                        })
                    });
                    if (!segmentData.BC_Amenities) segmentData.BC_Amenities = {};
                    var amenities = data.BC_Amenities[segmentId];
                    var correctClassTag = correct[data.segset[segmentId].cabinClass];
                    if (amenities && amenities[correctClassTag]) {
                        var classAmenities = amenities[correctClassTag];
                        segmentData.BC_Amenities = normalizeAmenities(classAmenities);
                    }
                    flight.class = correctClassTag;
                    if (!data.BC_Airlines[segmentData.airlineCode]) {
                        data.BC_Airlines[segmentData.airlineCode] = {};
                    }
                    if (!segmentData.airlineCode) {
                        console.log("WARNING, wrong airlineCode '" + segmentData.airlineCode + "'", flight, segmentId);
                        return;
                    }
                    var airline = segmentData.BC_Airline = data.BC_Airlines[segmentData.airlineCode];
                    var operatingAirline = data.BC_Airlines[segmentData.opCode];
                    segmentData.BC_OperatingAirline = operatingAirline;
                    var alliance = segmentData.BC_Airline.alliance = alliances === null || alliances === void 0 ? void 0 : alliances[segmentData.airlineCode];
                    if (alliance) {
                        if (!flightsAlliances[alliance]) {
                            flightsAlliances[alliance] = {
                                Name: alliance,
                                Airlines: {}
                            };
                        }
                        flightsAlliances[alliance].Airlines[airline.Iata] = airline;
                    } else {
                        if (!flightsAlliances[Alliances.NO_ALLIANCE.id]) {
                            flightsAlliances[Alliances.NO_ALLIANCE.id] = {
                                Name: Alliances.NO_ALLIANCE.id,
                                Airlines: {}
                            };
                        }
                        flightsAlliances[Alliances.NO_ALLIANCE.id].Airlines[airline.Iata] = airline;
                    }
                    segmentData.originAirport = data.airportDetails[segmentData.originCode];
                    segmentData.destinationAirport = data.airportDetails[segmentData.destinationCode];
                    if (!segmentData.originAirport || !segmentData.destinationAirport) {
                        console.log("WARNING, no airport for", flight, segmentId);
                    }
                    return segmentData;
                });
            });
            flight.legs.forEach(function(leg) {
                if (leg.segmentsData && leg.segmentsData.length > 0) {
                    var ref, ref1, ref2, ref3;
                    var firstSegment = leg.segmentsData[0];
                    var lastSegment = leg.segmentsData[leg.segmentsData.length - 1];
                    airportsList = airportsList.concat([
                        {
                            code: firstSegment.originCode,
                            name: (ref = firstSegment.originAirport) === null || ref === void 0 ? void 0 : ref.name,
                            city: (ref1 = firstSegment.originAirport) === null || ref1 === void 0 ? void 0 : ref1.city
                        },
                        {
                            code: lastSegment.destinationCode,
                            name: (ref2 = lastSegment.destinationAirport) === null || ref2 === void 0 ? void 0 : ref2.name,
                            city: (ref3 = firstSegment.destinationAirport) === null || ref3 === void 0 ? void 0 : ref3.city
                        }, 
                    ].filter(function(a) {
                        return !airportsList.find(function(al) {
                            return al.code === a.code;
                        });
                    }));
                    if (!lookedFrom[firstSegment.originCode]) {
                        lookedFrom[firstSegment.originCode] = 1;
                    } else {
                        lookedFrom[firstSegment.originCode]++;
                    }
                    if (!lookedTo[lastSegment.destinationCode]) {
                        lookedTo[lastSegment.destinationCode] = 1;
                    } else {
                        lookedTo[lastSegment.destinationCode]++;
                    }
                }
            });
            flight.providers.forEach(function(provider) {
                var isWrongDetailsCabinClass = provider.faringInfo && !provider.faringInfo.legInfo.every(function(leg, legIndex) {
                    return leg.segmentInfo.every(function(segment, segmentIndex) {
                        return segment.cabinClass === flight.legs[legIndex].segmentsData[segmentIndex].cabinClass;
                    });
                });
                provider.isWrongDetailsCabinClass = isWrongDetailsCabinClass;
            });
            flight.valueForMoneyScore = flight.BC_Score / flight.lowTotal;
            // This logic was moved to backend
            // if (
            //   !bestPriceFlight &&
            //   !bestDurationFlight &&
            //   !bestScoreFlight &&
            //   !bestValueForMoneyFlight
            // ) {
            //   bestPriceFlight = flight;
            //   bestDurationFlight = flight;
            //   bestScoreFlight = flight;
            //   bestValueForMoneyFlight = flight;
            // }
            // if (flight.lowTotal < bestPriceFlight.lowTotal) {
            //   bestPriceFlight = flight;
            // }
            // if (flight.duration < bestDurationFlight.duration) {
            //   bestDurationFlight = flight;
            // }
            // if (flight.BC_Score > bestScoreFlight.BC_Score) {
            //   bestScoreFlight = flight;
            // }
            // if (
            //   flight.valueForMoneyScore > bestValueForMoneyFlight.valueForMoneyScore
            // ) {
            //   bestValueForMoneyFlight = flight;
            // }
            flights.push(flight);
        });
    // if (bestPriceFlight) bestPriceFlight.isBestPrice = true;
    // if (bestDurationFlight) bestDurationFlight.isBestDuration = true;
    // if (bestScoreFlight) bestScoreFlight.isBestScore = true;
    // if (bestValueForMoneyFlight)
    //   bestValueForMoneyFlight.isBestValueForMoney = true;
    // console.timeEnd("Profile data normalizing");
    }
    airportsList.forEach(function(item) {
        item.total = lookedFrom[item.code] + lookedTo[item.code];
    });
    flightsAlliances[Alliances.ALL.id] = createAllAlliance(flightsAlliances);
    return {
        airlines: data.BC_Airlines ? Object.values(data.BC_Airlines) : [],
        airports: data.airports || {},
        airportsList: airportsList,
        alliances: flightsAlliances,
        alliancesArray: convertAlliancesToArray(flightsAlliances),
        seatTypes: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(seatTypes),
        seatFlatness: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(seatFlatness),
        flights: flights,
        // bestDurationFlight: bestDurationFlight,
        sponsoredCampaign: data.sponsoredCampaign,
        pageable: data.pageable
    };
};
function createAllAlliance(alliances) {
    return {
        Name: Alliances.ALL.id,
        Airlines: Object.values(alliances).reduce(function(allAirlines, alliance) {
            return Object.assign(allAirlines, alliance.Airlines);
        }, {})
    };
}
function flipAlliances(alliances) {
    var airportAlliances = {};
    alliances.forEach(function(alliance) {
        alliance.airlines.forEach(function(airline) {
            airportAlliances[airline.code] = alliance.name;
        });
    });
    return airportAlliances;
}
function convertAlliancesToArray(alliances) {
    return Object.keys(alliances).map(function(allianceName) {
        return {
            Name: allianceName,
            Airlines: Object.values(alliances[allianceName].Airlines).filter(function(a) {
                return !!a.Iata;
            }).sort(function(a, b) {
                if (a.Name < b.Name) return -1;
                if (a.Name > b.Name) return 1;
                return 0;
            })
        };
    });
}
var mapQuery = function(queryState) {
    switch(queryState.tripState){
        case "round_trip":
            var ref;
            return {
                from: queryState.segments[0].origin,
                exactFrom: queryState.segments[0].exactAirport === "true",
                to: queryState.segments[1].origin,
                exactTo: queryState.segments[1].exactAirport === "true",
                tripState: queryState.tripState,
                cabinClass: queryState.cabinClass,
                dateRange: {
                    departure: queryState.segments[0].departure,
                    return: queryState.segments[1].departure
                },
                stops: queryState.stops,
                departure: null,
                airlineType: "all",
                passengers: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                    adults: queryState.adults
                }, ((ref = queryState.children) === null || ref === void 0 ? void 0 : ref.length) && {
                    children: queryState.children
                }),
                multi_city: [
                    {
                        from: null,
                        to: null,
                        departure: null,
                        airlineType: "all"
                    }, 
                ]
            };
        case "one_way":
            var ref1;
            return {
                from: queryState.segments[0].origin,
                exactFrom: queryState.segments[0].exactFrom === "true",
                to: queryState.segments[0].destination,
                exactTo: queryState.segments[0].exactTo === "true",
                tripState: queryState.tripState,
                cabinClass: queryState.cabinClass,
                dateRange: {
                    departure: null,
                    return: null
                },
                stops: queryState.stops,
                departure: queryState.segments[0].departure,
                airlineType: "all",
                passengers: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                    adults: queryState.adults
                }, ((ref1 = queryState.children) === null || ref1 === void 0 ? void 0 : ref1.length) && {
                    children: queryState.children
                }),
                multi_city: [
                    {
                        from: null,
                        to: null,
                        departure: null,
                        airlineType: "all"
                    }, 
                ]
            };
        case "multi_city":
            var ref2;
            return {
                from: null,
                to: null,
                tripState: queryState.tripState,
                cabinClass: queryState.cabinClass,
                dateRange: {
                    departure: null,
                    return: null
                },
                stops: queryState.stops,
                departure: null,
                airlineType: "all",
                passengers: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                    adults: queryState.adults
                }, ((ref2 = queryState.children) === null || ref2 === void 0 ? void 0 : ref2.length) && {
                    children: queryState.children
                }),
                multi_city: queryState.segments.map(function(segment, i) {
                    return {
                        from: segment.origin,
                        to: segment.destination,
                        departure: segment.departure,
                        airlineType: "all",
                        exactFrom: queryState.segments[i].exactFrom === "true",
                        exactTo: queryState.segments[i].exactTo === "true"
                    };
                })
            };
    }
};
var cabinClasses = {
    ECO: {
        name: "Economy",
        code: "ECO",
        coefficient: 1
    },
    FLX: {
        name: "Premium Economy",
        code: "FLX",
        coefficient: 2
    },
    BIZ: {
        name: "Business Class",
        code: "BIZ",
        coefficient: 3
    },
    FST: {
        name: "First Class",
        code: "FST",
        coefficient: 4
    }
};
// Used to define the additional cabin class search to start align with the current cabin class selected by user
var additionalCabinMapping = {
    ECO: "FLX",
    FLX: "BIZ",
    BIZ: "FLX",
    FST: "BIZ"
};
var payoffs = {
    general: [
        "Please wait..."
    ],
    flight: [
        "Please wait...",
        "Comparing prices on all airlines.",
        "Identifying the best quality flights.",
        "Fetching info on aircraft, seats, photos and much more.", 
    ]
};
function getSegmentImages(segment, classTag) {
    var airline = segment.isCShare && segment.duration > 180 ? segment.BC_OperatingAirline : segment.BC_Airline;
    var model = segment.equipmentType;
    var commonImages = [];
    if ((airline === null || airline === void 0 ? void 0 : airline.BC_Images) && airline.BC_Images[classTag] && airline.BC_Images[classTag]["*"]) {
        var _commonImages;
        (_commonImages = commonImages).push.apply(_commonImages, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(airline.BC_Images[classTag]["*"]));
    }
    if (!(model && (airline === null || airline === void 0 ? void 0 : airline.BC_Images) && (airline === null || airline === void 0 ? void 0 : airline.BC_Images[classTag]))) return commonImages;
    var allImages = commonImages.concat(airline.BC_Images[classTag][model] || []);
    var images = allImages.map(function(i) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, i), {
            airline: airline,
            number: segment.flightNumber,
            airports: [
                segment.originCode,
                segment.destinationCode
            ]
        });
    }) || [];
    return images;
}
function getSegmentWithImages(flight, classTag) {
    return flight.legs.map(function(l) {
        return l.segmentsData;
    }).flat().filter(function(v) {
        return getSegmentImages(v, classTag).length > 0;
    }).sort(function(a, b) {
        return b.duration - a.duration;
    })[0];
}
function isEmptyObject(obj) {
    return Object.keys(obj).length === 0;
}
function convertDuration(duration) {
    var hours = Math.floor(duration / 60);
    var minutes = duration - hours * 60;
    return {
        hours: hours,
        minutes: minutes
    };
}
var BC = {
    loc: function(str) {
        return str;
    }
};
var getCabinClass = function(cabinClass, isMobile) {
    if (!cabinClass) {
        return "";
    }
    switch(cabinClass.toLowerCase()){
        case "b":
        case "biz":
            if (isMobile) {
                return "Business";
            } else {
                return "Business Class";
            }
        case "f":
        case "fst":
            if (isMobile) {
                return "First";
            } else {
                return "First Class";
            }
        case "e":
        case "eco":
            if (isMobile) {
                return "Economy";
            } else {
                return "Economy Class";
            }
        case "p":
        case "flx":
            if (isMobile) {
                return "Premium";
            } else {
                return "Premium Economy";
            }
    }
};


/***/ }),

/***/ 17518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ BookNow; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _BookNow_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85031);
/* harmony import */ var _BookNow_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_BookNow_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69417);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);




var BookNow = function(param) {
    var hotelName = param.hotelName, link = param.link;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_BookNow_module_scss__WEBPACK_IMPORTED_MODULE_2___default().bookNowWrapper),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_BookNow_module_scss__WEBPACK_IMPORTED_MODULE_2___default().bookNowHotelName), "font-garamond"),
                children: hotelName
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                color: "primary",
                variant: "contained",
                type: "button",
                href: link,
                target: "_blank",
                sx: {
                    color: "#ffffff",
                    background: "#7E183D",
                    textTransform: "unset",
                    fontSize: "15px",
                    lineHeight: "24px",
                    width: "50%",
                    margin: "auto",
                    "&:hover": {
                        color: "#ffffff",
                        background: "#7E183D"
                    }
                },
                children: "Book Now"
            })
        ]
    });
};


/***/ }),

/***/ 8496:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "n": function() { return /* binding */ HotelSearchAutocomplete; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(52875);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/createTheme.js + 13 modules
var createTheme = __webpack_require__(68239);
// EXTERNAL MODULE: ./node_modules/@mui/material/Autocomplete/Autocomplete.js + 8 modules
var Autocomplete = __webpack_require__(43665);
// EXTERNAL MODULE: ./node_modules/@mui/material/Paper/Paper.js + 2 modules
var Paper = __webpack_require__(90629);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/ThemeProvider.js + 5 modules
var ThemeProvider = __webpack_require__(22430);
// EXTERNAL MODULE: ./node_modules/@mui/material/TextField/TextField.js + 3 modules
var TextField = __webpack_require__(61903);
// EXTERNAL MODULE: ./node_modules/@mui/material/CircularProgress/CircularProgress.js + 1 modules
var CircularProgress = __webpack_require__(98456);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/HotelSearch/HotelSearchAutocomplete/HotelSearchAutocomplete.module.scss
var HotelSearchAutocomplete_module = __webpack_require__(69362);
var HotelSearchAutocomplete_module_default = /*#__PURE__*/__webpack_require__.n(HotelSearchAutocomplete_module);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./utils/store/features/hotelAutocompleteCacheSlice.js
var hotelAutocompleteCacheSlice = __webpack_require__(48059);
// EXTERNAL MODULE: ./utils/httpClient.js
var httpClient = __webpack_require__(22550);
;// CONCATENATED MODULE: ./components/api/hotel/autocomplete.js


/**
 * @typedef {Object} DisplayPlaceType
 * @property {string} [displayName]
 * @property {string} [type]
 */ /**
 * Place item returned by hotel autocomplete API
 * @typedef {Object} HotelPlace
 * @property {string} [cityName]
 * @property {string} [countryName]
 * @property {DisplayPlaceType} [displayPlaceType]
 * @property {string} [fullName]
 * @property {string} [iataCode] // present for airports in mixed results
 * @property {boolean} [isMetro]
 * @property {number} [placeId]
 * @property {string} [primaryPlaceType]    {'city'|'airport'|'country'|'hotel'|'village'}
 * @property {string} [regionName]
 * @property {string} [Iata]
 * @property {string} [Name]
 * @property {string} [city]
 */ /**
 * Fetch places for the Hotel Search autocomplete.
 *
 * @param {string} value
 * @returns {Promise<HotelPlace[]>}
*/ var getHotelsAutocomplete = function(value) {
    if (!value) {
        return Promise.resolve([]);
    }
    return (0,httpClient/* httpGet */.kA)("/api/hotel/autocomplete?search=".concat(value)).then(function(response) {
        if (!response.ok) {
            return []; // req failed
        }
        return response.json();
    }).then(function(result) {
        if (!result) {
            // empty response
            return [];
        }
        return result.results.map(mapAutocompleteResults);
        ;
    });
};
var mapAutocompleteResults = function(hotel) {
    return (0,_object_spread/* default */.Z)({
        cc: hotel.countryCode,
        n: hotel.name,
        t: hotel.primaryPlaceType,
        p: hotel.places,
        k: hotel.entityKey
    }, hotel);
};

;// CONCATENATED MODULE: ./components/HotelSearch/HotelSearchAutocomplete/HotelSearchAutocomplete.jsx










var HotelSearchAutocomplete = function(param) {
    var label = param.label, placeholder = param.placeholder, icon = param.icon, name = param.name, setFieldValue = param.setFieldValue, showOnly = param.showOnly, error = param.error, value = param.value, _primaryColor = param.primaryColor, primaryColor = _primaryColor === void 0 ? "#00454A" : _primaryColor;
    var theme = (0,createTheme/* default */.Z)({
        shape: {
            borderRadius: 12
        },
        palette: {
            primary: {
                main: primaryColor
            }
        },
        typography: {
            fontFamily: '"Libre Franklin", sans-serif'
        }
    });
    var ref = (0,react.useState)([]), hotelCombinedOptions = ref[0], setHotelCombinedOptions = ref[1];
    var ref1 = (0,react.useState)(false), open = ref1[0], setOpen = ref1[1];
    var ref2 = (0,react.useState)(false), loading = ref2[0], setLoading = ref2[1];
    var hotelAutocompleteCacheStore = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return (ref = state.hotelAutocompleteCache) === null || ref === void 0 ? void 0 : ref.value;
    });
    var dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(function() {
        if (value) {
            setOpen(false);
        }
    }, [
        value
    ]);
    var setInputValue = function(val) {
        setLoading(true);
        if (hotelAutocompleteCacheStore[val]) {
            setHotelCombinedOptions(hotelAutocompleteCacheStore[val]);
            setLoading(false);
        } else {
            getHotelsAutocomplete(val).then(function(result) {
                if (result.length) {
                    var filteredRU = [];
                    if (!showOnly) {
                        filteredRU = result.filter(function(result) {
                            return result.cc && result.cc.toUpperCase() !== "RU";
                        });
                    // .filter((res) => res.t === 'hotels' || res.s);
                    }
                    if (showOnly) {
                        filteredRU = result.filter(function(result) {
                            return result.cc && result.cc.toUpperCase() !== "RU";
                        }).filter(function(result) {
                            return showOnly.indexOf(result.t) !== -1;
                        });
                    }
                    setHotelCombinedOptions(filteredRU);
                    dispatch((0,hotelAutocompleteCacheSlice/* setAutocompleteCache */.t9)({
                        key: val,
                        value: filteredRU
                    }));
                }
                setLoading(false);
            });
        }
    };
    var setValue = function(newValue) {
        setFieldValue(name, newValue);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Autocomplete/* default */.Z, {
        disablePortal: false,
        value: value || "",
        onChange: function(event, newValue) {
            setValue(newValue);
        },
        isOptionEqualToValue: function(evt) {
            return evt.n;
        },
        open: open,
        onClose: function() {
            setOpen(false);
        },
        filterOptions: function(x) {
            return x;
        },
        onInputChange: function(event, newInputValue) {
            if (newInputValue.length >= 3) {
                setOpen(true);
                setInputValue(newInputValue);
            }
        },
        PaperComponent: function(param) {
            var children = param.children;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper/* default */.Z, {
                className: classnames_default()((HotelSearchAutocomplete_module_default()).option, "font-libre"),
                children: children
            });
        },
        options: hotelCombinedOptions,
        groupBy: function(option) {
            return option === null || option === void 0 ? void 0 : option.t;
        },
        onBlur: function() {
            return setHotelCombinedOptions([]);
        },
        getOptionLabel: function(option) {
            var ref, ref1;
            return option ? "".concat(option.n).concat(((ref = option.p) === null || ref === void 0 ? void 0 : ref.length) ? ", " + ((ref1 = option.p) === null || ref1 === void 0 ? void 0 : ref1.join(", ")) : "") : "";
        },
        fullWidth: true,
        freeSolo: true,
        renderInput: function(params) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeProvider/* default */.Z, {
                theme: theme,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params), {
                    error: error,
                    placeholder: placeholder,
                    label: label,
                    InputProps: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params.InputProps), {
                        startAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: icon
                        }),
                        endAdornment: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                params.InputProps.endAdornment,
                                loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                                    color: "inherit",
                                    size: 20
                                }) : null
                            ]
                        })
                    })
                }))
            });
        }
    });
};


/***/ }),

/***/ 74284:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ ImageWithFallback; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6453);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52875);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);






var ImageWithFallback = function(props) {
    var rest = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), fallbackState = ref[0], setFallbackState = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setFallbackState(false);
    }, [
        props
    ]);
    return fallbackState ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                src: "/images/bcbackground.webp",
                objectFit: "cover",
                layout: "fill"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                src: "/logo_vertical.webp",
                objectFit: "contain",
                layout: "fill",
                className: "p-4"
            })
        ]
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, rest), {
        blurDataURL: "/images/bcbackground.webp",
        onError: function() {
            setFallbackState(true);
        }
    }));
};


/***/ }),

/***/ 74079:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ ReviewItem; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52875);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _react_hook_window_size__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61715);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _utils_setImageUrl__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(22670);
/* harmony import */ var _ImageWithFallback_ImageWithFallback__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74284);
/* harmony import */ var _RatingBadge_RatingBadge__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92944);
/* harmony import */ var _StarRating_StarRating__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97946);
/* harmony import */ var _Lists_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(11013);
/* harmony import */ var _Lists_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_Lists_module_scss__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);











var ReviewItem = function(param) {
    var review = param.review, url = param.url, type = param.type, starRating = param.starRating, props = param.props;
    var ref;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), imageHeight = ref1[0], setImageHeight = ref1[1];
    var width = (0,_react_hook_window_size__WEBPACK_IMPORTED_MODULE_6__/* .useWindowWidth */ .Lm)();
    var image = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createRef)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setImageHeight(image.current.offsetWidth / 1.78);
    }, [
        width
    ]);
    var badgeType;
    switch(review.type){
        case "FULL":
            badgeType = "badge-tested";
            break;
        case "VERIFIED":
            badgeType = "badge-verified-check";
            break;
        default:
            badgeType = "badge-tested";
            break;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        className: (_Lists_module_scss__WEBPACK_IMPORTED_MODULE_9___default().a),
        href: url
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_5___default()((_Lists_module_scss__WEBPACK_IMPORTED_MODULE_9___default().reviewContainer), "font-libre"),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_Lists_module_scss__WEBPACK_IMPORTED_MODULE_9___default().reviewContentContainer),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_5___default()((_Lists_module_scss__WEBPACK_IMPORTED_MODULE_9___default().header), "font-libre"),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                className: "inline-block mr-4",
                                children: [
                                    type,
                                    " review"
                                ]
                            }),
                            starRating && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_StarRating_StarRating__WEBPACK_IMPORTED_MODULE_4__/* .StarRating */ .Z, {
                                    small: true,
                                    rating: review.rating || review.stars * 2,
                                    hideTextRating: true
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_5___default()((_Lists_module_scss__WEBPACK_IMPORTED_MODULE_9___default().ratingBadge), "ml-auto"),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "full-review",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_RatingBadge_RatingBadge__WEBPACK_IMPORTED_MODULE_3__/* .RatingBadge */ .H, {
                                    version: badgeType
                                }),
                                badgeType !== "badge-verified-check" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "font-fragment",
                                    children: review.rating || review.score
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_5___default()((_Lists_module_scss__WEBPACK_IMPORTED_MODULE_9___default().reviewTitle), "font-fragment"),
                        children: [
                            review.title,
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                            review.cabinClass
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_5___default()((_Lists_module_scss__WEBPACK_IMPORTED_MODULE_9___default().reviewImage)),
                        style: {
                            height: imageHeight
                        },
                        ref: image,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ImageWithFallback_ImageWithFallback__WEBPACK_IMPORTED_MODULE_2__/* .ImageWithFallback */ .J, {
                            src: ((ref = review.image) === null || ref === void 0 ? void 0 : ref.includes("https")) ? review.image : (0,_utils_setImageUrl__WEBPACK_IMPORTED_MODULE_10__/* .setImageUrl */ .B)(review.image),
                            layout: "fill",
                            objectFit: "cover",
                            alt: review.title + " image",
                            sizes: "(max-width: 1024px) 100vw, 520px"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_5___default()((_Lists_module_scss__WEBPACK_IMPORTED_MODULE_9___default().reviewContent)),
                        dangerouslySetInnerHTML: {
                            __html: review.content
                        }
                    })
                ]
            })
        })
    }));
};


/***/ }),

/***/ 92944:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* binding */ RatingBadge; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./public/badge-tested.svg
var _defs, _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgBadgeTested(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    id: "badge-tested_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 182 182"
  }, props), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("style", null, ".badge-tested_svg__cls-1{fill:#b29e87;stroke-width:0}"))), _path || (_path = /*#__PURE__*/react.createElement("path", {
    className: "badge-tested_svg__cls-1",
    d: "M91 0C40.82 0 0 40.82 0 91s40.82 91 91 91 91-40.82 91-91S141.18 0 91 0zm0 178.66c-48.34 0-87.66-39.32-87.66-87.66S42.66 3.34 91 3.34 178.66 42.66 178.66 91 139.34 178.66 91 178.66z"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    className: "badge-tested_svg__cls-1",
    d: "M91 31.72c-32.69 0-59.28 26.59-59.28 59.28S58.31 150.28 91 150.28s59.28-26.59 59.28-59.28S123.69 31.72 91 31.72zm0 115.22c-30.84 0-55.94-25.09-55.94-55.94S60.15 35.06 91 35.06 146.94 60.15 146.94 91 121.85 146.94 91 146.94zM15.98 63.15l1.78.55-1.74 5.65 3.93 1.21 1.36-4.4 1.78.55-1.35 4.41 5.82 1.79-.67 2.18L13.58 71l2.41-7.83zM18.2 58.07l12.77 5.56-.91 2.09-12.77-5.56.91-2.09zM35.68 54.99l-6.42-.12-.9 1.49 4.77 2.87-1.18 1.96-11.93-7.18 2.48-4.12c.55-.92 1.18-1.59 1.88-2.04.7-.44 1.42-.66 2.15-.65.73 0 1.42.21 2.09.61.78.47 1.35 1.12 1.71 1.95s.38 1.79.04 2.87l6.72.02-1.41 2.33zm-8.88.43l1.3-2.16c.44-.73.59-1.39.45-1.99-.14-.59-.52-1.07-1.14-1.45-.62-.37-1.21-.48-1.78-.32s-1.08.61-1.53 1.35l-1.3 2.16 4 2.41zM39.82 48.77c-.74.34-1.48.47-2.21.39-.73-.08-1.4-.39-2-.92l1.63-1.83c.48.36 1.01.51 1.58.46s1.11-.37 1.61-.94c.52-.59.79-1.17.8-1.76 0-.58-.21-1.07-.66-1.47-.35-.31-.72-.46-1.13-.45s-.8.11-1.19.31c-.39.2-.9.5-1.51.92-.78.52-1.46.91-2.02 1.17-.56.26-1.17.37-1.83.32-.66-.05-1.31-.36-1.96-.94-.6-.53-.99-1.15-1.17-1.85s-.15-1.42.09-2.18.68-1.48 1.31-2.19c.9-1.01 1.88-1.61 2.96-1.8 1.08-.19 2.09.06 3.03.78l-1.68 1.88c-.41-.31-.89-.42-1.45-.33-.56.09-1.08.4-1.56.94-.44.49-.67 1-.69 1.53s.2 1.01.66 1.42c.32.28.67.42 1.04.41.38-.01.76-.11 1.15-.31.39-.19.88-.49 1.48-.88.8-.52 1.49-.91 2.07-1.18.58-.27 1.2-.37 1.86-.33.67.05 1.33.36 1.98.95.53.47.9 1.06 1.12 1.76.22.7.22 1.45.02 2.25s-.63 1.56-1.29 2.3c-.62.7-1.3 1.22-2.05 1.56zM45.31 25.29l1.16 1.46-2.91 2.3 7.48 9.46-1.79 1.42-7.48-9.46-2.92 2.31-1.16-1.46 7.62-6.02zM59.3 23.8l.92 1.69-7.24 3.93-.92-1.69 7.24-3.93zM63.36 19.27c.3-1.22.88-2.27 1.76-3.17.87-.89 1.93-1.52 3.17-1.89 1.42-.42 2.79-.45 4.1-.08 1.32.37 2.41 1.12 3.29 2.25l-2.63.78c-.55-.6-1.19-.98-1.91-1.15-.72-.16-1.48-.12-2.29.11-.88.26-1.61.7-2.19 1.3-.57.6-.95 1.33-1.12 2.19s-.11 1.78.18 2.77.74 1.79 1.36 2.42c.61.63 1.32 1.04 2.13 1.24.81.2 1.66.17 2.54-.1.81-.24 1.47-.62 1.98-1.15s.84-1.2.97-2l2.63-.78c-.12 1.43-.63 2.65-1.53 3.67s-2.06 1.74-3.49 2.16c-1.25.37-2.49.42-3.7.15s-2.27-.84-3.19-1.7-1.57-1.94-1.96-3.24c-.39-1.31-.43-2.57-.13-3.79zM83.18 23.65l4.68-.49.19 1.83-6.96.73-1.46-13.85 2.27-.24 1.26 12.02zM98.37 22.53l-5.82-.37-1.18 2.78-2.38-.15 5.87-13.6 2.64.17 4.09 14.24-2.4-.15-.82-2.9zm-.52-1.9L96 14.03l-2.69 6.31 4.54.29zM105.81 26.31c-.64-.51-1.09-1.11-1.34-1.8-.26-.69-.28-1.42-.07-2.2l2.36.63c-.1.59 0 1.13.3 1.62.31.48.83.82 1.56 1.02.76.2 1.4.18 1.93-.07.52-.25.86-.67 1.02-1.25.12-.45.09-.85-.1-1.21s-.46-.66-.81-.92c-.35-.26-.85-.57-1.5-.94-.82-.47-1.46-.89-1.95-1.28s-.85-.88-1.11-1.49c-.25-.61-.27-1.33-.04-2.17.21-.77.58-1.4 1.12-1.88.54-.48 1.2-.78 1.98-.9s1.63-.06 2.54.18c1.3.35 2.28.96 2.94 1.84.66.88.88 1.89.67 3.05l-2.44-.65c.09-.5-.03-.98-.36-1.44-.33-.46-.85-.79-1.54-.97-.63-.17-1.19-.15-1.68.07-.49.21-.81.63-.97 1.23-.11.41-.08.79.1 1.12s.44.63.79.89c.35.26.83.57 1.45.93.83.48 1.48.92 1.98 1.32s.87.9 1.13 1.52c.26.62.27 1.35.04 2.2-.18.68-.54 1.28-1.07 1.79s-1.2.85-2 1.03c-.8.18-1.68.14-2.63-.12-.9-.24-1.67-.62-2.31-1.13zM117.26 30.05c-.53-.62-.87-1.29-.99-2.02s-.02-1.45.33-2.17l2.21 1.05c-.21.57-.21 1.11 0 1.64.21.53.66.96 1.35 1.29.71.34 1.35.43 1.91.28.56-.15.97-.5 1.23-1.04.2-.42.24-.82.12-1.21-.12-.38-.33-.73-.63-1.05-.3-.32-.73-.72-1.3-1.2-.72-.61-1.28-1.15-1.68-1.61-.41-.47-.68-1.02-.82-1.67s-.02-1.36.35-2.14c.34-.72.83-1.27 1.45-1.64.62-.37 1.33-.54 2.11-.52.79.02 1.61.24 2.47.64 1.22.58 2.07 1.36 2.56 2.34.49.98.52 2.02.1 3.12l-2.28-1.09c.18-.48.15-.97-.09-1.49s-.69-.93-1.34-1.24c-.59-.28-1.15-.36-1.66-.24-.52.12-.91.47-1.18 1.04-.18.39-.22.76-.1 1.12s.32.7.62 1.01c.29.32.71.71 1.26 1.18.72.63 1.29 1.18 1.71 1.66.42.48.69 1.04.83 1.7s.02 1.38-.36 2.17c-.3.64-.76 1.16-1.38 1.56-.61.4-1.33.62-2.15.65s-1.68-.17-2.57-.59c-.84-.4-1.53-.91-2.07-1.53zM125.69 34.56c-.09-.39-.02-.76.21-1.11.22-.35.53-.57.92-.65.39-.09.76-.02 1.1.21.34.22.55.52.64.9.09.39.02.76-.21 1.1-.22.35-.53.57-.92.65-.39.08-.75.02-1.09-.19-.35-.22-.57-.53-.65-.92zM136.75 29.25c1.19-.4 2.39-.47 3.61-.21a7.2 7.2 0 013.29 1.66c1.12.97 1.87 2.12 2.27 3.42.39 1.31.35 2.64-.14 3.99l-2.07-1.8c.21-.79.19-1.53-.05-2.23-.25-.69-.69-1.32-1.32-1.87-.69-.61-1.45-.99-2.27-1.15-.82-.16-1.63-.08-2.45.23-.82.32-1.56.86-2.24 1.64-.68.78-1.12 1.59-1.32 2.44-.2.85-.17 1.67.1 2.46s.75 1.49 1.44 2.1c.63.55 1.31.9 2.03 1.05s1.46.07 2.21-.25l2.07 1.8c-1.27.66-2.58.89-3.92.67-1.34-.22-2.58-.81-3.69-1.78-.99-.86-1.69-1.87-2.11-3.04a6.781 6.781 0 01-.28-3.6c.23-1.23.8-2.36 1.69-3.39.89-1.03 1.94-1.74 3.13-2.14zM143.43 49.57c-.13-1.24.06-2.43.58-3.58s1.34-2.11 2.45-2.9 2.29-1.23 3.54-1.34 2.44.11 3.56.65 2.06 1.33 2.81 2.39c.76 1.07 1.2 2.22 1.33 3.46.13 1.24-.06 2.43-.58 3.57s-1.34 2.1-2.45 2.89-2.29 1.24-3.54 1.36c-1.25.12-2.44-.09-3.56-.63a7.18 7.18 0 01-2.82-2.41c-.75-1.06-1.19-2.21-1.32-3.45zm4.88 3.95c.76.35 1.58.46 2.45.34.87-.12 1.73-.47 2.57-1.07.84-.59 1.46-1.28 1.86-2.06.4-.78.56-1.58.48-2.41-.08-.83-.38-1.62-.92-2.37-.53-.75-1.18-1.3-1.93-1.65-.75-.35-1.57-.47-2.43-.35-.87.12-1.72.47-2.56 1.06-.84.59-1.46 1.28-1.86 2.07s-.57 1.59-.49 2.42.38 1.62.91 2.38c.53.75 1.18 1.3 1.94 1.65zM168.4 69.89l-13.04 4.88-.8-2.14 8.93-3.34-10.42-.64-.55-1.48 7.44-7.34-8.93 3.34-.8-2.14 13.04-4.88.86 2.31-8.51 8.41 11.93.73.86 2.29z"
  })), _g || (_g = /*#__PURE__*/react.createElement("g", null, /*#__PURE__*/react.createElement("path", {
    className: "badge-tested_svg__cls-1",
    d: "M64.89 152.59l-.85 1.66-3.29-1.69-5.5 10.71-2.03-1.04 5.5-10.71-3.31-1.7.85-1.66 8.63 4.43zM69.23 156.03l-1.21 3.9 4.58 1.43-.55 1.78-4.58-1.43-1.26 4.07 5.16 1.6-.55 1.78-7.33-2.28 4.13-13.29 7.33 2.28-.55 1.78-5.16-1.6zM78.78 170.37c-.7-.41-1.23-.95-1.58-1.59-.35-.65-.48-1.37-.38-2.16l2.42.29c-.02.6.16 1.12.53 1.55.37.44.93.7 1.69.79.78.09 1.41-.02 1.9-.34.48-.32.76-.78.83-1.38.06-.46-.03-.86-.27-1.18-.24-.32-.55-.59-.93-.8-.38-.21-.92-.45-1.62-.72-.87-.35-1.57-.68-2.11-.99a3.58 3.58 0 01-1.3-1.32c-.33-.56-.45-1.28-.34-2.14.1-.79.38-1.46.85-2.01.47-.55 1.08-.94 1.83-1.17.75-.23 1.6-.29 2.54-.17 1.34.16 2.39.63 3.16 1.4.77.77 1.13 1.75 1.08 2.92l-2.5-.3c.02-.51-.17-.97-.56-1.38-.39-.41-.95-.66-1.66-.75-.65-.08-1.2.02-1.65.3s-.71.73-.79 1.35c-.05.42.04.79.26 1.09.22.3.53.56.9.76s.9.45 1.57.71c.88.36 1.6.71 2.14 1.03.54.32.99.77 1.33 1.34.34.57.46 1.29.35 2.17-.08.7-.35 1.34-.81 1.92-.45.58-1.06 1.01-1.83 1.3-.77.29-1.64.38-2.62.26-.93-.11-1.74-.38-2.44-.79zM100.19 157.25l.12 1.86-3.69.24.78 12.02-2.28.15-.78-12.01-3.71.24-.12-1.86 9.68-.63zM105.65 157.99l.95 3.97 4.67-1.12.43 1.81-4.67 1.12 1 4.14 5.25-1.26.43 1.81-7.47 1.79-3.25-13.53 7.47-1.79.43 1.81-5.25 1.26zM122.24 150.98c1.25.04 2.37.41 3.37 1.11 1 .7 1.8 1.69 2.4 2.97s.85 2.52.74 3.72-.55 2.29-1.32 3.26-1.83 1.78-3.17 2.4l-4.11 1.93-5.91-12.58 4.11-1.93c1.34-.63 2.63-.92 3.88-.88zm4.06 9c.41-1.17.28-2.47-.4-3.92-.69-1.46-1.61-2.42-2.78-2.87-1.17-.45-2.49-.33-3.96.36l-2.05.96 4.33 9.21 2.05-.96c1.47-.69 2.41-1.62 2.83-2.78z"
  }))));
}
/* harmony default export */ var badge_tested = (SvgBadgeTested);
;// CONCATENATED MODULE: ./public/badge-verified.svg
var badge_verified_defs, badge_verified_path, badge_verified_path2, badge_verified_g;
function badge_verified_extends() { badge_verified_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return badge_verified_extends.apply(this, arguments); }

function SvgBadgeVerified(props) {
  return /*#__PURE__*/react.createElement("svg", badge_verified_extends({
    id: "badge-verified_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 182 182"
  }, props), badge_verified_defs || (badge_verified_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("style", null, ".badge-verified_svg__cls-1{fill:#b29e87;stroke-width:0}"))), badge_verified_path || (badge_verified_path = /*#__PURE__*/react.createElement("path", {
    className: "badge-verified_svg__cls-1",
    d: "M91 0C40.82 0 0 40.82 0 91s40.82 91 91 91 91-40.82 91-91S141.18 0 91 0zm0 178.66c-48.34 0-87.66-39.32-87.66-87.66S42.66 3.34 91 3.34 178.66 42.66 178.66 91 139.34 178.66 91 178.66z"
  })), badge_verified_path2 || (badge_verified_path2 = /*#__PURE__*/react.createElement("path", {
    className: "badge-verified_svg__cls-1",
    d: "M91 31.72c-32.69 0-59.28 26.59-59.28 59.28S58.31 150.28 91 150.28s59.28-26.59 59.28-59.28S123.69 31.72 91 31.72zm0 115.22c-30.84 0-55.94-25.09-55.94-55.94S60.15 35.06 91 35.06 146.94 60.15 146.94 91 121.85 146.94 91 146.94zM15.98 63.15l1.78.55-1.74 5.65 3.93 1.21 1.36-4.4 1.78.55-1.35 4.41 5.82 1.79-.67 2.18L13.58 71l2.41-7.83zM18.2 58.07l12.77 5.56-.91 2.09-12.77-5.56.91-2.09zM35.68 54.99l-6.43-.12-.9 1.49 4.77 2.87-1.18 1.96-11.93-7.18 2.48-4.12c.55-.92 1.18-1.59 1.88-2.04.7-.44 1.42-.66 2.15-.65.73 0 1.42.21 2.09.61.78.47 1.35 1.12 1.71 1.95s.38 1.79.04 2.87l6.72.02-1.4 2.33zm-8.88.43l1.3-2.16c.44-.73.59-1.39.45-1.99-.14-.59-.52-1.07-1.14-1.45-.62-.37-1.21-.48-1.78-.32s-1.08.61-1.53 1.35l-1.3 2.16 4 2.41zM39.82 48.77c-.74.34-1.48.47-2.21.39-.73-.08-1.4-.39-2-.92l1.63-1.83c.48.36 1.01.51 1.58.46s1.11-.37 1.61-.94c.52-.59.79-1.17.8-1.76 0-.58-.21-1.07-.66-1.47-.35-.31-.72-.46-1.13-.45s-.8.11-1.19.31c-.39.2-.9.5-1.51.92-.78.52-1.46.91-2.02 1.17-.56.26-1.17.37-1.83.32-.66-.05-1.31-.36-1.96-.94-.6-.53-.99-1.15-1.17-1.85s-.15-1.42.09-2.18.68-1.48 1.31-2.19c.9-1.01 1.88-1.61 2.96-1.8 1.08-.19 2.09.06 3.03.78l-1.68 1.88c-.41-.31-.89-.42-1.45-.33-.56.09-1.08.4-1.56.94-.44.49-.67 1-.69 1.53s.2 1.01.66 1.42c.32.28.67.42 1.04.41.38-.01.76-.11 1.15-.31.39-.19.88-.49 1.48-.88.8-.52 1.49-.91 2.07-1.18.58-.27 1.2-.37 1.86-.33.67.05 1.33.36 1.98.95.53.47.9 1.06 1.12 1.76.22.7.22 1.45.02 2.25s-.63 1.56-1.29 2.3c-.62.7-1.3 1.22-2.05 1.56zM45.31 25.29l1.16 1.46-2.91 2.3 7.48 9.46-1.79 1.42-7.48-9.46-2.92 2.31-1.16-1.46 7.62-6.02zM59.3 23.8l.92 1.69-7.24 3.93-.92-1.69 7.24-3.93zM63.36 19.27c.3-1.22.88-2.27 1.76-3.17.87-.89 1.93-1.52 3.17-1.89 1.42-.42 2.79-.45 4.1-.08 1.32.37 2.41 1.12 3.29 2.25l-2.63.78c-.55-.6-1.19-.98-1.91-1.15-.72-.16-1.48-.12-2.29.11-.88.26-1.61.7-2.19 1.3-.57.6-.95 1.33-1.12 2.19s-.11 1.78.18 2.77.74 1.79 1.36 2.42c.61.63 1.32 1.04 2.13 1.24.81.2 1.66.17 2.54-.1.81-.24 1.47-.62 1.98-1.15s.84-1.2.97-2l2.63-.78c-.12 1.43-.63 2.65-1.53 3.67s-2.06 1.74-3.49 2.16c-1.25.37-2.49.42-3.7.15a6.752 6.752 0 01-3.19-1.7c-.92-.86-1.57-1.94-1.96-3.24-.39-1.31-.43-2.57-.13-3.79zM83.18 23.65l4.68-.49.19 1.83-6.96.73-1.46-13.85 2.27-.24 1.26 12.02zM98.37 22.53l-5.82-.37-1.18 2.78-2.38-.15 5.87-13.6 2.64.17 4.09 14.24-2.4-.15-.82-2.9zm-.52-1.9L96 14.03l-2.69 6.31 4.54.29zM105.81 26.31c-.64-.51-1.09-1.11-1.34-1.8-.26-.69-.28-1.42-.07-2.2l2.36.63c-.1.59 0 1.13.3 1.62.31.48.83.82 1.56 1.02.76.2 1.4.18 1.93-.07.52-.25.86-.67 1.02-1.25.12-.45.09-.85-.1-1.21s-.46-.66-.81-.92c-.35-.26-.85-.57-1.5-.94-.82-.47-1.46-.89-1.95-1.28s-.85-.88-1.1-1.49c-.25-.61-.27-1.33-.04-2.17.21-.77.58-1.4 1.12-1.88.54-.48 1.2-.78 1.98-.9s1.63-.06 2.54.18c1.3.35 2.28.96 2.94 1.84.66.88.88 1.89.67 3.05l-2.44-.65c.09-.5-.03-.98-.36-1.44-.33-.46-.85-.79-1.54-.97-.63-.17-1.19-.15-1.68.07-.49.21-.81.63-.97 1.23-.11.41-.08.79.1 1.12s.44.63.79.89c.35.26.83.57 1.45.93.83.48 1.48.92 1.98 1.32s.87.9 1.13 1.52c.26.62.27 1.35.04 2.2-.18.68-.54 1.28-1.07 1.79s-1.2.85-2 1.03c-.8.18-1.68.14-2.63-.12-.9-.24-1.67-.62-2.31-1.13zM117.26 30.05c-.53-.62-.87-1.29-.99-2.02s-.02-1.45.33-2.17l2.21 1.05c-.21.57-.21 1.11 0 1.64.21.53.66.96 1.35 1.29.71.34 1.35.43 1.91.28.56-.15.97-.5 1.23-1.04.2-.42.24-.82.12-1.21-.12-.38-.33-.73-.63-1.05-.3-.32-.73-.72-1.3-1.2-.72-.61-1.28-1.15-1.68-1.61-.41-.47-.68-1.02-.82-1.67s-.02-1.36.35-2.14c.34-.72.83-1.27 1.45-1.64.62-.37 1.33-.54 2.11-.52.79.02 1.61.24 2.47.64 1.22.58 2.07 1.36 2.56 2.34.49.98.52 2.02.1 3.12l-2.28-1.09c.18-.48.15-.97-.09-1.49s-.69-.93-1.34-1.24c-.59-.28-1.15-.36-1.66-.24-.52.12-.91.47-1.18 1.04-.18.39-.22.76-.1 1.12s.32.7.62 1.01c.29.32.71.71 1.26 1.18.72.63 1.29 1.18 1.71 1.66.42.48.69 1.04.83 1.7s.02 1.38-.36 2.17c-.3.64-.76 1.16-1.38 1.56-.61.4-1.33.62-2.15.65s-1.68-.17-2.57-.59c-.84-.4-1.53-.91-2.07-1.53zM125.69 34.56c-.09-.39-.02-.76.21-1.11.22-.35.53-.57.92-.65.39-.09.76-.02 1.1.21.34.22.55.52.64.9.09.39.02.76-.21 1.1-.22.35-.53.57-.92.65-.39.08-.75.02-1.09-.19-.35-.22-.57-.53-.65-.92zM136.75 29.25c1.19-.4 2.39-.47 3.61-.21a7.2 7.2 0 013.29 1.66c1.12.97 1.87 2.12 2.27 3.42.39 1.31.35 2.64-.14 3.99l-2.07-1.8c.21-.79.19-1.53-.05-2.23-.25-.69-.69-1.32-1.32-1.87-.69-.61-1.45-.99-2.27-1.15-.82-.16-1.63-.08-2.45.23s-1.56.86-2.24 1.64c-.68.78-1.12 1.59-1.32 2.44-.2.85-.17 1.67.1 2.46s.75 1.49 1.44 2.1c.63.55 1.31.9 2.03 1.05s1.46.07 2.21-.25l2.07 1.8c-1.27.66-2.58.89-3.92.67-1.35-.22-2.58-.81-3.69-1.78-.99-.86-1.69-1.88-2.11-3.04s-.51-2.37-.28-3.6c.23-1.23.8-2.36 1.69-3.39.89-1.03 1.94-1.74 3.13-2.14zM143.43 49.57c-.13-1.24.06-2.43.58-3.58s1.34-2.11 2.45-2.9 2.29-1.23 3.54-1.34 2.44.11 3.56.65 2.06 1.33 2.81 2.39c.76 1.07 1.2 2.22 1.33 3.46s-.06 2.43-.58 3.57-1.34 2.1-2.45 2.89-2.29 1.24-3.54 1.36c-1.25.12-2.44-.09-3.56-.63a7.18 7.18 0 01-2.82-2.41c-.75-1.06-1.19-2.21-1.32-3.45zm4.88 3.95c.76.35 1.58.46 2.45.34.87-.12 1.73-.47 2.57-1.07.84-.59 1.46-1.28 1.86-2.06.4-.78.56-1.58.48-2.41-.08-.83-.38-1.62-.92-2.37-.53-.75-1.18-1.3-1.93-1.65-.75-.35-1.57-.47-2.43-.35-.87.12-1.72.47-2.56 1.06-.84.59-1.46 1.28-1.86 2.07s-.57 1.59-.49 2.42.38 1.62.91 2.38c.53.75 1.18 1.3 1.94 1.65zM168.4 69.89l-13.04 4.88-.8-2.14 8.93-3.34-10.42-.64-.55-1.48 7.44-7.34-8.93 3.34-.8-2.14 13.04-4.88.86 2.31-8.51 8.41 11.93.73.86 2.29z"
  })), badge_verified_g || (badge_verified_g = /*#__PURE__*/react.createElement("g", null, /*#__PURE__*/react.createElement("path", {
    className: "badge-verified_svg__cls-1",
    d: "M63.14 151.98l-11.5 9.39-2.28-1.33 2.46-14.65 2.11 1.23-2.25 12.06 9.39-7.91 2.07 1.21zM67.54 155.44l-1.31 3.86 4.54 1.55-.6 1.76-4.54-1.55-1.37 4.03 5.11 1.74-.6 1.76-7.27-2.47 4.48-13.18 7.27 2.47-.6 1.76-5.11-1.74zM81.98 171.14l-2.39-5.96-1.72-.24-.78 5.5-2.26-.32 1.95-13.76 4.75.67c1.06.15 1.92.46 2.6.94.68.47 1.16 1.05 1.43 1.72.27.67.36 1.39.25 2.16-.13.9-.5 1.68-1.13 2.33-.63.66-1.5 1.04-2.62 1.15l2.6 6.19-2.69-.38zm-3.86-8l2.5.35c.84.12 1.51 0 2-.36s.78-.9.89-1.61c.1-.71-.03-1.3-.4-1.76s-.98-.75-1.83-.88l-2.5-.35-.66 4.61zM91.5 157.72l-.23 13.9-2.28-.04.23-13.9 2.28.04zM102 156.96l.18 1.85-5.87.57.4 4.08 4.58-.44.18 1.85-4.58.44.59 6.05-2.27.22-1.34-13.83 8.14-.79zM105.75 156.08l2.83 13.61-2.23.46-2.83-13.61 2.23-.46zM110.92 156.62l1.27 3.88 4.56-1.49.58 1.77-4.56 1.49 1.32 4.05 5.13-1.68.58 1.77-7.3 2.39-4.32-13.23 7.3-2.39.58 1.77-5.13 1.68zM126.88 148.32c1.25-.06 2.4.22 3.45.84 1.05.62 1.93 1.54 2.63 2.77s1.04 2.44 1.03 3.65c-.01 1.2-.36 2.32-1.06 3.35-.69 1.03-1.68 1.92-2.97 2.65l-3.94 2.25-6.88-12.08 3.94-2.25c1.29-.73 2.55-1.13 3.8-1.19zm4.76 8.65c.32-1.19.08-2.49-.71-3.88-.8-1.4-1.8-2.28-3-2.64-1.2-.36-2.51-.13-3.92.67l-1.96 1.12 5.04 8.84 1.96-1.12c1.41-.8 2.28-1.8 2.6-3z"
  }))));
}
/* harmony default export */ var badge_verified = (SvgBadgeVerified);
;// CONCATENATED MODULE: ./public/badge-verified-check.svg
var badge_verified_check_defs, badge_verified_check_path, badge_verified_check_path2, badge_verified_check_g, _path3;
function badge_verified_check_extends() { badge_verified_check_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return badge_verified_check_extends.apply(this, arguments); }

function SvgBadgeVerifiedCheck(props) {
  return /*#__PURE__*/react.createElement("svg", badge_verified_check_extends({
    id: "badge-verified-check_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 182 182"
  }, props), badge_verified_check_defs || (badge_verified_check_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("style", null, ".badge-verified-check_svg__cls-1{fill:#b29e87;stroke-width:0}"))), badge_verified_check_path || (badge_verified_check_path = /*#__PURE__*/react.createElement("path", {
    className: "badge-verified-check_svg__cls-1",
    d: "M91 0C40.82 0 0 40.82 0 91s40.82 91 91 91 91-40.82 91-91S141.18 0 91 0zm0 178.66c-48.34 0-87.66-39.32-87.66-87.66S42.66 3.34 91 3.34 178.66 42.66 178.66 91 139.34 178.66 91 178.66z"
  })), badge_verified_check_path2 || (badge_verified_check_path2 = /*#__PURE__*/react.createElement("path", {
    className: "badge-verified-check_svg__cls-1",
    d: "M91 31.72c-32.69 0-59.28 26.59-59.28 59.28S58.31 150.28 91 150.28s59.28-26.59 59.28-59.28S123.69 31.72 91 31.72zm0 115.22c-30.84 0-55.94-25.09-55.94-55.94S60.15 35.06 91 35.06 146.94 60.15 146.94 91 121.85 146.94 91 146.94zM15.98 63.15l1.78.55-1.74 5.65 3.93 1.21 1.36-4.4 1.78.55-1.35 4.41 5.82 1.79-.67 2.18L13.58 71l2.41-7.83zM18.2 58.07l12.77 5.56-.91 2.09-12.77-5.56.91-2.09zM35.68 54.99l-6.43-.12-.9 1.49 4.77 2.87-1.18 1.96-11.93-7.18 2.48-4.12c.55-.92 1.18-1.59 1.88-2.04.7-.44 1.42-.66 2.15-.65.73 0 1.42.21 2.09.61.78.47 1.35 1.12 1.71 1.95s.38 1.79.04 2.87l6.72.02-1.4 2.33zm-8.88.43l1.3-2.16c.44-.73.59-1.39.45-1.99-.14-.59-.52-1.07-1.14-1.45-.62-.37-1.21-.48-1.78-.32s-1.08.61-1.53 1.35l-1.3 2.16 4 2.41zM39.82 48.77c-.74.34-1.48.47-2.21.39-.73-.08-1.4-.39-2-.92l1.63-1.83c.48.36 1.01.51 1.58.46s1.11-.37 1.61-.94c.52-.59.79-1.17.8-1.76 0-.58-.21-1.07-.66-1.47-.35-.31-.72-.46-1.13-.45s-.8.11-1.19.31c-.39.2-.9.5-1.51.92-.78.52-1.46.91-2.02 1.17-.56.26-1.17.37-1.83.32-.66-.05-1.31-.36-1.96-.94-.6-.53-.99-1.15-1.17-1.85s-.15-1.42.09-2.18.68-1.48 1.31-2.19c.9-1.01 1.88-1.61 2.96-1.8 1.08-.19 2.09.06 3.03.78l-1.68 1.88c-.41-.31-.89-.42-1.45-.33-.56.09-1.08.4-1.56.94-.44.49-.67 1-.69 1.53s.2 1.01.66 1.42c.32.28.67.42 1.04.41.38-.01.76-.11 1.15-.31.39-.19.88-.49 1.48-.88.8-.52 1.49-.91 2.07-1.18.58-.27 1.2-.37 1.86-.33.67.05 1.33.36 1.98.95.53.47.9 1.06 1.12 1.76.22.7.22 1.45.02 2.25s-.63 1.56-1.29 2.3c-.62.7-1.3 1.22-2.05 1.56zM45.31 25.29l1.16 1.46-2.91 2.3 7.48 9.46-1.79 1.42-7.48-9.46-2.92 2.31-1.16-1.46 7.62-6.02zM59.3 23.8l.92 1.69-7.24 3.93-.92-1.69 7.24-3.93zM63.36 19.27c.3-1.22.88-2.27 1.76-3.17.87-.89 1.93-1.52 3.17-1.89 1.42-.42 2.79-.45 4.1-.08 1.32.37 2.41 1.12 3.29 2.25l-2.63.78c-.55-.6-1.19-.98-1.91-1.15-.72-.16-1.48-.12-2.29.11-.88.26-1.61.7-2.19 1.3-.57.6-.95 1.33-1.12 2.19s-.11 1.78.18 2.77.74 1.79 1.36 2.42c.61.63 1.32 1.04 2.13 1.24.81.2 1.66.17 2.54-.1.81-.24 1.47-.62 1.98-1.15s.84-1.2.97-2l2.63-.78c-.12 1.43-.63 2.65-1.53 3.67s-2.06 1.74-3.49 2.16c-1.25.37-2.49.42-3.7.15a6.752 6.752 0 01-3.19-1.7c-.92-.86-1.57-1.94-1.96-3.24-.39-1.31-.43-2.57-.13-3.79zM83.18 23.65l4.68-.49.19 1.83-6.96.73-1.46-13.85 2.27-.24 1.26 12.02zM98.37 22.53l-5.82-.37-1.18 2.78-2.38-.15 5.87-13.6 2.64.17 4.09 14.24-2.4-.15-.82-2.9zm-.52-1.9L96 14.03l-2.69 6.31 4.54.29zM105.81 26.31c-.64-.51-1.09-1.11-1.34-1.8-.26-.69-.28-1.42-.07-2.2l2.36.63c-.1.59 0 1.13.3 1.62.31.48.83.82 1.56 1.02.76.2 1.4.18 1.93-.07.52-.25.86-.67 1.02-1.25.12-.45.09-.85-.1-1.21s-.46-.66-.81-.92c-.35-.26-.85-.57-1.5-.94-.82-.47-1.46-.89-1.95-1.28s-.85-.88-1.1-1.49c-.25-.61-.27-1.33-.04-2.17.21-.77.58-1.4 1.12-1.88.54-.48 1.2-.78 1.98-.9s1.63-.06 2.54.18c1.3.35 2.28.96 2.94 1.84.66.88.88 1.89.67 3.05l-2.44-.65c.09-.5-.03-.98-.36-1.44-.33-.46-.85-.79-1.54-.97-.63-.17-1.19-.15-1.68.07-.49.21-.81.63-.97 1.23-.11.41-.08.79.1 1.12s.44.63.79.89c.35.26.83.57 1.45.93.83.48 1.48.92 1.98 1.32s.87.9 1.13 1.52c.26.62.27 1.35.04 2.2-.18.68-.54 1.28-1.07 1.79s-1.2.85-2 1.03c-.8.18-1.68.14-2.63-.12-.9-.24-1.67-.62-2.31-1.13zM117.26 30.05c-.53-.62-.87-1.29-.99-2.02s-.02-1.45.33-2.17l2.21 1.05c-.21.57-.21 1.11 0 1.64.21.53.66.96 1.35 1.29.71.34 1.35.43 1.91.28.56-.15.97-.5 1.23-1.04.2-.42.24-.82.12-1.21-.12-.38-.33-.73-.63-1.05-.3-.32-.73-.72-1.3-1.2-.72-.61-1.28-1.15-1.68-1.61-.41-.47-.68-1.02-.82-1.67s-.02-1.36.35-2.14c.34-.72.83-1.27 1.45-1.64.62-.37 1.33-.54 2.11-.52.79.02 1.61.24 2.47.64 1.22.58 2.07 1.36 2.56 2.34.49.98.52 2.02.1 3.12l-2.28-1.09c.18-.48.15-.97-.09-1.49s-.69-.93-1.34-1.24c-.59-.28-1.15-.36-1.66-.24-.52.12-.91.47-1.18 1.04-.18.39-.22.76-.1 1.12s.32.7.62 1.01c.29.32.71.71 1.26 1.18.72.63 1.29 1.18 1.71 1.66.42.48.69 1.04.83 1.7s.02 1.38-.36 2.17c-.3.64-.76 1.16-1.38 1.56-.61.4-1.33.62-2.15.65s-1.68-.17-2.57-.59c-.84-.4-1.53-.91-2.07-1.53zM125.69 34.56c-.09-.39-.02-.76.21-1.11.22-.35.53-.57.92-.65.39-.09.76-.02 1.1.21.34.22.55.52.64.9.09.39.02.76-.21 1.1-.22.35-.53.57-.92.65-.39.08-.75.02-1.09-.19-.35-.22-.57-.53-.65-.92zM136.75 29.25c1.19-.4 2.39-.47 3.61-.21a7.2 7.2 0 013.29 1.66c1.12.97 1.87 2.12 2.27 3.42.39 1.31.35 2.64-.14 3.99l-2.07-1.8c.21-.79.19-1.53-.05-2.23-.25-.69-.69-1.32-1.32-1.87-.69-.61-1.45-.99-2.27-1.15-.82-.16-1.63-.08-2.45.23s-1.56.86-2.24 1.64c-.68.78-1.12 1.59-1.32 2.44-.2.85-.17 1.67.1 2.46s.75 1.49 1.44 2.1c.63.55 1.31.9 2.03 1.05s1.46.07 2.21-.25l2.07 1.8c-1.27.66-2.58.89-3.92.67-1.35-.22-2.58-.81-3.69-1.78-.99-.86-1.69-1.88-2.11-3.04s-.51-2.37-.28-3.6c.23-1.23.8-2.36 1.69-3.39.89-1.03 1.94-1.74 3.13-2.14zM143.43 49.57c-.13-1.24.06-2.43.58-3.58s1.34-2.11 2.45-2.9 2.29-1.23 3.54-1.34 2.44.11 3.56.65 2.06 1.33 2.81 2.39c.76 1.07 1.2 2.22 1.33 3.46s-.06 2.43-.58 3.57-1.34 2.1-2.45 2.89-2.29 1.24-3.54 1.36c-1.25.12-2.44-.09-3.56-.63a7.18 7.18 0 01-2.82-2.41c-.75-1.06-1.19-2.21-1.32-3.45zm4.88 3.95c.76.35 1.58.46 2.45.34.87-.12 1.73-.47 2.57-1.07.84-.59 1.46-1.28 1.86-2.06.4-.78.56-1.58.48-2.41-.08-.83-.38-1.62-.92-2.37-.53-.75-1.18-1.3-1.93-1.65-.75-.35-1.57-.47-2.43-.35-.87.12-1.72.47-2.56 1.06-.84.59-1.46 1.28-1.86 2.07s-.57 1.59-.49 2.42.38 1.62.91 2.38c.53.75 1.18 1.3 1.94 1.65zM168.4 69.89l-13.04 4.88-.8-2.14 8.93-3.34-10.42-.64-.55-1.48 7.44-7.34-8.93 3.34-.8-2.14 13.04-4.88.86 2.31-8.51 8.41 11.93.73.86 2.29z"
  })), badge_verified_check_g || (badge_verified_check_g = /*#__PURE__*/react.createElement("g", null, /*#__PURE__*/react.createElement("path", {
    className: "badge-verified-check_svg__cls-1",
    d: "M63.14 151.98l-11.5 9.39-2.28-1.33 2.46-14.65 2.11 1.23-2.25 12.06 9.39-7.91 2.07 1.21zM67.54 155.44l-1.31 3.86 4.54 1.55-.6 1.76-4.54-1.55-1.37 4.03 5.11 1.74-.6 1.76-7.27-2.47 4.48-13.18 7.27 2.47-.6 1.76-5.11-1.74zM81.98 171.14l-2.39-5.96-1.72-.24-.78 5.5-2.26-.32 1.95-13.76 4.75.67c1.06.15 1.92.46 2.6.94.68.47 1.16 1.05 1.43 1.72.27.67.36 1.39.25 2.16-.13.9-.5 1.68-1.13 2.33-.63.66-1.5 1.04-2.62 1.15l2.6 6.19-2.69-.38zm-3.86-8l2.5.35c.84.12 1.51 0 2-.36s.78-.9.89-1.61c.1-.71-.03-1.3-.4-1.76s-.98-.75-1.83-.88l-2.5-.35-.66 4.61zM91.5 157.72l-.23 13.9-2.28-.04.23-13.9 2.28.04zM102 156.96l.18 1.85-5.87.57.4 4.08 4.58-.44.18 1.85-4.58.44.59 6.05-2.27.22-1.34-13.83 8.14-.79zM105.75 156.08l2.83 13.61-2.23.46-2.83-13.61 2.23-.46zM110.92 156.62l1.27 3.88 4.56-1.49.58 1.77-4.56 1.49 1.32 4.05 5.13-1.68.58 1.77-7.3 2.39-4.32-13.23 7.3-2.39.58 1.77-5.13 1.68zM126.88 148.32c1.25-.06 2.4.22 3.45.84 1.05.62 1.93 1.54 2.63 2.77s1.04 2.44 1.03 3.65c-.01 1.2-.36 2.32-1.06 3.35-.69 1.03-1.68 1.92-2.97 2.65l-3.94 2.25-6.88-12.08 3.94-2.25c1.29-.73 2.55-1.13 3.8-1.19zm4.76 8.65c.32-1.19.08-2.49-.71-3.88-.8-1.4-1.8-2.28-3-2.64-1.2-.36-2.51-.13-3.92.67l-1.96 1.12 5.04 8.84 1.96-1.12c1.41-.8 2.28-1.8 2.6-3z"
  }))), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    className: "badge-verified-check_svg__cls-1",
    d: "M72.43 107.35L59.65 91.76l-9.66 8.74L67 122.11l12.41-5.52c14.94-35.17 50.57-51.95 50.57-51.95s-40.7 4.58-57.57 42.71z"
  })));
}
/* harmony default export */ var badge_verified_check = (SvgBadgeVerifiedCheck);
;// CONCATENATED MODULE: ./public/badge-quality.svg
var badge_quality_defs, badge_quality_path, badge_quality_path2, badge_quality_g;
function badge_quality_extends() { badge_quality_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return badge_quality_extends.apply(this, arguments); }

function SvgBadgeQuality(props) {
  return /*#__PURE__*/react.createElement("svg", badge_quality_extends({
    id: "badge-quality_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 182 182"
  }, props), badge_quality_defs || (badge_quality_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("style", null, ".badge-quality_svg__cls-1{fill:#b29e87;stroke-width:0}"))), badge_quality_path || (badge_quality_path = /*#__PURE__*/react.createElement("path", {
    className: "badge-quality_svg__cls-1",
    d: "M91 0C40.82 0 0 40.82 0 91s40.82 91 91 91 91-40.82 91-91S141.18 0 91 0zm0 178.66c-48.34 0-87.66-39.32-87.66-87.66S42.66 3.34 91 3.34 178.66 42.66 178.66 91 139.34 178.66 91 178.66z"
  })), badge_quality_path2 || (badge_quality_path2 = /*#__PURE__*/react.createElement("path", {
    className: "badge-quality_svg__cls-1",
    d: "M91 31.72c-32.69 0-59.28 26.59-59.28 59.28S58.31 150.28 91 150.28s59.28-26.59 59.28-59.28S123.69 31.72 91 31.72zm0 115.22c-30.84 0-55.94-25.09-55.94-55.94S60.15 35.06 91 35.06 146.94 60.15 146.94 91 121.85 146.94 91 146.94zM15.98 63.15l1.78.55-1.74 5.65 3.93 1.21 1.36-4.4 1.78.55-1.35 4.41 5.82 1.79-.67 2.18L13.58 71l2.41-7.83zM18.2 58.07l12.77 5.56-.91 2.09-12.77-5.56.91-2.09zM35.68 54.99l-6.42-.12-.9 1.49 4.77 2.87-1.18 1.96-11.93-7.18 2.48-4.12c.55-.92 1.18-1.59 1.88-2.04.7-.44 1.42-.66 2.15-.65.73 0 1.42.21 2.09.61.78.47 1.35 1.12 1.71 1.95s.38 1.79.04 2.87l6.72.02-1.41 2.33zm-8.88.43l1.3-2.16c.44-.73.59-1.39.45-1.99-.14-.59-.52-1.07-1.14-1.45-.62-.37-1.21-.48-1.78-.32s-1.08.61-1.53 1.35l-1.3 2.16 4 2.41zM39.82 48.77c-.74.34-1.48.47-2.21.39-.73-.08-1.4-.39-2-.92l1.63-1.83c.48.36 1.01.51 1.58.46s1.11-.37 1.61-.94c.52-.59.79-1.17.8-1.76 0-.58-.21-1.07-.66-1.47-.35-.31-.72-.46-1.13-.45s-.8.11-1.19.31c-.39.2-.9.5-1.51.92-.78.52-1.46.91-2.02 1.17-.56.26-1.17.37-1.83.32-.66-.05-1.31-.36-1.96-.94-.6-.53-.99-1.15-1.17-1.85s-.15-1.42.09-2.18.68-1.48 1.31-2.19c.9-1.01 1.88-1.61 2.96-1.8 1.08-.19 2.09.06 3.03.78l-1.68 1.88c-.41-.31-.89-.42-1.45-.33-.56.09-1.08.4-1.56.94-.44.49-.67 1-.69 1.53s.2 1.01.66 1.42c.32.28.67.42 1.04.41.38-.01.76-.11 1.15-.31.39-.19.88-.49 1.48-.88.8-.52 1.49-.91 2.07-1.18.58-.27 1.2-.37 1.86-.33.67.05 1.33.36 1.98.95.53.47.9 1.06 1.12 1.76.22.7.22 1.45.02 2.25s-.63 1.56-1.29 2.3c-.62.7-1.3 1.22-2.05 1.56zM45.31 25.29l1.16 1.46-2.91 2.3 7.48 9.46-1.79 1.42-7.48-9.46-2.92 2.31-1.16-1.46 7.62-6.02zM59.3 23.8l.92 1.69-7.24 3.93-.92-1.69 7.24-3.93zM63.36 19.27c.3-1.22.88-2.27 1.76-3.17.87-.89 1.93-1.52 3.17-1.89 1.42-.42 2.79-.45 4.1-.08 1.32.37 2.41 1.12 3.29 2.25l-2.63.78c-.55-.6-1.19-.98-1.91-1.15-.72-.16-1.48-.12-2.29.11-.88.26-1.61.7-2.19 1.3-.57.6-.95 1.33-1.12 2.19s-.11 1.78.18 2.77.74 1.79 1.36 2.42c.61.63 1.32 1.04 2.13 1.24.81.2 1.66.17 2.54-.1.81-.24 1.47-.62 1.98-1.15s.84-1.2.97-2l2.63-.78c-.12 1.43-.63 2.65-1.53 3.67s-2.06 1.74-3.49 2.16c-1.25.37-2.49.42-3.7.15s-2.27-.84-3.19-1.7-1.57-1.94-1.96-3.24c-.39-1.31-.43-2.57-.13-3.79zM83.18 23.65l4.68-.49.19 1.83-6.96.73-1.46-13.85 2.27-.24 1.26 12.02zM98.37 22.53l-5.82-.37-1.18 2.78-2.38-.15 5.87-13.6 2.64.17 4.09 14.24-2.4-.15-.82-2.9zm-.52-1.9L96 14.03l-2.69 6.31 4.54.29zM105.81 26.31c-.64-.51-1.09-1.11-1.34-1.8-.26-.69-.28-1.42-.07-2.2l2.36.63c-.1.59 0 1.13.3 1.62.31.48.83.82 1.56 1.02.76.2 1.4.18 1.93-.07.52-.25.86-.67 1.02-1.25.12-.45.09-.85-.1-1.21s-.46-.66-.81-.92c-.35-.26-.85-.57-1.5-.94-.82-.47-1.46-.89-1.95-1.28s-.85-.88-1.11-1.49c-.25-.61-.27-1.33-.04-2.17.21-.77.58-1.4 1.12-1.88.54-.48 1.2-.78 1.98-.9s1.63-.06 2.54.18c1.3.35 2.28.96 2.94 1.84.66.88.88 1.89.67 3.05l-2.44-.65c.09-.5-.03-.98-.36-1.44-.33-.46-.85-.79-1.54-.97-.63-.17-1.19-.15-1.68.07-.49.21-.81.63-.97 1.23-.11.41-.08.79.1 1.12s.44.63.79.89c.35.26.83.57 1.45.93.83.48 1.48.92 1.98 1.32s.87.9 1.13 1.52c.26.62.27 1.35.04 2.2-.18.68-.54 1.28-1.07 1.79s-1.2.85-2 1.03c-.8.18-1.68.14-2.63-.12-.9-.24-1.67-.62-2.31-1.13zM117.26 30.05c-.53-.62-.87-1.29-.99-2.02s-.02-1.45.33-2.17l2.21 1.05c-.21.57-.21 1.11 0 1.64.21.53.66.96 1.35 1.29.71.34 1.35.43 1.91.28.56-.15.97-.5 1.23-1.04.2-.42.24-.82.12-1.21-.12-.38-.33-.73-.63-1.05-.3-.32-.73-.72-1.3-1.2-.72-.61-1.28-1.15-1.68-1.61-.41-.47-.68-1.02-.82-1.67s-.02-1.36.35-2.14c.34-.72.83-1.27 1.45-1.64.62-.37 1.33-.54 2.11-.52.79.02 1.61.24 2.47.64 1.22.58 2.07 1.36 2.56 2.34.49.98.52 2.02.1 3.12l-2.28-1.09c.18-.48.15-.97-.09-1.49s-.69-.93-1.34-1.24c-.59-.28-1.15-.36-1.66-.24-.52.12-.91.47-1.18 1.04-.18.39-.22.76-.1 1.12s.32.7.62 1.01c.29.32.71.71 1.26 1.18.72.63 1.29 1.18 1.71 1.66.42.48.69 1.04.83 1.7s.02 1.38-.36 2.17c-.3.64-.76 1.16-1.38 1.56-.61.4-1.33.62-2.15.65s-1.68-.17-2.57-.59c-.84-.4-1.53-.91-2.07-1.53zM125.69 34.56c-.09-.39-.02-.76.21-1.11.22-.35.53-.57.92-.65.39-.09.76-.02 1.1.21.34.22.55.52.64.9.09.39.02.76-.21 1.1-.22.35-.53.57-.92.65-.39.08-.75.02-1.09-.19-.35-.22-.57-.53-.65-.92zM136.76 29.25c1.19-.4 2.39-.47 3.61-.21a7.2 7.2 0 013.29 1.66c1.12.97 1.87 2.12 2.27 3.42.39 1.31.35 2.64-.14 3.99l-2.07-1.8c.21-.79.19-1.53-.05-2.23-.25-.69-.69-1.32-1.32-1.87-.69-.61-1.45-.99-2.27-1.15-.82-.16-1.63-.08-2.45.23-.82.32-1.56.86-2.24 1.64-.68.78-1.12 1.59-1.32 2.44-.2.85-.17 1.67.1 2.46s.75 1.49 1.44 2.1c.63.55 1.31.9 2.03 1.05s1.46.07 2.21-.25l2.07 1.8c-1.27.66-2.58.89-3.92.67-1.34-.22-2.58-.81-3.69-1.78-.99-.86-1.69-1.87-2.11-3.04a6.781 6.781 0 01-.28-3.6c.23-1.23.8-2.36 1.69-3.39.89-1.03 1.94-1.74 3.13-2.14zM143.43 49.57c-.13-1.24.06-2.43.58-3.58s1.34-2.11 2.45-2.9 2.29-1.23 3.54-1.34 2.44.11 3.56.65 2.06 1.33 2.81 2.39c.76 1.07 1.2 2.22 1.33 3.46.13 1.24-.06 2.43-.58 3.57s-1.34 2.1-2.45 2.89-2.29 1.24-3.54 1.36c-1.25.12-2.44-.09-3.56-.63a7.18 7.18 0 01-2.82-2.41c-.75-1.06-1.19-2.21-1.32-3.45zm4.88 3.95c.76.35 1.58.46 2.45.34.87-.12 1.73-.47 2.57-1.07.84-.59 1.46-1.28 1.86-2.06.4-.78.56-1.58.48-2.41-.08-.83-.38-1.62-.92-2.37-.53-.75-1.18-1.3-1.93-1.65-.75-.35-1.57-.47-2.43-.35-.87.12-1.72.47-2.56 1.06-.84.59-1.46 1.28-1.86 2.07s-.57 1.59-.49 2.42.38 1.62.91 2.38c.53.75 1.18 1.3 1.94 1.65zM168.4 69.89l-13.04 4.88-.8-2.14 8.93-3.34-10.42-.64-.55-1.48 7.44-7.34-8.93 3.34-.8-2.14 13.04-4.88.86 2.31-8.51 8.41 11.93.73.86 2.29z"
  })), badge_quality_g || (badge_quality_g = /*#__PURE__*/react.createElement("g", null, /*#__PURE__*/react.createElement("path", {
    className: "badge-quality_svg__cls-1",
    d: "M54.68 163.69l-.81-3.5c-.61-.15-1.22-.4-1.85-.75-1.12-.64-2.01-1.49-2.65-2.56a6.746 6.746 0 01-.98-3.48c-.01-1.26.32-2.48.99-3.66s1.55-2.08 2.64-2.71c1.08-.62 2.25-.93 3.49-.92s2.43.34 3.55.98c1.13.65 2.02 1.5 2.67 2.57s.97 2.22.98 3.47c0 1.25-.32 2.46-1 3.65-.63 1.11-1.45 1.98-2.44 2.6-.99.62-2.07.97-3.22 1.03l1.15 4.73-2.52-1.44zm-4.08-10.14c-.03.88.16 1.68.58 2.4.42.72 1.03 1.31 1.83 1.77.8.46 1.62.68 2.45.67.83 0 1.62-.25 2.36-.73.74-.48 1.36-1.16 1.87-2.05.51-.89.78-1.77.81-2.65s-.17-1.67-.59-2.38-1.03-1.3-1.83-1.76c-.8-.46-1.61-.68-2.44-.68-.83 0-1.61.24-2.35.71s-1.36 1.15-1.87 2.04c-.51.89-.78 1.78-.81 2.66zM70.98 152.63l-2.32 8.55c-.28 1.02-.22 1.85.18 2.51.39.66 1.07 1.12 2.02 1.38.96.26 1.78.21 2.46-.16.67-.37 1.15-1.06 1.42-2.08l2.32-8.55 2.2.6-2.31 8.51c-.3 1.09-.79 1.96-1.47 2.59a4.6 4.6 0 01-2.37 1.18c-.9.16-1.83.1-2.8-.16-.96-.26-1.79-.69-2.48-1.27a4.533 4.533 0 01-1.42-2.21c-.26-.88-.24-1.87.06-2.97l2.31-8.51 2.2.6zM91.39 166.82l-5.82-.19-1.09 2.81-2.38-.08 5.43-13.75 2.64.09 4.52 14.08-2.4-.08-.91-2.87zm-.58-1.88l-2.05-6.53-2.49 6.38 4.54.15zM101.69 167.03l4.65-.69.27 1.82-6.9 1.02-2.04-13.75 2.26-.33 1.77 11.93zM107.64 153.55l3.33 13.5-2.21.55-3.33-13.5 2.21-.55zM118.38 149.84l.66 1.74-3.46 1.31 4.25 11.26-2.13.8-4.25-11.26-3.48 1.31-.66-1.74 9.07-3.43zM129.67 143.2l.71 9.96 2.63 4.3-1.94 1.19-2.63-4.3-8.57-5.14 2.17-1.33 6.31 4.13-.82-7.5 2.15-1.32z"
  }))));
}
/* harmony default export */ var badge_quality = (SvgBadgeQuality);
;// CONCATENATED MODULE: ./components/RatingBadge/RatingBadge.js





var RatingBadge = function(param) {
    var version = param.version;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            transform: "scale(0.9)"
        },
        children: [
            version === "badge-rated" && /*#__PURE__*/ (0,jsx_runtime.jsx)(badge_quality, {}),
            version === "badge-tested" && /*#__PURE__*/ (0,jsx_runtime.jsx)(badge_tested, {}),
            version === "badge-verified" && /*#__PURE__*/ (0,jsx_runtime.jsx)(badge_verified, {}),
            version === "badge-verified-check" && /*#__PURE__*/ (0,jsx_runtime.jsx)(badge_verified_check, {})
        ]
    });
};


/***/ }),

/***/ 82039:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ RecommendationItem; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(52875);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _ImageWithFallback_ImageWithFallback__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74284);
/* harmony import */ var _RecommendationItem_module_scss__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(34221);
/* harmony import */ var _RecommendationItem_module_scss__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_RecommendationItem_module_scss__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _mui_icons_material_AirplanemodeActive__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86235);
/* harmony import */ var _mui_icons_material_LocalOfferOutlined__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(11961);
/* harmony import */ var _mui_icons_material_Hotel__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9001);
/* harmony import */ var _mui_icons_material_PinDropRounded__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(52135);
/* harmony import */ var _public_small_white_logo_svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60831);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);













function getArticleLink(type, subtype, textId, country, city) {
    if (!type || !subtype || !textId) {
        return null;
    }
    if (type === "Hotels" && subtype === "Reviews") {
        type = "hotel";
        subtype = "review";
    }
    if (country) {
        return "/destinations/".concat(country, "/").concat(city ? city : textId);
    }
    if (type === "Offers") {
        return "/offers" + "/" + textId;
    }
    return "/" + type.toLowerCase() + "/" + subtype.toLowerCase() + "/" + textId;
}
var RecommendationItem = function(param) {
    var item = param.item, _imageOut = param.imageOut, imageOut = _imageOut === void 0 ? true : _imageOut, props = param.props;
    var ref;
    if (item.image) {
        var ref1, ref2;
        if (((ref1 = item.image) === null || ref1 === void 0 ? void 0 : ref1[0]) === "/") {
            var ref3;
            item.image = (ref3 = item.image) === null || ref3 === void 0 ? void 0 : ref3.replace("/", "");
        }
        item.image = (ref2 = item.image) === null || ref2 === void 0 ? void 0 : ref2.replace("view/image/", "");
    }
    if (item.topImage) {
        var ref4, ref5;
        if (((ref4 = item.topImage.image) === null || ref4 === void 0 ? void 0 : ref4[0]) === "/") {
            var ref6;
            item.topImage.image = (ref6 = item.topImage.image) === null || ref6 === void 0 ? void 0 : ref6.replace("/", "");
        }
        item.topImage.image = (ref5 = item.topImage.image) === null || ref5 === void 0 ? void 0 : ref5.replace("view/image/", "");
    }
    var cardRef = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createRef();
    var getIcon = function() {
        switch(item.type){
            case "Airlines":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_AirplanemodeActive__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    className: "m-auto text-white"
                });
            case "Hotels":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Hotel__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    className: "m-auto text-white"
                });
            case "Destinations":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_PinDropRounded__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    className: "m-auto text-white"
                });
            case "Offers":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_LocalOfferOutlined__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    className: "m-auto text-white"
                });
            default:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_public_small_white_logo_svg__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    className: "m-auto text-white",
                    style: {
                        transform: "scale(0.8)"
                    }
                });
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
        href: "".concat(getArticleLink(item.type, item.subtype, item.textId, item.country, item.city)),
        "aria-label": item.heading
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_RecommendationItem_module_scss__WEBPACK_IMPORTED_MODULE_12___default().card), "relative mb-6"),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_RecommendationItem_module_scss__WEBPACK_IMPORTED_MODULE_12___default().recomendationContainer),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_RecommendationItem_module_scss__WEBPACK_IMPORTED_MODULE_12___default().icon), {
                            "bg-review-iconAirlines": item.type === "Airlines",
                            "bg-review-iconHotels": item.type === "Hotels",
                            "bg-review-iconDestinations": item.type === "Destinations",
                            "bg-review-iconOther": item.type !== "Destinations" && item.type !== "Hotels" && item.type !== "Airlines"
                        }),
                        children: getIcon()
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "h-full flex md:flex-col xs:flex-col",
                        ref: cardRef,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_RecommendationItem_module_scss__WEBPACK_IMPORTED_MODULE_12___default().imageContainer), imageOut && (_RecommendationItem_module_scss__WEBPACK_IMPORTED_MODULE_12___default().imageOut)),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ImageWithFallback_ImageWithFallback__WEBPACK_IMPORTED_MODULE_3__/* .ImageWithFallback */ .J, {
                                    src: "https://media.first-class.com/" + (((ref = item.topImage) === null || ref === void 0 ? void 0 : ref.image) || item.image),
                                    objectFit: "cover",
                                    layout: "fill",
                                    alt: item.title + " image",
                                    sizes: "(max-width: 1024px) 100vw, 220px"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_RecommendationItem_module_scss__WEBPACK_IMPORTED_MODULE_12___default().text), "relative flex flex-col justify-start items-start py-5", imageOut && "pl-3"),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_RecommendationItem_module_scss__WEBPACK_IMPORTED_MODULE_12___default().type), "font-libre"),
                                        children: [
                                            item.overline ? item.overline : item.type.replace("s", "") + " " + item.subtype.replace("s", ""),
                                            item.tag && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "ml-2",
                                                children: item.tag
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_RecommendationItem_module_scss__WEBPACK_IMPORTED_MODULE_12___default().title), "font-fragment"),
                                        children: [
                                            item.subtype === "Reviews" && "Review of ",
                                            item.subtype === "Reviews" && item.type === "Hotels" && !(item.title.includes("the") || item.title.includes("The")) ? item.title : item.title.startsWith("The") ? item.title : item.title.replace("The", "the"),
                                            !!item.cabinClass && " " + item.cabinClass
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_RecommendationItem_module_scss__WEBPACK_IMPORTED_MODULE_12___default().content), "font-libre"),
                                        dangerouslySetInnerHTML: {
                                            __html: item.content
                                        }
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: (_RecommendationItem_module_scss__WEBPACK_IMPORTED_MODULE_12___default().readMore),
                                        children: "Read more"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    }));
};


/***/ }),

/***/ 55542:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14251);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(41472);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68239);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(22430);
/* harmony import */ var _mui_material_Accordion__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82280);
/* harmony import */ var _mui_material_AccordionSummary__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(38895);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90948);
/* harmony import */ var _mui_icons_material_ExpandMore__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(23508);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _ScrollableContent_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(39673);
/* harmony import */ var _ScrollableContent_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_ScrollableContent_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);











var Accordion = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Accordion__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        elevation: 0,
        square: true
    }, props));
})(function() {
    return {
        "&:before": {
            display: "none"
        },
        borderBottom: "1px solid #0000001f"
    };
});
var AccordionSummary = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_AccordionSummary__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props));
})(function() {
    return {
        "& .MuiAccordionSummary-content.Mui-expanded": {
            marginBottom: 0
        }
    };
});
var theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
    palette: {
        primary: {
            main: "#00454A"
        },
        secondary: {
            main: "#202020"
        }
    },
    typography: {
        fontFamily: '"Libre Franklin", sans-serif'
    }
});
var ScrollableContent = function(param) {
    var heading = param.heading, content = param.content, _style = param.style, style = _style === void 0 ? {} : _style, headingClass = param.headingClass, isCusomHeading = param.isCusomHeading, _expanded = param.expanded, expanded = _expanded === void 0 ? function() {} : _expanded, _isExpanded = param.isExpanded, isExpanded = _isExpanded === void 0 ? false : _isExpanded;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(isExpanded), isLocalExpanded = ref[0], setLocalExpanded = ref[1];
    var handleAccordionChange = function(event, newExpanded) {
        setLocalExpanded(newExpanded);
        expanded(event, newExpanded); // Call the parent callback if needed
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(style ? style : (_ScrollableContent_module_scss__WEBPACK_IMPORTED_MODULE_8___default().container)),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
            theme: theme,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Accordion, {
                expanded: isLocalExpanded,
                onChange: handleAccordionChange,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(AccordionSummary, {
                        expandIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_ExpandMore__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {}),
                        children: [
                            isCusomHeading && heading,
                            !isCusomHeading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                className: headingClass,
                                children: heading
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_ScrollableContent_module_scss__WEBPACK_IMPORTED_MODULE_8___default().content),
                            children: content
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ScrollableContent);


/***/ }),

/***/ 19:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ SearchBox; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(67573);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52875);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(44747);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5616);
/* harmony import */ var _mui_icons_material_Flight__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(6559);
/* harmony import */ var _mui_icons_material_Hotel__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(9001);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90948);
/* harmony import */ var _mui_material_Tabs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11703);
/* harmony import */ var _mui_material_Tab__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(40044);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_intersection_observer__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(70131);














var FlightSearch = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9989), __webpack_require__.e(4231), __webpack_require__.e(2298), __webpack_require__.e(8423), __webpack_require__.e(9980), __webpack_require__.e(293), __webpack_require__.e(7522), __webpack_require__.e(5105), __webpack_require__.e(7647)]).then(__webpack_require__.bind(__webpack_require__, 75105));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(75105)
            ];
        }
    }
});
var HotelSearch = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9989), __webpack_require__.e(4231), __webpack_require__.e(2298), __webpack_require__.e(8423), __webpack_require__.e(7522), __webpack_require__.e(5494), __webpack_require__.e(7916)]).then(__webpack_require__.bind(__webpack_require__, 81666));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(81666)
            ];
        }
    }
});
var StyledTabs = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Tabs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props), {
        TabIndicatorProps: {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "MuiTabs-indicatorSpan"
            })
        }
    }));
})({
    "& .MuiTabs-indicator": {
        display: "flex",
        justifyContent: "center",
        backgroundColor: "transparent"
    },
    "& .MuiTabs-indicatorSpan": {
        width: "100%",
        backgroundColor: "transparent"
    }
});
function TabPanel(props) {
    var children = props.children, value = props.value, index = props.index, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(props, [
        "children",
        "value",
        "index"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        role: "tabpanel",
        hidden: value !== index,
        id: "simple-tabpanel-".concat(index),
        "aria-labelledby": "simple-tab-".concat(index)
    }, other), {
        children: value === index && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            children: children
        })
    }));
}
var StyledTab = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Tab__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        disableRipple: true
    }, props));
})(function(param) {
    var theme = param.theme;
    return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
        textTransform: "none",
        fontWeight: theme.typography.fontWeightRegular,
        fontSize: theme.typography.pxToRem(16),
        height: 48,
        position: "relative",
        bottom: "-1px",
        color: "rgba(255, 255, 255, 0.7)",
        "&.Mui-selected": {
            color: "#fff"
        },
        "&.Mui-focusVisible": {
            backgroundColor: "transparent"
        },
        "&.MuiButtonBase-root": {
            padding: 16,
            height: 48,
            maxHeight: 48,
            minHeight: 48
        }
    }, theme.breakpoints.down("md"), {
        "&.MuiButtonBase-root": {
            width: "50%"
        }
    });
});
var SearchBox = function(param) {
    var type = param.type, activeTab = param.activeTab, hotelSearchValue = param.hotelSearchValue, flightSearchValue = param.flightSearchValue, searchSource = param.searchSource;
    var handleChange = function(event, newValue) {
        setTab(newValue);
    };
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(activeTab), tab = ref[0], setTab = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(type), activeType = ref1[0], setActiveType = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), flightSearchState = ref2[0], setFlightSearchState = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (flightSearchValue) {
            setTimeout(function() {
                setFlightSearchState(flightSearchValue);
            }, 100);
        }
    }, [
        flightSearchValue
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setTab(activeTab);
    }, [
        activeTab
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setActiveType(type);
    }, [
        type
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        sx: {
            width: "100%",
            filter: "drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.05))"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                sx: {
                    borderBottom: 8,
                    borderColor: tab ? "#7E183D" : "#00454A",
                    background: "transparent"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledTabs, {
                    value: tab,
                    onChange: handleChange,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledTab, {
                            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                style: {
                                    transform: "skew(-30deg)"
                                },
                                className: "border border-white rounded-full mr-2",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Flight__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                    style: {
                                        width: "30px",
                                        height: "30px",
                                        padding: "6px"
                                    }
                                })
                            }),
                            iconPosition: "start",
                            label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                style: {
                                    transform: "skew(-30deg)"
                                },
                                children: "Flight"
                            }),
                            className: "font-libre",
                            sx: {
                                background: tab ? "#012426" : "#00454A",
                                zIndex: 1,
                                color: "white",
                                height: "50px",
                                minWidth: "162px",
                                transform: "skew(30deg)",
                                left: "-15px",
                                borderTopRightRadius: "8px"
                            }
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledTab, {
                            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                style: {
                                    transform: "skew(-30deg)"
                                },
                                className: "border border-white rounded-full mr-2",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Hotel__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                    style: {
                                        width: "30px",
                                        height: "30px",
                                        padding: "6px"
                                    }
                                })
                            }),
                            iconPosition: "start",
                            className: "font-libre",
                            label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                style: {
                                    transform: "skew(-30deg)"
                                },
                                children: "Hotel"
                            }),
                            sx: {
                                background: tab ? "#7E183D" : "#580E28",
                                color: "white",
                                height: "50px",
                                minWidth: "162px",
                                transform: "skew(30deg)",
                                left: "-22px",
                                borderTopRightRadius: "8px"
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TabPanel, {
                value: tab,
                index: 0,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    sx: {
                        width: "100%",
                        background: "white",
                        padding: [
                            "1rem 0",
                            "1rem 2rem",
                            "1rem 2rem"
                        ],
                        minHeight: [
                            "480px",
                            "120px"
                        ]
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FlightSearch, {
                            collapsed: false,
                            viewMode: activeType,
                            disablePortal: false,
                            flightSearchValueProp: flightSearchState,
                            searchSource: searchSource
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TabPanel, {
                value: tab,
                index: 1,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    sx: {
                        width: "100%",
                        background: "white",
                        padding: [
                            "1rem 0",
                            "1rem 2rem",
                            "1rem 2rem"
                        ],
                        minHeight: "120px"
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intersection_observer__WEBPACK_IMPORTED_MODULE_13__/* .InView */ .df, {
                        triggerOnce: true,
                        children: function(param) {
                            var inView = param.inView, ref = param.ref;
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                ref: ref,
                                className: "w-full",
                                children: inView && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HotelSearch, {
                                    viewMode: "mainSearch",
                                    value: hotelSearchValue
                                })
                            });
                        }
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 97946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ StarRating; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67573);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _StarRating_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56915);
/* harmony import */ var _StarRating_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_StarRating_module_scss__WEBPACK_IMPORTED_MODULE_2__);




var StarRating = function(param) {
    var rating = param.rating, label = param.label, _hideTextRating = param.hideTextRating, hideTextRating = _hideTextRating === void 0 ? false : _hideTextRating, _small = param.small, small = _small === void 0 ? false : _small, _inactive = param.inactive, inactive = _inactive === void 0 ? false : _inactive;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_StarRating_module_scss__WEBPACK_IMPORTED_MODULE_2___default().bcReviewScores),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_StarRating_module_scss__WEBPACK_IMPORTED_MODULE_2___default().stars0), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, (_StarRating_module_scss__WEBPACK_IMPORTED_MODULE_2___default().stars0Small), small), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, (_StarRating_module_scss__WEBPACK_IMPORTED_MODULE_2___default().stars0Inactive), inactive), (_StarRating_module_scss__WEBPACK_IMPORTED_MODULE_2___default())["stars".concat(rating)], {
                    "mr-2": !hideTextRating
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                children: label
            }),
            !hideTextRating && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    "\xa0",
                    "-",
                    "\xa0",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        children: [
                            rating,
                            "/10"
                        ]
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 60306:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CL": function() { return /* reexport */ About; },
  "PS": function() { return /* reexport */ AirlineReviewsList; },
  "d2": function() { return /* reexport */ Article; },
  "fO": function() { return /* reexport */ ArticlesList; },
  "MD": function() { return /* reexport */ AuthorBlock; },
  "JV": function() { return /* reexport */ AuthorPopup; },
  "k7": function() { return /* reexport */ Breadcrumbs/* BCBreadcrumbs */.k; },
  "M2": function() { return /* reexport */ Carousel/* BCCarousel */.M; },
  "Vp": function() { return /* reexport */ CircleRating; },
  "Cy": function() { return /* reexport */ CookiesPolicy; },
  "LC": function() { return /* reexport */ CountryAccordion; },
  "OP": function() { return /* reexport */ CountrySelect; },
  "A_": function() { return /* reexport */ CustomizedAccordion; },
  "ex": function() { return /* reexport */ DestinationItem; },
  "F8": function() { return /* reexport */ DestinationList; },
  "vb": function() { return /* reexport */ DropDown; },
  "Wj": function() { return /* reexport */ HotelReviewsList; },
  "JG": function() { return /* reexport */ ImageWithFallback/* ImageWithFallback */.J; },
  "GS": function() { return /* reexport */ OfferPage; },
  "pu": function() { return /* reexport */ PrivacyPolicy; },
  "AP": function() { return /* reexport */ ProgressMeter; },
  "Hm": function() { return /* reexport */ RatingBadge/* RatingBadge */.H; },
  "Rj": function() { return /* reexport */ SearchBox/* SearchBox */.R; },
  "t2": function() { return /* reexport */ TermsConditions; },
  "Fz": function() { return /* reexport */ VintageButton; },
  "Ch": function() { return /* reexport */ VintageHeader; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(67573);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(80969);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(52875);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(44747);
;// CONCATENATED MODULE: ./components/DropDown/DropDownItem/Item.jsx





var DropDownItem = function(_param) {
    var item = _param.item, props = (0,_object_without_properties/* default */.Z)(_param, [
        "item"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: item.label
    }));
};

// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/popper.js + 53 modules
var popper = __webpack_require__(95551);
// EXTERNAL MODULE: ./components/DropDown/Dropdown.module.scss
var Dropdown_module = __webpack_require__(40675);
var Dropdown_module_default = /*#__PURE__*/__webpack_require__.n(Dropdown_module);
// EXTERNAL MODULE: ./components/assets/Arrow.module.scss
var Arrow_module = __webpack_require__(86837);
var Arrow_module_default = /*#__PURE__*/__webpack_require__.n(Arrow_module);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/KeyboardArrowDownRounded.js
var KeyboardArrowDownRounded = __webpack_require__(71496);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
;// CONCATENATED MODULE: ./components/DropDown/DropDown.jsx











var DropDown = function(param) {
    var label = param.label, items = param.items, _child = param.child, child = _child === void 0 ? false : _child, _href = param.href, href = _href === void 0 ? "#" : _href, rel = param.rel, transparentHeader = param.transparentHeader, columnsNumber = param.columnsNumber, _isForumShown = param.isForumShown, isForumShown = _isForumShown === void 0 ? false : _isForumShown;
    var userStore = (0,es/* useSelector */.v9)(function(state) {
        return state.user.value;
    });
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), dropdownPopoverShow = ref[0], setDropdownPopoverShow = ref[1];
    var dropdownHandlerRef = /*#__PURE__*/ react.createRef();
    var popoverDropdownRef = /*#__PURE__*/ react.createRef();
    var openDropdownPopover = function() {
        (0,popper/* createPopper */.fi)(dropdownHandlerRef.current, popoverDropdownRef.current, {
            placement: child ? "right-start" : "bottom"
        });
        setDropdownPopoverShow(true);
    };
    var closeDropdownPopover = function() {
        setDropdownPopoverShow(false);
    };
    var _obj, _obj1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            onMouseEnter: openDropdownPopover,
            onMouseLeave: closeDropdownPopover,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()((Dropdown_module_default()).dropDownContainer, {
                        "px-4 py-2": !!child
                    }, "font-libre", "relative", "flex", "w-full"),
                    ref: dropdownHandlerRef,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: classnames_default()((_obj = {}, (0,_define_property/* default */.Z)(_obj, (Dropdown_module_default()).dropDownLinkLight, !child && transparentHeader), (0,_define_property/* default */.Z)(_obj, (Dropdown_module_default()).dropDownLink, child || !transparentHeader), _obj), "w-full"),
                            "aria-label": label + " menu item",
                            href: href,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: label
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowDownRounded/* default */.Z, {
                            className: classnames_default()((_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, (Arrow_module_default()).arrow, !child && transparentHeader), (0,_define_property/* default */.Z)(_obj1, (Arrow_module_default()).arrowBlack, child), (0,_define_property/* default */.Z)(_obj1, (Arrow_module_default()).arrowBlackHeading, !child && !transparentHeader), _obj1))
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    ref: popoverDropdownRef,
                    className: classnames_default()((0,_define_property/* default */.Z)({
                        block: dropdownPopoverShow,
                        hidden: !dropdownPopoverShow
                    }, "grid grid-cols-".concat(columnsNumber), columnsNumber), "text-black", "z-50", "float-left", "list-none", "text-left", "bg-white", (Dropdown_module_default()).card),
                    children: [
                        isForumShown && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "relative",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "/forum",
                                "aria-label": "Forum menu item",
                                className: (Dropdown_module_default()).dropDownLink,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "px-4 py-2",
                                    children: "Forum"
                                })
                            })
                        }),
                        items.length && items.map(function(item) {
                            var ref;
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                className: "relative",
                                children: ((ref = item.children) === null || ref === void 0 ? void 0 : ref.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DropDown, {
                                    label: item.label,
                                    items: item.children,
                                    child: true,
                                    href: item.href,
                                    action: item.action
                                }) : item.href ? item.isShownForLoggedInUsers ? (userStore === null || userStore === void 0 ? void 0 : userStore.userid) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: (Dropdown_module_default()).dropDownLink,
                                    href: item.href,
                                    rel: rel,
                                    "aria-label": item.label + "menu item",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DropDownItem, {
                                        className: "px-4 py-2",
                                        item: item
                                    })
                                }) : null : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: (Dropdown_module_default()).dropDownLink,
                                    href: item.href,
                                    rel: rel,
                                    "aria-label": item.label + "menu item",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DropDownItem, {
                                        className: "px-4 py-2",
                                        item: item
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    role: "menuitem",
                                    "aria-label": item.label,
                                    className: (Dropdown_module_default()).dropDownLink,
                                    onClick: function() {
                                        item.action();
                                        closeDropdownPopover();
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DropDownItem, {
                                        className: "px-4 py-2",
                                        item: item
                                    })
                                })
                            }, item.label);
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./config/index.js + 2 modules
var config = __webpack_require__(74907);
// EXTERNAL MODULE: ./utils/httpClient.js
var httpClient = __webpack_require__(22550);
;// CONCATENATED MODULE: ./components/utils/changeCountry.js

function changeCountry(code, session) {
    (0,httpClient/* httpPut */.e8)("/api/user/country", {
        country: code
    }).then(function() {
        session();
    });
}

// EXTERNAL MODULE: ./components/CountrySelect/CountrySelect.module.scss
var CountrySelect_module = __webpack_require__(82117);
var CountrySelect_module_default = /*#__PURE__*/__webpack_require__.n(CountrySelect_module);
;// CONCATENATED MODULE: ./components/CountrySelect/CountrySelect.jsx













var CountryListItem = function(param) {
    var country = param.country, session = param.session, closeDropdown = param.closeDropdown;
    var handleClick = (0,react.useCallback)(function() {
        changeCountry(country, session);
        closeDropdown();
    }, [
        country,
        session,
        closeDropdown
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        className: "relative",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex items-center h-8",
            onClick: handleClick,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: classnames_default()((CountrySelect_module_default()).flag32, "mr-1 flag-32 flag-".concat(country.toLowerCase()))
                }),
                config/* COUNTRIES */.od[country]
            ]
        })
    });
};
var MemoizedCountryListItem = /*#__PURE__*/ (0,react.memo)(CountryListItem);
var CountrySelectComponent = function(_param) {
    var selectedCountry = _param.selectedCountry, transparentHeader = _param.transparentHeader, session = _param.session, props = (0,_object_without_properties/* default */.Z)(_param, [
        "selectedCountry",
        "transparentHeader",
        "session"
    ]);
    var ref = (0,react.useState)(false), dropdownPopoverShow = ref[0], setDropdownPopoverShow = ref[1];
    // const dropdownHandlerRef = createRef();
    // const popoverDropdownRef = createRef();
    var dropdownHandlerRef = (0,react.useRef)(null);
    var popoverDropdownRef = (0,react.useRef)(null);
    // const openDropdownPopover = () => {
    //   createPopper(dropdownHandlerRef.current, popoverDropdownRef.current, {
    //     placement: 'bottom',
    //   });
    //   setDropdownPopoverShow(true);
    // };
    var openDropdownPopover = (0,react.useCallback)(function() {
        if (!dropdownPopoverShow) {
            (0,popper/* createPopper */.fi)(dropdownHandlerRef.current, popoverDropdownRef.current, {
                placement: "bottom"
            });
            setDropdownPopoverShow(true);
        }
    }, [
        dropdownPopoverShow
    ]);
    // const closeDropdownPopover = () => {
    //   setDropdownPopoverShow(false);
    // };
    var closeDropdownPopover = (0,react.useCallback)(function() {
        setDropdownPopoverShow(false);
    }, []);
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        onMouseLeave: closeDropdownPopover,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("relative", "flex items-center", "w-full", "font-libre"),
                ref: dropdownHandlerRef,
                onMouseEnter: openDropdownPopover,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: classnames_default()((CountrySelect_module_default()).flag32, "flag-32 flag-".concat(selectedCountry === null || selectedCountry === void 0 ? void 0 : selectedCountry.toLowerCase()))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowDownRounded/* default */.Z, {
                        className: classnames_default()((_obj = {}, (0,_define_property/* default */.Z)(_obj, (Arrow_module_default()).arrow, transparentHeader), (0,_define_property/* default */.Z)(_obj, (Arrow_module_default()).arrowBlackHeading, !transparentHeader), _obj))
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                ref: popoverDropdownRef,
                className: classnames_default()({
                    block: dropdownPopoverShow,
                    hidden: !dropdownPopoverShow
                }, "text-black", "float-left", "list-none", "text-left", "bg-white", "grid grid-cols-3", "px-3 py-2", (CountrySelect_module_default()).card),
                children: Object.keys(config/* COUNTRIES */.od).map(function(country) {
                    return(// <li key={country} className="relative">
                    //   <div
                    //     className="flex items-center h-8"
                    //     onClick={() => {
                    //       changeCountry(country, session);
                    //       closeDropdownPopover();
                    //     }}
                    //   >
                    //     <span
                    //       className={cn(
                    //         styles.flag32,
                    //         `flag-32 flag-${country.toLowerCase()}`
                    //       )}
                    //     />
                    //     {COUNTRIES[country]}
                    //   </div>
                    // </li>
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MemoizedCountryListItem, {
                        country: country,
                        session: session,
                        closeDropdown: closeDropdownPopover
                    }, country));
                })
            })
        ]
    }));
};
var CountrySelect = /*#__PURE__*/ (0,react.memo)(CountrySelectComponent);

// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./components/Accordion/Accordion.module.scss
var Accordion_module = __webpack_require__(58471);
var Accordion_module_default = /*#__PURE__*/__webpack_require__.n(Accordion_module);
// EXTERNAL MODULE: ./node_modules/@mui/material/Accordion/Accordion.js + 3 modules
var Accordion = __webpack_require__(82280);
// EXTERNAL MODULE: ./node_modules/@mui/material/AccordionSummary/AccordionSummary.js + 1 modules
var AccordionSummary = __webpack_require__(38895);
// EXTERNAL MODULE: ./node_modules/@mui/material/AccordionDetails/AccordionDetails.js + 1 modules
var AccordionDetails = __webpack_require__(22797);
;// CONCATENATED MODULE: ./components/Accordion/Accordion.jsx













var Accordion_Accordion = (0,styled/* default */.ZP)(function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, (0,_object_spread/* default */.Z)({
        disableGutters: true,
        elevation: 0,
        square: true
    }, props));
})(function() {
    return {
        color: "#202020",
        "&:not(:last-child)": {
            borderBottom: 0,
            borderTop: 0
        },
        "&:before": {
            display: "none"
        }
    };
});
var Accordion_AccordionSummary = (0,styled/* default */.ZP)(function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionSummary/* default */.Z, (0,_object_spread/* default */.Z)({
        expandIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowDownRounded/* default */.Z, {
            className: (Arrow_module_default()).arrowBlack
        })
    }, props));
})(function() {
    return {
        padding: 0,
        border: 0,
        backgroundColor: "transparent",
        flexDirection: "row-reverse",
        "& .MuiAccordionSummary-expandIconWrapper": {
            position: "absolute",
            right: 0
        },
        "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
            transform: "rotate(90deg)"
        },
        "& .MuiAccordionSummary-content": {
            margin: 0
        }
    };
});
var Accordion_AccordionDetails = (0,styled/* default */.ZP)(AccordionDetails/* default */.Z)(function() {
    return {
        padding: "8px 0 8px 16px"
    };
});
var CustomizedAccordion = function(param) {
    var children = param.children, label = param.label, items = param.items, collapse = param.collapse, currentCountry = param.currentCountry, columnsNumber = param.columnsNumber;
    var ref = (0,react.useState)(false), expandedState = ref[0], setExpandedState = ref[1];
    var handleChange = function() {
        setExpandedState(!expandedState);
    };
    (0,react.useEffect)(function() {
        if (collapse) {
            setExpandedState(false);
        }
    }, [
        collapse
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion_Accordion, {
            expanded: expandedState,
            onChange: function() {
                return handleChange();
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion_AccordionSummary, {
                    children: children ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: classnames_default()((Accordion_module_default()).flag32, "flag-32 flag-".concat(currentCountry === null || currentCountry === void 0 ? void 0 : currentCountry.toLowerCase(), " mr-2"))
                            }),
                            config/* COUNTRIES */.od[currentCountry === null || currentCountry === void 0 ? void 0 : currentCountry.toUpperCase()]
                        ]
                    }) : label
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion_AccordionDetails, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()((0,_define_property/* default */.Z)({}, "grid grid-cols-".concat(columnsNumber), columnsNumber)),
                        children: children ? children : items.map(function(item, idx) {
                            var ref;
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()((Accordion_module_default()).itemChild, "p-1"),
                                children: ((ref = item.children) === null || ref === void 0 ? void 0 : ref.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomizedAccordion, {
                                    items: item.children,
                                    label: item.label
                                }) : item.href ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: item.href,
                                    children: item.label
                                }, item.label) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    onClick: function() {
                                        item.action();
                                        setExpandedState(false);
                                    },
                                    children: item.label
                                }, item.label)
                            }, idx);
                        })
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/CountryAccrodion/CountryAccordion.jsx








var CountryAccordion = function(param) {
    var currentCountry = param.currentCountry, session = param.session, columnsNumber = param.columnsNumber;
    var ref = (0,react.useState)(0), collapse = ref[0], setCollapse = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomizedAccordion, {
        currentCountry: currentCountry,
        collapse: collapse,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classnames_default()((0,_define_property/* default */.Z)({}, "grid grid-cols-".concat(columnsNumber), columnsNumber)),
            children: Object.keys(config/* COUNTRIES */.od).map(function(country) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative font-libre",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center cursor-pointer",
                        style: {
                            minHeight: 32
                        },
                        onClick: function() {
                            changeCountry(country, session);
                            setCollapse(collapse + 1);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: classnames_default()((Accordion_module_default()).flag32, "flag-32 flag-".concat(country.toLowerCase(), " mr-2"))
                            }),
                            config/* COUNTRIES */.od[country]
                        ]
                    })
                }, country);
            })
        })
    });
};

// EXTERNAL MODULE: ./components/RatingBadge/RatingBadge.js + 4 modules
var RatingBadge = __webpack_require__(92944);
// EXTERNAL MODULE: ./components/Carousel/Carousel.jsx
var Carousel = __webpack_require__(30948);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(34727);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@material-ui/unstyled/NoSsr/NoSsr.js
var NoSsr = __webpack_require__(60898);
// EXTERNAL MODULE: ./node_modules/html-react-parser/index.mjs
var html_react_parser = __webpack_require__(25935);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/react-intersection-observer.m.js
var react_intersection_observer_m = __webpack_require__(70131);
// EXTERNAL MODULE: ./utils/cabinClasses.js
var utils_cabinClasses = __webpack_require__(11723);
// EXTERNAL MODULE: ./utils/setImageUrl.js
var setImageUrl = __webpack_require__(22670);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/Article/Article.module.scss
var Article_module = __webpack_require__(54510);
var Article_module_default = /*#__PURE__*/__webpack_require__.n(Article_module);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/HotelReview/components/BookNow.jsx
var BookNow = __webpack_require__(17518);
;// CONCATENATED MODULE: ./components/Article/Article.jsx





















var CallToSignUp = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4231), __webpack_require__.e(6700), __webpack_require__.e(8307), __webpack_require__.e(4522)]).then(__webpack_require__.bind(__webpack_require__, 68307));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(68307)
            ];
        }
    }
});
var FlightSearch = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9989), __webpack_require__.e(4231), __webpack_require__.e(2298), __webpack_require__.e(8423), __webpack_require__.e(9980), __webpack_require__.e(293), __webpack_require__.e(7522), __webpack_require__.e(5105), __webpack_require__.e(7647)]).then(__webpack_require__.bind(__webpack_require__, 75105));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(75105)
            ];
        }
    }
});
var RecommendationsList = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9972).then(__webpack_require__.bind(__webpack_require__, 39972));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(39972)
            ];
        }
    }
});
var SocialMediaLinks = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7401).then(__webpack_require__.bind(__webpack_require__, 17401));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(17401)
            ];
        }
    }
});
var ScrollableContent = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 55542));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(55542)
            ];
        }
    }
});
function Article(param) {
    var article = param.article, recommendation = param.recommendation, setLoginDialogState = param.setLoginDialogState, authCompleted = param.authCompleted;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
    var FlightSearchIndicator = "---FlightSearch---";
    var userStore = (0,es/* useSelector */.v9)(function(state) {
        return state.user.value;
    });
    var router = (0,next_router.useRouter)();
    var ref13 = (0,react.useState)(null), seoSchema = ref13[0], setSeoSchema = ref13[1];
    var ref14 = (0,react.useState)(0), mediaHeight = ref14[0], setMediaHeight = ref14[1];
    var ref15 = (0,react.useState)(0), mediaWidth = ref15[0], setMediaWidth = ref15[1];
    var imageRef = /*#__PURE__*/ (0,react.createRef)();
    (0,react.useEffect)(function() {
        var ref;
        if ((ref = article.contentMetaData) === null || ref === void 0 ? void 0 : ref.seoSchema) {
            setSeoSchema((0,html_react_parser/* default */.ZP)(article === null || article === void 0 ? void 0 : article.contentMetaData.seoSchema));
        }
    }, [
        article
    ]);
    (0,react.useEffect)(function() {
        if (imageRef === null || imageRef === void 0 ? void 0 : imageRef.current) {
            setMediaHeight(imageRef.current.offsetWidth / 1.78);
            setMediaWidth(imageRef.current.offsetWidth);
        }
    }, [
        imageRef
    ]);
    var ref16 = (0,react.useState)(null), authorizedContent = ref16[0], setAuthorizedContent = ref16[1];
    var ref17 = (0,react.useState)(false), authorizedContentExpired = ref17[0], setAuthorizedContentExpired = ref17[1];
    var options = {
        replace: function(domNode) {
            var ref, ref1, ref2, ref3, ref4;
            if (domNode.type === "tag" && domNode.name === "a") {
                var ref5, ref6;
                if ((ref5 = domNode.attribs) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.href) === null || ref6 === void 0 ? void 0 : ref6.includes("http")) {
                    var ref7, ref8, ref9;
                    if (((ref7 = domNode.attribs) === null || ref7 === void 0 ? void 0 : ref7.target) === "_blank") {
                        domNode.attribs.target = "_blank";
                    }
                    if ((ref8 = domNode.attribs) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.rel) === null || ref9 === void 0 ? void 0 : ref9.includes("sponsored")) {
                        domNode.attribs.rel = "noreferrer noopener sponsored";
                    } else {
                        domNode.attribs.rel = "noreferrer noopener nofollow";
                    }
                }
            }
            if (domNode.type === "tag" && domNode.attribs.class === "image-inline" && domNode.children[0].name === "video") {
                var videoSrc = domNode.children[0].children.find(function(node) {
                    return node.name === "source";
                }).attribs.src;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "video",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                        autoPlay: true,
                        muted: true,
                        loop: true,
                        style: {
                            height: mediaHeight,
                            width: mediaWidth
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                            src: videoSrc
                        })
                    })
                });
            }
            if (domNode.type === "tag" && domNode.name === "video" && !!domNode.attribs.src) {
                var ref10, ref11;
                var videoSrc1 = "https://media.first-class.com/" + domNode.attribs.src.replace("/", "");
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                    autoPlay: true,
                    muted: true,
                    loop: true,
                    style: {
                        height: (imageRef === null || imageRef === void 0 ? void 0 : (ref10 = imageRef.current) === null || ref10 === void 0 ? void 0 : ref10.offsetWidth) / 1.78,
                        width: imageRef === null || imageRef === void 0 ? void 0 : (ref11 = imageRef.current) === null || ref11 === void 0 ? void 0 : ref11.offsetWidth
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                        src: videoSrc1
                    })
                });
            }
            // if (domNode.type === 'tag' && domNode.name === 'video' && !domNode.attribs.src) {
            //   const videoSrc = process.env.mediaUrl + domNode.children[0].find(
            //     (node) => node.name === 'source'
            //   ).attribs.src;
            //   return (
            //     <video autoPlay muted loop>
            //       <source src={videoSrc} />
            //     </video>
            //   );
            // }
            var findVideoNode = function(domNode) {
                if (!domNode) return null;
                if (domNode.name === "video") {
                    return domNode;
                } else {
                    return findVideoNode(domNode.children.find(function(node) {
                        return node.type === "tag";
                    }));
                }
            };
            var findImageNode = function(domNode) {
                if (domNode) {
                    if (domNode.name === "img") {
                        return domNode;
                    } else {
                        var figureNode = domNode.children.find(function(node) {
                            return node.name === "figure";
                        });
                        if (figureNode) {
                            return findImageNode(figureNode);
                        } else {
                            return findImageNode(domNode.children.find(function(node) {
                                return node.type === "tag";
                            }));
                        }
                    }
                } else {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: "Wrong tag"
                    });
                }
            };
            if (domNode.name === "div" && domNode.attribs.id === "scrollable" && domNode.children[0].name !== "details") {
                var heading;
                var findHeading = function(nodes) {
                    if (nodes.length) {
                        nodes.forEach(function(node) {
                            var ref, ref1;
                            if (((ref = node.attribs) === null || ref === void 0 ? void 0 : ref.id) === "heading") {
                                heading = [
                                    node
                                ];
                            } else if ((ref1 = node.children) === null || ref1 === void 0 ? void 0 : ref1.length) {
                                findHeading(node.children);
                            }
                        });
                    }
                };
                findHeading(domNode.children);
                var content = domNode.children.filter(function(node) {
                    var ref;
                    return ((ref = node.attribs) === null || ref === void 0 ? void 0 : ref.id) !== "heading";
                });
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollableContent, {
                    heading: (0,html_react_parser/* domToReact */.du)(heading, options),
                    content: (0,html_react_parser/* domToReact */.du)(content, options),
                    style: (Article_module_default()).scrollableContent
                });
            }
            if (domNode.name === "details") {
                var heading1;
                var findHeading1 = function(nodes) {
                    if (nodes.length) {
                        nodes.forEach(function(node) {
                            var ref;
                            if (node.name === "summary") {
                                heading1 = [
                                    node.children[0]
                                ];
                            } else if ((ref = node.children) === null || ref === void 0 ? void 0 : ref.length) {
                                findHeading1(node.children);
                            }
                        });
                    }
                };
                findHeading1(domNode.children);
                var content1 = domNode.children.filter(function(node) {
                    return node.attribs.class === "accordion_content";
                });
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollableContent, {
                    heading: (0,html_react_parser/* domToReact */.du)(heading1, options),
                    content: (0,html_react_parser/* domToReact */.du)(content1, options),
                    style: (Article_module_default()).scrollableContent
                });
            }
            if (domNode.type === "tag" && domNode.name === "div" && ((ref = domNode.attribs.class) === null || ref === void 0 ? void 0 : ref.includes("bookNow_content"))) {
                var findDomNodeData = function(node) {
                    var ref, ref1;
                    if (node.data && node.data.trim() !== "") {
                        return node.data;
                    }
                    var ref2;
                    return (ref2 = (ref1 = (ref = node.children) === null || ref === void 0 ? void 0 : ref.map(function(n) {
                        return findDomNodeData(n);
                    })) === null || ref1 === void 0 ? void 0 : ref1.flat()) !== null && ref2 !== void 0 ? ref2 : [];
                };
                var data = findDomNodeData(domNode);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(BookNow/* BookNow */.U, {
                    hotelName: data[0],
                    link: data[1]
                });
            }
            if (domNode.type === "tag" && domNode.name === "div" && ((ref1 = domNode.attribs.class) === null || ref1 === void 0 ? void 0 : ref1.includes("cta"))) {
                var ref12;
                var cleanContentEditable = function(node) {
                    var ref, ref1;
                    if (node.attribs && node.attribs.contenteditable !== undefined) {
                        delete node.attribs.contenteditable;
                    }
                    if (node.attribs && ((ref = node.attribs.class) === null || ref === void 0 ? void 0 : ref.includes("ck-widget"))) {
                        node.attribs.class = node.attribs.class.replace("ck-widget", "");
                    }
                    if (node.attribs && ((ref1 = node.attribs.class) === null || ref1 === void 0 ? void 0 : ref1.includes("ck-editor__editable ck-editor__nested-editable"))) {
                        node.attribs.class = node.attribs.class.replace("ck-editor__editable ck-editor__nested-editable", "");
                    }
                    if (node.children) {
                        node.children.forEach(cleanContentEditable);
                    }
                    return node;
                };
                var cleanedNode = cleanContentEditable(domNode);
                var header = cleanedNode.children.find(function(child) {
                    var ref;
                    return (ref = child.attribs) === null || ref === void 0 ? void 0 : ref.class.includes("cta-header");
                });
                var subheader = cleanedNode.children.find(function(child) {
                    var ref;
                    return (ref = child.attribs) === null || ref === void 0 ? void 0 : ref.class.includes("cta-subheader");
                });
                var button = cleanedNode.children.find(function(child) {
                    var ref;
                    return (ref = child.attribs) === null || ref === void 0 ? void 0 : ref.class.includes("cta-button");
                });
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Article_module_default()).cta,
                    children: [
                        (header === null || header === void 0 ? void 0 : header.children[0].data) && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: (Article_module_default()).ctaHeader,
                            children: header === null || header === void 0 ? void 0 : header.children[0].data
                        }),
                        (subheader === null || subheader === void 0 ? void 0 : subheader.children[0].data) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (Article_module_default()).ctaSubheader,
                            children: subheader === null || subheader === void 0 ? void 0 : subheader.children[0].data
                        }),
                        (button === null || button === void 0 ? void 0 : button.children[0].data) && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: button === null || button === void 0 ? void 0 : (ref12 = button.attribs) === null || ref12 === void 0 ? void 0 : ref12.href,
                            className: (Article_module_default()).ctaButton,
                            children: button === null || button === void 0 ? void 0 : button.children[0].data
                        })
                    ]
                });
            }
            if (domNode.type === "tag" && domNode.name === "p" && ((ref2 = domNode.children[0].data) === null || ref2 === void 0 ? void 0 : ref2.trim()) === FlightSearchIndicator || domNode.type === "tag" && domNode.name === "div" && ((ref3 = domNode.attribs.class) === null || ref3 === void 0 ? void 0 : ref3.includes("flightsearch_content"))) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_intersection_observer_m/* InView */.df, {
                    triggerOnce: true,
                    children: function(param) {
                        var inView = param.inView, ref = param.ref;
                        var ref1, ref2, ref3, ref4;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                            ref: ref,
                            className: (Article_module_default()).flightSearch,
                            children: inView && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-full hidden xl:block",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FlightSearch, {
                                            contentSearch: true,
                                            collapsed: false,
                                            viewMode: "mainSearch",
                                            disablePortal: false,
                                            airlineName: (ref1 = article.airline) === null || ref1 === void 0 ? void 0 : ref1.name,
                                            airlineCode: (ref2 = article.airline) === null || ref2 === void 0 ? void 0 : ref2.code,
                                            airlineClass: utils_cabinClasses/* CABIN_CLASSES.find */.r.find(function(cabin) {
                                                return cabin.value === "ECO";
                                            }).label,
                                            searchSource: "".concat(article.type, " ").concat(article.subtype)
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-full block xl:hidden",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FlightSearch, {
                                            contentSearch: true,
                                            collapsed: false,
                                            viewMode: "sideSearch",
                                            disablePortal: false,
                                            airlineName: (ref3 = article.airline) === null || ref3 === void 0 ? void 0 : ref3.name,
                                            airlineCode: (ref4 = article.airline) === null || ref4 === void 0 ? void 0 : ref4.code,
                                            airlineClass: utils_cabinClasses/* CABIN_CLASSES.find */.r.find(function(cabin) {
                                                return cabin.value === "ECO";
                                            }).label,
                                            searchSource: "".concat(article.type, " ").concat(article.subtype)
                                        })
                                    })
                                ]
                            })
                        });
                    }
                });
            }
            if (domNode.type === "tag" && domNode.name === "p" && domNode.children[0].name === "iframe") {
                delete domNode.children[0].attribs.height;
                delete domNode.children[0].attribs.width;
                delete domNode.children[0].attribs.allowfullscreen;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Article_module_default()).youtubeIframe,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", (0,_object_spread/* default */.Z)({}, domNode.children[0].attribs))
                });
            }
            if (domNode.type === "tag" && domNode.name === "div" && (domNode.attribs.class === "image-carousel-inline-large" || ((ref4 = domNode.attribs.class) === null || ref4 === void 0 ? void 0 : ref4.includes("carousel_content")))) {
                var carouselImages = [];
                domNode.children.forEach(function(child, index) {
                    if (child.attribs && (child.attribs.class === "image-inline" || child.attribs.class === "image" || child.attribs.class === "image-style-side")) {
                        var figcaption = child.children.find(function(node) {
                            return node.name === "figcaption";
                        });
                        carouselImages.push({
                            src: findImageNode(child).attribs.src,
                            figcaption: !!(figcaption === null || figcaption === void 0 ? void 0 : figcaption.children.length) && figcaption.children[0],
                            alt: child.children[0].attribs.alt || "".concat(article.type, " ").concat(article.subtype, " - ").concat(article.title, " - ").concat(index)
                        });
                    }
                });
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Article_module_default()).carouselWrapper,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel/* BCCarousel */.M, {
                        children: carouselImages.map(function(img, index) {
                            var ref, ref1;
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                ref: imageRef,
                                className: (Article_module_default()).imageInline,
                                style: {
                                    height: mediaHeight
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
                                    className: "image-inline",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: (0,setImageUrl/* setImageUrl */.B)(img.src),
                                            alt: img.alt,
                                            blurDataURL: index && !((ref = img.src) === null || ref === void 0 ? void 0 : ref.includes("/_next/image")) ? "/_next/image?url=".concat((0,setImageUrl/* setImageUrl */.B)(img.src), "&w=16&q=1") : null,
                                            layout: "fill",
                                            objectFit: "cover",
                                            placeholder: index && !((ref1 = img.src) === null || ref1 === void 0 ? void 0 : ref1.includes("/_next/image")) ? "blur" : null
                                        }),
                                        img.figcaption && img.figcaption.children && /*#__PURE__*/ (0,jsx_runtime.jsx)("figcaption", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, img.figcaption.attribs), {
                                                rel: "nofollow",
                                                className: (Article_module_default()).carouselLink,
                                                children: img.figcaption.children[0].data
                                            }))
                                        }),
                                        img.figcaption && img.figcaption.type === "text" && /*#__PURE__*/ (0,jsx_runtime.jsx)("figcaption", {
                                            children: img.figcaption.data
                                        })
                                    ]
                                })
                            }, img.src);
                        })
                    })
                });
            }
            if (domNode.type === "tag" && domNode.name === "figure" && (domNode.attribs.class === "image-inline" || domNode.attribs.class === "image")) {
                var ref13;
                var video = findVideoNode(domNode);
                if (video) {
                    var videoSrc2 = "https://media.first-class.com/" + video.children.find(function(node) {
                        return node.name === "source";
                    }).attribs.src.replace("/", "");
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "video",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                            autoPlay: true,
                            muted: true,
                            loop: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                src: videoSrc2
                            })
                        })
                    });
                }
                var image = findImageNode(domNode);
                var figcaption = domNode.children.find(function(node) {
                    return node.name === "figcaption";
                });
                return !image.name ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        ref: imageRef,
                        className: (Article_module_default()).imageInline,
                        style: {
                            height: mediaHeight
                        },
                        children: [
                            image.name === "img" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
                                className: "image-inline",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: (0,setImageUrl/* setImageUrl */.B)(image.attribs.src),
                                        alt: image.attribs.alt || "".concat(article.type, " ").concat(article.subtype, " - ").concat(article.title),
                                        layout: "fill",
                                        objectFit: "cover"
                                    }),
                                    (figcaption === null || figcaption === void 0 ? void 0 : figcaption.children[0]) && (figcaption === null || figcaption === void 0 ? void 0 : figcaption.children[0].name) === "a" && /*#__PURE__*/ (0,jsx_runtime.jsx)("figcaption", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, figcaption.children[0].attribs), {
                                            className: (Article_module_default()).carouselLink,
                                            rel: "noreferrer noopener nofollow",
                                            children: figcaption.children[0].children[0].data
                                        }))
                                    }),
                                    (figcaption === null || figcaption === void 0 ? void 0 : figcaption.children[0]) && figcaption.name === "figcaption" && /*#__PURE__*/ (0,jsx_runtime.jsx)("figcaption", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (Article_module_default()).carouselLink,
                                            children: figcaption.children[0].data
                                        })
                                    })
                                ]
                            }),
                            (image === null || image === void 0 ? void 0 : (ref13 = image.parent) === null || ref13 === void 0 ? void 0 : ref13.name) === "a" && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, image.parent.attribs), {
                                rel: "noreferrer noopener nofollow",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
                                    className: "image-inline",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: (0,setImageUrl/* setImageUrl */.B)(image.attribs.src),
                                            layout: "fill",
                                            objectFit: "cover"
                                        }),
                                        (figcaption === null || figcaption === void 0 ? void 0 : figcaption.children[0]) && (figcaption === null || figcaption === void 0 ? void 0 : figcaption.children[0].name) === "a" && /*#__PURE__*/ (0,jsx_runtime.jsx)("figcaption", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                rel: "noreferrer noopener nofollow"
                                            }, figcaption.children[0].attribs), {
                                                className: (Article_module_default()).carouselLink,
                                                children: figcaption.children[0].children[0].data
                                            }))
                                        }),
                                        !!(figcaption === null || figcaption === void 0 ? void 0 : figcaption.children.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("figcaption", {
                                            children: figcaption.children[0].data
                                        })
                                    ]
                                })
                            }))
                        ]
                    })
                });
            }
        }
    };
    var root = (0,html_react_parser/* default */.ZP)(article.content, options);
    var metaDescription = "";
    var parseTextFromNode = function(node) {
        if (typeof node !== "string") {
            if (node && Array.isArray(node.props.children)) {
                node.props.children.forEach(function(child) {
                    parseTextFromNode(child);
                });
            } else if (node) {
                parseTextFromNode(node.props.children);
            }
        } else {
            metaDescription += node;
        }
    };
    parseTextFromNode(root[0]);
    (0,react.useEffect)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            if ((userStore === null || userStore === void 0 ? void 0 : userStore.userid) && article.contentAuthorizedEnabled) {
                setAuthorizedContent((0,html_react_parser/* default */.ZP)(article.contentAuthorized, options));
            } else if (new Date(article.contentAuthorizedExpired) < new Date()) {
                setAuthorizedContentExpired(true);
            }
            return [
                2
            ];
        });
    }), [
        userStore
    ]);
    var openLoginDialog = function() {
        setLoginDialogState({
            state: "login",
            opened: true,
            sourcePage: "Article login link"
        });
    };
    var openSignUpDialog = function() {
        setLoginDialogState({
            state: "signUp",
            opened: true,
            sourcePage: "Article sign up link"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("title", {
                        children: [
                            ((ref = article.contentMetaData) === null || ref === void 0 ? void 0 : ref.metaTitle) || article.title,
                            " - First-Class.com"
                        ]
                    }),
                    ((ref1 = article.contentMetaData) === null || ref1 === void 0 ? void 0 : ref1.seoHtml) === "true" && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "robots",
                        content: "noindex, nofollow"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: ((ref2 = article.contentMetaData) === null || ref2 === void 0 ? void 0 : ref2.metaDescription) || metaDescription
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:site",
                        content: "first-class.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: ((ref3 = article.contentMetaData) === null || ref3 === void 0 ? void 0 : ref3.metaTitle) || article.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: ((ref4 = article.contentMetaData) === null || ref4 === void 0 ? void 0 : ref4.metaDescription) || metaDescription
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: ((ref5 = article.contentMetaData) === null || ref5 === void 0 ? void 0 : ref5.canonicalTag) ? "https://www.first-class.com" + article.contentMetaData.canonicalTag : "".concat("https://www.first-class.com").concat(router.asPath.split("?")[0])
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:image",
                        content: (0,setImageUrl/* setImageUrl */.B)((ref6 = article.image[0]) === null || ref6 === void 0 ? void 0 : ref6.image)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: ((ref7 = article.contentMetaData) === null || ref7 === void 0 ? void 0 : ref7.metaTitle) || article.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: "article"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: (0,setImageUrl/* setImageUrl */.B)((ref8 = article.image[0]) === null || ref8 === void 0 ? void 0 : ref8.image)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: ((ref9 = article.contentMetaData) === null || ref9 === void 0 ? void 0 : ref9.metaDescription) || metaDescription
                    }),
                    seoSchema
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((Article_module_default()).article, "font-libre"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Article_module_default()).topContainer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "container",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* BCBreadcrumbs */.k, {
                                    headerText: article.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Article_module_default()).overline,
                                    children: article.overline
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: classnames_default()((Article_module_default()).title, "font-fragment"),
                                    children: article.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()((Article_module_default()).articleMeta),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthorPopup, {
                                        userBio: article.userBio,
                                        isReview: false,
                                        modifiedDate: article.modifiedDate ? article.modifiedDate : article.published
                                    })
                                }),
                                article.image.length && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (Article_module_default()).mainImage,
                                    children: [
                                        article.image.length === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: (0,setImageUrl/* setImageUrl */.B)((ref10 = article.image[0]) === null || ref10 === void 0 ? void 0 : ref10.image),
                                            layout: "fill",
                                            objectFit: "cover",
                                            alt: (ref11 = article.image[0]) === null || ref11 === void 0 ? void 0 : ref11.altText
                                        }),
                                        article.image.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel/* BCCarousel */.M, {
                                            children: article.image.map(function(img, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: (0,setImageUrl/* setImageUrl */.B)(img.image),
                                                    blurDataURL: index ? "/_next/image?url=".concat((0,setImageUrl/* setImageUrl */.B)(img.image), "&w=16&q=1") : null,
                                                    layout: "fill",
                                                    objectFit: "cover",
                                                    placeholder: index ? "blur" : null
                                                }, img.id);
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "sm:w-full mx-auto sm:px-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "content",
                                    children: [
                                        root,
                                        !(userStore === null || userStore === void 0 ? void 0 : userStore.userid) && article.contentAuthorizedEnabled && !authorizedContentExpired && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: classnames_default()((Article_module_default()).authorizedContentContainer, "font-fragment"),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (Article_module_default()).gradientContainer
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (Article_module_default()).authorizedContentText,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            onClick: function() {
                                                                return openSignUpDialog();
                                                            },
                                                            children: "Subscribe"
                                                        }),
                                                        " for free to First-Class.com - gain instant access to exclusive offers and content - and receive alerts on the best premium travel offers! Already signed up?",
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            onClick: function() {
                                                                return openLoginDialog();
                                                            },
                                                            children: "Login"
                                                        }),
                                                        " here."
                                                    ]
                                                })
                                            ]
                                        }),
                                        ((userStore === null || userStore === void 0 ? void 0 : userStore.userid) && article.contentAuthorizedEnabled || authorizedContentExpired) && authorizedContent
                                    ]
                                }),
                                article.userBio.content && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Article_module_default()).authorBioContainer,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthorBlock, {
                                        userBio: article.userBio
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NoSsr/* default */.Z, {
                                    children: typeof document !== "undefined" && /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialMediaLinks, {})
                                })
                            ]
                        })
                    })
                ]
            }),
            userStore && !userStore.userid && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_intersection_observer_m/* InView */.df, {
                triggerOnce: true,
                children: function(param) {
                    var inView = param.inView, ref = param.ref;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                        ref: ref,
                        className: "w-full mx-auto my-20 sm:mb-10",
                        children: inView && /*#__PURE__*/ (0,jsx_runtime.jsx)(CallToSignUp, {
                            country: userStore === null || userStore === void 0 ? void 0 : userStore.country,
                            authCompleted: authCompleted,
                            sourcePage: "Article"
                        })
                    });
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container flex justify-center items-center sm:w-full mt-20",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendationsList, {
                    items: recommendation
                })
            }),
            !!((ref12 = article.questionsAnswers) === null || ref12 === void 0 ? void 0 : ref12.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container flex flex-col justify-center items-center sm:w-full mb-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: classnames_default()((Article_module_default()).listTitle, "text-3xl font-fragment mb-4"),
                        children: "FAQs"
                    }),
                    article.questionsAnswers.map(function(faq) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollableContent, {
                            heading: faq.question,
                            content: faq.answer,
                            style: (Article_module_default()).scrollableContent
                        }, faq.id);
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/ImageWithFallback/ImageWithFallback.jsx
var ImageWithFallback = __webpack_require__(74284);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(69779);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/createTheme.js + 13 modules
var createTheme = __webpack_require__(68239);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/ThemeProvider.js + 5 modules
var ThemeProvider = __webpack_require__(22430);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 3 modules
var Button = __webpack_require__(69417);
// EXTERNAL MODULE: ./node_modules/react-infinite-scroll-component/dist/index.es.js
var index_es = __webpack_require__(58533);
// EXTERNAL MODULE: ./components/RecommendationsList/RecommendationItem/RecommendationItem.jsx
var RecommendationItem = __webpack_require__(82039);
// EXTERNAL MODULE: ./components/Lists/Lists.module.scss
var Lists_module = __webpack_require__(11013);
var Lists_module_default = /*#__PURE__*/__webpack_require__.n(Lists_module);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/AirplanemodeActive.js
var AirplanemodeActive = __webpack_require__(86235);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Hotel.js
var Hotel = __webpack_require__(9001);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/PinDropRounded.js
var PinDropRounded = __webpack_require__(52135);
// EXTERNAL MODULE: ./public/small-white-logo.svg
var small_white_logo = __webpack_require__(60831);
;// CONCATENATED MODULE: ./components/Lists/ArticlesList.jsx




















var ArticlesList_CallToSignUp = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4231), __webpack_require__.e(6700), __webpack_require__.e(8307), __webpack_require__.e(4522)]).then(__webpack_require__.bind(__webpack_require__, 68307));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(68307)
            ];
        }
    }
});
var theme = (0,createTheme/* default */.Z)({
    palette: {
        primary: {
            main: "#00454A"
        },
        secondary: {
            main: "#202020"
        }
    },
    typography: {
        fontFamily: '"Libre Franklin", Arial, sans-serif',
        color: "#202020"
    }
});
var getArticles = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(page, perPage, type, subtype, loadingHandler, location) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    loadingHandler(true);
                    return [
                        4,
                        (0,httpClient/* httpGet */.kA)("/api/article?".concat(location ? "&location=".concat(location) : "").concat(type ? "&type=".concat(type) : "").concat(subtype ? "&subtype=".concat(subtype) : "", "&page=").concat(page, "&size=").concat(perPage))
                    ];
                case 1:
                    return [
                        4,
                        _state.sent().json()
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getArticles(page, perPage, type, subtype, loadingHandler, location) {
        return _ref.apply(this, arguments);
    };
}();
function ArticlesList(param) {
    var type = param.type, subtype = param.subtype, location = param.location, heading = param.heading, authCompleted = param.authCompleted;
    var ref = (0,react.useState)(0), currentPage = ref[0], setCurrentPage = ref[1];
    var ref1 = (0,react.useState)(false), hasMore = ref1[0], setHasMore = ref1[1];
    var ref2 = (0,react.useState)([]), articles = ref2[0], setArticles = ref2[1];
    var ref3 = (0,react.useState)(true), loading = ref3[0], setLoading = ref3[1];
    var userStore = (0,es/* useSelector */.v9)(function(state) {
        return state.user.value;
    });
    var perPage = 10;
    (0,react.useEffect)(function() {
        getArticles(currentPage, perPage, type, subtype, setLoading, location).then(function(res) {
            setHasMore(!res.last);
            setArticles((0,_to_consumable_array/* default */.Z)(articles).concat((0,_to_consumable_array/* default */.Z)(res === null || res === void 0 ? void 0 : res.content)));
            setLoading(false);
        });
    }, [
        currentPage
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ThemeProvider/* default */.Z, {
        theme: theme,
        children: [
            !!type && !!subtype && /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    rel: "canonical",
                    href: "".concat("https://www.first-class.com", "/").concat(type.toLowerCase(), "/").concat(subtype.toLowerCase())
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((Lists_module_default()).headingContainer, type ? (Lists_module_default())[type.toLowerCase()] : (Lists_module_default()).noType),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* BCBreadcrumbs */.k, {
                        className: "text-white",
                        headerText: heading ? heading : "".concat(type ? type : "", " ").concat(subtype ? subtype : "", "  ").concat(location ? location : "")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                        className: classnames_default()((Lists_module_default()).heading, "font-fragment text-center"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Lists_module_default()).icon,
                                children: [
                                    type === "Airlines" && /*#__PURE__*/ (0,jsx_runtime.jsx)(AirplanemodeActive/* default */.Z, {
                                        className: "m-auto text-white"
                                    }),
                                    type === "Hotels" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Hotel/* default */.Z, {
                                        className: "m-auto text-white"
                                    }),
                                    type === "Destinations" && /*#__PURE__*/ (0,jsx_runtime.jsx)(PinDropRounded/* default */.Z, {
                                        className: "m-auto text-white"
                                    }),
                                    type !== "Destinations" && type !== "Hotels" && type !== "Airlines" && /*#__PURE__*/ (0,jsx_runtime.jsx)(small_white_logo/* default */.Z, {
                                        className: "m-auto text-white"
                                    })
                                ]
                            }),
                            heading ? heading : "".concat(type ? type : "", " ").concat(subtype ? subtype : "", "  ").concat(location ? location : "")
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((Lists_module_default()).listContainer),
                children: [
                    !!articles.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.Z, {
                        dataLength: articles.length,
                        next: function() {
                            return setCurrentPage(currentPage + 1);
                        },
                        hasMore: hasMore,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Lists_module_default()).list,
                            children: articles.map(function(article) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Lists_module_default()).recommendationItem,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendationItem/* RecommendationItem */.A, {
                                        item: article
                                    })
                                }, article.textId);
                            })
                        })
                    }),
                    !loading && !articles.length && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Lists_module_default()).emptyList,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                className: "font-fragment my-4",
                                children: [
                                    "Currently we don`t have any ",
                                    !subtype && "content about ",
                                    type && type.charAt(0).toLowerCase() + type.slice(1),
                                    " ",
                                    subtype && subtype.charAt(0).toLowerCase() + subtype.slice(1)
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mb-8",
                                children: "But we are working hard to keep you updated with most fresh content!"
                            }),
                            userStore && !userStore.userid && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_intersection_observer_m/* InView */.df, {
                                triggerOnce: true,
                                children: function(param) {
                                    var inView = param.inView, ref = param.ref;
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                        ref: ref,
                                        className: "w-full lg:w-2/3 mx-auto mb-8",
                                        children: inView && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticlesList_CallToSignUp, {
                                            country: userStore === null || userStore === void 0 ? void 0 : userStore.country,
                                            authCompleted: authCompleted,
                                            sourcePage: "".concat(type ? type : "", " ").concat(subtype ? subtype : "") + " Article List"
                                        })
                                    });
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                variant: "outlined",
                                color: "secondary",
                                className: "mt-2",
                                type: "button",
                                onClick: function() {
                                    document.location = "/";
                                },
                                children: "Click here to go to frontpage"
                            })
                        ]
                    }),
                    loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Lists_module_default()).loader
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/Lists/ReviewItem.jsx
var ReviewItem = __webpack_require__(74079);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 112 modules
var formik_esm = __webpack_require__(28482);
// EXTERNAL MODULE: ./node_modules/@mui/material/Select/Select.js + 4 modules
var Select = __webpack_require__(18360);
// EXTERNAL MODULE: ./node_modules/@mui/material/MenuItem/MenuItem.js + 2 modules
var MenuItem = __webpack_require__(30431);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/debounce.js
var debounce = __webpack_require__(57144);
// EXTERNAL MODULE: ./node_modules/@mui/material/Dialog/Dialog.js + 2 modules
var Dialog = __webpack_require__(78262);
// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__(80129);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(72276);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Close.js
var Close = __webpack_require__(50594);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Sort.js
var Sort = __webpack_require__(85877);
// EXTERNAL MODULE: ./node_modules/@mui/material/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(21023);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/SortByAlpha.js
var SortByAlpha = __webpack_require__(58568);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ArrowRightAlt.js
var ArrowRightAlt = __webpack_require__(57354);
// EXTERNAL MODULE: ./node_modules/@react-hook/window-size/dist/module/index.js + 3 modules
var dist_module = __webpack_require__(61715);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/TuneRounded.js
var TuneRounded = __webpack_require__(22734);
// EXTERNAL MODULE: ./components/AirlineAutocomplete/AirlineAutocomplete.jsx
var AirlineAutocomplete = __webpack_require__(94740);
// EXTERNAL MODULE: ./utils/usePrevious.js
var usePrevious = __webpack_require__(20569);
// EXTERNAL MODULE: ./node_modules/lodash/cloneDeep.js
var cloneDeep = __webpack_require__(50361);
var cloneDeep_default = /*#__PURE__*/__webpack_require__.n(cloneDeep);
;// CONCATENATED MODULE: ./components/Lists/AirlineReviewsLists.jsx
// pages/404.js






























var AirlineReviewsLists_theme = (0,createTheme/* default */.Z)({
    shape: {
        borderRadius: 12
    },
    palette: {
        primary: {
            main: "#00454A"
        },
        dark: {
            main: "#0a0a0a"
        }
    },
    typography: {
        fontFamily: '"Libre Franklin", sans-serif'
    }
});
var getReviews = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(page, perPage, loadingHandler, filters) {
        var query, ref, ref1, ref2, ref3, url;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    loadingHandler(true);
                    query = {};
                    if (filters === null || filters === void 0 ? void 0 : filters.airline) {
                        filters.code = filters.airline.code;
                        delete filters.airline;
                    }
                    if (filters && Object.keys(filters).length) {
                        query = lib_default().stringify(filters);
                    }
                    if (filters && Object.keys(filters).length && filters.sort && Object.keys(filters.sort).length) {
                        ;
                        if ((ref = filters.sort) === null || ref === void 0 ? void 0 : ref.rating) {
                            ;
                            query += "&sort=rating,".concat((ref2 = filters.sort) === null || ref2 === void 0 ? void 0 : ref2.rating);
                        }
                        if ((ref1 = filters.sort) === null || ref1 === void 0 ? void 0 : ref1.airline) {
                            ;
                            query += "&sort=airline.name,".concat((ref3 = filters.sort) === null || ref3 === void 0 ? void 0 : ref3.airline);
                        }
                    }
                    url = Object.keys(query).length ? "/api/airline/review?page=".concat(page, "&size=").concat(perPage, "&").concat(query) : "/api/airline/review?page=".concat(page, "&size=").concat(perPage);
                    return [
                        4,
                        (0,httpClient/* httpGet */.kA)(url)
                    ];
                case 1:
                    return [
                        4,
                        _state.sent().json()
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getReviews(page, perPage, loadingHandler, filters) {
        return _ref.apply(this, arguments);
    };
}();
var loadAlliances = function() {
    return (0,httpClient/* httpGet */.kA)("/api/airline/alliance").then(function(res) {
        return res.json();
    });
};
function AirlineReviewsList() {
    var defaultFilters = {
        alliance: "Select alliance",
        class: "Any class",
        airline: "",
        sort: {
            airline: null,
            rating: null
        }
    };
    var ref = (0,react.useState)(0), currentPage = ref[0], setCurrentPage = ref[1];
    var ref1 = (0,react.useState)([]), reviews = ref1[0], setReviews = ref1[1];
    var ref2 = (0,react.useState)([]), alliances = ref2[0], setAlliances = ref2[1];
    var ref3 = (0,react.useState)(defaultFilters), filters = ref3[0], setFilters = ref3[1];
    var ref4 = (0,react.useState)([]), cabinClasses = ref4[0], setCabinClasses = ref4[1];
    var ref5 = (0,react.useState)(false), hasMore = ref5[0], setHasMore = ref5[1];
    var ref6 = (0,react.useState)(false), loading = ref6[0], setLoading = ref6[1];
    var ref7 = (0,react.useState)(false), mobileFilters = ref7[0], setMobileFilters = ref7[1];
    var width = (0,dist_module/* useWindowWidth */.Lm)();
    var renderFilters = function(param) {
        var setFieldValue = param.setFieldValue, values = param.values;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Lists_module_default()).filterSmaller,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AirlineAutocomplete/* AirlineAutocomplete */.b, {
                        name: "airline",
                        type: "text",
                        fullWidth: true,
                        value: values.airline,
                        placeholder: "Airline",
                        primaryColor: "#202020",
                        setFieldValue: setFieldValue
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()((Lists_module_default()).filterSmaller),
                    children: cabinClasses && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Select/* default */.Z, {
                        value: values.class,
                        onChange: function(event) {
                            setFieldValue("class", event.target.value);
                        },
                        fullWidth: true,
                        defaultValue: "Any class",
                        name: "class",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                value: "Any class",
                                children: "Any class"
                            }),
                            cabinClasses.map(function(cabin) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                    value: cabin.value,
                                    children: cabin.label
                                }, cabin.value);
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()((Lists_module_default()).filterSmaller),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Select/* default */.Z, {
                        value: values.alliance,
                        onChange: function(event) {
                            setFieldValue("alliance", event.target.value);
                        },
                        fullWidth: true,
                        defaultValue: "Select alliance",
                        name: "alliance",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                value: "Select alliance",
                                children: "Select alliance"
                            }),
                            alliances.slice(0, 3).map(function(alliance) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                    value: alliance,
                                    children: alliance
                                }, alliance);
                            })
                        ]
                    })
                })
            ]
        });
    };
    var perPage = 10;
    var prevFilters = (0,usePrevious/* usePrevious */.D)({
        filters: filters
    });
    var validateFilters = function(f) {
        var ref, ref1;
        var filters = cloneDeep_default()(f);
        if (((ref = filters.sort) === null || ref === void 0 ? void 0 : ref.airline) === null) {
            delete filters.sort.airline;
        }
        if (((ref1 = filters.sort) === null || ref1 === void 0 ? void 0 : ref1.rating) === null) {
            delete filters.sort.rating;
        }
        if (filters.alliance === "Select alliance") {
            delete filters.alliance;
        }
        if (filters.class === "Any class") {
            delete filters.class;
        }
        if (!filters.airline) {
            delete filters.airline;
        }
        if (filters.sort && !Object.keys(filters.sort).length) {
            delete filters.sort;
        }
        return filters;
    };
    (0,react.useEffect)(function() {
        if (JSON.stringify(defaultFilters) !== JSON.stringify(filters)) {
            var f = validateFilters(filters);
            getReviews(currentPage, perPage, setLoading, f).then(function(res) {
                setHasMore(!res.last);
                setReviews((0,_to_consumable_array/* default */.Z)(reviews).concat((0,_to_consumable_array/* default */.Z)(res.content)));
                setLoading(false);
            });
        } else {
            getReviews(currentPage, perPage, setLoading).then(function(res) {
                setHasMore(!res.last);
                setReviews((0,_to_consumable_array/* default */.Z)(reviews).concat((0,_to_consumable_array/* default */.Z)(res.content)));
                setLoading(false);
            });
        }
    }, [
        currentPage
    ]);
    (0,react.useEffect)(function() {
        if (JSON.stringify(defaultFilters) !== JSON.stringify(filters) && JSON.stringify(prevFilters.filters) !== JSON.stringify(filters) && !filters.resetFilters) {
            setLoading(true);
            var f = validateFilters(filters);
            getReviews(currentPage, perPage, setLoading, f).then(function(res) {
                setHasMore(!res.last);
                setReviews((0,_to_consumable_array/* default */.Z)(res.content));
                setLoading(false);
            });
        }
        if (filters.resetFilters) {
            setFilters(defaultFilters);
            setCurrentPage(0);
            getReviews(0, perPage, setLoading).then(function(res) {
                setHasMore(!res.last);
                setReviews((0,_to_consumable_array/* default */.Z)(res.content));
                setLoading(false);
            });
        }
    }, [
        filters
    ]);
    (0,react.useEffect)(function() {
        loadAlliances().then(function(res) {
            setAlliances(res.map(function(alliance) {
                return alliance.name;
            }));
        });
        var cabinClasses = (0,_to_consumable_array/* default */.Z)(utils_cabinClasses/* CABIN_CLASSES */.r).reverse();
        cabinClasses.pop();
        setCabinClasses(cabinClasses);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    rel: "canonical",
                    href: "".concat("https://www.first-class.com", "/airlines/reviews")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((Lists_module_default()).headingContainer, (Lists_module_default()).airline),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* BCBreadcrumbs */.k, {
                        className: "text-white",
                        headerText: "Reviews"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                        className: classnames_default()((Lists_module_default()).heading, "font-fragment text-center"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Lists_module_default()).airlineIcon,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AirplanemodeActive/* default */.Z, {
                                    className: "m-auto text-white"
                                })
                            }),
                            "Airline reviews"
                        ]
                    }),
                    width && /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeProvider/* default */.Z, {
                        theme: AirlineReviewsLists_theme,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
                            enableReinitialize: true,
                            initialValues: filters,
                            validate: (0,debounce/* default */.Z)(function(value) {
                                setFilters((0,_object_spread/* default */.Z)({}, value));
                            }, 1000),
                            children: function(param) {
                                var setFieldValue = param.setFieldValue, values = param.values, resetForm = param.resetForm;
                                var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, {
                                    children: [
                                        width >= 1024 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (Lists_module_default()).filtersContainer,
                                            children: [
                                                renderFilters({
                                                    setFieldValue: setFieldValue,
                                                    values: values
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                                    title: "Sort by rating",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconButton/* default */.Z, {
                                                        color: "inherit",
                                                        type: "reset",
                                                        onClick: function() {
                                                            var ref, ref1, ref2;
                                                            if (((ref = filters.sort) === null || ref === void 0 ? void 0 : ref.rating) === "desc") {
                                                                setFieldValue("sort", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filters.sort), {
                                                                    rating: "asc"
                                                                }));
                                                            }
                                                            if (((ref1 = filters.sort) === null || ref1 === void 0 ? void 0 : ref1.rating) === "asc") {
                                                                setFieldValue("sort", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filters.sort), {
                                                                    rating: null
                                                                }));
                                                            }
                                                            if (!((ref2 = filters.sort) === null || ref2 === void 0 ? void 0 : ref2.rating)) {
                                                                setFieldValue("sort", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filters.sort), {
                                                                    rating: "desc"
                                                                }));
                                                            }
                                                        },
                                                        "aria-label": "clear",
                                                        sx: {
                                                            border: "1px solid #fff",
                                                            borderRadius: "50%",
                                                            color: "#fff",
                                                            width: "56px",
                                                            marginRight: "1rem"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Sort/* default */.Z, {}),
                                                            ((ref = filters.sort) === null || ref === void 0 ? void 0 : ref.rating) === "asc" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightAlt/* default */.Z, {
                                                                sx: {
                                                                    position: "absolute",
                                                                    right: "-2px",
                                                                    transform: "rotate(90deg)"
                                                                }
                                                            }),
                                                            ((ref1 = filters.sort) === null || ref1 === void 0 ? void 0 : ref1.rating) === "desc" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightAlt/* default */.Z, {
                                                                sx: {
                                                                    position: "absolute",
                                                                    right: "-2px",
                                                                    transform: "rotate(-90deg)"
                                                                }
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                                    title: "Sort alphabetically",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconButton/* default */.Z, {
                                                        color: "inherit",
                                                        type: "reset",
                                                        onClick: function() {
                                                            var ref, ref1, ref2;
                                                            if (((ref = filters.sort) === null || ref === void 0 ? void 0 : ref.airline) === "desc") {
                                                                setFieldValue("sort", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filters.sort), {
                                                                    airline: "asc"
                                                                }));
                                                            }
                                                            if (((ref1 = filters.sort) === null || ref1 === void 0 ? void 0 : ref1.airline) === "asc") {
                                                                setFieldValue("sort", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filters.sort), {
                                                                    airline: null
                                                                }));
                                                            }
                                                            if (!((ref2 = filters.sort) === null || ref2 === void 0 ? void 0 : ref2.airline)) {
                                                                setFieldValue("sort", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filters.sort), {
                                                                    airline: "desc"
                                                                }));
                                                            }
                                                        },
                                                        "aria-label": "clear",
                                                        sx: {
                                                            border: "1px solid #fff",
                                                            borderRadius: "50%",
                                                            color: "#fff",
                                                            width: "56px",
                                                            marginRight: "1rem"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SortByAlpha/* default */.Z, {}),
                                                            ((ref2 = filters.sort) === null || ref2 === void 0 ? void 0 : ref2.airline) === "asc" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightAlt/* default */.Z, {
                                                                sx: {
                                                                    position: "absolute",
                                                                    right: "-2px",
                                                                    transform: "rotate(90deg)"
                                                                }
                                                            }),
                                                            ((ref3 = filters.sort) === null || ref3 === void 0 ? void 0 : ref3.airline) === "desc" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightAlt/* default */.Z, {
                                                                sx: {
                                                                    position: "absolute",
                                                                    right: "-2px",
                                                                    transform: "rotate(-90deg)"
                                                                }
                                                            })
                                                        ]
                                                    })
                                                }),
                                                JSON.stringify(defaultFilters) !== JSON.stringify(filters) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                                    title: "Reset filters",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                                        color: "inherit",
                                                        type: "reset",
                                                        onClick: function() {
                                                            resetForm({
                                                                values: defaultFilters
                                                            });
                                                            setFilters({
                                                                resetFilters: true
                                                            });
                                                        },
                                                        "aria-label": "clear",
                                                        sx: {
                                                            border: "1px solid #fff",
                                                            borderRadius: "50%",
                                                            color: "#fff",
                                                            width: "56px"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
                                                    })
                                                })
                                            ]
                                        }),
                                        width < 1024 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (Lists_module_default()).mobileFiltersWrapper,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (Lists_module_default()).filtersButton,
                                                    onClick: function() {
                                                        return setMobileFilters(true);
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TuneRounded/* default */.Z, {
                                                            className: "mr-2"
                                                        }),
                                                        " Filters"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* default */.Z, {
                                                    open: mobileFilters,
                                                    fullWidth: true,
                                                    PaperProps: {
                                                        style: {
                                                            margin: 0,
                                                            width: "100%",
                                                            bottom: 0,
                                                            position: "absolute",
                                                            borderBottomLeftRadius: 0,
                                                            borderBottomRightRadius: 0
                                                        }
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (Lists_module_default()).filtersContainerMobile,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                                                color: "inherit",
                                                                onClick: function() {
                                                                    return setMobileFilters(false);
                                                                },
                                                                "aria-label": "close",
                                                                className: (Lists_module_default()).closeMobileFilters,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
                                                            }),
                                                            renderFilters({
                                                                setFieldValue: setFieldValue,
                                                                values: values
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (Lists_module_default()).sorting,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                                            title: "Sort by rating",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconButton/* default */.Z, {
                                                                color: "inherit",
                                                                type: "reset",
                                                                onClick: function() {
                                                                    var ref, ref1, ref2;
                                                                    if (((ref = filters.sort) === null || ref === void 0 ? void 0 : ref.rating) === "desc") {
                                                                        setFieldValue("sort", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filters.sort), {
                                                                            rating: "asc"
                                                                        }));
                                                                    }
                                                                    if (((ref1 = filters.sort) === null || ref1 === void 0 ? void 0 : ref1.rating) === "asc") {
                                                                        setFieldValue("sort", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filters.sort), {
                                                                            rating: null
                                                                        }));
                                                                    }
                                                                    if (!((ref2 = filters.sort) === null || ref2 === void 0 ? void 0 : ref2.rating)) {
                                                                        setFieldValue("sort", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filters.sort), {
                                                                            rating: "desc"
                                                                        }));
                                                                    }
                                                                },
                                                                "aria-label": "clear",
                                                                sx: {
                                                                    border: "1px solid #fff",
                                                                    borderRadius: "50%",
                                                                    color: "#fff",
                                                                    width: "42px",
                                                                    marginRight: "1.25rem"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Sort/* default */.Z, {}),
                                                                    ((ref4 = filters.sort) === null || ref4 === void 0 ? void 0 : ref4.rating) === "asc" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightAlt/* default */.Z, {
                                                                        sx: {
                                                                            position: "absolute",
                                                                            right: "-21px",
                                                                            transform: "rotate(90deg)"
                                                                        }
                                                                    }),
                                                                    ((ref5 = filters.sort) === null || ref5 === void 0 ? void 0 : ref5.rating) === "desc" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightAlt/* default */.Z, {
                                                                        sx: {
                                                                            position: "absolute",
                                                                            right: "-21px",
                                                                            transform: "rotate(-90deg)"
                                                                        }
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                                            title: "Sort alphabetically",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconButton/* default */.Z, {
                                                                color: "inherit",
                                                                type: "reset",
                                                                onClick: function() {
                                                                    var ref, ref1, ref2;
                                                                    if (((ref = filters.sort) === null || ref === void 0 ? void 0 : ref.airline) === "desc") {
                                                                        setFieldValue("sort", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filters.sort), {
                                                                            airline: "asc"
                                                                        }));
                                                                    }
                                                                    if (((ref1 = filters.sort) === null || ref1 === void 0 ? void 0 : ref1.airline) === "asc") {
                                                                        setFieldValue("sort", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filters.sort), {
                                                                            airline: null
                                                                        }));
                                                                    }
                                                                    if (!((ref2 = filters.sort) === null || ref2 === void 0 ? void 0 : ref2.airline)) {
                                                                        setFieldValue("sort", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filters.sort), {
                                                                            airline: "desc"
                                                                        }));
                                                                    }
                                                                },
                                                                "aria-label": "clear",
                                                                sx: {
                                                                    border: "1px solid #fff",
                                                                    borderRadius: "50%",
                                                                    color: "#fff",
                                                                    width: "42px",
                                                                    marginRight: "1.25rem"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SortByAlpha/* default */.Z, {}),
                                                                    ((ref6 = filters.sort) === null || ref6 === void 0 ? void 0 : ref6.airline) === "asc" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightAlt/* default */.Z, {
                                                                        sx: {
                                                                            position: "absolute",
                                                                            right: "-21px",
                                                                            transform: "rotate(90deg)"
                                                                        }
                                                                    }),
                                                                    ((ref7 = filters.sort) === null || ref7 === void 0 ? void 0 : ref7.airline) === "desc" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightAlt/* default */.Z, {
                                                                        sx: {
                                                                            position: "absolute",
                                                                            right: "-21px",
                                                                            transform: "rotate(-90deg)"
                                                                        }
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        JSON.stringify(defaultFilters) !== JSON.stringify(filters) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                                            title: "Reset filters",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                                                color: "inherit",
                                                                type: "reset",
                                                                onClick: function() {
                                                                    resetForm({
                                                                        values: defaultFilters
                                                                    });
                                                                    setFilters({
                                                                        resetFilters: true
                                                                    });
                                                                },
                                                                "aria-label": "clear",
                                                                sx: {
                                                                    border: "1px solid #fff",
                                                                    borderRadius: "50%",
                                                                    color: "#fff",
                                                                    width: "42px"
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                });
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((Lists_module_default()).listContainer, "container"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.Z, {
                        dataLength: reviews.length,
                        next: function() {
                            return setCurrentPage(currentPage + 1);
                        },
                        hasMore: hasMore,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Lists_module_default()).list,
                            children: reviews.map(function(review, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Lists_module_default()).review,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewItem/* ReviewItem */.r, {
                                        type: "Airline",
                                        review: review,
                                        url: "/airlines/reviews/".concat(review.textId)
                                    })
                                }, index);
                            })
                        })
                    }),
                    loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Lists_module_default()).loader
                    }),
                    !reviews.length && !loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Lists_module_default()).noReviewsFound,
                        children: "No reviews found..."
                    })
                ]
            }),
            ";"
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./components/HotelSearch/HotelSearchAutocomplete/HotelSearchAutocomplete.jsx + 1 modules
var HotelSearchAutocomplete = __webpack_require__(8496);
// EXTERNAL MODULE: ./node_modules/@mui/material/TextField/TextField.js + 3 modules
var TextField = __webpack_require__(61903);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/LocationOn.js
var LocationOn = __webpack_require__(69308);
;// CONCATENATED MODULE: ./components/Lists/HotelReviewsList.jsx
// pages/404.js





























var HotelReviewsList_theme = (0,createTheme/* default */.Z)({
    shape: {
        borderRadius: 12
    },
    palette: {
        primary: {
            main: "#7E183D"
        },
        dark: {
            main: "#0a0a0a"
        }
    },
    typography: {
        fontFamily: '"Libre Franklin", sans-serif'
    }
});
var HotelReviewsList_getReviews = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(listConfig, page, perPage, loadingHandler) {
        var filters, destUrl, q, query, ref, ref1, ref2, ref3, ref4, ref5;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    filters = _arguments.length > 4 && _arguments[4] !== void 0 ? _arguments[4] : undefined;
                    destUrl = "/api";
                    q = {};
                    query = "";
                    if (filters) {
                        ;
                        if (filters.name) {
                            q.hotel = filters.name;
                        }
                        if (((ref = filters.autocomplete) === null || ref === void 0 ? void 0 : ref.t) === "cities") {
                            q.city = filters.autocomplete.n;
                        } else if (((ref1 = filters.autocomplete) === null || ref1 === void 0 ? void 0 : ref1.t) === "countries") {
                            q.country = filters.autocomplete.n;
                        }
                        query = lib_default().stringify(q);
                        if (filters && Object.keys(filters).length && filters.sort && Object.keys(filters.sort).length) {
                            ;
                            if ((ref2 = filters.sort) === null || ref2 === void 0 ? void 0 : ref2.rating) {
                                ;
                                query += "&sort=hotel.score.total,".concat((ref4 = filters.sort) === null || ref4 === void 0 ? void 0 : ref4.rating);
                            }
                            if ((ref3 = filters.sort) === null || ref3 === void 0 ? void 0 : ref3.name) {
                                ;
                                query += "&sort=hotel.name,".concat((ref5 = filters.sort) === null || ref5 === void 0 ? void 0 : ref5.name);
                            }
                        }
                    }
                    switch(listConfig.type){
                        case "destination":
                            if (filters) {
                                destUrl += "/destinations/hotels?country=".concat(listConfig.country, "&city=").concat(listConfig.city, "&page=").concat(page, "&size=").concat(perPage, "&").concat(query);
                            } else {
                                destUrl += "/destinations/hotels?country=".concat(listConfig.country, "&city=").concat(listConfig.city, "&page=").concat(page, "&size=").concat(perPage);
                            }
                            break;
                        default:
                            if (filters) {
                                destUrl += "/hotel?page=".concat(page, "&size=").concat(perPage, "&").concat(query);
                            } else {
                                destUrl += "/hotel?page=".concat(page, "&size=").concat(perPage);
                            }
                            break;
                    }
                    loadingHandler(true);
                    return [
                        4,
                        (0,httpClient/* httpGet */.kA)(decodeURI(destUrl))
                    ];
                case 1:
                    return [
                        4,
                        _state.sent().json()
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getReviews(listConfig, page, perPage, loadingHandler) {
        return _ref.apply(this, arguments);
    };
}();
HotelReviewsList.propTypes = {
    type: prop_types.string,
    country: prop_types.string,
    city: prop_types.string
};
function HotelReviewsList(param) {
    var type = param.type, listTitle = param.listTitle, country = param.country, city = param.city;
    var usePrevious = function usePrevious(value) {
        var ref = (0,react.useRef)();
        (0,react.useEffect)(function() {
            ref.current = value;
        });
        return ref.current;
    };
    var width = (0,dist_module/* useWindowWidth */.Lm)();
    var ref = (0,react.useState)(false), mobileFilters = ref[0], setMobileFilters = ref[1];
    var ref1 = (0,react.useState)(0), currentPage = ref1[0], setCurrentPage = ref1[1];
    var ref2 = (0,react.useState)([]), reviews = ref2[0], setReviews = ref2[1];
    var defaultFilters = {
        name: "",
        autocomplete: "",
        sort: {
            name: null,
            rating: null
        }
    };
    var ref3 = (0,react.useState)(defaultFilters), filters = ref3[0], setFilters = ref3[1];
    var ref4 = (0,react.useState)(false), hasMore = ref4[0], setHasMore = ref4[1];
    var ref5 = (0,react.useState)(false), loading = ref5[0], setLoading = ref5[1];
    var listConfig = {
        type: type,
        country: country,
        city: city
    };
    var perPage = 10;
    var prevFilters = usePrevious({
        filters: filters
    });
    (0,react.useEffect)(function() {
        if (JSON.stringify(defaultFilters) !== JSON.stringify(filters) && JSON.stringify(prevFilters.filters) !== JSON.stringify(filters)) {
            var ref, ref1;
            setCurrentPage(0);
            setLoading(true);
            setReviews([]);
            setHasMore(false);
            if (((ref = filters.sort) === null || ref === void 0 ? void 0 : ref.name) === null) {
                delete filters.sort.name;
            }
            if (((ref1 = filters.sort) === null || ref1 === void 0 ? void 0 : ref1.rating) === null) {
                delete filters.sort.rating;
            }
            if (filters) {
                HotelReviewsList_getReviews(listConfig, 0, perPage, setLoading, filters).then(function(res) {
                    setHasMore(!res.last);
                    setReviews((0,_to_consumable_array/* default */.Z)(res.content));
                    setLoading(false);
                });
            }
            if (filters.resetFilters) {
                setFilters(defaultFilters);
                setCurrentPage(0);
            }
        }
    }, [
        filters
    ]);
    (0,react.useEffect)(function() {
        HotelReviewsList_getReviews(listConfig, currentPage, perPage, setLoading, filters).then(function(res) {
            setHasMore(!res.last);
            setReviews((0,_to_consumable_array/* default */.Z)(reviews).concat((0,_to_consumable_array/* default */.Z)(res.content)));
            setLoading(false);
        });
    }, [
        currentPage
    ]);
    var renderFilters = function(param) {
        var setFieldValue = param.setFieldValue, values = param.values, errors = param.errors, touched = param.touched;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                listConfig.type !== "destination" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()((Lists_module_default()).filter),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HotelSearchAutocomplete/* HotelSearchAutocomplete */.n, {
                        setFieldValue: setFieldValue,
                        name: "autocomplete",
                        placeholder: "Enter destination",
                        showOnly: [
                            "cities",
                            "countries"
                        ],
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationOn/* default */.Z, {}),
                        error: !!(touched.autocomplete && errors.autocomplete),
                        primaryColor: "#202020",
                        value: values.autocomplete
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Lists_module_default()).filter,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                        name: "name",
                        type: "text",
                        fullWidth: true,
                        value: values.name,
                        placeholder: "Hotel Name",
                        primaryColor: "#202020",
                        onChange: function(event) {
                            setFieldValue("name", event.target.value);
                        }
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    rel: "canonical",
                    href: "".concat("https://www.first-class.com", "/hotels/reviews")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((Lists_module_default()).headingContainer, (Lists_module_default()).hotel),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* BCBreadcrumbs */.k, {
                        className: "text-white",
                        headerText: type && type === "destination" ? listTitle : "Reviews"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                        className: classnames_default()((Lists_module_default()).heading, "font-fragment text-center"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Lists_module_default()).icon,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Hotel/* default */.Z, {
                                    className: "m-auto text-white"
                                })
                            }),
                            type && type === "destination" ? listTitle : "Hotel reviews"
                        ]
                    }),
                    width && /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeProvider/* default */.Z, {
                        theme: HotelReviewsList_theme,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
                            enableReinitialize: true,
                            initialValues: filters,
                            validate: (0,debounce/* default */.Z)(function(value) {
                                setFilters((0,_object_spread/* default */.Z)({}, value));
                            }, 1000),
                            children: function(param) {
                                var setFieldValue = param.setFieldValue, values = param.values, errors = param.errors, touched = param.touched, resetForm = param.resetForm;
                                var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(formik_esm/* Form */.l0, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            width >= 1024 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (Lists_module_default()).filtersContainer,
                                                children: [
                                                    renderFilters({
                                                        setFieldValue: setFieldValue,
                                                        values: values,
                                                        errors: errors,
                                                        touched: touched
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                                        title: "Sort by rating",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconButton/* default */.Z, {
                                                            color: "inherit",
                                                            type: "reset",
                                                            onClick: function() {
                                                                var ref, ref1, ref2;
                                                                if (((ref = filters.sort) === null || ref === void 0 ? void 0 : ref.rating) === "desc") {
                                                                    setFieldValue("sort", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filters.sort), {
                                                                        rating: "asc"
                                                                    }));
                                                                }
                                                                if (((ref1 = filters.sort) === null || ref1 === void 0 ? void 0 : ref1.rating) === "asc") {
                                                                    setFieldValue("sort", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filters.sort), {
                                                                        rating: null
                                                                    }));
                                                                }
                                                                if (!((ref2 = filters.sort) === null || ref2 === void 0 ? void 0 : ref2.rating)) {
                                                                    setFieldValue("sort", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filters.sort), {
                                                                        rating: "desc"
                                                                    }));
                                                                }
                                                            },
                                                            "aria-label": "clear",
                                                            sx: {
                                                                border: "1px solid #fff",
                                                                borderRadius: "50%",
                                                                color: "#fff",
                                                                width: "56px",
                                                                marginRight: "1rem"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Sort/* default */.Z, {}),
                                                                ((ref = filters.sort) === null || ref === void 0 ? void 0 : ref.rating) === "asc" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightAlt/* default */.Z, {
                                                                    sx: {
                                                                        position: "absolute",
                                                                        right: "-2px",
                                                                        transform: "rotate(90deg)"
                                                                    }
                                                                }),
                                                                ((ref1 = filters.sort) === null || ref1 === void 0 ? void 0 : ref1.rating) === "desc" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightAlt/* default */.Z, {
                                                                    sx: {
                                                                        position: "absolute",
                                                                        right: "-2px",
                                                                        transform: "rotate(-90deg)"
                                                                    }
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                                        title: "Sort alphabetically",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconButton/* default */.Z, {
                                                            color: "inherit",
                                                            type: "reset",
                                                            onClick: function() {
                                                                var ref, ref1, ref2;
                                                                if (((ref = filters.sort) === null || ref === void 0 ? void 0 : ref.name) === "desc") {
                                                                    setFieldValue("sort", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filters.sort), {
                                                                        name: "asc"
                                                                    }));
                                                                }
                                                                if (((ref1 = filters.sort) === null || ref1 === void 0 ? void 0 : ref1.name) === "asc") {
                                                                    setFieldValue("sort", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filters.sort), {
                                                                        name: null
                                                                    }));
                                                                }
                                                                if (!((ref2 = filters.sort) === null || ref2 === void 0 ? void 0 : ref2.name)) {
                                                                    setFieldValue("sort", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filters.sort), {
                                                                        name: "desc"
                                                                    }));
                                                                }
                                                            },
                                                            "aria-label": "clear",
                                                            sx: {
                                                                border: "1px solid #fff",
                                                                borderRadius: "50%",
                                                                color: "#fff",
                                                                width: "56px",
                                                                marginRight: "1rem"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SortByAlpha/* default */.Z, {}),
                                                                ((ref2 = filters.sort) === null || ref2 === void 0 ? void 0 : ref2.name) === "asc" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightAlt/* default */.Z, {
                                                                    sx: {
                                                                        position: "absolute",
                                                                        right: "-2px",
                                                                        transform: "rotate(90deg)"
                                                                    }
                                                                }),
                                                                ((ref3 = filters.sort) === null || ref3 === void 0 ? void 0 : ref3.name) === "desc" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightAlt/* default */.Z, {
                                                                    sx: {
                                                                        position: "absolute",
                                                                        right: "-2px",
                                                                        transform: "rotate(-90deg)"
                                                                    }
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    JSON.stringify(defaultFilters) !== JSON.stringify(filters) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                                        title: "Reset filters",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                                            color: "inherit",
                                                            type: "reset",
                                                            onClick: function() {
                                                                resetForm({
                                                                    values: defaultFilters
                                                                });
                                                                setFilters({
                                                                    resetFilters: true
                                                                });
                                                            },
                                                            "aria-label": "clear",
                                                            sx: {
                                                                border: "1px solid #fff",
                                                                borderRadius: "50%",
                                                                color: "#fff",
                                                                width: "56px",
                                                                visibility: Object.keys(filters).length ? "visible" : "hidden"
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
                                                        })
                                                    })
                                                ]
                                            }),
                                            width < 1024 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (Lists_module_default()).mobileFiltersWrapper,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (Lists_module_default()).filtersButton,
                                                        onClick: function() {
                                                            return setMobileFilters(true);
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TuneRounded/* default */.Z, {
                                                                className: "mr-2"
                                                            }),
                                                            " Filters"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* default */.Z, {
                                                        open: mobileFilters,
                                                        fullWidth: true,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (Lists_module_default()).filtersContainerMobile,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                                                    color: "inherit",
                                                                    onClick: function() {
                                                                        return setMobileFilters(false);
                                                                    },
                                                                    "aria-label": "close",
                                                                    className: (Lists_module_default()).closeMobileFilters,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
                                                                }),
                                                                renderFilters({
                                                                    setFieldValue: setFieldValue,
                                                                    values: values,
                                                                    errors: errors,
                                                                    touched: touched
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (Lists_module_default()).sorting,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                                                title: "Sort by rating",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconButton/* default */.Z, {
                                                                    color: "inherit",
                                                                    type: "reset",
                                                                    onClick: function() {
                                                                        var ref, ref1, ref2;
                                                                        if (((ref = filters.sort) === null || ref === void 0 ? void 0 : ref.rating) === "desc") {
                                                                            setFieldValue("sort", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filters.sort), {
                                                                                rating: "asc"
                                                                            }));
                                                                        }
                                                                        if (((ref1 = filters.sort) === null || ref1 === void 0 ? void 0 : ref1.rating) === "asc") {
                                                                            setFieldValue("sort", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filters.sort), {
                                                                                rating: null
                                                                            }));
                                                                        }
                                                                        if (!((ref2 = filters.sort) === null || ref2 === void 0 ? void 0 : ref2.rating)) {
                                                                            setFieldValue("sort", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filters.sort), {
                                                                                rating: "desc"
                                                                            }));
                                                                        }
                                                                    },
                                                                    "aria-label": "clear",
                                                                    sx: {
                                                                        border: "1px solid #fff",
                                                                        borderRadius: "50%",
                                                                        color: "#fff",
                                                                        width: "42px",
                                                                        marginRight: "1.25rem"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Sort/* default */.Z, {}),
                                                                        ((ref4 = filters.sort) === null || ref4 === void 0 ? void 0 : ref4.rating) === "asc" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightAlt/* default */.Z, {
                                                                            sx: {
                                                                                position: "absolute",
                                                                                right: "-21px",
                                                                                transform: "rotate(90deg)"
                                                                            }
                                                                        }),
                                                                        ((ref5 = filters.sort) === null || ref5 === void 0 ? void 0 : ref5.rating) === "desc" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightAlt/* default */.Z, {
                                                                            sx: {
                                                                                position: "absolute",
                                                                                right: "-21px",
                                                                                transform: "rotate(-90deg)"
                                                                            }
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                                                title: "Sort alphabetically",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconButton/* default */.Z, {
                                                                    color: "inherit",
                                                                    type: "reset",
                                                                    onClick: function() {
                                                                        var ref, ref1, ref2;
                                                                        if (((ref = filters.sort) === null || ref === void 0 ? void 0 : ref.name) === "desc") {
                                                                            setFieldValue("sort", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filters.sort), {
                                                                                name: "asc"
                                                                            }));
                                                                        }
                                                                        if (((ref1 = filters.sort) === null || ref1 === void 0 ? void 0 : ref1.name) === "asc") {
                                                                            setFieldValue("sort", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filters.sort), {
                                                                                name: null
                                                                            }));
                                                                        }
                                                                        if (!((ref2 = filters.sort) === null || ref2 === void 0 ? void 0 : ref2.name)) {
                                                                            setFieldValue("sort", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filters.sort), {
                                                                                name: "desc"
                                                                            }));
                                                                        }
                                                                    },
                                                                    "aria-label": "clear",
                                                                    sx: {
                                                                        border: "1px solid #fff",
                                                                        borderRadius: "50%",
                                                                        color: "#fff",
                                                                        width: "42px",
                                                                        marginRight: "1.25rem"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SortByAlpha/* default */.Z, {}),
                                                                        ((ref6 = filters.sort) === null || ref6 === void 0 ? void 0 : ref6.name) === "asc" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightAlt/* default */.Z, {
                                                                            sx: {
                                                                                position: "absolute",
                                                                                right: "-21px",
                                                                                transform: "rotate(90deg)"
                                                                            }
                                                                        }),
                                                                        ((ref7 = filters.sort) === null || ref7 === void 0 ? void 0 : ref7.name) === "desc" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightAlt/* default */.Z, {
                                                                            sx: {
                                                                                position: "absolute",
                                                                                right: "-21px",
                                                                                transform: "rotate(-90deg)"
                                                                            }
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            JSON.stringify(defaultFilters) !== JSON.stringify(filters) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                                                title: "Reset filters",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                                                    color: "inherit",
                                                                    type: "reset",
                                                                    onClick: function() {
                                                                        resetForm({
                                                                            values: defaultFilters
                                                                        });
                                                                        setFilters({
                                                                            resetFilters: true
                                                                        });
                                                                    },
                                                                    "aria-label": "clear",
                                                                    sx: {
                                                                        border: "1px solid #fff",
                                                                        borderRadius: "50%",
                                                                        color: "#fff",
                                                                        width: "42px"
                                                                    },
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                });
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((Lists_module_default()).listContainer, "container"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.Z, {
                        dataLength: reviews.length,
                        next: function() {
                            return setCurrentPage(currentPage + 1);
                        },
                        hasMore: hasMore,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Lists_module_default()).list,
                            children: reviews.map(function(review, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Lists_module_default()).review,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewItem/* ReviewItem */.r, {
                                        type: "Hotel",
                                        starRating: true,
                                        review: review,
                                        url: "/hotel/review/".concat(review.textId)
                                    })
                                }, index);
                            })
                        })
                    }),
                    loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Lists_module_default()).loader
                    }),
                    !reviews.length && !loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Lists_module_default()).noReviewsFound,
                        children: "No reviews found..."
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/CircleRating/CircleRating.module.scss
var CircleRating_module = __webpack_require__(38351);
var CircleRating_module_default = /*#__PURE__*/__webpack_require__.n(CircleRating_module);
;// CONCATENATED MODULE: ./components/CircleRating/CircleRating.jsx




var CircleRating = function(param) {
    var rating = param.rating, text = param.text, helpTooltip = param.helpTooltip;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (CircleRating_module_default()).bcReviewScores,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()((CircleRating_module_default())["user-review"]),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()((CircleRating_module_default())["user-rating"], (CircleRating_module_default())["user".concat(rating)])
                }),
                helpTooltip && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                    enterTouchDelay: 1,
                    enterDelay: 0,
                    title: helpTooltip,
                    leaveTouchDelay: 10000,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (CircleRating_module_default()).tooltipHandler,
                        dangerouslySetInnerHTML: {
                            __html: text
                        }
                    })
                }),
                !helpTooltip && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    dangerouslySetInnerHTML: {
                        __html: text
                    }
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./components/ProgressMeter/ProgressMeter.module.scss
var ProgressMeter_module = __webpack_require__(44361);
var ProgressMeter_module_default = /*#__PURE__*/__webpack_require__.n(ProgressMeter_module);
;// CONCATENATED MODULE: ./components/ProgressMeter/ProgressMeter.jsx


var ProgressMeter = function(param) {
    var label = param.label, progress = param.progress;
    var capitalizeFirstLetter = function capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.toLowerCase().slice(1);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (ProgressMeter_module_default()).progressMeterContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ProgressMeter_module_default()).progressMeterBar,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (ProgressMeter_module_default()).progressMeterBarProgress,
                    style: {
                        width: progress + "%"
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ProgressMeter_module_default()).progressMeterLabel,
                children: capitalizeFirstLetter(label)
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/SearchBox/SearchBox.jsx
var SearchBox = __webpack_require__(19);
// EXTERNAL MODULE: ./components/DestinationList/DestinationList.module.scss
var DestinationList_module = __webpack_require__(33589);
var DestinationList_module_default = /*#__PURE__*/__webpack_require__.n(DestinationList_module);
;// CONCATENATED MODULE: ./components/DestinationList/DestinationList.jsx












var getDestinations = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(country, page, perPage, loadingHandler) {
        var requestUrl;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    loadingHandler(true);
                    requestUrl = country ? "/api/destinations?&country=".concat(country, "&page=").concat(page, "&size=").concat(perPage) : "/api/destinations?page=".concat(page, "&size=").concat(perPage);
                    return [
                        4,
                        (0,httpClient/* httpGet */.kA)(requestUrl)
                    ];
                case 1:
                    return [
                        4,
                        _state.sent().json()
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getDestinations(country, page, perPage, loadingHandler) {
        return _ref.apply(this, arguments);
    };
}();
DestinationList.propTypes = {
    country: prop_types.string,
    heading: prop_types.string
};
function DestinationList(param) {
    var country = param.country, heading = param.heading;
    var getArticleItem = function getArticleItem(review) {
        var ref;
        return {
            type: "Destinations",
            subtype: "Destination",
            textId: review.citySafename,
            image: (ref = review.frontImage) === null || ref === void 0 ? void 0 : ref.substring(1),
            overline: "".concat(review.country, " ").concat(review.city === "-" ? "" : ", " + review.city),
            title: review.heading,
            content: review.intro,
            country: review.countrySafename,
            city: review.citySafename === "-" ? "" : review.citySafename
        };
    };
    var ref = (0,react.useState)(0), currentPage = ref[0], setCurrentPage = ref[1];
    var ref1 = (0,react.useState)([]), destinations = ref1[0], setDestinations = ref1[1];
    var ref2 = (0,react.useState)(false), hasMore = ref2[0], setHasMore = ref2[1];
    var ref3 = (0,react.useState)(false), loading = ref3[0], setLoading = ref3[1];
    var ref4 = (0,react.useState)(false), countryName = ref4[0], setCountryName = ref4[1];
    var perPage = 10;
    (0,react.useEffect)(function() {
        getDestinations(country, currentPage, perPage, setLoading).then(function(res) {
            setHasMore(!res.last);
            setDestinations((0,_to_consumable_array/* default */.Z)(destinations).concat((0,_to_consumable_array/* default */.Z)(res.content)));
            if (country) {
                setCountryName(res.content[0].country);
            }
            setLoading(false);
        });
    }, [
        currentPage
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((DestinationList_module_default()).headingContainer),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* BCBreadcrumbs */.k, {
                        className: "text-white",
                        headerText: countryName ? "Destinations in ".concat(countryName) : heading
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: classnames_default()((DestinationList_module_default()).heading, "font-fragment text-center"),
                        children: countryName ? "Destinations in ".concat(countryName) : heading
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((DestinationList_module_default()).listContainer, "container"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.Z, {
                        dataLength: destinations.length,
                        next: function() {
                            return setCurrentPage(currentPage + 1);
                        },
                        hasMore: hasMore,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (DestinationList_module_default()).list,
                            children: destinations.map(function(review, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (DestinationList_module_default()).recommendationItem,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendationItem/* RecommendationItem */.A, {
                                        item: getArticleItem(review)
                                    })
                                }, index);
                            })
                        })
                    }),
                    loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (DestinationList_module_default()).loader
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/DestinationItem/DestinationItem.module.scss
var DestinationItem_module = __webpack_require__(57842);
var DestinationItem_module_default = /*#__PURE__*/__webpack_require__.n(DestinationItem_module);
;// CONCATENATED MODULE: ./components/DestinationItem/DestinationItem.jsx









function getLink(country, city) {
    if (country) {
        return "/destinations/".concat(country, "/").concat(city);
    }
}
var DestinationItem = function(param) {
    var item = param.item, props = param.props;
    var ref;
    var cardRef = /*#__PURE__*/ react.createRef();
    var ref1 = (0,react.useState)(0), imageHeight = ref1[0], setImageHeight = ref1[1];
    var width = (0,dist_module/* useWindowWidth */.Lm)();
    var image = /*#__PURE__*/ (0,react.createRef)();
    (0,react.useEffect)(function() {
        setImageHeight(image.current.offsetWidth / 1.78);
    }, [
        width
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        href: "".concat(getLink(item.countrySafename, item.citySafename))
    }, props), {
        "aria-label": item.heading,
        className: classnames_default()((DestinationItem_module_default()).card, "relative mb-0"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "h-full w-full",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()((DestinationItem_module_default()).icon, "bg-review-iconDestinations"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PinDropRounded/* default */.Z, {
                        className: "m-auto text-white"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "h-full",
                    ref: cardRef,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()((DestinationItem_module_default()).text, "relative w-full flex flex-col justify-center items-center"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: classnames_default()((DestinationItem_module_default()).title, "font-fragment"),
                                children: item.heading
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: classnames_default()((DestinationItem_module_default()).subTitle, "font-libre"),
                                children: item.subHeading
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()((DestinationItem_module_default()).imageContainer),
                                ref: image,
                                style: {
                                    height: imageHeight
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWithFallback/* ImageWithFallback */.J, {
                                    src: "https://media.first-class.com/" + ((ref = item.frontImage) === null || ref === void 0 ? void 0 : ref.substring(1)),
                                    layout: "fill",
                                    objectFit: "cover",
                                    quality: 95,
                                    alt: item.heading + " image",
                                    sizes: "(max-width: 1024px) 100vw, 520px",
                                    priority: true
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: classnames_default()((DestinationItem_module_default()).typesList, "font-libre"),
                                children: "Flights | Hotels | Dining | Activities | Culture & more"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()((DestinationItem_module_default()).readMore, "font-libre"),
                                children: "Read more"
                            })
                        ]
                    })
                })
            ]
        })
    }));
};

// EXTERNAL MODULE: ./components/CookiesPolicy/CookiesPolicy.module.scss
var CookiesPolicy_module = __webpack_require__(55065);
var CookiesPolicy_module_default = /*#__PURE__*/__webpack_require__.n(CookiesPolicy_module);
;// CONCATENATED MODULE: ./components/CookiesPolicy/CookiesPolicy.jsx







var CookiesPolicy_theme = (0,createTheme/* default */.Z)({
    palette: {
        primary: {
            main: "#00454A"
        },
        secondary: {
            main: "#202020"
        }
    },
    typography: {
        fontFamily: '"Libre Franklin", sans-serif',
        color: "#202020"
    }
});
var CookiesPolicy = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ThemeProvider/* default */.Z, {
        theme: CookiesPolicy_theme,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (CookiesPolicy_module_default()).top,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    className: (CookiesPolicy_module_default()).topImage,
                    src: "".concat("https://media.first-class.com/", "assets/cookie_front.jpeg"),
                    layout: "fill",
                    objectFit: "cover",
                    objectPosition: "center 70%"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("container font-libre"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* BCBreadcrumbs */.k, {
                        headerText: "Cookies Policy"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (CookiesPolicy_module_default()).content,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "font-fragment",
                                children: "COOKIES AND INTEREST-BASED ADVERTISING POLICY"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "for First-Class.com V02.04 Dated 10.07.2024"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                children: "What are Cookies? "
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    "Cookies and similar tracking technologies, such as beacons, scripts, web beacons and tags (which together we refer to as “",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "cookies"
                                    }),
                                    "”), are small bits of text, usually stored on a user's computer hard drive or within a browser. They enable a website to remember information about the user's visit to the website. On mobile websites and mobile applications, we use device IDs and / or Advertising IDs in a similar manner to which we use cookies."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    "We and certain third-party partners (as described below) use cookies on our websites, our mobile applications and within emails or other communications we send to you (we refer to these together as our",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Sites"
                                    }),
                                    ")."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Please keep in mind that, without cookies, you may not have access to certain features on our Sites, including access to your profile"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "",
                                children: "What Types of Cookies are Used on Our Sites and What Do We Use Them For?"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "We use first-party cookies, i.e., those that are used solely by us or by third parties who act only on our instructions or on our behalf. These types of cookies are used for our own analysis of our own Sites, or to provide functionality such as remembering your language preference."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Other cookies on our Sites are used both by us for the purposes described in this policy and by third parties for purposes where those third parties may wish to combine information from our Sites with information from other sites to improve their services. For example, these types of cookies may be used for interest-based advertising purposes."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "The cookies used on our Sites, by either us or by third parties, can be “session” cookies, or “persistent” cookies. “Session” cookies are deleted automatically when you close your browser and are used for things like ensuring you are kept logged in as you navigate around our Sites. “Persistent” cookies remain stored on your device or browser even after you close it. These cookies are used, for example, to recognize you when you come back to our Sites."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "We divide the cookies we use into three categories:"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("table", {
                                cellPadding: "10",
                                border: "1",
                                className: "table-auto",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    children: "Type of cookie"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    children: "Description of how we use this type of cookie"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    children: "What choices do you have?"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: "Required"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "Essential for site functionality and security, such as maintaining your login status."
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            children: [
                                                                "- To provide a secure log-in to our Sites. ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                                "- To keep you logged in so that you do not have to log in repeatedly to access different pages of the Sites."
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: "Required cookies are necessary for our Sites to operate."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: "Functional"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "Enhance user experience by remembering preferences and providing insights into site usage."
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            children: [
                                                                "- To recognize you if you have visited previously, and remember your preferences from past visits, such as your country preference. ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                                "- To track when you make purchases or bookings on websites operated by our Partners so that we can display your bookings with our group companies on your account page. ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            children: [
                                                                "Our Partners are: ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                    className: "mb-0",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            children: "Kayak, "
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                href: "https://www.google.com/url?q=https://www.kayak.com&sa=D&source=editors&ust=1720183177914030&usg=AOvVaw3jZZTAgydQJo7iB5Q5lcqM",
                                                                                children: "Kayak"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            children: "."
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                    className: "mb-0",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            children: "ETraveli Group AB, "
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                href: "https://www.google.com/url?q=https://www.etraveligroup.com/&sa=D&source=editors&ust=1720183177914246&usg=AOvVaw16Les9tyyK4B0yaii7LwKi",
                                                                                children: "https://www.etraveligroup.com"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            children: "."
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                    className: "mb-0",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            children: "Amadeus Connect, "
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                href: "https://www.google.com/url?q=https://amadeus.com&sa=D&source=editors&ust=1720183177914406&usg=AOvVaw3UNU-UiwJwBfVZ-XAFKbrk",
                                                                                children: "Amadeus"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            children: "\xa0."
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                    className: "mb-0",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            children: "HotelsCombined, "
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                href: "https://www.google.com/url?q=https://hotelscombined.com&sa=D&source=editors&ust=1720183177914580&usg=AOvVaw3Q1UjNARzR4je-C805oecM",
                                                                                children: "HotelsCombined"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            children: "."
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            children: "\xa0"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            children: [
                                                                "- To improve our Sites and our offerings by helping us to understand how users use the Sites and to analyze trends which appear in that data. ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                                "- To personalize your experience of our Sites, for example, by showing you offers on our homepage or in emails that are most relevant to you based on your previous visits to our Sites or those operated by our group companies or by ranking certain types of options (e.g., only non-stop flights) higher in your search results."
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "Where required by law, functional cookies will only be used on the Sites where you have given your consent to their use."
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            children: [
                                                                "You can opt out of our use of Google Analytics by downloading the browser add-on",
                                                                " ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    className: "_kiA",
                                                                    href: "https://tools.google.com/dlpage/gaoptout",
                                                                    rel: "noreferrer noopener nofollow",
                                                                    children: "here"
                                                                }),
                                                                "."
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: "Advertising"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "Used for personalized ads and analytics."
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "- To recognize you if you have used our services on another device. We combine information received from multiple devices to determine if you are using a new device, so that we can continue to provide you with a personalized experience on our Sites."
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "- To enable you to post to social media sites and other platforms, for example, to allow you to access a particular social media page to post a comment or a “like.”"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "- To collect information for use in advertising on our own Sites and on third party sites which you may visit. Such information is based on your preferences and your usage of our Sites."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "Where required by law, advertising cookies will be used only on the Sites where you have given your consent to their use."
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "See the section entitled “Your Cookie Choices” below to learn more about how to withdraw your consent to advertising cookies."
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                children: "Our Advertising Cookies "
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "We work with third parties that place cookies on our Sites to provide their services, including:"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                                className: "_im7 _kkE",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                children: "Ad Targeting"
                                            }),
                                            ". We work with third-party advertising companies to serve ads while you are visiting our Sites and to permit these companies to place and access their own cookies on your computer in the course of serving advertisements on our Sites. These companies may use information obtained through their cookies (which does not include your name, address, e-mail address, or telephone number) about your visits to our Sites and other websites, in combination with information about your purchases and interests from other online sites, to provide advertisements about goods and services of interest to you."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                children: "Advertising Analytics/Measurement."
                                            }),
                                            " We make use of analytics cookies as part of our online advertising campaigns to learn how users interact with our Sites after they have been shown an online advertisement, which may include advertisements on third-party websites. In particular, our Sites use Google Analytics 4, which are web analytics and analytics advertising services provided by Google, Inc., which use third-party cookies. We have enabled the IP address anonymization functionality so that the IP address of the user is shortened by Google. Our Sites also use the following Google Analytics Advertising features: Google Remarketing, Google Segments, Google Ads Manager, and Google Ads. These features use third-party cookies to collect information about our website traffic by tracking users across websites and across time and generating reports for us to better understand our website users and to create audiences for our advertisements based on such understanding."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                children: "Remarketing Pixel Tags"
                                            }),
                                            ". We may share website usage information about visitors to our Sites with third-party advertising companies for the purpose of managing and targeting advertisements and for market research analysis on our Sites and other sites. For these purposes, we and our third-party advertising companies may place pixel tags (also called clear gifs) on some of the pages you visit on our Sites. We will then use the information that is collected using these pixel tags to serve you relevant advertisements when you are visiting other sites on the Internet. These advertisements may be based on your interests, for example, on the basis of specific searches you conducted on our Sites during earlier browsing sessions."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                children: "Other Cookies:"
                                            }),
                                            " Our partners, who provide certain features on our Sites or display advertising based on your browsing activity, also use Local Storage such as HTML5, to collect and store content information and preferences. Please note that different web browsers offer their own management tools for removing HTML5 local storage."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Mobile Devices, Anonymous Device Identifiers and Hashed IDs."
                                    }),
                                    " ",
                                    "We and/or third parties that we have engaged may collect and store a unique identifier matched to your mobile device, in order to deliver customized ads or content while you use applications or surf the internet, or to identify you in a unique manner across other devices or browsers. In order to customize these ads or content, we or a third party may collect de-identified usage data or other data about you which you have either voluntarily submitted to us, for example, your email address, or has been passively collected from you, such as your device identifier or IP address, where permitted. However, if we share your email address, we share it solely in hashed, non-human-readable form."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                children: "Your Cookie Choices "
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "We provide you with choices over the use of cookies as described in this policy."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "When you first visit our Sites, where required by law, you will have the option to give your explicit consent to the advertising and functional cookies we use, or to refuse your consent to our use of those cookies by clicking on the [X] within that disclosure."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Browsers."
                                    }),
                                    ' Most browsers accept cookies by default. You may be able to change the settings to have your browser refuse certain cookies or notify you before accepting cookies. To do so, please follow the instructions provided by your browser which are usually located within the "Help", "Tools" or "Edit" facility. Some third parties also provide the ability to refuse their cookies directly by clicking on an opt-out link, and we have tried to indicate where this is possible in the table above.'
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    "You can also find more information about cookies, including how to see what cookies have been set on your device and how to manage and delete them, at",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "_kiA",
                                        href: "https://www.allaboutcookies.org",
                                        rel: "noreferrer noopener nofollow",
                                        children: "www.allaboutcookies.org"
                                    }),
                                    " ",
                                    "and",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "_kiA",
                                        href: "https://www.youronlinechoices.eu",
                                        rel: "noreferrer noopener nofollow",
                                        children: "www.youronlinechoices.eu"
                                    }),
                                    "."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Mobile Devices."
                                    }),
                                    " IIf you no longer wish to receive interest-based advertising on your mobile applications, please refer to your device’s operating system settings and follow instructions below."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            'iOS users: To use the "Limit Ad-Tracking" option, follow the instructions provided by Apple here:',
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "_kiA",
                                                href: "https://support.apple.com/en-us/HT202074",
                                                rel: "noreferrer noopener nofollow",
                                                children: "Apple Support Center"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            'Android Users: To use the "opt-out of interest-based advertising" option, follow the instructions provided by Google here:',
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "_kiA",
                                                href: "https://support.google.com/googleplay/answer/3405269",
                                                rel: "noreferrer noopener nofollow",
                                                children: "Google Play Help"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            "You may also consider downloading the ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "https://youradchoices.com/appchoices",
                                                target: "_blank",
                                                rel: "noopener noreferrer nofollow",
                                                children: "DAA AppChoices Mobile App"
                                            }),
                                            " to manage online behavioral advertising technology."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "If you no longer wish to receive interest-based advertising on your mobile device browser, you can follow the steps in relation to Browsers outlined above."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Do-Not-Track Signals."
                                    }),
                                    " We currently do not employ technology that recognizes “do-not-track” signals from your browser."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Please keep in mind that, without cookies, you may not have access to certain features on our Sites, including access to your profile"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    "Please also refer to our Privacy Policy on",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "_kiA",
                                        href: "https://www.first-class.com/view/privacy_policy",
                                        children: "https://www.first-class.com/view/privacy_policy"
                                    }),
                                    " ",
                                    " and Term & Conditions for use on ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "https://www.first-class.com/view/terms_conditions",
                                        target: "_blank",
                                        children: "https://www.first-class.com/view/terms_conditions"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/TermsConditions/TermsConditions.module.scss
var TermsConditions_module = __webpack_require__(46459);
var TermsConditions_module_default = /*#__PURE__*/__webpack_require__.n(TermsConditions_module);
;// CONCATENATED MODULE: ./components/TermsConditions/TermsConditions.jsx






var TermsConditions_theme = (0,createTheme/* default */.Z)({
    palette: {
        primary: {
            main: "#00454A"
        },
        secondary: {
            main: "#202020"
        }
    },
    typography: {
        fontFamily: '"Libre Franklin", sans-serif',
        color: "#202020"
    }
});
var TermsConditions = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ThemeProvider/* default */.Z, {
        theme: TermsConditions_theme,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (TermsConditions_module_default()).top,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    className: (TermsConditions_module_default()).topImage,
                    src: "".concat("https://media.first-class.com/", "assets/cookie_front.jpeg"),
                    layout: "fill",
                    objectFit: "cover",
                    objectPosition: "center 70%"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("container font-libre"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (TermsConditions_module_default()).content,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row section message",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "column large-16 large-centered",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: "font-garamond",
                                    children: "Terms & Conditions"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "for First-Class.com V02.03 Dated 10.07.2024"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    children: "1. Acceptance of Terms"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: 'Please read these terms and conditions of use carefully before accessing, using or obtaining any materials, information, products or services. By accessing the First-Class.com website, mobile or tablet application, or any other feature or other First-Class.com platform (collectively, "Our Website"), you agree to be bound by these terms and conditions ("Terms") and our Privacy Policy. If you do not accept all of these Terms, then you may not use Our Website. In these Terms, "we", "us", "our" and "First-Class.com" refers to First-Class.com, and "you" and "your" refers to you, the user of Our Website.'
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    children: "2. Changes to Terms"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "We may modify these Terms for any reason at any time by posting a new version on Our Website. These changes do not affect rights and obligations that arose prior to such changes. Your continued use of Our Website following the posting of modified Terms will be subject to the Terms in effect at the time of your use. Please review these Terms periodically for changes. If you object to any provision of these Terms or any subsequent modifications to these Terms or become dissatisfied with Our Website in any way, your only recourse is to immediately terminate use of Our Website."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    children: " 3. We Do Not Sell Travel Products"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: 'Our Website is a travel search engine. First-Class.com does not provide, own, or control any of the travel services and products that you can access through Our Website, such as flights, accommodations, rental cars, packages, or travel insurance (the "Travel Products"). The Travel Products are owned, controlled, or made available by third parties (the "Travel Providers") either directly (e.g., airline) or as an agent (e.g., online travel agency). The Travel Providers are responsible for the Travel Products. The Travel Provider\'s terms and privacy policies apply to your booking, so you must agree to and understand those terms. Furthermore, the terms of the actual travel provider (airline, hotel, tour operator, etc.) apply to your travel, so you must also agree to and understand those terms. Your interaction with any Travel Provider accessed through Our Website is at your own risk; First-Class.com does not bear any responsibility should anything go wrong with your booking or during your travel.'
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "The display on Our Website of a Travel Product or Travel Provider does not in any way imply, suggest, or constitute a recommendation by First-Class.com of that Travel Product or Travel Provider, or any sponsorship or approval of First-Class.com by such Travel Provider, or any affiliation between such Travel Provider and First-Class.com."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "First-Class.com hosts content, including prices, made available by or obtained from Travel Providers. First-Class.com is in no way responsible for the accuracy, timeliness, or completeness of such content. Since First-Class.com has no control over the Travel Products and does not verify the content uploaded by the Travel Providers, it is not possible for us to guarantee the prices displayed on Our Website. Prices change constantly and additional charges (e.g., payment fees, service charges, checked-in luggage fees, local taxes and fees) may apply, so you should always check whether the price asked for a booking is the one you expected. Some Travel Products may also be sold in another currency than the one preset or chosen by you for the display of the search results. Our currency conversion is for informational purposes only and should not be relied upon as accurate or real-time; actual rates may vary, and your payment provider (e.g., your credit card company) may charge conversion fees and apply another date's currency rate."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    children: "4. Booking through First-Class.com"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "If you make a booking through Our Website for Travel Products, that booking is made with the Travel Provider named on the booking page, and Our Website only acts as a user interface. Accordingly, First-Class.com has no responsibility for the booking or the Travel Product because First-Class.com has no involvement in creating the description of the Travel Product, in defining the price and any fees, or in providing the Travel Products that you book. If you have any issues or disputes with your booking and/or the Travel Product, you agree to address and resolve these with the Travel Provider and not with us."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    children: "5. Intellectual Property"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "We, along with our corporate affiliates, the Travel Providers, and other licensors, own all of the text, images, software, trademarks, service marks, and other material contained on Our Website except User Content. You will not copy or transmit any of the material except if you are doing so for your personal, non-commercial use. All copyright, trademark, and other proprietary rights notices presented on Our Website must appear on all copies you print. Other non-First-Class.com product, service, or company designations on Our Website belong to those respective third parties and may be mentioned on Our Website for identification purposes only. You should contact the appropriate third party for more complete information regarding such designations and their registration status. Your use of and access to Our Website does not grant you any license or right to use any of the marks included on Our Website."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    children: "6. Use of Our Website"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "You may only use and register to become a user of Our Website if you are of sufficient legal age and can enter into binding contracts. If you become a registered user, you are responsible for maintaining the secrecy of your passwords, login, and account information. You will be responsible for all use of Our Website by you, anyone using your password and login information (with or without your permission), and anyone who you allow to access your travel itineraries. All information that you provide to us must be accurate and up-to-date. If any of your information changes, you must immediately update it. If you have reason to believe that your account is no longer secure (e.g., loss, theft, or unauthorized disclosure or use of your information or computer or mobile device used to access Our Website), you must promptly change your personal information that is affected."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "If you decide to have messages or other communications from Our Website sent directly to your mobile device, you are solely responsible for keeping us updated with your current phone number, updating to the latest version of the mobile app, and for any charges incurred by receiving such messages. We will not be liable for information sent to a device that is associated with your outdated mobile phone number or using an outdated mobile app. If you install any software or enable any service that stores information from Our Website on any mobile device or computer, it is your responsibility, prior to transfer or disposal of such device, to remove your information or otherwise disable access to such software or service to prevent unauthorized access to your information or account."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "You may only use Our Website to search for legitimate travel deals; you may not use Our Website to make any false, fraudulent, or speculative reservations or any reservation in anticipation of demand. By using Our Website, you agree to comply with laws that apply to Norway and your own country, including laws that apply to exporting technical data."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "In addition, you agree not to do any of the following without prior express written permission from First-Class.com:"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    className: "list-disc mb-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: 'Access the site with any manual or automated process for any purpose other than your personal use or for inclusion of First-Class.com pages in a search index. Use of any automated system or software to extract data from Our Website ("screen scraping"), for commercial or non-commercial purposes, is prohibited;'
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "Violate the restrictions in any robot exclusion headers on Our Website or bypass or circumvent other measures employed to prevent or limit access to Our Website;"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "Deep-link to any portion of Our Website for any purpose;"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "Use any device, software, or routine that interferes or attempts to interfere with the normal operation of Our Website or take any action that imposes an unreasonable load on our computer or network equipment;"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "Reproduce, duplicate, copy, sell, trade, resell, or exploit Our Website;"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "Use any feature of Our Website for any purpose that is unlawful, harmful, or otherwise objectionable or inappropriate, as determined by us;"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "Post or distribute any material on Our Website that violates the rights of any third party or applicable law;"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "Use Our Website to collect or store personal data about others;"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "Use Our Website for any commercial purpose; or"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "Transmit any ad or promotional materials on Our Website."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "We may, at our sole discretion, at any time and without advance notice or liability, suspend, terminate, or restrict your access to any or all components of Our Website. Furthermore, you can always delete your account."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "You further agree not to:"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    className: "list-disc mb-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "Circumvent, disable, or otherwise interfere with security-related features of Our Website or features that prevent or restrict the use or copying of any content or enforce limitations on the use of Our Website or any content on the Website;"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "Impersonate any person or entity, or otherwise misrepresent your affiliation with a person or entity;"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "Intentionally or unintentionally violate or encourage others to violate any applicable law, statute, ordinance, or regulation;"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "Provide false or deceptive information;"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "Solicit personal information from anyone;"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "Delete, add, or otherwise change other people's User Content;"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "Remove or alter any copyright or other proprietary notices on or in connection with any content on the Website;"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "Publicly disparage anyone or any User Content;"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "Publish or post threats of violence, or promote or encourage others to engage in violence or illegal activity."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        "Please report abusive content to",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "mailto:media@firts-class.com",
                                            children: "media@first-class.com"
                                        }),
                                        " ",
                                        "if you see it."
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    children: "7. Notify Us of Infringers"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "If you believe any of the content on Our Website violates your copyright, please notify us in writing. Our contact information is at the bottom of this section."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "In order for us to take action, you must do the following in your notice:"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    className: "list-disc mb-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "Provide your physical or electronic signature;"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "Identify the copyrighted work that you believe is being infringed;"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "Identify the item that you think is infringing your work and include sufficient information, such as a URL or copy of the webpage showing the URL, so that we can find it;"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "Provide us with a way to contact you, such as your address, telephone number, or email;"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "Provide a statement that you believe in good faith that the item you have identified as infringing is not authorized by the copyright owner, its agent, or the law to be used in connection with the services; and"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            children: [
                                                " ",
                                                "Provide a statement that the information you provide in your notice is accurate, and that (under penalty of perjury) you are authorized to act on behalf of the copyright owner whose work is being infringed."
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Here is the contact information for copyright issues:"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "mailto:media@first-class.com",
                                        children: "media@first-class.com"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "or"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        "First-Class.com",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        "Fredriksborgveien 2",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        "0286 Oslo",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        "Norway"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Again, we cannot take action unless you give us all the required information."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    children: "8. Warranty Disclaimer"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: 'Our Website and all content and services provided on Our Website are provided on an "as is" and "as available" basis. Our content is largely generated in an automated fashion; errors can and do happen. We usually have many search results, but we are not comprehensive and do not display all available providers and offers. Accordingly, we do not always display the lowest available price. First-Class.com expressly disclaims to the fullest extent permissible all warranties of any kind, whether express or implied, including, but not limited to, any implied warranties of merchantability, fitness for a particular purpose, title, non-infringement, and security and accuracy, as well as all warranties arising by usage of trade, course of dealing, or course of performance.'
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    children: "9. Our Liability Is Limited"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "We (together with our officers, directors, employees, representatives, shareholders, affiliates, and providers), to the extent permitted by law, hereby expressly exclude any responsibility and liability for:"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    className: "list-disc mb-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "Any loss or damages to, or viruses that may infect, your computer equipment or other property as the result of your access to Our Website, your downloading of any content from Our Website; or"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            children: [
                                                "Any injury; death; loss; claim; act of god; accident; delay; or any direct, special, exemplary, punitive, indirect, incidental or consequential damages of any kind (including without limitation lost profits or lost savings), whether based in contract, tort, strict liability or otherwise, that arise out of or is in any way connected with:",
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                    className: "list-disc",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Any use of Our Website, our content;"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Any failure or delay (including without limitation the use of or inability to use any component of this Website for reservations or booking); or"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "The performance or nonperformance by us or any Travel Provider, even if we have been advised of the possibility of damages to such parties or any other party. Some states or countries do not allow this limitation of liability, so the limitations above may not apply or apply only partially to you."
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    children: "10. You Agree to Protect Us"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Subject to these Terms, you will defend, indemnify and hold us and each of our officers, directors, employees, and agents harmless from and against any claim, cause of action, liability, expense, loss, or demand, including without limitation reasonable legal and accounting fees, arising out of, or in any way connected with your breach of these Terms or the agreements made part of these Terms by reference, your breach of any applicable law, and your use of or access to Our Website or the Intellectual Property."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    children: "11. Jurisdiction and Applicable Law"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "You agree that the Privacy Policy and Terms & Conditions of First-Class.com shall, save for mandatory local law, be governed and construed in accordance with the laws of Norway and be subject to the non-exclusive jurisdiction of the courts of Norway."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    children: "12. Links to Other Websites"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: 'Our Website may contain links to other websites that we do not operate or control and for which we are not responsible ("Other Websites"). We provide these links for your reference and convenience and do not endorse the contents of Other Websites and accept no responsibility for them or for any loss or damages that may arise from your use of them. You should refer to the separate terms of use, privacy policies, and other rules posted on Other Websites before you use them.'
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    children: "13. Air Carrier Rules"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "The circumvention of an air carrier's rules, including practices such as back-to-back ticketing (purchasing two or more tickets with overlapping travel dates in order to circumvent minimum stay requirements) and hidden-city ticketing (purchasing tickets including segments which the purchaser does not intend to use in order to circumvent an air carrier's pricing structure), is prohibited by many air carriers. The use of prohibited ticketing practices may result in the air carrier taking actions, including the cancellation of the ticket, denied boarding, revocation of frequent flier miles and other benefits, additional charges to the purchaser's credit card, additional charges collected at the airport, or future invoicing."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    children: "14. User Content"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: 'The websites and services contain reviews, travel guides, or other forums in which you can post content. If you use said interactive areas on the websites, you are solely responsible for the travel information and other content, including without limitation, any reviews, text, images, links, or videos that you upload, transmit, or share with us or others on or through the website (collectively, the "User Content"), and you represent and warrant that you are not transmitting or sharing User Content that you do not have permission to share. We do not guarantee any confidentiality with respect to the User Content and you understand that the User Content may be publicly displayed.'
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        "By posting User Content to the Website, you represent that:",
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    className: "list-disc mb-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "You are the owner of the User Content; or"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "You have the right and license to use the User Content; or"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "The User Content is in the public domain; or"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "To your knowledge, no one else claims ownership of, or exclusive rights to, the User Content; and"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "You have the legal right to grant a license to us to use the User Content."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "When you provide us with User Content, you own the content you create and share, and you also grant us a perpetual, transferable, irrevocable, sub-licensable, fully-paid, worldwide license to use, modify, reproduce, distribute, prepare derivative works of, publicly perform, and publicly display (in any form and on all mediums now known or hereafter devised) all User Content or other content provided to us. We can use the User Content in any format, channel, platform, or region with the right to localize the content into other languages. If uploaded or submitted to us, you further give us permission and the right to use your name, image, likeness, or other personal attributes."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "You authorize us to make copies as we deem necessary to facilitate the storage and assimilation of the User Content on the websites. By providing us User Content, you represent and warrant that the User Content you provide will not violate or in any way infringe upon the rights of third parties, including property, contractual, employment, trade secrets, proprietary information, and nondisclosure rights, or any intellectual property rights. You may remove your User Content from the website, but the license that you have granted will remain in effect."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "You understand that we do not control the User Content and will not be, in any way, responsible or liable for such User Content."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "We take no responsibility for any User Content posted, stored, uploaded, distributed, transmitted or otherwise published by any User, including yours, on Our Website. We assume no liability for any loss or damage to User Content, nor are we liable for any mistakes, defamation, slander, libel, omissions, falsehoods, obscenity, pornography or profanity User may encounter when viewing User Content. Although we have no obligation to screen, edit or monitor any User Content, we reserve the right, and have the sole and absolute discretion to remove, edit or screen, without notice, any such User Content from Our Website at any time and for any reason, including, but not limited to when we believe in good faith that such User Content is in breach of these Terms or otherwise believe the removal may be reasonably necessary to safeguard our rights or the rights of Users or to mitigate any risk of harm or liability to us or any User."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Further, you expressly agree not to post, upload, transmit, distribute, store, create or otherwise publish any User Content on Our Website that:"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    className: "list-disc mb-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "Is unlawful, harmful, inappropriate, false, misleading, libelous, defamatory, obscene, pornographic, indecent, lewd, suggestive, harassing, promoting of harassment of a third party, threatening, in violation of privacy or publicity rights, abusive, inflammatory, offensive to the online community (such as, without limitation, promotes racism, bigotry, hatred or physical harm of any kind against any group or individual), fraudulent or otherwise objectionable;"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "Would constitute, promote, encourage, provide instructions for, or enable conduct of an illegal activity, criminal offense, give rise to civil liability, violate the rights of any third party in any country of the world, or that would create liability or violate any local, state, national or international law, such as, without limitation, providing instructions or guides about attending or participating in illegal activities such as human trafficking or creating computer viruses;"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "May infringe any patent, trademark, trade secret, copyright, proprietary right or any other intellectual property right of any party;"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: 'Constitutes mass mailings, "spamming", junk mail, pyramid schemes, or chain letters;'
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "Impersonates any person or entity or misrepresents your affiliation with any person or entity;"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "Is private information of any third party, including but not limited to, Social Security numbers, passwords, credit card numbers, addresses, email addresses, phone numbers, and any other information that enables a User to readily identify any third party;"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "Contains restricted or hidden content;"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "Includes or facilitates viruses, corrupt data or other harmful, destructive or disruptive files;"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "Is unrelated to the topic or intended use of the area on Our Website, in our sole discretion; or"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "In our sole discretion, restricts any other person from using or enjoying Our Website."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    children: "15. Hacker Fare"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "In the case of a Hacker Fare, Our Website displays search results for a combination of Travel Products (e.g., separate flight and hotel results, or two one-way flights, instead of a round trip). If you use these search results, you will make two different bookings with different rules and policies (for example, for baggage fees, change fees, and refunds). Any changes made to one of your bookings will not affect the other booking (for example, if your initial flight is cancelled by either you or the airline, the other airline with which you booked your return flight is not obligated to issue a refund or change your itinerary). If you are traveling internationally, you may need to provide proof that you have a return flight at check-in and at immigration."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    children: "16. Member Club"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                    children: "16.1 Membership Levels"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "First-Class.com offers a Member Club with two levels: Gold and Elite."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                            children: "Gold Membership:"
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        "To become a Gold member, you must subscribe to our newsletters and complete your profile information. This enables us to send you more relevant offers and deals based on your preferences and profile."
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                            children: "Elite Membership:"
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        "Elite membership is a paid subscription that provides access to all Gold membership benefits plus exclusive access to flight tickets with deep discounts."
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                    children: "16.2 Membership Benefits"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                            children: "Gold Membership Benefits:"
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        "- Access to special offers and deals tailored to your preferences. ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        "- Regular updates via our newsletters."
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                            children: "Elite Membership Benefits:"
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        "- All benefits of the Gold membership. ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        "- Access to exclusive flight tickets with significant discounts."
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                    children: "16.4 Membership Cancellation"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        "- You may cancel your membership at any time by contacting our customer service. ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        "- If you cancel an Elite membership, you will not be entitled to a refund for any remaining period of your subscription."
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    children: "17. General Requirements"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "We may change the site and these Terms at any time, in our sole discretion and without notice to you. You are responsible for remaining knowledgeable about these Terms. Your continued use of the site constitutes your acceptance of any changes to these Terms and any changes will supersede all previous versions of the Terms. Unless otherwise specified herein, all changes to these Terms apply to all users, including those enrolled before the date the changes take effect. Furthermore, we may terminate this agreement with you under these Terms at any time by notifying you in writing (including by email) and/or, if you are a registered user, by cancelling your account and your access to your account."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Nothing contained in these Terms will be deemed to constitute either party as the agent or representative of the other party, or both parties as joint venturers or partners for any purpose. You may not assign, delegate or transfer your rights or obligations under these Terms. We may assign our rights and duties under these Terms without such assignment being considered a change to the Terms and without notice to you, provided your rights under these Terms are not prejudiced."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "If we fail to act with respect to your breach or anyone else's breach on any occasion, we are not waiving our right to act with respect to future or similar breaches. If a court finds any of these Terms to be unenforceable or invalid, that Term will be enforced to the fullest extent permitted by applicable law and the other Terms will remain valid and enforceable. These Terms, together with those agreements made a part of these Terms by reference, make up the entire agreement between us relating to your use of Our Website, and replace any prior understandings or agreements (whether oral or written) regarding your use of Our Website."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "To the extent permitted by law, the laws of Norway, without regard to its conflict of laws rules, will govern these Terms, as well as your and our observance of them. If you take any legal action relating to your use of Our Website, or these Terms, or our services, you agree to file such action only in the courts located in Norway; if you are a consumer, the law may allow you to also bring proceedings in the courts for the place where you are domiciled. In any such action or any action we may initiate, the prevailing party will be entitled to recover all legal expenses incurred in connection with the action, including but not limited to costs, both taxable and non-taxable, and reasonable attorney fees. To the extent permitted by law, you agree that any disputes, claims and causes of action arising out of or connected with Our Website and/or these Terms, will be resolved individually, without resort to any form of class action."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    children: "18. Your Feedback"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "We encourage you to share your comments and questions with us here, but we may not be able to respond to all of them. Please note that we assume no responsibility for reviewing unsolicited ideas for our business (like product or advertising ideas) and will not incur any liability as a result of any similarities between those ideas and materials that may appear in future First-Class.com products or services. Also, please remember that you are responsible for whatever material you submit, including its reliability, originality, and copyright. Please do not reveal trade secrets or other confidential information in your messages. Any and all rights to materials submitted to us become the exclusive property of First-Class.com. Furthermore, by submitting Feedback, you are granting us an irrevocable, perpetual, non-exclusive, transferable, fully-paid, worldwide license (with the right to freely sublicense) to use, copy, modify, publicly perform, publicly display, reformat, translate, syndicate, republish, excerpt (in whole or in part) and distribute Feedback we receive from you for any purpose, including business, commercial, marketing, advertising, or otherwise."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    children: "19. Legal notices"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Google Play and the Google Play logo are trademarks of Google LLC. Apple, the Apple logo, iPhone, and iPad are trademarks of Apple Inc., registered in the U.S. and other countries and regions. App Store is a service mark of Apple Inc."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    children: "20. Operator Information"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Our Website is operated by:"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        "First-Class.com",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        "Tjuvholmen All\xe9 3",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        "0252 Oslo",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        "Norway"
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/PrivacyPolicy/PrivacyPolicy.module.scss
var PrivacyPolicy_module = __webpack_require__(95761);
var PrivacyPolicy_module_default = /*#__PURE__*/__webpack_require__.n(PrivacyPolicy_module);
;// CONCATENATED MODULE: ./components/PrivacyPolicy/PrivacyPolicy.jsx







var PrivacyPolicy_theme = (0,createTheme/* default */.Z)({
    palette: {
        primary: {
            main: "#00454A"
        },
        secondary: {
            main: "#202020"
        }
    },
    typography: {
        fontFamily: '"Libre Franklin", sans-serif',
        color: "#202020"
    }
});
var PrivacyPolicy = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ThemeProvider/* default */.Z, {
        theme: PrivacyPolicy_theme,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (PrivacyPolicy_module_default()).top,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    className: (PrivacyPolicy_module_default()).topImage,
                    src: "".concat("https://media.first-class.com/", "assets/cookie_front.jpeg"),
                    layout: "fill",
                    objectFit: "cover",
                    objectPosition: "center 70%"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("container font-libre"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* BCBreadcrumbs */.k, {
                        headerText: "Privacy Policy"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (PrivacyPolicy_module_default()).content,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row section message",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "column large-16 large-centered",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        className: "font-fragment",
                                        children: "Privacy Policy"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "for First-Class.com V02.01 Dated 10.07.2024"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        children: [
                                            'This Privacy Policy describes how First-Class.com and its subsidiaries, (collectively, "First-Class.com," "we", "our" or "us") collect, use, process and share personal information. This Policy applies to visitors and users (individually, "you") of First-Class.com"s websites (including but not limited to First-Class.com and AwardFlights.com), applications, social media accounts, and other services (collectively, our "Services"). Please note that your use of our Services is additionally subject to the First-Class.com Terms and Conditions.',
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "https://www.first-class.com/view/terms_conditions",
                                                target: "_blank",
                                                children: "https://www.first-class.com/view/terms_conditions"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        children: "Overview"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("table", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            width: "20%",
                                                            children: " Information We Collect and Use"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: "When you use or visit our Services, we collect information directly from you, generate information about you, and obtain personal information from third parties."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: "How We Use Your Information"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: "We use your information to provide our Services, tailor your experience, show you bookings and transactions made with our travel partners, send you marketing communications, provide you with more relevant advertising and offers, and for other purposes described below."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: "How We Share Your Information"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: "We share your information with travel partners, other business partners, social networking services, third-party services or applications you use to log into your First-Class.com account, service providers, and others as described below."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: "How We Store and Protect Your Information"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: "We maintain technical, administrative, and physical security measures to protect your information."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: "Cookies"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: "We use cookies and similar technologies to help provide our Services, offer you a more personalized user experience, and market our and third parties' products and services to you."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: "Your Choices and Rights"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: "You have choices about your personal information and may have rights to opt out of receiving marketing communications, change your communication preferences, access and update your information, and exercise choices regarding cookies."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: "International Transfers of Information"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: "Information about you may be transferred to or accessed by entities located in countries outside of your home country."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: "Links to Other Websites"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: "Our Services may contain links to other websites or services that are not owned or controlled by First-Class.com."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: "Children"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: "Our Services are not directed at or intended for use by children, nor do we knowingly collect information from children under 18 years of age."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: "Changes to This Policy"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: "We update this Policy from time to time, and changes will be effective when posted."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: "How to Contact Us"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: "If you have any questions about this Policy or the way your personal information has been used, please contact us."
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        children: "Information We Collect and Use"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        children: "Personal Information We Collect Directly From You"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "When you visit or use our Services, we collect the following categories of personal information directly from you:"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        className: "list-disc mb-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "Personal details (such as your name, age, birthday, gender)"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "Contact information (such as email address, address, phone number)"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "Booking information (such as traveler’s name, frequent flyer details, passport number, country of citizenship, booking reference number, itinerary details, meal preferences, luggage information, and layover information)"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "Account information (such as login credentials, including email address and password, and account settings)"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "Social media data (if you link your First-Class.com account with a social media account, we may collect personal information such as name, age, gender, photograph, and other personal information relating to your social media account)"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "Billing information (such as credit, debit, or other payment card information and billing address)"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "Your contacts (such as contact information of people you add to or notify of your reservations or itineraries through our Services)"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "Your preferences (such as home airport, seating preferences, meal preferences, communication preferences, and other preference information you provide)"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "Reviews you submit (including any screen name you publish under or any personal information you include about yourself or others in such review)"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "Content you publish (including travel recommendations and any personal information you include about yourself or others in content you publish)"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "Photos of you (such as when you add a photo of yourself to your profile or upload photos to a review)"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "Communications you send us (such as questions, conversations, complaints, or other information submitted to our support team)"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "Promotion information (if you participate in a contest, sweepstakes, or similar campaign, we collect information provided in relation to such activity, such as photos, images, captions, or other content)"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "Other information you may provide (including other information provided about yourself or others through our Services or accessed via third-party platforms)"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        children: "Personal Information Generated By Us"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "As you use our Services, we generate certain personal information about you, including through automatic data collection and by inferences based on the information we collect about you and your activity. This includes:"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        className: "list-disc mb-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "Device information (such as your mobile device, computer, or tablet, including information about your hardware and software, device configuration, and nearby networks)"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "Usage and performance information (such as your searches, statistics about travel itineraries you share, how you interact with features of our Services, access times, referring URL, and performance of our Services)"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "Location information (such as approximate location information, or with your consent, precise geographic location data from your mobile device)"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "Inferences about you (such as preferences and interests to provide and personalize our Services and tailor advertising)"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        children: "Personal Information We Obtain from Third Parties."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "We may also receive certain categories of personal information from third parties, such as:"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        className: "list-disc mb-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: " Your name"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "Email address or other contact information"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "Social media data, if you connect to our Services using a social media third-party platform"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "Browsing, purchase, usage, and advertising details, including information about restaurant or travel accommodations and bookings made through travel partners"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        children: "How We Use Your Information"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: 'We use your personal information for the following purposes ("Purposes"):'
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        className: "list-disc mb-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "To provide the Services, including processing bookings, facilitating travel arrangements, and providing customer support"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "To authenticate your account credentials and identify you"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "To communicate with you about your account or use of our Services"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "To send you marketing communications"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "To operate and improve our Services and develop new products and services"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "To process and deliver contest entries and rewards"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "To process your payment information"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "To provide services and information to travel partners"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "To tailor your experience with our Services"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "To provide you more relevant advertising on and off our Services"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "To protect against, investigate, and deter fraudulent, unauthorized, or illegal activity"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "To comply with our policies, procedures, and legal obligations"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        children: "How We Share Your Information"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "We disclose the personal information we collect (or otherwise generate or obtain) as follows:"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        className: "list-disc mb-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "With our travel partners to provide the Services and for their own purposes"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "With other business partners for their own marketing purposes"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "With social networking services to connect and share your information"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "With third-party services or applications you use to log into your account"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "To process payments"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "With other service providers who perform services on our behalf"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "In the event of a corporate transaction"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "To protect rights and property"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "To comply with legal obligations"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "Aggregate information"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "At your request"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mb-2",
                                        children: [
                                            "Our Partners are: ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "mb-0",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "Kayak, "
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "https://www.google.com/url?q=https://www.kayak.com&sa=D&source=editors&ust=1720183177914030&usg=AOvVaw3jZZTAgydQJo7iB5Q5lcqM",
                                                            children: "Kayak"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "mb-0",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "ETraveli Group AB, "
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "https://www.google.com/url?q=https://www.etraveligroup.com/&sa=D&source=editors&ust=1720183177914246&usg=AOvVaw16Les9tyyK4B0yaii7LwKi",
                                                            children: "https://www.etraveligroup.com"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "mb-0",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "Amadeus Connect, "
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "https://www.google.com/url?q=https://amadeus.com&sa=D&source=editors&ust=1720183177914406&usg=AOvVaw3UNU-UiwJwBfVZ-XAFKbrk",
                                                            children: "Amadeus"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "\xa0."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "mb-0",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "HotelsCombined, "
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "https://www.google.com/url?q=https://hotelscombined.com&sa=D&source=editors&ust=1720183177914580&usg=AOvVaw3Q1UjNARzR4je-C805oecM",
                                                            children: "HotelsCombined"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "."
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "\xa0"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        children: "Membership Club"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        children: "Membership Levels"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "First-Class.com offers a Member Club with two levels: Gold and Elite."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        children: "Gold Membership:"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "- To become a Gold member, you must subscribe to our newsletters and complete your profile information. This enables us to send you more relevant offers and deals based on your preferences and profile."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        children: "Elite Membership:"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "- Elite membership is a paid subscription that provides access to all Gold membership benefits plus exclusive access to flight tickets with deep discounts."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        children: "Membership Benefits"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        children: "Gold Membership Benefits:"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        children: [
                                            "- Access to special offers and deals tailored to your preferences ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "- Regular updates via our newsletters"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        children: "Elite Membership Benefits:"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        children: [
                                            "- All benefits of the Gold membership ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "- Access to exclusive flight tickets with significant discounts"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        children: "Membership Terms"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        children: [
                                            "- Membership in the Member Club is subject to these Terms and Conditions and any additional terms and conditions that may apply to specific benefits or offers. ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "- Elite membership requires payment of a subscription fee. The fee amount, payment schedule, and payment methods will be specified at the time of subscription. ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "- Membership benefits are personal and non-transferable. You must not share your membership details or benefits with any third party. ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        children: "Membership Cancellation"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        children: [
                                            "- You may cancel your membership at any time by contacting our customer service. ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "- If you cancel an Elite membership, you will not be entitled to a refund for any remaining period of your subscription. ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        children: "How We Store and Protect Your Information"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "We maintain technical, administrative, and physical security measures to protect your information from loss, misuse, unauthorized access, disclosure, alteration, and destruction. When your payment information is transmitted through our Services, it will be protected by cryptographic protocols. We only store your payment information if you choose to save that information to your account. However, we cannot guarantee the security of your information, and you should not share your username, password, or other security information with anyone."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        children: "Retention"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "We may retain your personal information for as long as your account is active and for a period thereafter to allow you to re-activate your account without loss of information. We may also retain your information as necessary to comply with legal obligations, protect our rights, resolve disputes, and enforce our contracts."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        children: "Cookies"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        children: [
                                            "We use cookies and similar technologies to collect information about your usage and activity. Third parties may also use cookies on our Sites. See our Cookies and Interest-Based Advertising Policy for more details.",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "https://www.first-class.com/view/cookies_policy",
                                                target: "_blank",
                                                children: "https://www.first-class.com/view/cookies_policy"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        children: "Your Choices and Rights"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "You have choices about your personal information, including the ability to opt out of marketing communications, change communication preferences, access and update your information, and exercise choices regarding cookies."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        children: "Email"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: 'To opt out of marketing emails, click on the "unsubscribe" link in the email or adjust your account settings.'
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        children: "Push Notifications"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Use your mobile device settings to enable or turn off push notifications."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        children: "Text Messages"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Reply STOP to opt out of text messages or adjust your account settings."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        children: "Cookies and Interest-Based Advertising"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "See our Cookies and Interest-Based Advertising Policy for details on how to exercise choices regarding cookies and other online tracking."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        children: "Application Location"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Change your device settings to turn off location services."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        children: "Sharing with Third Parties"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Opt out of sharing your information with third parties for their marketing purposes by changing your account preferences or contacting us."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        children: "Access and Correction"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "If you have an account, you can access and update your information through your account settings. Contact us if you wish to exercise legal rights related to your personal information."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        children: "International Transfers of Information"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Information about you may be transferred to or accessed by entities in countries outside of your home country. We have put in place safeguards to protect your information during international transfers."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        children: "Links to Other Websites"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Our Services may contain links to other websites or services that are not owned or controlled by First-Class.com. Your use of third-party websites is at your own risk, and you should read their privacy policies."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        children: "Children"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Our Services are not directed at or intended for use by children. We do not knowingly collect information from children under 18 years of age. If you become aware that a child has provided us with information, please contact us."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        children: "Changes to This Policy"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "We update this Privacy Policy from time to time. Changes will be effective when posted. If changes materially impact previously collected personal information, we will provide notice and obtain consent as required by law."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        id: "user-delete",
                                        children: "Your right to request deletion of data"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: 'If you no longer want us to retain any data linked to your name or personal profile, you can delete your profile and all associated data by logging in. Navigate to your profile, open the "Edit Profile" dialog, scroll to the bottom, and press the "Delete Profile" button. In the confirmation dialog, press "Confirm" to finalize the deletion process.'
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        children: "How to Contact Us"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        children: [
                                            "If you have any questions about this Policy or how your personal information has been used, please contact us at: ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "mailto:media@first-class.com",
                                                children: "media@first-class.com"
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "or ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("i", {
                                                children: [
                                                    "First-Class.com ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                    "Attn: Data Protection Officer ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                    "Fredriksborgveien 2 ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                    "0286 Oslo ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                    "Norway ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/About/About.module.scss
var About_module = __webpack_require__(23503);
var About_module_default = /*#__PURE__*/__webpack_require__.n(About_module);
;// CONCATENATED MODULE: ./components/About/About.jsx












var About_theme = (0,createTheme/* default */.Z)({
    palette: {
        primary: {
            main: "#00454A"
        },
        secondary: {
            main: "#0a0a0a"
        }
    },
    typography: {
        fontFamily: '"Libre Franklin", sans-serif',
        color: "#0a0a0a"
    }
});
var About = function(param) {
    var setLoginDialogState = param.setLoginDialogState;
    var expandInfo = function expandInfo(p) {
        p.expanded = !p.expanded;
        setPeopleState((0,_to_consumable_array/* default */.Z)(peopleState));
    };
    var getContactPhoneNumber = function getContactPhoneNumber() {
        if (userStore) {
            return config/* CONTACT_INFO */.dZ[userStore.country] ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: "tel:".concat(config/* CONTACT_INFO */.dZ[userStore.country]),
                children: config/* CONTACT_INFO */.dZ[userStore.country]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: "tel:+44 203 455 03 90",
                children: "+44 203 455 03 90"
            });
        }
    };
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        if (router.asPath.includes("#")) {
            var section = router.asPath.split("#")[1];
            document.querySelector("a[name=".concat(section, "]")).scrollIntoView();
        }
    }, [
        router
    ]);
    var people = [
        {
            name: "Jason Eckhoff",
            position: "Founder & CEO",
            subtitle: "Editor-In-Chief",
            image: "assets/jason.jpg",
            info: "Jason is the Founder and CEO of First-Class.com, with over 20 years of experience in the digital travel space. He has played a key role in shaping online travel distribution, successfully building and managing multiple online travel agencies across Scandinavia.\n      Jason is recognized as Entrepreneur of the Year by Ernst & Young after his company Reisegiganten became one of Norway’s fastest-growing travel businesses. Seeing an opportunity in the premium travel segment, he founded First-Class.com that was launched in 2021 - a platform dedicated to helping travelers find and experience the best in business and first-class flights, five-star hotels, and luxury travel insights.\n      Also taking on the role as the Editor-in-Chief, Jason combines his industry expertise with his passion for premium travel, writing in-depth reviews of business and first-class products, as well as five-star hotels around the world. He enjoys exploring the finer details of luxury travel, from seat comfort to service quality, always with the goal of providing genuine, insightful recommendations to fellow travelers.\n      With a strong background in travel and a commitment to high-quality journalism and expert insights, Jason continues to lead First-Class.com as a trusted resource for those seeking elevated travel experiences."
        },
        // {
        //   name: 'Henrik Hanevold',
        //   position: 'Chief Product Officer',
        //   image: 'assets/henrik.jpg',
        //   info: 'Henrik joined First-Class.com in early 2020, bringing more than 20 years of experience from the travel industry with him. He looks after product strategy, business development, supplier relations and partnerships. He spent the first decade of his career with Radisson Blu Hotels & Resorts before moving on to travel technology giant Amadeus. In 2013, he joined Singapore Airlines, managing leisure sales in the Nordics. Henrik has visited more than 60 countries and lived in Canada, Sweden and the UK before settling back in Norway.',
        // },
        {
            name: "Thomas Vervik",
            position: "Chief Technology Officer",
            image: "assets/thomas.jfif",
            info: "Thomas is a senior developer with long experience managing development teams and complex IT projects. He has worked with First-Class.com since 2018 and has a Masters of Science degree from the University of Bergen. He has experience from Singapore, the Czech Republic, Ukraine and Uganda, and has worked for companies such as TV2, Umoe, Nordea and Bipper Communications."
        },
        {
            name: "Lena Bj\xf8rkum",
            position: "Co-Founder",
            image: "assets/lena.jpg",
            info: "Lena co-founded First-Class.com together with Jason back in 2015. She is a hotel aficionado and experienced traveller. Lena looks after concept development and quality assurance as well as hotel and destination research."
        },
        {
            name: "Adeel Khan ",
            position: "SEO Lead",
            image: "assets/Adeel.jpg",
            info: "Adeel is a seasoned SEO specialist with years of experience working with a diverse range of industries including e-commerce, legal, medical and IT. Adeel joined First-Class.com in 2022. Adeel is responsible for driving organic growth and developing effective content strategies."
        },
        {
            name: "Amanda Ling",
            position: "Content Manager",
            image: "assets/Amanda.jpeg",
            info: "Amanda is responsible for planning and publishing digital content across our website, social media, and newsletter. Before joining First-Class.com, she ran one of the largest marketing agencies in the South West England. With over 25 years’ experience, Amanda specialises in creating digital content that creates long lasting and valuable customer relationships."
        },
        {
            name: "Anton Kolychev",
            position: "Head of Development, IT",
            image: "assets/anton-kolychev.jpg",
            info: "Anton is an experienced senior website developer. He oversees the front and back-end development at First-Class.com. Anton holds a Masters Degree in Electronics Systems and has extensive experience in IT security solutions. Before joining First-Class.com in early 2021, Anton worked for technology giant Samsung at its Research and Development Institute in Ukraine."
        },
        // {
        //   name: 'Danil Serada',
        //   position: 'Senior Frontend Engineer',
        //   image: 'assets/danil-sereda.jpg',
        //   info: 'Danil is a seasoned senior front-end developer with many years experience in building progressive web applications. Over the years he has worked for a wide range of clients in the retail, insurance, personal safety and public sectors.',
        // },
        {
            name: "Oleh Leskiv",
            position: "Senior Frontend Engineer",
            image: "assets/Oleh.JPG",
            info: "With more than 10 years of experience in developing complex UI applications, Oleh has worked within big outsourcing companies with distributed teams and small start-ups - as a key developer and team leader. Oleh has experience in the healthcare, marketing, finance, insurance, entertainment sectors. He was involved in the creation of projects for clients including SAP, US Golf Association and DASH Financial Technologies. He has also created UI applications from scratch for both Norwegian and international start-up projects."
        },
        {
            name: "Tamim Md. Hossain",
            position: "Deals Expert",
            image: "assets/tamim.jpg",
            info: "Tamim is a seasoned points and miles specialist with over six years of experience in award flight bookings. At First-Class, he helps clients secure the best-value flights, ensuring seamless and cost-effective travel. He also researches and lists the best market offers on the website. With deep expertise in airline alliances, redemption strategies, and premium cabin availability, Tamim tailors optimal flight solutions for every traveler."
        },
        {
            name: "Ursula Mahmoud",
            position: "Customer Experience Manager",
            image: "assets/ursula.jpg",
            info: "Ursula is a results-driven professional with over 10 years of experience in Customer Experience Management and Sales Leadership. As a Deals Manager, Ursula specializes in driving sales growth, optimizing processes, and enhancing customer engagement.\n      With more than three years in the aviation industry, she has deep expertise in airline operations, fare management, and travel solutions. Previously, as a Team Leader at Trevolution Group, Ursula led high-performing sales teams in the aviation sector, helping customers secure the best travel deals. Prior to that, as a Q Manager at Microsoft, focused on quality management and process optimization.\n      Passionate about innovation and teamwork, Ursula is committed to delivering exceptional results and elevating customer experiences."
        },
        {
            name: "Varun Sharma",
            position: "Contributing Writer",
            image: "assets/varun.jpg",
            info: "With over 25 years of experience in luxury travel journalism, Varun has contributed to a lot of the content on First-Class.com. BBC-trained, Varun has appeared in print, on radio, television, and now online media - having worked for outlets including the BBC, Telegraph (UK), MSNBC, Travel Channel and Cond\xe9 Nast Traveller. Varun has visited over a hundred countries, reviewed hundreds of luxury hotels & resorts and dozens of airlines, and cooked with some of the greatest chefs in the world - many of whom appeared on his international television series - Inside Luxury Travel."
        },
        {
            name: "James Moreton",
            position: "Contributing Writer",
            image: "assets/james-moreton.jpg",
            info: "Jim, a former British CID Detective, turned crime fiction writer has a passion for travel and a keen eye for detail. Using the pseudonym of James D Mortain, Jim has authored five published thriller novels with a sixth on the way. When he`s not writing edge-of-the-seat fiction, Jim loves nothing more than spending quality time with his young family exploring new cultures and cuisines on faraway shores."
        },
        {
            name: "Ramsey Qubein",
            position: "Contributing Writer",
            image: "assets/ramsey.jpg",
            info: "Ramsey flies more than 450,000 miles per year and has traveled to 166 countries, all seven continents, and 50 U.S. states. As a travel journalist, he covers hotels, cruises, airlines, and loyalty programs from around the globe. His work has appeared in numerous publications including Conde Nast Traveler, Travel+Leisure, Forbes.com, BBC Worldwide, USA Today, Frommers.com, Business Traveler, Fortune, Airways, and AAA magazines. He is a member of the Society of American Travel Writers (SATW) and completed a Master's Degree thesis researching the evolution of brands in the airline industry."
        },
        {
            name: "Punita Malhotra",
            position: "Contributing Writer",
            image: "assets/punita.jpg",
            info: "Punita shifted gears from a career in entrepreneurship and publishing to live her dream of travel and writing. She is a passionate traveller, writer, blogger and content strategist, with expertise in travel, art, food, history, heritage and culture. She works on commissioned articles for select print and digital platforms, including Outlook Traveller, Matador Network, A Small World' and inflight magazines of Air Vistara, Indigo Airlines, Air India, Air Asia and Jazeera Airways. She partners with innovation-obsessed travel brands to craft revitalizing, engaging, inspiring and stand-out content. She 'stays travellous' by penning her personal wanderlust stories through her blog, 100cobbledroads."
        },
        {
            name: "Dawn Jorgensen",
            position: "Contributing Writer",
            image: "assets/dawn.jpg",
            info: "A self-proclaimed earth advocate and beauty seeker, Dawn is a conscious traveller with a deep love for Africa, its people and the environment. Her career has embraced all aspects of travel, including running her own bespoke tour operating company, establishing an award-winning blog – The Incidental Tourist, and sharing stories from her international and local travels as a prolific freelance travel writer. Dawn's passion lies in sustainable and ethical travel practices and in communicating with travellers seeking out exceptional experiences in the places she knows – and loves. When not on the road, you'll find her in Cape Town beach walking her dogs, doing yoga, or figuring out how best to save a species."
        },
        {
            name: "Sugato Mukherjee",
            position: "Contributing Writer",
            image: "assets/sugato-mukherjee.jpg",
            info: 'Sugato is a travel journalist with bylines in The Globe and Mail, National Geographic Traveller, Fodor\'s Travel, Travel+Leisure, Atlas Obscura, Hidden Compass, Discovery, Silkwinds, Roads & Kingdoms, Mint Lounge and a host of inflight magazines. His coffee table book "An Antique Land: A Visual Memoir of Ladakh" has been widely acclaimed. Sugato writes, and also photographs his personal and professional projects; and his work on sulphur miners of East Java has been awarded by UNESCO. He collaborates with premium travel brands and tourism boards to highlight initiatives that blend luxury, elegance and sustainability through his creative content. Some of his works can be found at sugatomukherjee.com'
        },
        {
            name: "Eivind Roald",
            position: "Advisor & Lead Investor",
            image: "assets/eivind.jpg",
            info: "Eivind is an experienced leader within technology and travel. Having served as Executive Vice President & Chief Commercial Officer at SAS Scandinavian Airlines, he has also managed SAS EuroBonus, the largest loyalty program in the Nordics. Eivind was the first external investor in First-Class.com in 2018, bringing with him a wealth of airline insight and a deep understanding of the premium travel segment. His passion for people and the use of technology and digital solutions was born during his time at Hewlett-Packard and Accenture, and reinforced when he moved into the airline industry. Eivind is now CEO at QNTM Group, owned by Altor, one of the largest private equity investors in Europe. Eivind remains an active investor and advisor at First-Class.com."
        },
        {
            name: "Ingeborg Eckhoff",
            position: "Production Associate",
            image: "assets/ingeborg-eckhoff.jpg",
            info: "Ingeborg is a member of the editorial team at First-Class.com. She publishes our editorial content onto the website and helps create the weekly newsletter. Ingeborg also updates the content that appears in our hotel search facility. She also assists with the sourcing and editing of images for editorials and builds and tests website links."
        },
        {
            name: "Henry Eckhoff",
            position: "Production Associate",
            image: "assets/henry-eckhoff.png",
            info: "Henry supports the editorial and product teams at First-Class.com. He publishes editorial content and hotel listings. Henry also assists with the sourcing and editing of images for editorials and builds and tests website links."
        },
        {
            name: "Karl-Philip Lund",
            position: "Board member",
            image: "assets/karl.jpg",
            info: "Karl-Philip was the first digital marketing consultant at the airline Norwegian and is an expert in fields such as internet strategy, email marketing, Google Adwords / search engine marketing, search engine optimization, organizational development, coaching, sales, project management and consulting."
        },
        {
            name: "Krister Nekstad",
            position: "Board member",
            image: "assets/Krister.jpg",
            info: "Krister is an investor and board member of First-Class.com, bringing a wealth of experience in marketing and business development to our company."
        }, 
    ];
    var ref = (0,react.useState)(people), peopleState = ref[0], setPeopleState = ref[1];
    var userStore = (0,es/* useSelector */.v9)(function(state) {
        return state.user.value;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ThemeProvider/* default */.Z, {
        theme: About_theme,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (About_module_default()).top,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    className: (About_module_default()).topImage,
                    src: "".concat("https://media.first-class.com/", "assets/cookie_front.jpeg"),
                    layout: "fill",
                    objectFit: "cover",
                    objectPosition: "center 70%"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("container", "font-libre"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* BCBreadcrumbs */.k, {
                        headerText: "About"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (About_module_default()).content,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            id: "about",
                            className: "menu-marg-fix",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "row section vision content",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "column large-16 large-centered",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                className: classnames_default()((About_module_default()).welcome, "font-fragment"),
                                                children: "Welcome to First-Class.com"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "First-Class.com offers the best premium travel search engine in the world. The site is aimed at those who fly in First Class, Business Class and Premium Economy cabins and stay in the finest hotels & resorts. First-Class.com searches hundreds of travel sites to help you find the best premium travel offers for both flights and accommodation."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                className: "font-fragment w-full",
                                                children: "A message from our Founder & CEO"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "message",
                                                children: '"I had been working in travel tech for over 20 years, and still found it hard to find the best travel offers. I was also finding it difficult to understand the differences between all the airline and hotel suggestions that were being provided by the plethora of search engines. It was truly a jungle out there. I concluded that no travel search engine catered for the more discerning traveller looking for comfort and class at a great price.'
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "message",
                                                children: "In 2015, I came up with the concept of First-Class.com"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "message",
                                                children: "Using proprietary algorithms, we have meticulously designed and built a search engine that not only collates the most competitive flight and hotel prices but is also extremely user-friendly."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "message",
                                                children: "Our contribution to a greener tomorrow and sustainability in travel is of utmost importance to me. To this end, we highlight the green initiatives that are being implemented by all the airlines and hotels & resorts we review."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "message",
                                                children: 'There is much more to First-Class.com than just amazing offers!"'
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Jason Eckhoff"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "row",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "column large-20 large-centered headers-index",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "#team",
                                                children: "Team"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "#philosophy",
                                                children: "Philosophy"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "#technology",
                                                children: "Technology"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "#exclusive-offers",
                                                children: "Exclusive Offers"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "#inspiration",
                                                children: "Inspiration"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "#coming-soon",
                                                children: "Coming Soon"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "#people",
                                                children: "People"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "#rating",
                                                children: "Rating"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "#partners",
                                                children: "Partners"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "#invest",
                                                children: "Invest"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "#contact",
                                                children: "Contact"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "row mt-10",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "column large-18 large-centered",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "https://media.first-class.com/" + "assets/3_culture.jpg",
                                            className: "resize169",
                                            alt: ""
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "row section",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "column large-16 large-centered content ",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                                children: [
                                                    "Team",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        name: "team"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Our dedicated and passionate team has extensive and successful backgrounds in travel, technology, commerce, and journalism."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "The team is here to help you figure out where to go and how to get there, in the most cost-effective and timely manner."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "For more on the team, please scroll further down on this page."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                                children: [
                                                    "Philosophy",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        name: "philosophy"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "First-Class.com combines the latest technology, smart innovation, and the values & expert knowledge of a traditional travel agent to help you identify your perfect leisure and business trip."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "We believe that however you choose to travel, your journey should start from the moment you begin planning it. Although First-Class.com helps you compare prices as well as quality, we take it much further than that. We offer inspiration, insight, recommendations, and useful information throughout our site. We believe that you should be able to find all the information you need, right here."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "We are completely independent and offer full transparency. As such, we do not accept payment by any third parties to rank one option above another."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                                children: [
                                                    "Technology",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        name: "technology"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Our website searches hundreds of thousands of flights and hotels. But unlike other search engines First-Class.com deploys its own unique, innovative algorithms that selects and highlights only the choices that matter to you, based on your personal preferences and with added recommendations from us."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                                children: [
                                                    "Exclusive offers",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        name: "exclusive-offers"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Premium travellers are telling us all the time how hard they find it to identify great offers. Identifying and delivering you the best collection of global travel offers is in our DNA. There are always offers available and we collect them in one single place - here at First-Class.com."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                                children: [
                                                    "Inspiration",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        name: "inspiration"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Our own expert team of international writers and reviewers are circumnavigating the globe writing honest reviews about premium airline cabins and luxury hotels & resorts."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                children: [
                                                    "All these reviews and original destination guides are accessible – free - on First-Class.com. Every week we publish a newsletter with inspiring articles and exclusive offers to popular and indeed far-flung destinations. To receive our complimentary newsletter, please",
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "cursor-pointer",
                                                        onClick: function() {
                                                            return setLoginDialogState({
                                                                state: "signUp",
                                                                opened: true,
                                                                sourcePage: "About"
                                                            });
                                                        },
                                                        children: "sign up here"
                                                    }),
                                                    "."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                                children: [
                                                    "Coming Soon",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        name: "coming-soon"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Our website development team never stops. We are constantly adding new features – aimed at helping you - the discerning traveller. If you have an idea, suggestion, or comment about our website, we would love to hear from you."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                children: [
                                                    "Please ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "#contact",
                                                        children: "contact us here"
                                                    }),
                                                    "."
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "row",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "column large-18 large-centered",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "https://media.first-class.com/" + "assets/2_culture.jpg",
                                            className: "resize169",
                                            alt: ""
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "row section content",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "column large-16 large-centered",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                                className: "font-fragment",
                                                children: [
                                                    "People",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        name: "people"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Travel represents the epitome of globalisation and we believe diversity enhances creativity. Our global team of experts brings extensive wisdom in the fields of travel, technology, commerce, and journalism. Our European headquarters is in Oslo, Norway but we have colleagues based in Europe, Asia, Africa and North America. Between us, we have explored over 170 countries around the world, have stayed in more than 2,500 luxury hotels and flown by over 100 carriers."
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "row",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "column large-22 large-centered people",
                                        children: peopleState.map(function(p) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "column large-8 people-info",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "column small-12 small-centered expert-image",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            width: "100%",
                                                            src: "https://media.first-class.com/" + p.image,
                                                            alt: p.name,
                                                            className: (About_module_default()).avatar
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "column large-12",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "name",
                                                                children: p.name
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "position",
                                                                children: p.position
                                                            }),
                                                            p.subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "position",
                                                                children: p.subtitle
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                className: "about-people",
                                                                onClick: function() {
                                                                    return expandInfo(p);
                                                                },
                                                                children: [
                                                                    "About ",
                                                                    p.name.split(" ")[0]
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    p.expanded && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: classnames_default()("column small-24 about-people-description"),
                                                        children: p.info
                                                    })
                                                ]
                                            }, p.name);
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "row section rating",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "column large-16 large-centered",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                                    className: "font-fragment",
                                                    children: [
                                                        "Rating",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            name: "rating"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    children: [
                                                        "Rating on ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            children: "First-Class.com"
                                                        }),
                                                        " is there to help you understand what to expect from a hotel stay, a flight or another travel related product or experience. User ratings, Expert ratings – ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            children: "First-Class tested"
                                                        }),
                                                        " – as well as proprietary algorithms – ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            children: "First-Class Quality"
                                                        }),
                                                        " – are there to assist you in assessing quality."
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "column large-24 large-centered",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    className: "font-fragment",
                                                    children: "Flights"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "row flex small-column",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "column large-12 content",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "row flex",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "column small-4 large-4 rating-badge",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RatingBadge/* RatingBadge */.H, {
                                                                            version: "badge-rated"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "column small-20 large-20 rating-description",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "title",
                                                                                children: "First-Class Quality"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                                children: [
                                                                                    "At ",
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                        children: "First-Class.com"
                                                                                    }),
                                                                                    " we strive very hard to offer a truthful understanding of the quality of a given flight. It is hard for a human to understand and assess the quality of millions of flight combinations and all of their attributions. In comes",
                                                                                    " ",
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                        children: "First-Class Quality"
                                                                                    }),
                                                                                    ", an algorithm-based score that runs from 0 to 10. This score is calculated based on a number of criteria. Our unique technology and complex algorithms aims at simplifying and shortening the lengthy and difficult process of identifying ideal airline tickets. This is all the more important, as buying a ticket in Premium Economy, Business Class or First Class represents an investment in your comfort. The ",
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                        children: "First-Class Quality"
                                                                                    }),
                                                                                    " algorithms takes into account a vast array of critical evaluation factors and combines them into a single quality score, like:"
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                        children: "How good is the airline and cabin configuration."
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                        children: "How good is the seat. Can it convert to a fully horizontal bed."
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                        children: "How good is the aircraft, noise and humidity levels, affecting jet lag."
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                        children: "Is there Wi-fi and other amenities."
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "column large-12 content",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "row flex",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "column small-4 large-4 rating-badge",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RatingBadge/* RatingBadge */.H, {
                                                                            version: "badge-tested"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "column small-20 large-20 rating-description",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "title",
                                                                                children: "First-Class tested"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                                children: [
                                                                                    "Editors at ",
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                        children: "First-Class.com"
                                                                                    }),
                                                                                    " or approved expert writers have flown all tested flights, and made a thorough review of the quality of the flight, evaluating many aspects of the experience. One general rating is awarded on the overall flight. The report will suggest who the experience is suited for and will highlight three things we really enjoyed about the flight. We will only publish reviews on flights we can safely recommend and on flights awarded a rating of 8, 9 or 10 out of 10. Here is an overview on how we rate flights:"
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                        children: "8/10: A good flight you will enjoy and do again"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                        children: "9/10: A great flight you will recommend to friends"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                        children: "10/10: A must-do experience on any travel lovers bucket-list"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "row info",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "column large-12 content",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "row",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "column small-20 small-offset-4 rating-description user-ratings",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        className: "title",
                                                                        children: "User ratings"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                children: "First-Class.com"
                                                                            }),
                                                                            " does not yet offer data on user ratings on flights, this is in the pipeline."
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "column rating-section",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    className: "font-fragment",
                                                    children: "Hotels"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "row flex small-column",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "column large-12 content",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "row flex",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "column small-4 large-4 rating-badge",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RatingBadge/* RatingBadge */.H, {
                                                                            version: "badge-tested"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "column small-20 large-20 rating-description",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "title",
                                                                                children: "First-Class Quality"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                                children: [
                                                                                    "Editors at ",
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                        children: "First-Class.com"
                                                                                    }),
                                                                                    " or approved expert writers have stayed overnight at all tested properties, and made a thorough review of the quality of the stay, evaluating many aspects of the experience. One general rating is awarded on the overall stay and sub-ratings reflects how we experienced Location, Rooms, Service, Style and Food. The report will suggest who the property is suited for and will highlight three thing we really enjoyed about the stay. In general, First-Class tested, differ and do not compare directly to user rating in how we rate them. Further, we will publish reviews we can safely recommend and on properties awarded a rating of 8, 9 or 10 out of 10. Here is an overview on how we rate properties:"
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                        children: "8/10: A good hotel you will enjoy and revisit"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                        children: "9/10: A great hotel you will recommend to friends"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                        children: "10/10: A must-do experience on any hotel lovers bucket-list"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "column large-12 content",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "row",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "column small-20 large-20 small-offset-4 large-offset-4 rating-description user-ratings",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            className: "title",
                                                                            children: "User ratings"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                            children: [
                                                                                "The user ratings represents a good indication of the overall satisfaction experienced by a large number of hotel guests. We collect the user ratings from reliable sources, from some of the worlds largest whole sellers of hotel stays. For reliability, user ratings are collected from verified guests.",
                                                                                " "
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "row",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "column large-18 large-centered",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "https://media.first-class.com/" + "assets/1_nature.jpg",
                                            className: "resize169",
                                            alt: ""
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "row section content",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "column large-16 large-centered",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                                    className: "font-fragment",
                                                    children: [
                                                        "Partners",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            name: "partners"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Strategic partnerships and collaborations take centre stage at First-Class.com. We work with a wide range of partners to provide high-quality search results based on APIs, exclusive offers for premium travel and inspirational, editorial content. Travel providers, destination representatives and suppliers dedicated to premium travel are welcome to get in touch by sending an email to media@first-class.com."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "column large-16 large-centered",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                                    className: "font-fragment",
                                                    children: [
                                                        "Invest in First-Class.com",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            name: "invest"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Since inception, First-Class.com has been on a creative and cost-effective journey. Through prudent use of our seed investment, we have built our website with original proprietary algorithms and indeed software. Our current team of experienced, professional investors are highly regarded and hail from a wide range of sectors including e-commerce and travel. If you share our vision and are interested in joining us as we plan for exponential growth, please email us: media@first-class.com"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "column large-16 large-centered",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                                    className: "font-fragment",
                                                    children: [
                                                        "Contact - Customer Service",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            name: "contact"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "As a premium travel search engine, First-Class.com compares prices from a range of airlines, hotel groups and travel agents to help you find the best offers."
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Please note that First-Class.com can only assist with reservations made directly on First-Class.com. This will be clearly indicated on your confirmation email. We do not charge for Customer Service."
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "If you have booked directly with an airline or a hotel, or via another travel agency, any and all inquiries regarding reservations, changes and payments must be made directly to them, using the contact details provided in their confirmation email or on their websites. Charges may apply for customer service provided by our Partners."
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    children: [
                                                        "If your booking was made directly on First-Class.com, please contact our Customer Service 24/7 on ",
                                                        getContactPhoneNumber()
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    children: [
                                                        "To contact First-Class.com, please send an email to \xa0",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "mailto:media@first-class.com",
                                                            children: "media@first-class.com"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    children: [
                                                        "Media requests for interviews or advertising may be sent to \xa0",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "mailto:media@first-class.com",
                                                            children: "media@first‑class.com"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "column large-16 large-centered",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                                    className: "font-fragment",
                                                    children: [
                                                        "Contact - Corporate",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            name: "contact"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "For any inquiries that are not related to bookings:"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    children: [
                                                        "Please email your requests to: \xa0",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "mailto:media@first-class.com",
                                                            children: "media@first-class.com"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    children: [
                                                        "Media requests for interviews or advertising, please email: \xa0",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "mailto:media@first-class.com",
                                                            children: "media@first-class.com"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/VintageHeader/VintageHeader.module.scss
var VintageHeader_module = __webpack_require__(36516);
var VintageHeader_module_default = /*#__PURE__*/__webpack_require__.n(VintageHeader_module);
;// CONCATENATED MODULE: ./components/VintageHeader/VintageHeader.jsx




var VintageHeader = function(param) {
    var _showHole = param.showHole, showHole = _showHole === void 0 ? true : _showHole, _isDark = param.isDark, isDark = _isDark === void 0 ? false : _isDark;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((VintageHeader_module_default()).container, (0,_define_property/* default */.Z)({}, (VintageHeader_module_default()).dark, isDark)),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (VintageHeader_module_default()).leftSide
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (VintageHeader_module_default()).centre,
                children: showHole && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (VintageHeader_module_default()).hole
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (VintageHeader_module_default()).rightSide
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/VintageButton/VintageButton.module.scss
var VintageButton_module = __webpack_require__(82857);
var VintageButton_module_default = /*#__PURE__*/__webpack_require__.n(VintageButton_module);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/VintageButton/VintageButton.jsx





var VintageButton = function(param) {
    var label = param.label, onClick = param.onClick, href = param.href, _dark = param.dark, dark = _dark === void 0 ? false : _dark;
    return href ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            "aria-label": label,
            role: "button",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((VintageButton_module_default()).vintageButtonWrapper, (0,_define_property/* default */.Z)({}, (VintageButton_module_default()).dark, dark)),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (VintageButton_module_default()).heading,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (VintageButton_module_default()).leftSide
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (VintageButton_module_default()).centre
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (VintageButton_module_default()).rightSide
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: label
                    })
                ]
            })
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
        onClick: onClick,
        type: "button",
        "aria-label": label,
        className: classnames_default()((VintageButton_module_default()).vintageButtonWrapper, (0,_define_property/* default */.Z)({}, (VintageButton_module_default()).dark, dark)),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (VintageButton_module_default()).heading,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (VintageButton_module_default()).leftSide
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (VintageButton_module_default()).centre
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (VintageButton_module_default()).rightSide
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: label
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/Breadcrumbs/Breadcrumbs.jsx
var Breadcrumbs = __webpack_require__(71186);
// EXTERNAL MODULE: ./components/AuthorPopup/AuthorPopup.module.scss
var AuthorPopup_module = __webpack_require__(42063);
var AuthorPopup_module_default = /*#__PURE__*/__webpack_require__.n(AuthorPopup_module);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/@mui/material/Popper/Popper.js + 3 modules
var Popper = __webpack_require__(79350);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/AccountCircle.js
var AccountCircle = __webpack_require__(28201);
;// CONCATENATED MODULE: ./components/AuthorPopup/AuthorPopup.jsx









var AuthorPopup = function(param) {
    var userBio = param.userBio, modifiedDate = param.modifiedDate, _isReview = param.isReview, isReview = _isReview === void 0 ? true : _isReview;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var ref10 = (0,react.useState)(null), anchorEl = ref10[0], setAnchorEl = ref10[1];
    var handleHover = function(event) {
        if (event) {
            setAnchorEl(event.currentTarget);
        } else {
            setAnchorEl(null);
        }
    };
    var open = Boolean(anchorEl);
    var id = open ? "simple-popper" : undefined;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex items-center mb-6",
        onMouseEnter: function(e) {
            return handleHover(e);
        },
        onMouseLeave: function() {
            return handleHover(null);
        },
        children: [
            userBio.image && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (AuthorPopup_module_default()).userBioImageWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: ((ref = userBio.image) === null || ref === void 0 ? void 0 : ref.startsWith("/")) ? "https://media.first-class.com/" + ((ref1 = userBio.image) === null || ref1 === void 0 ? void 0 : ref1.replace("/", "")) : "https://media.first-class.com/" + userBio.image,
                    layout: "fill",
                    objectFit: "cover"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()((AuthorPopup_module_default()).subtitle, "font-libre"),
                        children: [
                            isReview ? "First-Class.com review" : "",
                            " by",
                            " ",
                            userBio.textId ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                href: "/authors/" + userBio.textId,
                                children: [
                                    (ref2 = userBio.user) === null || ref2 === void 0 ? void 0 : ref2.firstName,
                                    " ",
                                    (ref3 = userBio.user) === null || ref3 === void 0 ? void 0 : ref3.lastName
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    (ref4 = userBio.user) === null || ref4 === void 0 ? void 0 : ref4.firstName,
                                    " ",
                                    (ref5 = userBio.user) === null || ref5 === void 0 ? void 0 : ref5.lastName
                                ]
                            })
                        ]
                    }),
                    modifiedDate && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()((AuthorPopup_module_default()).subtitleMb, "font-libre"),
                        children: [
                            "Updated ",
                            moment_default()(modifiedDate).format("D. MMM yyyy")
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Popper/* default */.Z, {
                placement: "bottom-start",
                id: id,
                open: open && !!userBio.content,
                anchorEl: anchorEl,
                style: {
                    zIndex: 3
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()((AuthorPopup_module_default()).authorPopup, "font-libre"),
                    onMouseEnter: function() {
                        return handleHover({
                            currentTarget: anchorEl
                        });
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (AuthorPopup_module_default()).userBioImageLargeWrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: ((ref6 = userBio.image) === null || ref6 === void 0 ? void 0 : ref6.startsWith("/")) ? "https://media.first-class.com/" + ((ref7 = userBio.image) === null || ref7 === void 0 ? void 0 : ref7.replace("/", "")) : "https://media.first-class.com/" + userBio.image,
                                layout: "fill",
                                objectFit: "cover"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (AuthorPopup_module_default()).authorPopupContent,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (AuthorPopup_module_default()).authorPopupIcon,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountCircle/* default */.Z, {
                                        fontSize: "large"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (AuthorPopup_module_default()).authorPopupOverline,
                                    children: "About the author"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classnames_default()((AuthorPopup_module_default()).authorPopupName, "font-fragment"),
                                    children: [
                                        (ref8 = userBio.user) === null || ref8 === void 0 ? void 0 : ref8.firstName,
                                        " ",
                                        (ref9 = userBio.user) === null || ref9 === void 0 ? void 0 : ref9.lastName
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (AuthorPopup_module_default()).authorPopupText,
                                    children: userBio.content
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (AuthorPopup_module_default()).authorPopupReadMore,
                                    children: userBio.textId && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/authors/" + userBio.textId,
                                        children: "Read more"
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/AuthorBlock/AuthorBlock.module.scss
var AuthorBlock_module = __webpack_require__(25258);
var AuthorBlock_module_default = /*#__PURE__*/__webpack_require__.n(AuthorBlock_module);
;// CONCATENATED MODULE: ./components/AuthorBlock/AuthorBlock.jsx







var AuthorBlock = function(param) {
    var userBio = param.userBio;
    var ref, ref1, ref2, ref3;
    var authorContent = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((AuthorBlock_module_default()).blockWrapper),
        children: [
            userBio.image && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (AuthorBlock_module_default()).userBioImageWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: ((ref = userBio.image) === null || ref === void 0 ? void 0 : ref.startsWith("/")) ? "https://media.first-class.com/" + ((ref1 = userBio.image) === null || ref1 === void 0 ? void 0 : ref1.replace("/", "")) : "https://media.first-class.com/" + userBio.image,
                    layout: "fill",
                    objectFit: "cover"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (AuthorBlock_module_default()).authorBlockContent,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (AuthorBlock_module_default()).authorBlockIcon,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountCircle/* default */.Z, {
                            fontSize: "large"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()((AuthorBlock_module_default()).authorBlockOverline, "font-libre"),
                        children: "About the author"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()((AuthorBlock_module_default()).authorBlockName, "font-fragment"),
                        children: [
                            (ref2 = userBio.user) === null || ref2 === void 0 ? void 0 : ref2.firstName,
                            " ",
                            (ref3 = userBio.user) === null || ref3 === void 0 ? void 0 : ref3.lastName
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()((AuthorBlock_module_default()).authorBlockText, "font-libre lg:text-left text-center my-2"),
                        children: userBio.jobTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()((AuthorBlock_module_default()).authorBlockText, "font-libre"),
                        children: userBio.content
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()((AuthorBlock_module_default()).authorBlockReadMore, "font-libre"),
                        children: "Read more"
                    })
                ]
            })
        ]
    });
    return userBio.textId ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/authors/" + userBio.textId,
        children: authorContent
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};

// EXTERNAL MODULE: ./components/OfferPage/OfferPage.module.scss
var OfferPage_module = __webpack_require__(33705);
var OfferPage_module_default = /*#__PURE__*/__webpack_require__.n(OfferPage_module);
// EXTERNAL MODULE: ./components/utils/textEditorParseOptions.js
var textEditorParseOptions = __webpack_require__(5937);
// EXTERNAL MODULE: ./components/OffersListSection/OffersListSection.module.scss
var OffersListSection_module = __webpack_require__(31549);
var OffersListSection_module_default = /*#__PURE__*/__webpack_require__.n(OffersListSection_module);
// EXTERNAL MODULE: ./components/OfferCard/OfferCard.module.scss
var OfferCard_module = __webpack_require__(82047);
var OfferCard_module_default = /*#__PURE__*/__webpack_require__.n(OfferCard_module);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/styles/createTheme.js + 13 modules
var styles_createTheme = __webpack_require__(98125);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/Tooltip/Tooltip.js + 3 modules
var Tooltip_Tooltip = __webpack_require__(68760);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/Dialog/Dialog.js + 2 modules
var Dialog_Dialog = __webpack_require__(68914);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/TextField/TextField.js + 3 modules
var TextField_TextField = __webpack_require__(86005);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/Button/Button.js + 1 modules
var Button_Button = __webpack_require__(38513);
// EXTERNAL MODULE: ./components/FlightSearchResults/utils/flightUtils.js
var flightUtils = __webpack_require__(70231);
// EXTERNAL MODULE: ./node_modules/react-currency-format/lib/currency-format.js
var currency_format = __webpack_require__(95340);
var currency_format_default = /*#__PURE__*/__webpack_require__.n(currency_format);
// EXTERNAL MODULE: ./node_modules/currency-symbol-map/currency-symbol-map.js
var currency_symbol_map = __webpack_require__(81463);
var currency_symbol_map_default = /*#__PURE__*/__webpack_require__.n(currency_symbol_map);
// EXTERNAL MODULE: ./node_modules/@mui/material/Drawer/Drawer.js + 2 modules
var Drawer = __webpack_require__(77533);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton_IconButton = __webpack_require__(93946);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/AnnouncementOutlined.js
var AnnouncementOutlined = __webpack_require__(51983);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/DescriptionOutlined.js
var DescriptionOutlined = __webpack_require__(40535);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/TravelExploreOutlined.js
var TravelExploreOutlined = __webpack_require__(24790);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ListAltOutlined.js
var ListAltOutlined = __webpack_require__(13056);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/IosShare.js
var IosShare = __webpack_require__(69773);
// EXTERNAL MODULE: ./node_modules/react-gtm-module/dist/index.js
var dist = __webpack_require__(1785);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
;// CONCATENATED MODULE: ./components/OfferCard/OfferCard.jsx



































var OfferCard_FlightSearch = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9989), __webpack_require__.e(4231), __webpack_require__.e(2298), __webpack_require__.e(8423), __webpack_require__.e(9980), __webpack_require__.e(293), __webpack_require__.e(7522), __webpack_require__.e(5105), __webpack_require__.e(7647)]).then(__webpack_require__.bind(__webpack_require__, 75105));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(75105)
            ];
        }
    }
});
var OfferCard_theme = (0,styles_createTheme/* default */.Z)({
    palette: {
        primary: {
            main: "#00454A"
        },
        secondary: {
            main: "#0a0a0a"
        }
    },
    typography: {
        fontFamily: '"Libre Franklin", sans-serif',
        color: "#0a0a0a"
    }
});
var getSimilarOffers = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(origin, destination) {
        var url;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    url = "/api/offer/items?page=0&size=20&origin=".concat(origin, "&destination=").concat(destination, "&sort=price,asc");
                    return [
                        4,
                        (0,httpClient/* httpGet */.kA)(url)
                    ];
                case 1:
                    return [
                        4,
                        _state.sent().json()
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getSimilarOffers(origin, destination) {
        return _ref.apply(this, arguments);
    };
}();
function OfferCard(param) {
    var data = param.data, searchSource = param.searchSource, isOpened = param.isOpened, _type = param.type, type = _type === void 0 ? "card" : _type, _showOrigin = param.showOrigin, showOrigin = _showOrigin === void 0 ? false : _showOrigin, _closeDetails = param.closeDetails, closeDetails = _closeDetails === void 0 ? function() {} : _closeDetails;
    var sendFlightOptionsClickEvent = function sendFlightOptionsClickEvent(offer, cabinClass) {
        var tagManagerArgs = {
            dataLayer: {
                event: "offerClick",
                flightCabinClass: (0,flightUtils/* getCabinClass */.CP)(cabinClass, true),
                userCountry: userStore === null || userStore === void 0 ? void 0 : userStore.country.toUpperCase(),
                airlineName: offer.airline.name,
                destinationCity: offer.destination.name,
                originCity: offer.origin.name,
                membershipId: userStore === null || userStore === void 0 ? void 0 : userStore.membershipNumber,
                traffic_type: (userStore === null || userStore === void 0 ? void 0 : userStore.is_admin) ? "internal" : "external"
            }
        };
        dist_default().dataLayer(tagManagerArgs);
    };
    var renderOfferTableItem = function renderOfferTableItem(offer, isOriginShown) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            className: classnames_default()((OfferCard_module_default()).offerTableItem),
            onClick: function() {
                return openOfferDetails(offer);
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (OfferCard_module_default()).offerName,
                    title: offer.destination.name,
                    children: [
                        isOriginShown && offer.origin.name + " - ",
                        offer.destination.name
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (OfferCard_module_default()).offerAirlineImage,
                    children: [
                        offer.airline.logo && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: offer.airline.logo.replace("http", "https").replace("width=108&height=92", "width=30&height=25"),
                            title: offer.airline.name + " (" + offer.airline.code + ")",
                            alt: "Airline Logo"
                        }),
                        !offer.airline.logo && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            title: offer.airline.name + " (" + offer.airline.logo + ")",
                            children: offer.airline.name
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (OfferCard_module_default()).offerDate,
                    children: [
                        moment_default()(offer.departureDate, "YYYY-MM-DD").format("D MMM"),
                        " ",
                        "-",
                        " ",
                        moment_default()(offer.returnDate, "YYYY-MM-DD").format("D MMM")
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (OfferCard_module_default()).offerPrice,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        title: "from " + currency_symbol_map_default()(offer.currency) + Math.round(offer.price),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: classnames_default()((OfferCard_module_default()).fromLabel, "text-xs text-gray-500"),
                                children: "From"
                            }),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((currency_format_default()), {
                                className: (OfferCard_module_default()).price,
                                thousandSeparator: true,
                                displayType: "text",
                                prefix: currency_symbol_map_default()(offer.currency) + " ",
                                value: Math.round(offer.price)
                            })
                        ]
                    })
                })
            ]
        });
    };
    var generateOffer = function generateOffer(offer, airline) {
        if (!offer) {
            return;
        }
        return {
            from: offer.origin.code,
            to: offer.destination.code,
            dateRange: {
                departure: offer.departureDate || null,
                return: offer.returnDate || null
            },
            cabinClass: offer.cabinClass,
            tripState: "round_trip",
            airlineType: airline,
            passengers: {
                adults: 1,
                children: 0
            }
        };
    };
    var openOfferDetails = function openOfferDetails(offer) {
        setIsOfferDialogOpen(true);
        sendFlightOptionsClickEvent(offer, offer.cabinClass);
        getSimilarOffers(offer.origin.code, offer.destination.code).then(function(res) {
            setSimilarOffers((0,_to_consumable_array/* default */.Z)(res.content));
        });
        sessionStorage.setItem("BC-offerIDOpened", offer.id);
        router.push({
            pathname: router.pathname,
            query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                offerid: offer.id
            })
        }, undefined, {
            shallow: true
        });
    };
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var ref8 = (0,react.useState)(false), isOfferDialogOpen = ref8[0], setIsOfferDialogOpen = ref8[1];
    var width = (0,dist_module/* useWindowWidth */.Lm)();
    var router = (0,next_router.useRouter)();
    var ref9 = (0,react.useState)(0), mediaHeight = ref9[0], setMediaHeight = ref9[1];
    var ref10 = (0,react.useState)(0), mediaWidth = ref10[0], setMediaWidth = ref10[1];
    var ref11 = (0,react.useState)([]), similarOffers = ref11[0], setSimilarOffers = ref11[1];
    var ref12 = (0,react.useState)((0,_object_spread/* default */.Z)({}, data)), offer = ref12[0], setOffer = ref12[1];
    var ref13 = (0,react.useState)({
        open: false,
        offer: null
    }), shareDialogState = ref13[0], setShareDialogState = ref13[1];
    var imageRef = /*#__PURE__*/ (0,react.createRef)();
    var userStore = (0,es/* useSelector */.v9)(function(state) {
        return state.user.value;
    });
    (0,react.useEffect)(function() {
        if (imageRef === null || imageRef === void 0 ? void 0 : imageRef.current) {
            setMediaHeight(imageRef.current.offsetWidth / 1.78);
            setMediaWidth(imageRef.current.offsetWidth);
        }
    }, [
        imageRef
    ]);
    (0,react.useEffect)(function() {
        if (isOpened) {
            setIsOfferDialogOpen(true);
        }
    }, [
        isOpened
    ]);
    (0,react.useEffect)(function() {
        setOffer((0,_object_spread/* default */.Z)({}, data));
    }, [
        data
    ]);
    var options = (0,textEditorParseOptions/* getTextEditorParseOptions */.G)({
        article: {},
        mediaWidth: mediaWidth,
        mediaHeight: mediaHeight,
        imageRef: imageRef,
        styles: (OfferCard_module_default())
    });
    var isFlightSearchLink = function(offerLink) {
        if (!offerLink) {
            return false;
        }
        return offerLink.includes("searchRedirect");
    };
    var isDealsLink = function(offerLink) {
        if (!offerLink) {
            return false;
        }
        return offerLink.includes("dealsRedirect");
    };
    var generateDealsLink = function(offer) {
        if (!offer) {
            return "";
        }
        return "/?country=".concat(offer.country.toUpperCase(), "&origin=").concat(offer.origin.code, "&destination=").concat(offer.destination.code, "&airline=").concat(offer.airline.code, "&airlineName=").concat(offer.airline.name, "&cabinClass=").concat(offer.cabinClass, "&currency=").concat(offer.currency);
    };
    var closeOfferDialog = function() {
        setIsOfferDialogOpen(false);
        var query = (0,_object_spread/* default */.Z)({}, router.query);
        delete query.offerid;
        sessionStorage.setItem("BC-offerIDOpened", null);
        router.push({
            pathname: router.pathname,
            query: query
        }, undefined, {
            shallow: true
        });
        closeDetails(true);
    };
    ;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            offer && type === "card" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((OfferCard_module_default()).offerCard, "cursor-pointer", (!(offer === null || offer === void 0 ? void 0 : (ref = offer.destination) === null || ref === void 0 ? void 0 : ref.region) || !(offer === null || offer === void 0 ? void 0 : (ref1 = offer.destination) === null || ref1 === void 0 ? void 0 : ref1.code)) && (userStore === null || userStore === void 0 ? void 0 : userStore.is_admin) && "bg-red-100"),
                onClick: function() {
                    openOfferDetails(offer);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (OfferCard_module_default()).offerImage,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWithFallback/* ImageWithFallback */.J, {
                            src: (0,setImageUrl/* setImageUrl */.B)(offer.image),
                            width: 400,
                            height: 400,
                            objectFit: "cover",
                            alt: offer.destination.name,
                            quality: 95,
                            sizes: "(max-width: 1024px) 100vw, 400px"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (OfferCard_module_default()).offerData,
                        children: [
                            ((ref2 = offer.airline) === null || ref2 === void 0 ? void 0 : ref2.code) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()((OfferCard_module_default()).offerOverline, "flex"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: classnames_default()((OfferCard_module_default()).offerOverline, "w-full m-0 p-0"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "font-bold",
                                                children: [
                                                    " ",
                                                    (0,flightUtils/* getCabinClass */.CP)(offer.cabinClass, false)
                                                ]
                                            }),
                                            " | ",
                                            offer.airline.name,
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            offer.origin.name,
                                            " (",
                                            offer.origin.code,
                                            ") -",
                                            " ",
                                            offer.destination.name,
                                            " (",
                                            offer.destination.code,
                                            ")",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (OfferCard_module_default()).airlineLogo,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: (ref3 = offer.airline.logo) === null || ref3 === void 0 ? void 0 : ref3.replace("http", "https"),
                                            width: 40,
                                            height: 35,
                                            loading: "lazy",
                                            alt: "Airline logo",
                                            className: "ml-auto"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                className: classnames_default()("font-fragment my-3", showOrigin && "text-lg"),
                                children: [
                                    showOrigin && offer.origin.name + " - ",
                                    offer.destination.name
                                ]
                            }),
                            ((offer === null || offer === void 0 ? void 0 : offer.departureDate) || (offer === null || offer === void 0 ? void 0 : offer.returnDate)) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: classnames_default()("text-xs text-black"),
                                children: [
                                    moment_default()(offer === null || offer === void 0 ? void 0 : offer.departureDate).format("D. MMM"),
                                    " ",
                                    "- ",
                                    moment_default()(offer === null || offer === void 0 ? void 0 : offer.returnDate).format("D. MMM yyyy")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()((OfferCard_module_default()).offerPrice, "font-libre"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "mr-1",
                                        children: "From"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((currency_format_default()), {
                                        thousandSeparator: true,
                                        displayType: "text",
                                        prefix: currency_symbol_map_default()(offer.currency) + " ",
                                        value: Math.round(offer.price),
                                        className: "mr-2"
                                    }),
                                    offer.regularPrice && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: classnames_default()((OfferCard_module_default()).regularPrice, "line-through mr-2"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((currency_format_default()), {
                                                    thousandSeparator: true,
                                                    displayType: "text",
                                                    prefix: currency_symbol_map_default()(offer.currency) + " ",
                                                    value: offer.regularPrice
                                                })
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: (OfferCard_module_default()).regularPrice,
                                                children: [
                                                    "(",
                                                    Math.round((offer.regularPrice - offer.price) / offer.regularPrice * 100) + "% off",
                                                    ")"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            (userStore === null || userStore === void 0 ? void 0 : userStore.is_admin) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    !(offer === null || offer === void 0 ? void 0 : (ref4 = offer.destination) === null || ref4 === void 0 ? void 0 : ref4.region) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-red-600 text-xs",
                                        children: "No region specified"
                                    }),
                                    !(offer === null || offer === void 0 ? void 0 : (ref5 = offer.destination) === null || ref5 === void 0 ? void 0 : ref5.code) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-red-600 text-xs",
                                        children: "No destination code specified"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            offer && type === "table" && renderOfferTableItem(offer, width >= 1024 ? showOrigin : false),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer/* default */.ZP, {
                open: isOfferDialogOpen,
                onClose: function() {
                    return closeOfferDialog();
                },
                anchor: "right",
                ModalProps: {
                    disableAutoFocus: true,
                    disableEnforceFocus: true
                },
                sx: {
                    "& .MuiDrawer-paper": (0,_define_property/* default */.Z)({
                        width: "60%",
                        backgroundColor: "#FAF8F4"
                    }, OfferCard_theme.breakpoints.down("md"), {
                        width: "100%"
                    })
                },
                children: offer && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()((OfferCard_module_default()).offerDialogContent, (OfferCard_module_default()).offers, "p-3 lg:p-6 lg:pt-20 pt-16"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                                    color: "inherit",
                                    onClick: function() {
                                        return closeOfferDialog();
                                    },
                                    "aria-label": "close",
                                    className: (OfferCard_module_default()).closeDialog,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "text-3xl w-full font-libre",
                                    children: "Offer details"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classnames_default()((OfferCard_module_default()).offerDetailsContainer, "relative grid grid-cols-1 lg:grid-cols-2 gap-4 mb-4"),
                            id: "offer-details",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()((OfferCard_module_default()).offerDetailsImageContainer, "relative max-w-full"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWithFallback/* ImageWithFallback */.J, {
                                        src: (0,setImageUrl/* setImageUrl */.B)(offer === null || offer === void 0 ? void 0 : offer.image),
                                        layout: "fill",
                                        objectFit: "cover",
                                        alt: offer === null || offer === void 0 ? void 0 : offer.destination.name,
                                        quality: 95,
                                        sizes: "(max-width: 1024px) 100vw, 400px",
                                        className: "h-40"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classnames_default()((OfferCard_module_default()).offerData, "w-full"),
                                    children: [
                                        ((ref6 = offer.airline) === null || ref6 === void 0 ? void 0 : ref6.code) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: classnames_default()((OfferCard_module_default()).offerOverline, "flex"),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: classnames_default()((OfferCard_module_default()).offerOverline, "w-full m-0 p-0 text-base"),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            className: "font-bold",
                                                            children: [
                                                                " ",
                                                                (0,flightUtils/* getCabinClass */.CP)(offer.cabinClass, false)
                                                            ]
                                                        }),
                                                        " | ",
                                                        offer.airline.name,
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                        offer.origin.name,
                                                        " (",
                                                        offer.origin.code,
                                                        ") -",
                                                        " ",
                                                        offer.destination.name,
                                                        " (",
                                                        offer.destination.code,
                                                        ")"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: (ref7 = offer.airline.logo) === null || ref7 === void 0 ? void 0 : ref7.replace("http", "https"),
                                                        width: 50,
                                                        height: 46,
                                                        loading: "lazy",
                                                        alt: "Airline logo",
                                                        className: "ml-auto"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                            className: classnames_default()("font-fragment text-left my-5", showOrigin ? "text-2xl" : "text-3xl"),
                                            children: [
                                                showOrigin && offer.origin.name + " - ",
                                                offer === null || offer === void 0 ? void 0 : offer.destination.name
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: classnames_default()((OfferCard_module_default()).offerPrice, "text-2xl", !offer.regularPrice && "mb-4"),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "mr-2 text-base",
                                                    children: "From"
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((currency_format_default()), {
                                                    thousandSeparator: true,
                                                    displayType: "text",
                                                    prefix: currency_symbol_map_default()(offer === null || offer === void 0 ? void 0 : offer.currency) + " ",
                                                    value: Math.round(offer === null || offer === void 0 ? void 0 : offer.price),
                                                    className: "mr-2"
                                                })
                                            ]
                                        }),
                                        offer.regularPrice && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "text-base mb-4",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: classnames_default()((OfferCard_module_default()).regularPrice, "line-through mr-2 text-lg"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((currency_format_default()), {
                                                        thousandSeparator: true,
                                                        displayType: "text",
                                                        prefix: currency_symbol_map_default()(offer.currency) + " ",
                                                        value: offer.regularPrice
                                                    })
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: classnames_default()((OfferCard_module_default()).regularPrice, "text-lg"),
                                                    children: [
                                                        "(",
                                                        Math.round((offer.regularPrice - offer.price) / offer.regularPrice * 100) + "% off",
                                                        ")"
                                                    ]
                                                })
                                            ]
                                        }),
                                        !isFlightSearchLink(offer === null || offer === void 0 ? void 0 : offer.link) && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: isDealsLink ? generateDealsLink(offer) : offer === null || offer === void 0 ? void 0 : offer.link,
                                            className: classnames_default()((OfferCard_module_default()).offerLink, "mb-2"),
                                            target: "_blank",
                                            children: "View offer"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: classnames_default()((OfferCard_module_default()).offerOverline, "mb-2"),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: "text-lg",
                                                    children: [
                                                        "Offer expires:",
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                            children: moment_default()(offer === null || offer === void 0 ? void 0 : offer.expirationDate).format("DD.MM.YYYY")
                                                        })
                                                    ]
                                                }),
                                                ((offer === null || offer === void 0 ? void 0 : offer.departureDate) || (offer === null || offer === void 0 ? void 0 : offer.returnDate)) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: "text-lg",
                                                    children: [
                                                        "Travel dates:",
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                                            children: [
                                                                moment_default()(offer === null || offer === void 0 ? void 0 : offer.departureDate).format("DD.MM.YYYY"),
                                                                " -",
                                                                " ",
                                                                moment_default()(offer === null || offer === void 0 ? void 0 : offer.returnDate).format("DD.MM.YYYY")
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip_Tooltip/* default */.Z, {
                                    title: "Share offer",
                                    placement: "top",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                                        color: "inherit",
                                        className: (OfferCard_module_default()).shareIcon,
                                        onClick: function(event) {
                                            event.stopPropagation();
                                            event.preventDefault();
                                            setShareDialogState({
                                                open: true,
                                                offer: offer
                                            });
                                        },
                                        "aria-label": "close",
                                        sx: {
                                            display: "inline-flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            marginLeft: "5px"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IosShare/* default */.Z, {
                                            className: "m-0 lg:h-6 lg:w-6 -mt-1"
                                        })
                                    })
                                })
                            ]
                        }),
                        isFlightSearchLink(offer === null || offer === void 0 ? void 0 : offer.link) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classnames_default()((OfferCard_module_default()).offerDetailsContainer, "mb-4"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                                    className: "text-left font-libre mb-0",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TravelExploreOutlined/* default */.Z, {
                                            className: "mr-2"
                                        }),
                                        " Start offer flight search"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_intersection_observer_m/* default */.ZP, {
                                    triggerOnce: true,
                                    children: function(param) {
                                        var inView = param.inView, ref = param.ref;
                                        var ref1, ref2, ref3;
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                            ref: ref,
                                            className: "w-full",
                                            children: inView && /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferCard_FlightSearch, {
                                                collapsed: false,
                                                disablePortal: true,
                                                airlineName: (ref1 = offer.airline) === null || ref1 === void 0 ? void 0 : ref1.name,
                                                airlineCode: (ref2 = offer.airline) === null || ref2 === void 0 ? void 0 : ref2.code,
                                                airlineClass: utils_cabinClasses/* CABIN_CLASSES.find */.r.find(function(cabin) {
                                                    return cabin.value === offer.cabinClass;
                                                }).label,
                                                flightSearchValueProp: generateOffer(offer, (ref3 = offer.airline) === null || ref3 === void 0 ? void 0 : ref3.code),
                                                minDate: offer === null || offer === void 0 ? void 0 : offer.departureDate,
                                                maxDate: offer === null || offer === void 0 ? void 0 : offer.returnDate,
                                                defaultSortBy: "price",
                                                viewMode: width > 1600 ? "mainSearch" : "sideSearch",
                                                customHeader: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "text-sm font-semibold font-libre",
                                                    children: [
                                                        "Select your dates",
                                                        " ",
                                                        offer.departureDate && offer.returnDate && " between ".concat(moment_default()(offer === null || offer === void 0 ? void 0 : offer.departureDate).format("DD.MM.YYYY"), " and ").concat(moment_default()(offer === null || offer === void 0 ? void 0 : offer.returnDate).format("DD.MM.YYYY")),
                                                        " ",
                                                        "and click 'Find offer' to find flight details"
                                                    ]
                                                }),
                                                customSearchText: "Find offer",
                                                openInNewTab: true,
                                                searchSource: searchSource
                                            })
                                        });
                                    }
                                })
                            ]
                        }),
                        (similarOffers === null || similarOffers === void 0 ? void 0 : similarOffers.length) > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classnames_default()("mb-4"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                                    className: "text-left font-libre mb-0",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ListAltOutlined/* default */.Z, {
                                            className: "mr-2"
                                        }),
                                        " Similar offers"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()("grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-4"),
                                    children: similarOffers.map(function(similarOffer) {
                                        var ref;
                                        return similarOffer.id !== offer.id && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: classnames_default()((OfferCard_module_default()).offerData, (OfferCard_module_default()).offerDetailsContainer, "w-full cursor-pointer"),
                                            onClick: function() {
                                                var drawerContainer = document.querySelector(".MuiDrawer-paper");
                                                if (drawerContainer) {
                                                    drawerContainer.scrollTo({
                                                        top: 0,
                                                        behavior: "smooth"
                                                    });
                                                }
                                                setOffer(null);
                                                setOffer(similarOffer);
                                                router.push({
                                                    pathname: router.pathname,
                                                    query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                                                        offerid: similarOffer.id
                                                    })
                                                }, undefined, {
                                                    shallow: true
                                                });
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: classnames_default()((OfferCard_module_default()).offerOverline, "flex"),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "font-bold block",
                                                            children: (0,flightUtils/* getCabinClass */.CP)(similarOffer.cabinClass, true)
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "px-1",
                                                            children: "|"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            children: [
                                                                " ",
                                                                similarOffer.airline.name
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: (ref = similarOffer.airline.logo) === null || ref === void 0 ? void 0 : ref.replace("http", "https"),
                                                            width: 25,
                                                            height: 20,
                                                            loading: "lazy",
                                                            alt: "Airline logo",
                                                            className: "ml-auto"
                                                        })
                                                    ]
                                                }),
                                                ((similarOffer === null || similarOffer === void 0 ? void 0 : similarOffer.departureDate) || (similarOffer === null || similarOffer === void 0 ? void 0 : similarOffer.returnDate)) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (OfferCard_module_default()).offerOverline,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-sm",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                                            children: [
                                                                moment_default()(similarOffer === null || similarOffer === void 0 ? void 0 : similarOffer.departureDate).format("DD.MM.YYYY"),
                                                                " ",
                                                                "- ",
                                                                moment_default()(similarOffer === null || similarOffer === void 0 ? void 0 : similarOffer.returnDate).format("DD.MM.YYYY")
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: classnames_default()((OfferCard_module_default()).offerPrice, "text-xl mt-4"),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: "mr-2 text-base",
                                                            children: "From"
                                                        }),
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((currency_format_default()), {
                                                            thousandSeparator: true,
                                                            displayType: "text",
                                                            prefix: currency_symbol_map_default()(similarOffer === null || similarOffer === void 0 ? void 0 : similarOffer.currency) + " ",
                                                            value: Math.round(similarOffer === null || similarOffer === void 0 ? void 0 : similarOffer.price),
                                                            className: "mr-2"
                                                        })
                                                    ]
                                                }),
                                                similarOffer.regularPrice && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "text-base",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: classnames_default()((OfferCard_module_default()).regularPrice, "line-through mr-2 text-base"),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((currency_format_default()), {
                                                                thousandSeparator: true,
                                                                displayType: "text",
                                                                prefix: currency_symbol_map_default()(similarOffer.currency) + " ",
                                                                value: similarOffer.regularPrice
                                                            })
                                                        }),
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            className: classnames_default()((OfferCard_module_default()).regularPrice, "text-lg"),
                                                            children: [
                                                                "(",
                                                                Math.round((similarOffer.regularPrice - similarOffer.price) / similarOffer.regularPrice * 100) + "% off",
                                                                ")"
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, similarOffer.id);
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classnames_default()((OfferCard_module_default()).offerDetailsContainer, "mb-4"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                                    className: "text-left font-libre",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DescriptionOutlined/* default */.Z, {
                                            className: "mr-2"
                                        }),
                                        " Offer description, terms and conditions"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: (0,html_react_parser/* default */.ZP)(offer.content, options)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (OfferCard_module_default()).offerDetailsContainer,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                                    className: "text-left font-libre",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AnnouncementOutlined/* default */.Z, {
                                            className: "mr-2"
                                        }),
                                        " Important notes"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Amazing fares like these don’t last long - they can disappear within hours, or even minutes! If you don’t see similar prices to those listed above, try selecting different travel dates to find other great options. And don’t worry, we’ve got plenty more incredible deals coming your way very soon. Stay tuned!"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog_Dialog/* default */.Z, {
                open: shareDialogState.open && shareDialogState.offer,
                onBackdropClick: function() {
                    setShareDialogState({
                        open: false,
                        offer: null
                    });
                },
                PaperProps: {
                    style: {
                        position: "relative",
                        minWidth: "30vw"
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                        color: "inherit",
                        onClick: function() {
                            setShareDialogState({
                                open: false,
                                offer: null
                            });
                        },
                        "aria-label": "close",
                        className: (OfferCard_module_default()).closeShareDialog,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (OfferCard_module_default()).imageHeader,
                                children: shareDialogState.offer && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWithFallback/* ImageWithFallback */.J, {
                                    src: (0,setImageUrl/* setImageUrl */.B)(shareDialogState.offer.image),
                                    width: 1200,
                                    height: 400,
                                    quality: 50,
                                    objectFit: "cover"
                                })
                            }),
                            shareDialogState.offer && /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                className: classnames_default()((OfferCard_module_default()).imageTitle, "font-fragment font-normal text-xl lg:text-3xl"),
                                children: [
                                    shareDialogState.offer.origin.name,
                                    " - ",
                                    shareDialogState.offer.destination.name
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "p-4 mt-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                className: "font-libre",
                                children: "Share this offer"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex align-items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField_TextField/* default */.Z, {
                                        label: "Share url",
                                        variant: "outlined",
                                        defaultValue: "".concat("https://www.first-class.com").concat(router.asPath),
                                        className: "w-full",
                                        inputProps: {
                                            readOnly: true
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                        variant: "contained",
                                        color: "secondary",
                                        sx: {
                                            backgroundColor: "#0a0a0a",
                                            color: "#ffffff",
                                            marginLeft: "1rem",
                                            textTransform: "none",
                                            minWidth: "100px",
                                            "&:hover": {
                                                backgroundColor: "#ffffff",
                                                color: "#0a0a0a"
                                            }
                                        },
                                        onClick: function() {
                                            navigator.clipboard.writeText("".concat("https://www.first-class.com").concat(router.asPath));
                                            setShareDialogState({
                                                open: false,
                                                offer: null
                                            });
                                        },
                                        children: "Copy link"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@material-ui/system/esm/ThemeProvider/ThemeProvider.js + 2 modules
var ThemeProvider_ThemeProvider = __webpack_require__(83587);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/Select/Select.js + 13 modules
var Select_Select = __webpack_require__(64497);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/MenuItem/MenuItem.js + 4 modules
var MenuItem_MenuItem = __webpack_require__(12122);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/ToggleButtonGroup/ToggleButtonGroup.js + 2 modules
var ToggleButtonGroup = __webpack_require__(39416);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/ToggleButton/ToggleButton.js + 1 modules
var ToggleButton = __webpack_require__(23094);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/Snackbar/Snackbar.js + 4 modules
var Snackbar = __webpack_require__(3261);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/Alert/Alert.js + 6 modules
var Alert = __webpack_require__(8430);
;// CONCATENATED MODULE: ./components/OffersListSection/OffersListSection.jsx














var OffersListSection_theme = (0,styles_createTheme/* default */.Z)({
    shape: {
        borderRadius: 12
    },
    palette: {
        primary: {
            main: "#00454A"
        },
        dark: {
            main: "#0a0a0a"
        }
    },
    typography: {
        fontFamily: '"Libre Franklin", sans-serif'
    },
    components: {
        MuiToggleButtonGroup: {
            styleOverrides: {
                grouped: {
                    margin: "4px",
                    borderRadius: "10px",
                    "&:not(:last-of-type)": {
                        borderTopRightRadius: "10px",
                        borderBottomRightRadius: "10px"
                    },
                    "&:not(:first-of-type)": {
                        marginLeft: "4px",
                        borderLeft: 1,
                        borderLeftStyle: "solid",
                        borderLeftColor: "#20202033",
                        borderTopLeftRadius: 10,
                        borderBottomLeftRadius: 10
                    },
                    "&.Mui-selected": {
                        color: "#fff",
                        backgroundColor: "#BB9269",
                        borderColor: "#BB9269",
                        "&:hover": {
                            backgroundColor: "#BB9269"
                        }
                    }
                }
            }
        }
    }
});
var getOfferItems = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(country) {
        var origin, destination, airline, cabinClass, params, urlParams;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    origin = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "", destination = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : "", airline = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : "", cabinClass = _arguments.length > 4 ? _arguments[4] : void 0;
                    params = [];
                    if (country) {
                        params.push("country=".concat(country));
                    }
                    if (origin) {
                        params.push("origin=".concat(origin));
                    }
                    if (destination) {
                        params.push("destination=".concat(destination));
                    }
                    if (airline) {
                        params.push("airline=".concat(airline));
                    }
                    if (cabinClass) {
                        params.push("cabinClass=".concat(cabinClass));
                    }
                    urlParams = params.join("&");
                    return [
                        4,
                        (0,httpClient/* httpGet */.kA)("/api/offer/items?".concat(urlParams))
                    ];
                case 1:
                    return [
                        4,
                        _state.sent().json()
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getOfferItems(country) {
        return _ref.apply(this, arguments);
    };
}();
function OffersListSection(param) {
    var offers = param.offers, _type = param.type, type = _type === void 0 ? "card" : _type, _showOrigin = param.showOrigin, showOrigin = _showOrigin === void 0 ? false : _showOrigin, country = param.country, origin = param.origin, destination = param.destination, airline = param.airline, cabinClass = param.cabinClass, searchSource = param.searchSource, customHeader = param.customHeader;
    var userStore = (0,es/* useSelector */.v9)(function(state) {
        return state.user.value;
    });
    var ref = (0,react.useState)([]), offerItems = ref[0], setOfferItems = ref[1];
    var ref1 = (0,react.useState)(null), openedOfferId = ref1[0], setOpenedOfferId = ref1[1];
    var ref2 = (0,react.useState)({
        open: false,
        message: "",
        type: "success"
    }), openSnackbar = ref2[0], setOpenSnackbar = ref2[1];
    var ref3 = (0,react.useState)([]), regions = ref3[0], setRegions = ref3[1];
    var ref4 = (0,react.useState)("All"), activeRegion = ref4[0], setActiveRegion = ref4[1];
    var router = (0,next_router.useRouter)();
    var width = (0,dist_module/* useWindowWidth */.Lm)();
    (0,react.useEffect)(function() {
        if (offers && offers.length > 0) {
            setOfferItems(offers);
            var regionsSet = new Set();
            offers.forEach(function(offer) {
                var region = offer.destination.region;
                regionsSet.add(region ? region : "Not specified");
            });
            var regionsArray = Array.from(regionsSet).map(function(region) {
                return {
                    name: region
                };
            });
            setRegions(regionsArray);
            if (regionsArray.length > 0) {
                setActiveRegion("All");
                sortByRegion("All");
            }
        } else {
            var fetchOfferItems = function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function() {
                    var offerItems;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    getOfferItems(country || (userStore === null || userStore === void 0 ? void 0 : userStore.country), origin ? origin : "", destination, airline ? airline : "", cabinClass)
                                ];
                            case 1:
                                offerItems = _state.sent();
                                setOfferItems((0,_to_consumable_array/* default */.Z)(offerItems.content));
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function fetchOfferItems() {
                    return _ref.apply(this, arguments);
                };
            }();
            fetchOfferItems();
        }
    }, [
        offers
    ]);
    (0,react.useEffect)(function() {
        if (offerItems.length > 0) {
            var query = lib_default().parse(router.query);
            if (Object.keys(query).length && query.offerid) {
                var offer = offerItems.find(function(offer) {
                    return offer.id === +query.offerid;
                });
                if (offer) {
                    setOpenedOfferId(offer.id);
                } else {
                    setOpenSnackbar({
                        open: true,
                        message: "Offer which you are trying to open from the link is not found or not available anymore",
                        type: "error"
                    });
                }
            }
        }
    }, [
        offerItems
    ]);
    var handleCloseSnackbar = function(event, reason) {
        if (reason === "clickaway") {
            return;
        }
        setOpenSnackbar({
            open: false,
            message: "",
            type: "success"
        });
    };
    var handleRegionChange = function(event, region) {
        setActiveRegion(region);
        sortByRegion(region);
    };
    var handleSelectRegionChange = function(event) {
        var region = event.target.value;
        setActiveRegion(region);
        sortByRegion(region);
    };
    var sortByRegion = function(region) {
        var regionToSort = region === "Not specified" ? null : region;
        var filteredOffers = regionToSort === "All" ? offers : offers.filter(function(offer) {
            var offerRegion = offer.destination.region || null;
            return regionToSort === offerRegion;
        });
        setOfferItems(filteredOffers);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            customHeader && offerItems.length > 0 && customHeader,
            regions && regions.length > 2 && (!destination || destination === "All destinations" || destination === "") && /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeProvider_ThemeProvider/* default */.Z, {
                theme: OffersListSection_theme,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container flex justify-center px-3",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()((OffersListSection_module_default()).regionFilters, "w-full"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex flex-col lg:flex-row items-center w-full justify-center",
                            children: width < 1024 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full flex",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Select_Select/* default */.Z, {
                                    value: activeRegion,
                                    onChange: handleSelectRegionChange,
                                    fullWidth: true,
                                    className: "bg-white font-bold",
                                    variant: "outlined",
                                    sx: {
                                        color: "#202020",
                                        "& .MuiOutlinedInput-input": {
                                            padding: "8px",
                                            border: "2px solid transparent",
                                            borderColor: activeRegion !== "All" ? "#BB9269" : "currentColor"
                                        }
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem_MenuItem/* default */.Z, {
                                            value: "All",
                                            children: "All regions"
                                        }),
                                        regions.map(function(region) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem_MenuItem/* default */.Z, {
                                                value: region.name,
                                                children: region.name
                                            }, region.name);
                                        })
                                    ]
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(ToggleButtonGroup/* default */.Z, {
                                orientation: width < 1024 ? "vertical" : "horizontal",
                                size: "large",
                                value: activeRegion,
                                fullWidth: width < 1024,
                                exclusive: true,
                                onChange: handleRegionChange,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ToggleButton/* default */.Z, {
                                        value: "All",
                                        "aria-label": "All regions",
                                        className: (OffersListSection_module_default()).regionButton,
                                        selected: activeRegion === "All",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex flex-col lg:flex-row items-center",
                                            children: "All regions"
                                        })
                                    }),
                                    regions.map(function(region) {
                                        if (region.name === "Not specified" && !userStore.is_admin) return null;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ToggleButton/* default */.Z, {
                                            value: region.name,
                                            "aria-label": region.name,
                                            className: classnames_default()((OffersListSection_module_default()).regionButton, region.name === "Not specified" && "bg-red-100"),
                                            selected: region.name === activeRegion,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex flex-col lg:flex-row items-center",
                                                children: region.name
                                            })
                                        }, region.name);
                                    })
                                ]
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((OffersListSection_module_default()).offers, "mt-7", type === "card" && "grid lg:grid-cols-3 gap-6 grid-cols-1 mb-8"),
                children: offerItems && offerItems.length > 0 && offerItems.map(function(offer, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferCard, {
                        data: offer,
                        searchSource: searchSource,
                        isOpened: offer.id === openedOfferId,
                        type: type,
                        showOrigin: showOrigin
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Snackbar/* default */.Z, {
                open: openSnackbar.open,
                autoHideDuration: 10000,
                onClose: handleCloseSnackbar,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                    onClose: handleCloseSnackbar,
                    severity: openSnackbar.type,
                    variant: "filled",
                    sx: {
                        width: "100%"
                    },
                    children: openSnackbar.message
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/LocalOffer.js
var LocalOffer = __webpack_require__(50449);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Event.js
var Event = __webpack_require__(86467);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Place.js
var Place = __webpack_require__(3769);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/LocalAirport.js
var LocalAirport = __webpack_require__(55736);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ConnectingAirports.js
var ConnectingAirports = __webpack_require__(63501);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Tune.js
var Tune = __webpack_require__(75395);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Airlines.js
var Airlines = __webpack_require__(57797);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Schedule.js
var Schedule = __webpack_require__(26730);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/DateRange.js
var DateRange = __webpack_require__(21075);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/NotificationsActive.js
var NotificationsActive = __webpack_require__(25150);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/AirplaneTicket.js
var AirplaneTicket = __webpack_require__(1768);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Bed.js
var Bed = __webpack_require__(77134);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/SafetyCheck.js
var SafetyCheck = __webpack_require__(89998);
// EXTERNAL MODULE: ./components/ScrollableContent/ScrollableContent.jsx
var ScrollableContent_ScrollableContent = __webpack_require__(55542);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/CardMembership.js
var CardMembership = __webpack_require__(85821);
;// CONCATENATED MODULE: ./components/OfferPage/OfferPage.jsx















































var OfferPage_CallToSignUp = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4231), __webpack_require__.e(6700), __webpack_require__.e(8307), __webpack_require__.e(4522)]).then(__webpack_require__.bind(__webpack_require__, 68307));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(68307)
            ];
        }
    }
});
var OfferPage_RecommendationsList = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9972).then(__webpack_require__.bind(__webpack_require__, 39972));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(39972)
            ];
        }
    }
});
var OfferPage_theme = (0,createTheme/* default */.Z)({
    shape: {
        borderRadius: 12
    },
    palette: {
        primary: {
            main: "#00454A"
        },
        dark: {
            main: "#0a0a0a"
        }
    },
    typography: {
        fontFamily: '"Libre Franklin", sans-serif'
    }
});
function OfferPage(param) {
    var article = param.article, recommendation = param.recommendation, authCompleted = param.authCompleted;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var defaultFilters = {
        origin: "All",
        destination: "All",
        class: "Any class",
        sort: null
    };
    var userStore = (0,es/* useSelector */.v9)(function(state) {
        return state.user.value;
    });
    var router = (0,next_router.useRouter)();
    var ref7 = (0,react.useState)(0), mediaHeight = ref7[0], setMediaHeight = ref7[1];
    var ref8 = (0,react.useState)(0), mediaWidth = ref8[0], setMediaWidth = ref8[1];
    var imageRef = /*#__PURE__*/ (0,react.createRef)();
    var ref9 = (0,react.useState)((0,_to_consumable_array/* default */.Z)(article.offers)), countryOffers = ref9[0], setCountryOffers = ref9[1];
    var ref10 = (0,react.useState)(defaultFilters), filters = ref10[0], setFilters = ref10[1];
    var ref11 = (0,react.useState)([]), cabinClasses = ref11[0], setCabinClasses = ref11[1];
    var ref12 = (0,react.useState)([]), origins = ref12[0], setOrigins = ref12[1];
    var ref13 = (0,react.useState)([]), destinations = ref13[0], setDestinations = ref13[1];
    var width = (0,dist_module/* useWindowWidth */.Lm)();
    var isAirlineLanding = !!((ref = article.airline) === null || ref === void 0 ? void 0 : ref.name);
    (0,react.useEffect)(function() {
        if (imageRef === null || imageRef === void 0 ? void 0 : imageRef.current) {
            setMediaHeight(imageRef.current.offsetWidth / 1.78);
            setMediaWidth(imageRef.current.offsetWidth);
        }
    }, [
        imageRef
    ]);
    var options = (0,textEditorParseOptions/* getTextEditorParseOptions */.G)({
        article: article,
        mediaWidth: mediaWidth,
        mediaHeight: mediaHeight,
        imageRef: imageRef,
        styles: (OfferPage_module_default())
    });
    var root = (0,html_react_parser/* default */.ZP)(article.content, options);
    (0,react.useEffect)(function() {
        var fetchUserCountry = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var ref, country, filteredOffers, uniqueOrigins, uniqueDestinationCodes, destinations;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                userStore === null || userStore === void 0 ? void 0 : userStore.country
                            ];
                        case 1:
                            country = _state.sent();
                            if (!country) return [
                                2
                            ];
                            // console.log('article offers for ', country.toUpperCase(), article.offers.filter((offer) => offer.country.toUpperCase() === country.toUpperCase()));
                            if (((ref = article.offers) === null || ref === void 0 ? void 0 : ref.length) > 0) {
                                filteredOffers = article.offers.filter(function(offer) {
                                    return offer.country.toUpperCase() === country.toUpperCase();
                                });
                                setCountryOffers(filteredOffers);
                                uniqueOrigins = new Map();
                                uniqueDestinationCodes = new Set();
                                destinations = [];
                                filteredOffers.forEach(function(offer) {
                                    if (!uniqueOrigins.has(offer.origin.code)) {
                                        uniqueOrigins.set(offer.origin.code, offer.origin);
                                    }
                                    if (!uniqueDestinationCodes.has(offer.destination.code)) {
                                        uniqueDestinationCodes.add(offer.destination.code);
                                        destinations.push(offer.destination);
                                    }
                                });
                                setOrigins(Array.from(uniqueOrigins.values()).sort(function(a, b) {
                                    return a.name.localeCompare(b.name);
                                }));
                                setDestinations(destinations.sort(function(a, b) {
                                    return a.name.localeCompare(b.name);
                                }));
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchUserCountry() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchUserCountry();
    }, [
        article,
        userStore === null || userStore === void 0 ? void 0 : userStore.country
    ]);
    (0,react.useEffect)(function() {
        var cabinClasses = (0,_to_consumable_array/* default */.Z)(utils_cabinClasses/* CABIN_CLASSES */.r).reverse();
        setCabinClasses(cabinClasses);
    }, []);
    (0,react.useEffect)(function() {
        var ref, ref1;
        if (!filters.resetFilters) {
            var filteredOffers = article.offers.filter(function(offer) {
                return (filters.origin === "All" || offer.origin.code === filters.origin) && (filters.destination === "All" || offer.destination.code === filters.destination) && (filters.class === "Any class" || offer.cabinClass === filters.class);
            });
            setCountryOffers((0,_to_consumable_array/* default */.Z)(filteredOffers));
        }
        if (filters.resetFilters) {
            setCountryOffers((0,_to_consumable_array/* default */.Z)(article.offers.filter(function(offer) {
                return offer.country.toUpperCase() === userStore.country.toUpperCase();
            })));
            setFilters(defaultFilters);
        }
        if ((ref = filters.sort) === null || ref === void 0 ? void 0 : ref.price) {
            handlePriceSort(filters.sort.price);
        }
        if ((ref1 = filters.sort) === null || ref1 === void 0 ? void 0 : ref1.destination) {
            handleDestinationSort(filters.sort.destination);
        }
    }, [
        filters
    ]);
    var handlePriceSort = function(sortType) {
        var sortedOffers = (0,_to_consumable_array/* default */.Z)(countryOffers);
        if (sortType === "asc") {
            sortedOffers.sort(function(a, b) {
                return a.price - b.price;
            });
        } else if (sortType === "desc") {
            sortedOffers.sort(function(a, b) {
                return b.price - a.price;
            });
        } else {
            // TODO: Sord by order
            sortedOffers.sort(function(a, b) {
                var dateA = Date.parse(a.expirationDate);
                var dateB = Date.parse(b.expirationDate);
                return dateB - dateA;
            });
        }
        setCountryOffers(sortedOffers);
    };
    var handleDestinationSort = function(sortType) {
        var sortedOffers = (0,_to_consumable_array/* default */.Z)(countryOffers);
        if (sortType === "asc") {
            sortedOffers.sort(function(a, b) {
                return a.destination.name.localeCompare(b.destination.name);
            });
        } else if (sortType === "desc") {
            sortedOffers.sort(function(a, b) {
                return b.destination.name.localeCompare(a.destination.name);
            });
        } else {
            sortedOffers.sort(function(a, b) {
                var dateA = Date.parse(a.expirationDate);
                var dateB = Date.parse(b.expirationDate);
                return dateB - dateA;
            });
        }
        setCountryOffers(sortedOffers);
    };
    var getTitle = function() {
        if (isAirlineLanding) {
            return "".concat(article.airline.name, " Flights, Tickets, Offers & Deals");
        } else {
            return article.title;
        }
    };
    var getAirlineInfoIcon = function(property) {
        switch(property){
            case "signUp":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CardMembership/* default */.Z, {
                    fontSize: "large",
                    sx: {
                        color: "#86694B"
                    }
                });
            case "filterSearch":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tune/* default */.Z, {
                    fontSize: "large",
                    sx: {
                        color: "#86694B"
                    }
                });
            case "flyFrom":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalAirport/* default */.Z, {
                    fontSize: "large",
                    sx: {
                        color: "#86694B"
                    }
                });
            case "stayLoyal":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Airlines/* default */.Z, {
                    fontSize: "large",
                    sx: {
                        color: "#86694B"
                    }
                });
            case "flexDates":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Schedule/* default */.Z, {
                    fontSize: "large",
                    sx: {
                        color: "#86694B"
                    }
                });
            case "catchFlight":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(DateRange/* default */.Z, {
                    fontSize: "large",
                    sx: {
                        color: "#86694B"
                    }
                });
            case "setPriceAlert":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationsActive/* default */.Z, {
                    fontSize: "large",
                    sx: {
                        color: "#86694B"
                    }
                });
            case "checkTickets":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(AirplaneTicket/* default */.Z, {
                    fontSize: "large",
                    sx: {
                        color: "#86694B"
                    }
                });
            case "bookHotels":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Bed/* default */.Z, {
                    fontSize: "large",
                    sx: {
                        color: "#86694B"
                    }
                });
            case "getInsured":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(SafetyCheck/* default */.Z, {
                    fontSize: "large",
                    sx: {
                        color: "#86694B"
                    }
                });
        }
    };
    var renderFilters = function(param) {
        var setFieldValue = param.setFieldValue, values = param.values;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()((OfferPage_module_default()).filterSmaller),
                    children: origins && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Select/* default */.Z, {
                        value: values.origin,
                        onChange: function(event) {
                            setFieldValue("origin", event.target.value);
                        },
                        defaultValue: "All",
                        fullWidth: true,
                        name: "origin",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                value: "All",
                                children: "- Any origin -"
                            }),
                            origins.map(function(origin) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                    value: origin.code,
                                    children: origin.name
                                }, origin.code);
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()((OfferPage_module_default()).filterSmaller),
                    children: destinations && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Select/* default */.Z, {
                        value: values.destination,
                        onChange: function(event) {
                            setFieldValue("destination", event.target.value);
                        },
                        defaultValue: "All",
                        fullWidth: true,
                        name: "destination",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                value: "All",
                                children: "- Any destination -"
                            }),
                            destinations.map(function(destination) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                    value: destination.code,
                                    children: destination.name
                                }, destination.code);
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()((OfferPage_module_default()).filterSmaller),
                    children: cabinClasses && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Select/* default */.Z, {
                        value: values.class,
                        onChange: function(event) {
                            setFieldValue("class", event.target.value);
                        },
                        fullWidth: true,
                        defaultValue: "Any class",
                        name: "class",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                value: "Any class",
                                children: "- Any class -"
                            }),
                            cabinClasses.map(function(cabin) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                    value: cabin.value,
                                    children: cabin.label
                                }, cabin.value);
                            })
                        ]
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("title", {
                        children: [
                            getTitle(),
                            " | First-Class.com"
                        ]
                    }),
                    ((ref1 = article.contentMetaData) === null || ref1 === void 0 ? void 0 : ref1.seoHtml) === "true" && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "robots",
                        content: "noindex, nofollow"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: article.subtitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:site",
                        content: "first-class.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: getTitle()
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: article.subtitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: "".concat("https://www.first-class.com").concat(router.asPath.split("?")[0])
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:image",
                        content: (0,setImageUrl/* setImageUrl */.B)(article.image)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: getTitle()
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: "article"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: (0,setImageUrl/* setImageUrl */.B)(article.image)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: article.subtitle
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((OfferPage_module_default()).article, "font-libre"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (OfferPage_module_default()).topContainer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "container",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* BCBreadcrumbs */.k, {
                                    headerText: article.title
                                }),
                                !isAirlineLanding && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (OfferPage_module_default()).overline,
                                    children: "Fly Business Class for less!"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: classnames_default()((OfferPage_module_default()).title, "font-fragment", isAirlineLanding && "mt-6"),
                                    children: article.title
                                }),
                                !isAirlineLanding && /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                    className: "font-libre text-base",
                                    children: article.subtitle
                                }),
                                isAirlineLanding && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()((OfferPage_module_default()).topSectionSearch, "container mx-auto px-4"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchBox/* SearchBox */.R, {
                                        type: width && width >= 1024 ? "mainSearch" : "sideSearch",
                                        activeTab: 0,
                                        searchSource: "Flights landing page"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "container",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "sm:w-full mx-auto sm:px-4 my-6",
                                children: [
                                    ((ref2 = article.offers) === null || ref2 === void 0 ? void 0 : ref2.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (OfferPage_module_default()).offersFilters,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                children: "Find the Best Flight Offers – Any Destination, Any Class"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeProvider/* default */.Z, {
                                                theme: OfferPage_theme,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
                                                    enableReinitialize: true,
                                                    initialValues: filters,
                                                    validate: function(value) {
                                                        return setFilters((0,_object_spread/* default */.Z)({}, value));
                                                    },
                                                    children: function(param) {
                                                        var setFieldValue = param.setFieldValue, values = param.values, resetForm = param.resetForm;
                                                        var ref, ref1, ref2, ref3;
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(formik_esm/* Form */.l0, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (OfferPage_module_default()).filtersContainer,
                                                                children: [
                                                                    renderFilters({
                                                                        setFieldValue: setFieldValue,
                                                                        values: values
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: (OfferPage_module_default()).sortButton,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                                                                title: "Sort by price",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconButton_IconButton/* default */.Z, {
                                                                                    color: "inherit",
                                                                                    type: "reset",
                                                                                    onClick: function() {
                                                                                        var ref, ref1, ref2;
                                                                                        if (((ref = filters.sort) === null || ref === void 0 ? void 0 : ref.price) === "desc") {
                                                                                            setFieldValue("sort", {
                                                                                                price: "asc"
                                                                                            });
                                                                                        }
                                                                                        if (((ref1 = filters.sort) === null || ref1 === void 0 ? void 0 : ref1.price) === "asc") {
                                                                                            setFieldValue("sort", {
                                                                                                price: null
                                                                                            });
                                                                                        }
                                                                                        if (!((ref2 = filters.sort) === null || ref2 === void 0 ? void 0 : ref2.price)) {
                                                                                            setFieldValue("sort", {
                                                                                                price: "desc"
                                                                                            });
                                                                                        }
                                                                                    },
                                                                                    "aria-label": "clear",
                                                                                    sx: {
                                                                                        border: "1px solid rgba(0, 0, 0, 0.23)",
                                                                                        borderRadius: "50%",
                                                                                        color: "#0A0A0A",
                                                                                        width: "56px",
                                                                                        height: "56px",
                                                                                        marginRight: "1rem",
                                                                                        backgroundColor: "#fff"
                                                                                    },
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Sort/* default */.Z, {}),
                                                                                        ((ref = filters.sort) === null || ref === void 0 ? void 0 : ref.price) === "desc" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightAlt/* default */.Z, {
                                                                                            sx: {
                                                                                                position: "absolute",
                                                                                                right: "-2px",
                                                                                                transform: "rotate(90deg)"
                                                                                            }
                                                                                        }),
                                                                                        ((ref1 = filters.sort) === null || ref1 === void 0 ? void 0 : ref1.price) === "asc" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightAlt/* default */.Z, {
                                                                                            sx: {
                                                                                                position: "absolute",
                                                                                                right: "-2px",
                                                                                                transform: "rotate(-90deg)"
                                                                                            }
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                                                                title: "Sort alphabetically by destination name",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconButton_IconButton/* default */.Z, {
                                                                                    color: "inherit",
                                                                                    type: "reset",
                                                                                    onClick: function() {
                                                                                        var ref, ref1, ref2;
                                                                                        if (((ref = filters.sort) === null || ref === void 0 ? void 0 : ref.destination) === "desc") {
                                                                                            setFieldValue("sort", {
                                                                                                destination: "asc"
                                                                                            });
                                                                                        }
                                                                                        if (((ref1 = filters.sort) === null || ref1 === void 0 ? void 0 : ref1.destination) === "asc") {
                                                                                            setFieldValue("sort", {
                                                                                                destination: null
                                                                                            });
                                                                                        }
                                                                                        if (!((ref2 = filters.sort) === null || ref2 === void 0 ? void 0 : ref2.destination)) {
                                                                                            setFieldValue("sort", {
                                                                                                destination: "desc"
                                                                                            });
                                                                                        }
                                                                                    },
                                                                                    "aria-label": "clear",
                                                                                    sx: {
                                                                                        border: "1px solid rgba(0, 0, 0, 0.23)",
                                                                                        borderRadius: "50%",
                                                                                        color: "#0A0A0A",
                                                                                        width: "56px",
                                                                                        height: "56px",
                                                                                        marginRight: "1rem",
                                                                                        backgroundColor: "#fff"
                                                                                    },
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SortByAlpha/* default */.Z, {}),
                                                                                        ((ref2 = filters.sort) === null || ref2 === void 0 ? void 0 : ref2.destination) === "desc" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightAlt/* default */.Z, {
                                                                                            sx: {
                                                                                                position: "absolute",
                                                                                                right: "-2px",
                                                                                                transform: "rotate(90deg)"
                                                                                            }
                                                                                        }),
                                                                                        ((ref3 = filters.sort) === null || ref3 === void 0 ? void 0 : ref3.destination) === "asc" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightAlt/* default */.Z, {
                                                                                            sx: {
                                                                                                position: "absolute",
                                                                                                right: "-2px",
                                                                                                transform: "rotate(-90deg)"
                                                                                            }
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            })
                                                                        ]
                                                                    }),
                                                                    Object.keys(filters).some(function(key) {
                                                                        return filters[key] !== defaultFilters[key];
                                                                    }) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                                                        title: "Reset filters",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                                                                            color: "inherit",
                                                                            type: "reset",
                                                                            onClick: function() {
                                                                                resetForm({
                                                                                    values: defaultFilters
                                                                                });
                                                                                setFilters({
                                                                                    resetFilters: true
                                                                                });
                                                                            },
                                                                            "aria-label": "clear",
                                                                            sx: {
                                                                                border: "1px solid rgba(0, 0, 0, 0.23)",
                                                                                borderRadius: "50%",
                                                                                color: "#0a0a0a",
                                                                                width: "56px",
                                                                                backgroundColor: "#fff"
                                                                            },
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        });
                                                    }
                                                })
                                            })
                                        ]
                                    }),
                                    (userStore === null || userStore === void 0 ? void 0 : userStore.country) && (countryOffers === null || countryOffers === void 0 ? void 0 : countryOffers.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(OffersListSection, {
                                        offers: countryOffers,
                                        searchSource: "Offer",
                                        type: "card"
                                    }),
                                    !countryOffers.length && Object.keys(filters).some(function(key) {
                                        return filters[key] !== defaultFilters[key];
                                    }) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (OfferPage_module_default()).noOffers,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                className: "font-libre",
                                                children: "No offers available for your filters"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Please change or reset you filters to view more offers"
                                            })
                                        ]
                                    }),
                                    !((ref3 = article.offers) === null || ref3 === void 0 ? void 0 : ref3.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (OfferPage_module_default()).noOffers,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                className: "font-libre",
                                                children: "No offers currently available"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "You could check other airlines offer pages or come back later"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/offers",
                                                className: "font-libre",
                                                children: "Check all offer pages"
                                            })
                                        ]
                                    }),
                                    ((ref4 = article.offers) === null || ref4 === void 0 ? void 0 : ref4.length) > 0 && !(countryOffers === null || countryOffers === void 0 ? void 0 : countryOffers.length) && Object.keys(filters).every(function(key) {
                                        return filters[key] === defaultFilters[key];
                                    }) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (OfferPage_module_default()).noOffers,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                className: "font-libre",
                                                children: "No offers available for your country"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Please select another country or view all offers"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                                color: "secondary",
                                                variant: "contained",
                                                type: "button",
                                                sx: {
                                                    borderRadius: "4px",
                                                    marginLeft: "0.5rem",
                                                    color: "#ffffff",
                                                    minWidth: "140px",
                                                    backgroundColor: "#0a0a0a",
                                                    "&:hover": {
                                                        color: "#ffffff",
                                                        backgroundColor: "#0a0a0a"
                                                    }
                                                },
                                                onClick: function(evt) {
                                                    setCountryOffers((0,_to_consumable_array/* default */.Z)(article.offers));
                                                    setOrigins(Array.from(new Set(article.offers.map(function(offer) {
                                                        return offer.origin.code;
                                                    }))).map(function(code) {
                                                        return article.offers.find(function(offer) {
                                                            return offer.origin.code === code;
                                                        }).origin;
                                                    }));
                                                    setDestinations(Array.from(new Set(article.offers.map(function(offer) {
                                                        return offer.destination.code;
                                                    }))).map(function(code) {
                                                        return article.offers.find(function(offer) {
                                                            return offer.destination.code === code;
                                                        }).destination;
                                                    }));
                                                    evt.stopPropagation();
                                                },
                                                children: "Show all available offers"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "content",
                                        children: root
                                    })
                                ]
                            }),
                            ((ref5 = article.airlineReviews) === null || ref5 === void 0 ? void 0 : ref5.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "container my-8",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: "Expert Airline Reviews – Fly in Comfort and Style"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: classnames_default()((OfferPage_module_default()).reviewList, "lg:grid lg:grid-cols-2 lg:gap-10"),
                                        children: article.airlineReviews.map(function(review, i) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: classnames_default()((article.airlineReviews.length === 1 || article.airlineReviews.length > 2 && i === article.airlineReviews.length - 1) && (OfferPage_module_default()).halfWidth, (OfferPage_module_default()).review, "mb-3"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewItem/* ReviewItem */.r, {
                                                    type: "Airline",
                                                    review: review,
                                                    url: "/airlines/reviews/".concat(review.textId)
                                                })
                                            }, i);
                                        })
                                    })
                                ]
                            }),
                            article.flightInfo && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()("container my-8", (OfferPage_module_default()).flightInfo),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                        children: [
                                            article.airline.name,
                                            " Flight Information"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                                        type: "application/ld+json",
                                        dangerouslySetInnerHTML: {
                                            __html: JSON.stringify({
                                                "@context": "https://schema.org",
                                                "@type": "WebPage",
                                                "headline": "".concat(article.airline.name, " Flights, Tickets, Offers & Deals | First-Class.com"),
                                                "about": [
                                                    {
                                                        "@type": "Organization",
                                                        "name": "".concat(article.airline.name),
                                                        "sameAs": "https://en.wikipedia.org/wiki/".concat(article.airline.name, "_(airline)")
                                                    },
                                                    {
                                                        "@type": "Thing",
                                                        "name": "Flights",
                                                        "sameAs": "https://en.wikipedia.org/wiki/Flight"
                                                    },
                                                    {
                                                        "@type": "Thing",
                                                        "name": "Tickets",
                                                        "sameAs": "https://en.wikipedia.org/wiki/Ticket_(admission)"
                                                    },
                                                    {
                                                        "@type": "Thing",
                                                        "name": "Deals",
                                                        "sameAs": "https://en.wikipedia.org/wiki/Financial_transaction"
                                                    },
                                                    {
                                                        "@type": "Thing",
                                                        "name": "Airline",
                                                        "sameAs": "https://en.wikipedia.org/wiki/Airline"
                                                    },
                                                    {
                                                        "@type": "Thing",
                                                        "name": "Business Class",
                                                        "sameAs": "https://en.wikipedia.org/wiki/Business_class"
                                                    },
                                                    {
                                                        "@type": "Thing",
                                                        "name": "Premium Economy",
                                                        "sameAs": "https://en.wikipedia.org/wiki/Premium_economy"
                                                    },
                                                    {
                                                        "@type": "Thing",
                                                        "name": "Discount",
                                                        "sameAs": "https://en.wikipedia.org/wiki/Discounts_and_allowances"
                                                    },
                                                    {
                                                        "@type": "Thing",
                                                        "name": "International Travel",
                                                        "sameAs": "https://en.wikipedia.org/wiki/Travel"
                                                    }
                                                ],
                                                "mentions": [
                                                    {
                                                        "@type": "Thing",
                                                        "name": "Compare",
                                                        "sameAs": "https://en.wikipedia.org/wiki/Comparison"
                                                    },
                                                    {
                                                        "@type": "Thing",
                                                        "name": "Price",
                                                        "sameAs": "https://en.wikipedia.org/wiki/Price"
                                                    }
                                                ],
                                                "mainEntity": [
                                                    {
                                                        "@type": "Airline",
                                                        "name": "".concat(article.airline.name),
                                                        "iataCode": "".concat(article.airline.code),
                                                        "sameAs": "https://en.wikipedia.org/wiki/Emirates_(airline)"
                                                    }
                                                ]
                                            })
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "grid grid-cols-2 lg:grid-cols-3 gap-4",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: classnames_default()((OfferPage_module_default()).flightInfoItem),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalOffer/* default */.Z, {
                                                        fontSize: "medium"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "Best flight deal"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: article.flightInfo.bestFlightDeal
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: classnames_default()((OfferPage_module_default()).flightInfoItem),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Event/* default */.Z, {
                                                        fontSize: "medium"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "Cheapest month to fly"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: article.flightInfo.cheapestMonth
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: classnames_default()((OfferPage_module_default()).flightInfoItem),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Place/* default */.Z, {
                                                        fontSize: "medium"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "Destinations"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: article.flightInfo.destinations
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: classnames_default()((OfferPage_module_default()).flightInfoItem),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalAirport/* default */.Z, {
                                                        fontSize: "medium"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "Most popular airport"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: article.flightInfo.mostPopularAirport
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: classnames_default()((OfferPage_module_default()).flightInfoItem),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectingAirports/* default */.Z, {
                                                        fontSize: "medium"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "Average flights per week"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: article.flightInfo.flightsPerWeek
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            article.airlineInfo && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()("container my-8", (OfferPage_module_default()).flightInfo),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                        children: [
                                            "How to Find the Cheapest ",
                                            article.airline.name,
                                            " Flights"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "w-full",
                                        children: [
                                            "Smart ways to secure the best ",
                                            article.airline.name,
                                            " flight prices:"
                                        ]
                                    }),
                                    Object.entries(article.airlineInfo).map(function(param) {
                                        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                key === "bookHotels" && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    className: "mt-8",
                                                    children: "Enhance Your Travel Experience"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex w-full",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "mr-4",
                                                            children: getAirlineInfoIcon(key)
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "w-full",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                    className: "font-libre text-left text-xl w-full font-semibold",
                                                                    children: value.header
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "w-full px-0",
                                                                    dangerouslySetInnerHTML: {
                                                                        __html: value.content
                                                                    }
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, key);
                                    })
                                ]
                            }),
                            !!((ref6 = article.faq) === null || ref6 === void 0 ? void 0 : ref6.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "container flex flex-col justify-center items-center sm:w-full mb-8",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                                        type: "application/ld+json",
                                        dangerouslySetInnerHTML: {
                                            __html: JSON.stringify({
                                                "@context": "https://schema.org",
                                                "@type": "FAQPage",
                                                "mainEntity": article.faq.map(function(faq) {
                                                    return {
                                                        "@type": "Question",
                                                        "name": faq.question,
                                                        "acceptedAnswer": {
                                                            "@type": "Answer",
                                                            "text": [
                                                                faq.answer
                                                            ]
                                                        }
                                                    };
                                                })
                                            })
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: "Frequently Asked Questions"
                                    }),
                                    article.faq.map(function(faq) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollableContent_ScrollableContent["default"], {
                                            heading: faq.question,
                                            content: faq.answer,
                                            style: (OfferPage_module_default()).scrollableContent
                                        }, faq.question);
                                    })
                                ]
                            }),
                            article.otherAirlines && article.otherAirlines.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "container flex flex-col justify-center items-center sm:w-full mb-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: "Other Popular Airlines"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex flex-wrap justify-center items-center bg-white p-4",
                                        children: article.otherAirlines.map(function(item) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/offers/" + item.textId,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                    className: "flex flex-col justify-center items-center p-2 cursor-pointer",
                                                    "aria-label": item.airline.name,
                                                    role: "link",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            src: "https://media.first-class.com/" + item.image.replace("/", ""),
                                                            alt: item.name,
                                                            width: 30,
                                                            height: 30
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: item.airline.name
                                                        })
                                                    ]
                                                })
                                            }, item.code);
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            userStore && !userStore.userid && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_intersection_observer_m/* InView */.df, {
                triggerOnce: true,
                children: function(param) {
                    var inView = param.inView, ref = param.ref;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                        ref: ref,
                        className: "w-full mx-auto my-20 sm:mb-10",
                        children: inView && /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferPage_CallToSignUp, {
                            country: userStore === null || userStore === void 0 ? void 0 : userStore.country,
                            authCompleted: authCompleted,
                            sourcePage: "Article"
                        })
                    });
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container flex justify-center items-center sm:w-full mt-16",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferPage_RecommendationsList, {
                    items: recommendation
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/index.js




























/***/ }),

/***/ 5937:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ getTextEditorParseOptions; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(52875);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var html_react_parser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25935);
/* harmony import */ var _ScrollableContent_ScrollableContent__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55542);
/* harmony import */ var _HotelReview_components_BookNow__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17518);
/* harmony import */ var _utils_setImageUrl__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22670);
/* harmony import */ var _Carousel_Carousel__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30948);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_5__);









var getTextEditorParseOptions = function(param) {
    var article = param.article, mediaWidth = param.mediaWidth, mediaHeight = param.mediaHeight, imageRef = param.imageRef, styles = param.styles;
    var options = {
        replace: function(domNode) {
            var ref, ref1, ref2;
            if (domNode.type === "tag" && domNode.name === "a") {
                var ref3, ref4;
                if ((ref3 = domNode.attribs) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.href) === null || ref4 === void 0 ? void 0 : ref4.includes("http")) {
                    var ref5, ref6, ref7;
                    if (((ref5 = domNode.attribs) === null || ref5 === void 0 ? void 0 : ref5.target) === "_blank") {
                        domNode.attribs.target = "_blank";
                    }
                    if ((ref6 = domNode.attribs) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.rel) === null || ref7 === void 0 ? void 0 : ref7.includes("sponsored")) {
                        domNode.attribs.rel = "noreferrer noopener sponsored";
                    } else {
                        domNode.attribs.rel = "noreferrer noopener nofollow";
                    }
                }
            }
            if (domNode.type === "tag" && domNode.attribs.class === "image-inline" && domNode.children[0].name === "video") {
                var videoSrc = domNode.children[0].children.find(function(node) {
                    return node.name === "source";
                }).attribs.src;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "video",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                        autoPlay: true,
                        muted: true,
                        loop: true,
                        style: {
                            height: mediaHeight,
                            width: mediaWidth
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                            src: videoSrc
                        })
                    })
                });
            }
            if (domNode.type === "tag" && domNode.name === "video" && !!domNode.attribs.src) {
                var ref8, ref9;
                var videoSrc1 = "https://media.first-class.com/" + domNode.attribs.src.replace("/", "");
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                    autoPlay: true,
                    muted: true,
                    loop: true,
                    style: {
                        height: (imageRef === null || imageRef === void 0 ? void 0 : (ref8 = imageRef.current) === null || ref8 === void 0 ? void 0 : ref8.offsetWidth) / 1.78,
                        width: imageRef === null || imageRef === void 0 ? void 0 : (ref9 = imageRef.current) === null || ref9 === void 0 ? void 0 : ref9.offsetWidth
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                        src: videoSrc1
                    })
                });
            }
            var findVideoNode = function(domNode) {
                if (!domNode) return null;
                if (domNode.name === "video") {
                    return domNode;
                } else {
                    return findVideoNode(domNode.children.find(function(node) {
                        return node.type === "tag";
                    }));
                }
            };
            var findImageNode = function(domNode) {
                if (domNode) {
                    if (domNode.name === "img") {
                        return domNode;
                    } else {
                        var figureNode = domNode.children.find(function(node) {
                            return node.name === "figure";
                        });
                        if (figureNode) {
                            return findImageNode(figureNode);
                        } else {
                            return findImageNode(domNode.children.find(function(node) {
                                return node.type === "tag";
                            }));
                        }
                    }
                } else {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        children: "Wrong tag"
                    });
                }
            };
            if (domNode.name === "div" && domNode.attribs.id === "scrollable" && domNode.children[0].name !== "details") {
                var heading;
                var findHeading = function(nodes) {
                    if (nodes.length) {
                        nodes.forEach(function(node) {
                            var ref, ref1;
                            if (((ref = node.attribs) === null || ref === void 0 ? void 0 : ref.id) === "heading") {
                                heading = [
                                    node
                                ];
                            } else if ((ref1 = node.children) === null || ref1 === void 0 ? void 0 : ref1.length) {
                                findHeading(node.children);
                            }
                        });
                    }
                };
                findHeading(domNode.children);
                var content = domNode.children.filter(function(node) {
                    var ref;
                    return ((ref = node.attribs) === null || ref === void 0 ? void 0 : ref.id) !== "heading";
                });
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ScrollableContent_ScrollableContent__WEBPACK_IMPORTED_MODULE_2__["default"], {
                    heading: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_1__/* .domToReact */ .du)(heading, options),
                    content: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_1__/* .domToReact */ .du)(content, options),
                    style: styles.scrollableContent
                });
            }
            if (domNode.name === "details") {
                var heading1;
                var findHeading1 = function(nodes) {
                    if (nodes.length) {
                        nodes.forEach(function(node) {
                            var ref;
                            if (node.name === "summary") {
                                heading1 = [
                                    node.children[0]
                                ];
                            } else if ((ref = node.children) === null || ref === void 0 ? void 0 : ref.length) {
                                findHeading1(node.children);
                            }
                        });
                    }
                };
                findHeading1(domNode.children);
                var content1 = domNode.children.filter(function(node) {
                    return node.attribs.class === "accordion_content";
                });
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ScrollableContent_ScrollableContent__WEBPACK_IMPORTED_MODULE_2__["default"], {
                    heading: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_1__/* .domToReact */ .du)(heading1, options),
                    content: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_1__/* .domToReact */ .du)(content1, options),
                    style: styles.scrollableContent
                });
            }
            if (domNode.type === "tag" && domNode.name === "div" && ((ref = domNode.attribs.class) === null || ref === void 0 ? void 0 : ref.includes("bookNow_content"))) {
                var findDomNodeData = function(node) {
                    if (node.data) {
                        return node.data;
                    }
                    return node.children.map(function(n) {
                        return findDomNodeData(n);
                    }).flat();
                };
                var data = findDomNodeData(domNode);
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_HotelReview_components_BookNow__WEBPACK_IMPORTED_MODULE_3__/* .BookNow */ .U, {
                    hotelName: data[0],
                    link: data[1]
                });
            }
            if (domNode.type === "tag" && domNode.name === "div" && ((ref1 = domNode.attribs.class) === null || ref1 === void 0 ? void 0 : ref1.includes("cta"))) {
                var ref10;
                var cleanContentEditable = function(node) {
                    var ref, ref1;
                    if (node.attribs && node.attribs.contenteditable !== undefined) {
                        delete node.attribs.contenteditable;
                    }
                    if (node.attribs && ((ref = node.attribs.class) === null || ref === void 0 ? void 0 : ref.includes("ck-widget"))) {
                        node.attribs.class = node.attribs.class.replace("ck-widget", "");
                    }
                    if (node.attribs && ((ref1 = node.attribs.class) === null || ref1 === void 0 ? void 0 : ref1.includes("ck-editor__editable ck-editor__nested-editable"))) {
                        node.attribs.class = node.attribs.class.replace("ck-editor__editable ck-editor__nested-editable", "");
                    }
                    if (node.children) {
                        node.children.forEach(cleanContentEditable);
                    }
                    return node;
                };
                var cleanedNode = cleanContentEditable(domNode);
                var header = cleanedNode.children.find(function(child) {
                    var ref;
                    return (ref = child.attribs) === null || ref === void 0 ? void 0 : ref.class.includes("cta-header");
                });
                var subheader = cleanedNode.children.find(function(child) {
                    var ref;
                    return (ref = child.attribs) === null || ref === void 0 ? void 0 : ref.class.includes("cta-subheader");
                });
                var button = cleanedNode.children.find(function(child) {
                    var ref;
                    return (ref = child.attribs) === null || ref === void 0 ? void 0 : ref.class.includes("cta-button");
                });
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: styles.cta,
                    children: [
                        (header === null || header === void 0 ? void 0 : header.children[0].data) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            className: styles.ctaHeader,
                            children: header === null || header === void 0 ? void 0 : header.children[0].data
                        }),
                        (subheader === null || subheader === void 0 ? void 0 : subheader.children[0].data) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: styles.ctaSubheader,
                            children: subheader === null || subheader === void 0 ? void 0 : subheader.children[0].data
                        }),
                        (button === null || button === void 0 ? void 0 : button.children[0].data) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: button === null || button === void 0 ? void 0 : (ref10 = button.attribs) === null || ref10 === void 0 ? void 0 : ref10.href,
                            className: styles.ctaButton,
                            children: button === null || button === void 0 ? void 0 : button.children[0].data
                        })
                    ]
                });
            }
            if (domNode.type === "tag" && domNode.name === "p" && domNode.children[0].name === "iframe") {
                delete domNode.children[0].attribs.height;
                delete domNode.children[0].attribs.width;
                delete domNode.children[0].attribs.allowfullscreen;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: styles.youtubeIframe,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, domNode.children[0].attribs))
                });
            }
            if (domNode.type === "tag" && domNode.name === "div" && (domNode.attribs.class === "image-carousel-inline-large" || ((ref2 = domNode.attribs.class) === null || ref2 === void 0 ? void 0 : ref2.includes("carousel_content")))) {
                var carouselImages = [];
                domNode.children.forEach(function(child, index) {
                    if (child.attribs && (child.attribs.class === "image-inline" || child.attribs.class === "image" || child.attribs.class === "image-style-side")) {
                        var figcaption = child.children.find(function(node) {
                            return node.name === "figcaption";
                        });
                        carouselImages.push({
                            src: findImageNode(child).attribs.src,
                            figcaption: !!(figcaption === null || figcaption === void 0 ? void 0 : figcaption.children.length) && figcaption.children[0],
                            alt: child.children[0].attribs.alt || "".concat(article.title, " - ").concat(index)
                        });
                    }
                });
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: styles.carouselWrapper,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Carousel_Carousel__WEBPACK_IMPORTED_MODULE_4__/* .BCCarousel */ .M, {
                        children: carouselImages.map(function(img, index) {
                            var ref, ref1;
                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                ref: imageRef,
                                className: styles.imageInline,
                                style: {
                                    height: mediaHeight
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("figure", {
                                    className: "image-inline",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_5___default()), {
                                            src: (0,_utils_setImageUrl__WEBPACK_IMPORTED_MODULE_7__/* .setImageUrl */ .B)(img.src),
                                            alt: img.alt,
                                            blurDataURL: index && !((ref = img.src) === null || ref === void 0 ? void 0 : ref.includes("/_next/image")) ? "/_next/image?url=".concat((0,_utils_setImageUrl__WEBPACK_IMPORTED_MODULE_7__/* .setImageUrl */ .B)(img.src), "&w=16&q=1") : null,
                                            layout: "fill",
                                            objectFit: "cover",
                                            placeholder: index && !((ref1 = img.src) === null || ref1 === void 0 ? void 0 : ref1.includes("/_next/image")) ? "blur" : null
                                        }),
                                        img.figcaption && img.figcaption.children && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("figcaption", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, img.figcaption.attribs), {
                                                rel: "nofollow",
                                                className: styles.carouselLink,
                                                children: img.figcaption.children[0].data
                                            }))
                                        }),
                                        img.figcaption && img.figcaption.type === "text" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("figcaption", {
                                            children: img.figcaption.data
                                        })
                                    ]
                                })
                            }, img.src);
                        })
                    })
                });
            }
            if (domNode.type === "tag" && domNode.name === "figure" && (domNode.attribs.class === "image-inline" || domNode.attribs.class === "image")) {
                var ref11;
                var video = findVideoNode(domNode);
                if (video) {
                    var videoSrc2 = "https://media.first-class.com/" + video.children.find(function(node) {
                        return node.name === "source";
                    }).attribs.src.replace("/", "");
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "video",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                            autoPlay: true,
                            muted: true,
                            loop: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                                src: videoSrc2
                            })
                        })
                    });
                }
                var image = findImageNode(domNode);
                var figcaption = domNode.children.find(function(node) {
                    return node.name === "figcaption";
                });
                return !image.name ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        ref: imageRef,
                        className: styles.imageInline,
                        style: {
                            height: mediaHeight
                        },
                        children: [
                            image.name === "img" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("figure", {
                                className: "image-inline",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_5___default()), {
                                        src: (0,_utils_setImageUrl__WEBPACK_IMPORTED_MODULE_7__/* .setImageUrl */ .B)(image.attribs.src),
                                        alt: image.attribs.alt || "".concat(article.type, " ").concat(article.subtype, " - ").concat(article.title),
                                        layout: "fill",
                                        objectFit: "cover"
                                    }),
                                    (figcaption === null || figcaption === void 0 ? void 0 : figcaption.children[0]) && (figcaption === null || figcaption === void 0 ? void 0 : figcaption.children[0].name) === "a" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("figcaption", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, figcaption.children[0].attribs), {
                                            className: styles.carouselLink,
                                            rel: "noreferrer noopener nofollow",
                                            children: figcaption.children[0].children[0].data
                                        }))
                                    }),
                                    (figcaption === null || figcaption === void 0 ? void 0 : figcaption.children[0]) && figcaption.name === "figcaption" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("figcaption", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: styles.carouselLink,
                                            children: figcaption.children[0].data
                                        })
                                    })
                                ]
                            }),
                            (image === null || image === void 0 ? void 0 : (ref11 = image.parent) === null || ref11 === void 0 ? void 0 : ref11.name) === "a" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, image.parent.attribs), {
                                rel: "noreferrer noopener nofollow",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("figure", {
                                    className: "image-inline",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_5___default()), {
                                            src: (0,_utils_setImageUrl__WEBPACK_IMPORTED_MODULE_7__/* .setImageUrl */ .B)(image.attribs.src),
                                            layout: "fill",
                                            objectFit: "cover"
                                        }),
                                        (figcaption === null || figcaption === void 0 ? void 0 : figcaption.children[0]) && (figcaption === null || figcaption === void 0 ? void 0 : figcaption.children[0].name) === "a" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("figcaption", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                                                rel: "noreferrer noopener nofollow"
                                            }, figcaption.children[0].attribs), {
                                                className: styles.carouselLink,
                                                children: figcaption.children[0].children[0].data
                                            }))
                                        }),
                                        !!(figcaption === null || figcaption === void 0 ? void 0 : figcaption.children.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("figcaption", {
                                            children: figcaption.children[0].data
                                        })
                                    ]
                                })
                            }))
                        ]
                    })
                });
            }
        }
    };
    return options;
};


/***/ }),

/***/ 91110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ COUNTRIES; },
/* harmony export */   "p": function() { return /* binding */ USAStates; }
/* harmony export */ });
var COUNTRIES = {
    AR: "Argentina",
    AT: "Austria",
    AU: "Australia",
    BE: "Belgium",
    BO: "Bolivia",
    BR: "Brazil",
    CA: "Canada",
    CL: "Chile",
    CO: "Colombia",
    CR: "Costa Rica",
    CZ: "Czechia",
    DK: "Denmark",
    DO: "Dominican Republic",
    EC: "Ecuador",
    SV: "El Salvador",
    FI: "Finland",
    FR: "France",
    DE: "Germany",
    GR: "Greece",
    GT: "Guatemala",
    HK: "Hong Kong",
    HN: "Honduras",
    ID: "Indonesia",
    IE: "Ireland",
    IL: "Israel",
    IN: "India",
    IT: "Italia",
    JP: "Japan",
    MX: "M\xe9xico",
    MY: "Malaysia",
    NI: "Nicaragua",
    NL: "Netherlands",
    NO: "Norway",
    NZ: "New Zealand",
    PA: "Panama",
    PE: "Peru",
    PH: "Philippines",
    PL: "Poland",
    PR: "Puerto Rico",
    PT: "Portugal",
    PY: "Paraguay",
    QA: "Qatar",
    RO: "Romania",
    SA: "Saudi Arabia",
    SG: "Singapore",
    ZA: "South Africa",
    KR: "South Korea",
    ES: "Spain",
    SE: "Sweden",
    CH: "Switzerland",
    TH: "Thailand",
    TR: "Turkey",
    TW: "Taiwan",
    UA: "Ukraine",
    AE: "United Arab Emirates",
    GB: "United Kingdom",
    US: "United States",
    UY: "Uruguay",
    VN: "Vietnam"
};
var USAStates = [
    {
        code: "AL",
        label: "Alabama"
    },
    {
        code: "AK",
        label: "Alaska"
    },
    {
        code: "AZ",
        label: "Arizona"
    },
    {
        code: "AR",
        label: "Arkansas"
    },
    {
        code: "CA",
        label: "California"
    },
    {
        code: "CO",
        label: "Colorado"
    },
    {
        code: "CT",
        label: "Connecticut"
    },
    {
        code: "DE",
        label: "Delaware"
    },
    {
        code: "FL",
        label: "Florida"
    },
    {
        code: "GA",
        label: "Georgia"
    },
    {
        code: "HI",
        label: "Hawaii"
    },
    {
        code: "ID",
        label: "Idaho"
    },
    {
        code: "IL",
        label: "Illinois"
    },
    {
        code: "IN",
        label: "Indiana"
    },
    {
        code: "IA",
        label: "Iowa"
    },
    {
        code: "KS",
        label: "Kansas"
    },
    {
        code: "KY",
        label: "Kentucky"
    },
    {
        code: "LA",
        label: "Louisiana"
    },
    {
        code: "ME",
        label: "Maine"
    },
    {
        code: "MD",
        label: "Maryland"
    },
    {
        code: "MA",
        label: "Massachusetts"
    },
    {
        code: "MI",
        label: "Michigan"
    },
    {
        code: "MN",
        label: "Minnesota"
    },
    {
        code: "MS",
        label: "Mississippi"
    },
    {
        code: "MO",
        label: "Missouri"
    },
    {
        code: "MT",
        label: "Montana"
    },
    {
        code: "NE",
        label: "Nebraska"
    },
    {
        code: "NV",
        label: "Nevada"
    },
    {
        code: "NH",
        label: "New Hampshire"
    },
    {
        code: "NJ",
        label: "New Jersey"
    },
    {
        code: "NM",
        label: "New Mexico"
    },
    {
        code: "NY",
        label: "New York"
    },
    {
        code: "NC",
        label: "North Carolina"
    },
    {
        code: "ND",
        label: "North Dakota"
    },
    {
        code: "OH",
        label: "Ohio"
    },
    {
        code: "OK",
        label: "Oklahoma"
    },
    {
        code: "OR",
        label: "Oregon"
    },
    {
        code: "PA",
        label: "Pennsylvania"
    },
    {
        code: "RI",
        label: "Rhode Island"
    },
    {
        code: "SC",
        label: "South Carolina"
    },
    {
        code: "SD",
        label: "South Dakota"
    },
    {
        code: "TN",
        label: "Tennessee"
    },
    {
        code: "TX",
        label: "Texas"
    },
    {
        code: "UT",
        label: "Utah"
    },
    {
        code: "VT",
        label: "Vermont"
    },
    {
        code: "VA",
        label: "Virginia"
    },
    {
        code: "WA",
        label: "Washington"
    },
    {
        code: "WV",
        label: "West Virginia"
    },
    {
        code: "WI",
        label: "Wisconsin"
    },
    {
        code: "WY",
        label: "Wyoming"
    }, 
];


/***/ }),

/***/ 90193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ DEALS_COUNTRIES; }
/* harmony export */ });
/* unused harmony export BC_ONLY_DEAL_COUNTRIES */
var DEALS_COUNTRIES = [
    "NO",
    "AU",
    "GB",
    "SE",
    "US"
];
var BC_ONLY_DEAL_COUNTRIES = (/* unused pure expression or super */ null && ([
    "SE",
    "US"
]));


/***/ }),

/***/ 74907:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "dZ": function() { return /* reexport */ CONTACT_INFO; },
  "od": function() { return /* reexport */ countries/* COUNTRIES */.o; },
  "wA": function() { return /* reexport */ CURRENCY; },
  "Yc": function() { return /* reexport */ dealsCountries/* DEALS_COUNTRIES */.Y; }
});

;// CONCATENATED MODULE: ./config/currency.js
var CURRENCY = {
    AED: "AED",
    ARS: "ARS",
    AUD: "AUD",
    BOB: "BOB",
    BRL: "BRL",
    CAD: "CAD",
    CHF: "CHF",
    CLP: "CLP",
    COP: "COP",
    CRC: "CRC",
    CZK: "CZK",
    DKK: "DKK",
    DOP: "DOP",
    EUR: "EUR",
    GBP: "GBP",
    GTQ: "GTQ",
    HKD: "HKD",
    HNL: "HNL",
    IDR: "IDR",
    ILS: "ILS",
    INR: "INR",
    JPY: "JPY",
    KRW: "KRW",
    MXN: "MXN",
    MYR: "MYR",
    NIO: "NIO",
    NOK: "NOK",
    NZD: "NZD",
    PEN: "PEN",
    PHP: "PHP",
    PLN: "PLN",
    PYG: "PYG",
    QAR: "QAR",
    SAR: "SAR",
    SEK: "SEK",
    SGD: "SGD",
    THB: "THB",
    TRY: "TRY",
    TWD: "TWD",
    UAH: "UAH",
    USD: "USD",
    UYU: "UYU",
    VND: "VND",
    ZAR: "ZAR"
};

// EXTERNAL MODULE: ./config/countries.js
var countries = __webpack_require__(91110);
;// CONCATENATED MODULE: ./config/contactInfo.js
var CONTACT_INFO = {
    US: "+1 786 405 85 11",
    GB: "+44 203 455 03 90",
    AU: "+61 290 617 019",
    CA: "+1 647 956 0177",
    IN: "+911 171 279 371",
    NO: "+47 219 361 10",
    SE: "+46 8 525 099 29",
    DK: "+45 32 46 30 40"
};

// EXTERNAL MODULE: ./config/dealsCountries.js
var dealsCountries = __webpack_require__(90193);
;// CONCATENATED MODULE: ./config/index.js






/***/ }),

/***/ 22670:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ setImageUrl; }
/* harmony export */ });
var setImageUrl = function(url) {
    var mainImageUrl = url === null || url === void 0 ? void 0 : url.replace("/view/image/", "");
    if (mainImageUrl === null || mainImageUrl === void 0 ? void 0 : mainImageUrl.startsWith("/")) {
        mainImageUrl = mainImageUrl.replace("/", "");
    }
    return "https://media.first-class.com/" + mainImageUrl;
};


/***/ }),

/***/ 20569:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ usePrevious; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function usePrevious(value) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        ref.current = value;
    });
    return ref.current;
}


/***/ }),

/***/ 87753:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"menu":"Header_menu__NFNIm","headerContentContainer":"Header_headerContentContainer__Z4OaV","developmentBanner":"Header_developmentBanner__l4RZJ","transparentHeader":"Header_transparentHeader__7f4Sn","hidden":"Header_hidden__gvTIr","header":"Header_header__COhW3","searchContainer":"Header_searchContainer__0oHSr","loginButton":"Header_loginButton__IVLcz","navItem":"Header_navItem__Xjqzr","searchIcon":"Header_searchIcon__60wZB","darkSearchIcon":"Header_darkSearchIcon__icBw7","darkFont":"Header_darkFont__v16bG","closeDialog":"Header_closeDialog__pL24S"};

/***/ }),

/***/ 11980:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"accordionTitle":"MobileHeader_accordionTitle__UBV21","searchContainer":"MobileHeader_searchContainer__WUeVl","menuContainer":"MobileHeader_menuContainer__oAVaC"};

/***/ }),

/***/ 23503:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"top":"About_top__S5Vlq","content":"About_content__dY8RO","hide":"About_hide__5dpNW","show":"About_show__Ntlw8","avatar":"About_avatar__q_K0b","welcome":"About_welcome__6I6vT"};

/***/ }),

/***/ 58471:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"flag32":"Accordion_flag32__V6oZM","itemChild":"Accordion_itemChild__LtomW"};

/***/ }),

/***/ 40889:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"option":"AirlineAutocomplete_option__G6AfC"};

/***/ }),

/***/ 54510:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"topContainer":"Article_topContainer__kiGCI","carouselWrapper":"Article_carouselWrapper__gjkk5","imageInline":"Article_imageInline__5eSOV","scrollableContent":"Article_scrollableContent__cdEOc","content":"Article_content__LQLtv","authorizedContentContainer":"Article_authorizedContentContainer__z1iKF","gradientContainer":"Article_gradientContainer__Zy1fo","authorizedContentText":"Article_authorizedContentText__DdZpb","article":"Article_article__J1KYI","overline":"Article_overline__AbHuP","title":"Article_title___TC6d","authorBioContainer":"Article_authorBioContainer__zJg7i","articleMeta":"Article_articleMeta__uREN7","carouselLink":"Article_carouselLink__EX1M9","youtubeIframe":"Article_youtubeIframe__ZUKhn","mainImage":"Article_mainImage__zFJRg","flightSearch":"Article_flightSearch__11nbr","cta":"Article_cta__uM0MY","ctaHeader":"Article_ctaHeader__B4wio","ctaSubheader":"Article_ctaSubheader__Me0tn","ctaButton":"Article_ctaButton__oarqw"};

/***/ }),

/***/ 25258:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"subtitleMb":"AuthorBlock_subtitleMb__FicB5","subtitle":"AuthorBlock_subtitle__UuzYi","blockWrapper":"AuthorBlock_blockWrapper__4bBqe","userBioImageWrapper":"AuthorBlock_userBioImageWrapper__cRC_r","authorBlockContent":"AuthorBlock_authorBlockContent__fAs5i","authorBlockIcon":"AuthorBlock_authorBlockIcon__g00GB","authorBlockName":"AuthorBlock_authorBlockName__2MyjM","authorBlockOverline":"AuthorBlock_authorBlockOverline__P3EKG","authorBlockText":"AuthorBlock_authorBlockText__OjBax","authorBlockReadMore":"AuthorBlock_authorBlockReadMore__TE9ts"};

/***/ }),

/***/ 42063:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"subtitleMb":"AuthorPopup_subtitleMb__NPVZ6","userBioImageWrapper":"AuthorPopup_userBioImageWrapper__hrmhT","userBioImageLargeWrapper":"AuthorPopup_userBioImageLargeWrapper__fCGih","subtitle":"AuthorPopup_subtitle__3VnG4","authorPopup":"AuthorPopup_authorPopup__9C6ds","authorPopupContent":"AuthorPopup_authorPopupContent__BIWrd","authorPopupIcon":"AuthorPopup_authorPopupIcon__PJEzO","authorPopupName":"AuthorPopup_authorPopupName__DOqfs","authorPopupOverline":"AuthorPopup_authorPopupOverline__I56qb","authorPopupText":"AuthorPopup_authorPopupText__NGeUo","authorPopupReadMore":"AuthorPopup_authorPopupReadMore__8zE2_"};

/***/ }),

/***/ 88766:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"closeDialog":"Carousel_closeDialog___3zQa","fullscreenCarousel":"Carousel_fullscreenCarousel__KauDN","carouselWrapper":"Carousel_carouselWrapper__j2Ytz","dialogPaper":"Carousel_dialogPaper__LZweQ"};

/***/ }),

/***/ 38351:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bcReviewScores":"CircleRating_bcReviewScores__SllFn","user-review":"CircleRating_user-review__vfQg_","user-rating":"CircleRating_user-rating__jg9uH","tooltipHandler":"CircleRating_tooltipHandler__fS6v3","user10":"CircleRating_user10__JnP6b","user9":"CircleRating_user9__E6NpH","user8":"CircleRating_user8__1l07j","user7":"CircleRating_user7__9ubwI","user6":"CircleRating_user6__RrbmD","user5":"CircleRating_user5__1afve","user4":"CircleRating_user4__vTVi6","user3":"CircleRating_user3__V63uD","user2":"CircleRating_user2__BlkpM","user1":"CircleRating_user1__op7jY"};

/***/ }),

/***/ 55065:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"top":"CookiesPolicy_top__2whFM","content":"CookiesPolicy_content__XN0Wc"};

/***/ }),

/***/ 82117:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"flag32":"CountrySelect_flag32__lJvTQ","card":"CountrySelect_card__xSVjC"};

/***/ }),

/***/ 57842:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card":"DestinationItem_card__J_gyz","imageContainer":"DestinationItem_imageContainer__RjxNp","typesList":"DestinationItem_typesList__H14GX","readMore":"DestinationItem_readMore__JuV1Q","type":"DestinationItem_type__431a_","title":"DestinationItem_title__aBX_f","subTitle":"DestinationItem_subTitle__zQpl6","content":"DestinationItem_content__fgc3c","icon":"DestinationItem_icon__Kh3r7","text":"DestinationItem_text__HCYfO"};

/***/ }),

/***/ 33589:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"listContainer":"DestinationList_listContainer__ipK5d","headingContainer":"DestinationList_headingContainer__5naTE","heading":"DestinationList_heading__2wdqo","list":"DestinationList_list__PKY03","loader":"DestinationList_loader__wkrKc","pulseScaleOut":"DestinationList_pulseScaleOut__8sgdf","recommendationItem":"DestinationList_recommendationItem__glPyX"};

/***/ }),

/***/ 40675:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card":"Dropdown_card__tg0_H","dropDownContainer":"Dropdown_dropDownContainer__cW_W2","dropDownLink":"Dropdown_dropDownLink__S04wX","dropDownLinkLight":"Dropdown_dropDownLinkLight__lbxv4"};

/***/ }),

/***/ 85031:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bookNowWrapper":"BookNow_bookNowWrapper__oVoIu","bookNowHotelName":"BookNow_bookNowHotelName__tiB83"};

/***/ }),

/***/ 69362:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"option":"HotelSearchAutocomplete_option__UUVLl"};

/***/ }),

/***/ 11013:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"listContainer":"Lists_listContainer__zhxBa","emptyList":"Lists_emptyList__PMWJZ","recommendationItem":"Lists_recommendationItem__RbS50","headingContainer":"Lists_headingContainer__iGZfJ","airline":"Lists_airline__F_AV3","airlines":"Lists_airlines__qmZ0c","hotel":"Lists_hotel__dDYqf","hotels":"Lists_hotels__5VQK7","lifestyle":"Lists_lifestyle___OQDX","guides":"Lists_guides__2rfyx","trains":"Lists_trains__amEYp","cruises":"Lists_cruises__cmMAG","airports":"Lists_airports__WaEkv","dining":"Lists_dining__Pgn4U","finest":"Lists_finest__lbAW_","noType":"Lists_noType__UB29W","destinations":"Lists_destinations__84kw3","noReviewsFound":"Lists_noReviewsFound__A_CpZ","heading":"Lists_heading__6374I","airlineIcon":"Lists_airlineIcon__mCQek","icon":"Lists_icon___kXQ7","ratingBadge":"Lists_ratingBadge__FbkHW","list":"Lists_list__3jUgC","review":"Lists_review__TcEv_","header":"Lists_header__tCON9","reviewTitle":"Lists_reviewTitle__v5JX5","reviewContent":"Lists_reviewContent__TGZkV","a":"Lists_a___VyUP","reviewContainer":"Lists_reviewContainer__FOvNJ","reviewImage":"Lists_reviewImage__w8Fyw","reviewContentContainer":"Lists_reviewContentContainer__qso0K","loader":"Lists_loader__Jb886","pulseScaleOut":"Lists_pulseScaleOut__ysSww","filtersContainer":"Lists_filtersContainer__qwSmd","filter":"Lists_filter__WNXdh","filterSmaller":"Lists_filterSmaller__3Azu1","filtersSubmit":"Lists_filtersSubmit__TcvGF","filtersContainerMobile":"Lists_filtersContainerMobile__RMSPh","closeMobileFilters":"Lists_closeMobileFilters__9bpa8","sortingDirectionIcon":"Lists_sortingDirectionIcon__lutVl","mobileFiltersWrapper":"Lists_mobileFiltersWrapper__VMiXO","filtersButton":"Lists_filtersButton__wrB8h","sorting":"Lists_sorting__fXRzO"};

/***/ }),

/***/ 82047:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"offerCard":"OfferCard_offerCard__YxmC3","similarOffers":"OfferCard_similarOffers__wZNpC","bigDiscount":"OfferCard_bigDiscount__RPqvh","offerDiscountTag":"OfferCard_offerDiscountTag__Ilpmv","offerDiscountTagText":"OfferCard_offerDiscountTagText__Ueb59","offerDiscountHot":"OfferCard_offerDiscountHot__p4lLl","airlineLogo":"OfferCard_airlineLogo__XOj1E","offerImage":"OfferCard_offerImage__c9UNz","offerDetailsImageContainer":"OfferCard_offerDetailsImageContainer__JX7pG","offerData":"OfferCard_offerData__UHsXV","offerOverline":"OfferCard_offerOverline__kU0Am","airlineName":"OfferCard_airlineName__Qwj2u","offerPrice":"OfferCard_offerPrice__zqEIU","cardRegularPrice":"OfferCard_cardRegularPrice__Y_SXa","regularPrice":"OfferCard_regularPrice__5AGKW","offerLink":"OfferCard_offerLink__9ERKx","closeDialog":"OfferCard_closeDialog__KEsIV","closeShareDialog":"OfferCard_closeShareDialog__A_uB5","offerDetailsContainer":"OfferCard_offerDetailsContainer__ndgxe","chartContainer":"OfferCard_chartContainer__sz6_r","chartHistoryContainer":"OfferCard_chartHistoryContainer__YVLeG","hint":"OfferCard_hint__mdimr","cardShareIcon":"OfferCard_cardShareIcon__haovx","shareIcon":"OfferCard_shareIcon__E_44A","offerTableItem":"OfferCard_offerTableItem__CWabn","offerName":"OfferCard_offerName__paGbW","offerAirlineImage":"OfferCard_offerAirlineImage__YFX1b","price":"OfferCard_price__lV9ze","fromLabel":"OfferCard_fromLabel__wLsaI","offerDate":"OfferCard_offerDate__FJ2oY","similarOffersCount":"OfferCard_similarOffersCount__GqpWl","chooseDatesHint":"OfferCard_chooseDatesHint__IL83B","noResults":"OfferCard_noResults__PhS6_","loader":"OfferCard_loader__22m5c","pulseScaleOut":"OfferCard_pulseScaleOut__bGk_Z"};

/***/ }),

/***/ 33705:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"topContainer":"OfferPage_topContainer__53u_N","reviewList":"OfferPage_reviewList__bgd1P","review":"OfferPage_review__MzHVv","halfWidth":"OfferPage_halfWidth__sl7GV","carouselWrapper":"OfferPage_carouselWrapper__UPEIe","imageInline":"OfferPage_imageInline__vBn47","scrollableContent":"OfferPage_scrollableContent__rzJWU","content":"OfferPage_content__XiA6Y","article":"OfferPage_article__bqkD4","overline":"OfferPage_overline__R20Pw","title":"OfferPage_title__FJR1c","authorBioContainer":"OfferPage_authorBioContainer__iIL02","articleMeta":"OfferPage_articleMeta__Qyxk6","carouselLink":"OfferPage_carouselLink__CY3Jc","youtubeIframe":"OfferPage_youtubeIframe__1JnVe","mainImage":"OfferPage_mainImage__BgZtD","flightSearch":"OfferPage_flightSearch__TN9pc","cta":"OfferPage_cta__qNlo7","ctaHeader":"OfferPage_ctaHeader__CON9n","ctaSubheader":"OfferPage_ctaSubheader__iNaAB","ctaButton":"OfferPage_ctaButton__BQ4CH","closeDialog":"OfferPage_closeDialog__GDn2s","offerDetailsContainer":"OfferPage_offerDetailsContainer__9RdhY","noOffers":"OfferPage_noOffers__VOMn2","filtersContainer":"OfferPage_filtersContainer__x_nmU","filter":"OfferPage_filter__WH04M","filterSmaller":"OfferPage_filterSmaller__bPd7K","filtersSubmit":"OfferPage_filtersSubmit__twOPN","flightInfo":"OfferPage_flightInfo__2Lwa6","flightInfoItem":"OfferPage_flightInfoItem__XVaP3"};

/***/ }),

/***/ 31549:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"regionFilters":"OffersListSection_regionFilters__3yxsr","regionButton":"OffersListSection_regionButton__rUOPp","noResults":"OffersListSection_noResults__6HmwV"};

/***/ }),

/***/ 95761:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"top":"PrivacyPolicy_top__RSFI6","content":"PrivacyPolicy_content__FRo3Q"};

/***/ }),

/***/ 44361:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressMeterContainer":"ProgressMeter_progressMeterContainer__yrCBm","progressMeterBar":"ProgressMeter_progressMeterBar__tyfxI","progressMeterBarProgress":"ProgressMeter_progressMeterBarProgress__mPhWd","progressMeterLabel":"ProgressMeter_progressMeterLabel__sywKe"};

/***/ }),

/***/ 34221:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card":"RecommendationItem_card__FDoz_","recomendationContainer":"RecommendationItem_recomendationContainer__meg_h","imageContainer":"RecommendationItem_imageContainer__stzty","imageOut":"RecommendationItem_imageOut__QisVW","text":"RecommendationItem_text__Y7tFC","type":"RecommendationItem_type__Uchuf","title":"RecommendationItem_title__Bc3xs","content":"RecommendationItem_content__1VYZL","icon":"RecommendationItem_icon__5_BDH","readMore":"RecommendationItem_readMore__4CCfN"};

/***/ }),

/***/ 39673:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"ScrollableContent_container__zk47z","content":"ScrollableContent_content__fn85q"};

/***/ }),

/***/ 56915:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bcReviewScores":"StarRating_bcReviewScores__DION2","stars0":"StarRating_stars0___dsdC","stars0Small":"StarRating_stars0Small__aqFOR","stars0Inactive":"StarRating_stars0Inactive__kwiRI","stars10":"StarRating_stars10__E1PqL","stars9":"StarRating_stars9__yTqSV","stars8":"StarRating_stars8__DG14n","stars7":"StarRating_stars7__QklJC","stars6":"StarRating_stars6__1rkcD","stars5":"StarRating_stars5__mAZ9O","stars4":"StarRating_stars4__fwxzH","stars3":"StarRating_stars3__8DSYn","stars2":"StarRating_stars2___9FWL","stars1":"StarRating_stars1__Gdwo9"};

/***/ }),

/***/ 46459:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"top":"TermsConditions_top__kto1F","content":"TermsConditions_content__nSqug"};

/***/ }),

/***/ 82857:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"vintageButtonWrapper":"VintageButton_vintageButtonWrapper__wCXqp","heading":"VintageButton_heading__Jtdqa","leftSide":"VintageButton_leftSide__iHOcA","rightSide":"VintageButton_rightSide__FONCl","centre":"VintageButton_centre__AkOFu","dark":"VintageButton_dark__v5zBq"};

/***/ }),

/***/ 36516:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"VintageHeader_container__FxTWt","leftSide":"VintageHeader_leftSide__PYRWO","rightSide":"VintageHeader_rightSide__jcoDC","centre":"VintageHeader_centre__Ld_lo","hole":"VintageHeader_hole__MYq7X","dark":"VintageHeader_dark__2p1aU"};

/***/ }),

/***/ 86837:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"arrow":"Arrow_arrow__Lzoyp","arrowBlack":"Arrow_arrowBlack__wmv8X","arrowWhite":"Arrow_arrowWhite__QxX3Z","arrowBlackHeading":"Arrow_arrowBlackHeading__zX_Vi"};

/***/ })

}]);